/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Arrayscape Gaming Dashboard API
 * Comprehensive REST API for event management, business operations, and analytics
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ActivityDefaultRate,
  AddressValidationRequest,
  AddressValidationResponse,
  Applicant,
  ApplicantAssignRequest,
  ApplicantDocument,
  ApplicantEmailInput,
  ApplicantImportResult,
  AuthMeResponse,
  BankTransaction,
  BankTransactionPaymentRecord,
  BurnRateReport,
  BurnRateTransaction,
  CommissionDiff,
  CommissionDiffReviewWrite,
  CommissionPaymentSyncResult,
  ConflictErrorResponse,
  ContactAcknowledgeInput,
  CreateActivityDefaultRateRequest,
  CreateBankTransactionPaymentRequest,
  CreateDealRequest,
  CreatePayrollActivityRequest,
  CreateUserActivityRateRequest,
  CreateUserRequest,
  Customer,
  CustomerSlingLocationMap,
  Deal,
  DeleteCommissionPaymentsId200,
  DeleteCommissionsProjectionsId200,
  DeleteCommissionsUploads200,
  DeleteCustomersSourcesSourceId200,
  DeleteEventsIdShifts400,
  DeleteEventsIdShifts404,
  DeleteEventsIdShiftsBody,
  DeleteIntegrationsFileBankAccountsIntegrationId200,
  DeleteIntegrationsFileBankAccountsIntegrationIdFilesFileId200,
  DeleteIntegrationsFileBankAccountsIntegrationIdFilesFileId400,
  DeleteIntegrationsGooglesheetsIntegrationId200,
  DeleteIntegrationsHubspotIntegrationId200,
  DeleteIntegrationsMercuryIntegrationId200,
  DeleteIntegrationsQuickbooksIntegrationId200,
  DeleteIntegrationsSendgridIntegrationId200,
  DeleteIntegrationsSlingIntegrationId200,
  DeleteIntegrationsUspsIntegrationId200,
  DeleteMarketingEmailContacts200,
  DeleteMarketingEmailContactsParams,
  DeleteMarketingEmailListsIdContacts200,
  DeleteMarketingEmailListsIdContactsBody,
  DeleteMarketingEmailsEmailId200,
  DeleteSlingLocationMappingsId200,
  EmailContact,
  EmailContactsBulkImportResult,
  EmailIngestRequest,
  EmailIngestResult,
  EmailList,
  EmailScanInstructions,
  Event,
  EventsFilterOptionsResponse,
  FileBankAccountIntegrationDetail,
  ForbiddenErrorResponse,
  ForecastData,
  GeneralSettings,
  GetAnalyticsForecastsParams,
  GetAnalyticsPerformanceParams,
  GetAnalyticsTrendsParams,
  GetApplicantDocuments200,
  GetApplicantDocumentsParams,
  GetApplicants200,
  GetApplicantsParams,
  GetBankTransactions200,
  GetBankTransactionsParams,
  GetBankTransactionsTransactionIdAttachments200,
  GetBankTransactionsTransactionIdPaymentCandidates200,
  GetCommissionPayments200,
  GetCommissionPaymentsParams,
  GetCommissionsDiff200,
  GetCommissionsDiffParams,
  GetCommissionsProjections200,
  GetCommissionsProjectionsParams,
  GetCommissionsStrandedBankTransactions200,
  GetCommissionsUploads200,
  GetCommissionsUserId200,
  GetCommissionsUserIdInvoices200,
  GetCommissionsUserIdInvoicesParams,
  GetCommissionsUserIdParams,
  GetCommissionsUserIdPayments200,
  GetCommissionsUserIdPaymentsParams,
  GetCommissionsUserIdPayouts200,
  GetCommissionsUserIdPayoutsParams,
  GetCustomers200,
  GetCustomersIdLocations200,
  GetCustomersIdSlingLocationMappings200,
  GetCustomersParams,
  GetDeals200,
  GetDealsIdActivities200,
  GetDealsIdActivitiesParams,
  GetDealsParams,
  GetEmails200,
  GetEmailsParams,
  GetEvents200,
  GetEventsParams,
  GetHealth200,
  GetIntegrationsFileBankAccounts200,
  GetIntegrationsGooglesheets200,
  GetIntegrationsHubspot200,
  GetIntegrationsHubspotCallbackParams,
  GetIntegrationsMercury200,
  GetIntegrationsMercuryIntegrationIdAccounts200,
  GetIntegrationsQuickbooks200,
  GetIntegrationsQuickbooksCallbackParams,
  GetIntegrationsSendgrid200,
  GetIntegrationsSling200,
  GetIntegrationsUsps200,
  GetInvoicePayments200,
  GetInvoicePaymentsParams,
  GetInvoicePaymentsPaymentIdAttachments200,
  GetInvoicePaymentsPaymentIdBankTransactionCandidates200,
  GetInvoices200,
  GetInvoicesExportParams,
  GetInvoicesInvoiceIdAttachments200,
  GetInvoicesParams,
  GetItems200,
  GetMarketingEmailContacts200,
  GetMarketingEmailContactsExportParams,
  GetMarketingEmailContactsParams,
  GetMarketingEmailSends200,
  GetMarketingEmailSendsIdEvents200,
  GetMarketingEmailSendsIdEventsParams,
  GetMarketingEmailSendsParams,
  GetMarketingEmails200,
  GetMarketingEmailsSenders200,
  GetNotifications200,
  GetNotificationsParams,
  GetPayees200,
  GetPayeesParams,
  GetPaymentsRequests200,
  GetPaymentsRequestsParams,
  GetPayrollActivities200,
  GetPayrollActivitiesActivityIdParams,
  GetPayrollActivitiesActivityIdRates200,
  GetPayrollActivitiesAll200,
  GetPayrollActivitiesAllParams,
  GetPayrollActivitiesParams,
  GetPayrollUsersConfigs200,
  GetPayrollUsersUserIdActivities200,
  GetPayrollUsersUserIdRates200,
  GetPayrollUsersUserIdRatesParams,
  GetPipelineForecastParams,
  GetPipelineParams,
  GetPipelineStages200,
  GetPipelineStagesParams,
  GetReportsBurnRateParams,
  GetReportsBurnRateTransactionsParams,
  GetReportsIdExport200Three,
  GetReportsIdExportParams,
  GetReportsIncome200,
  GetReportsIncomeBreakdown200,
  GetReportsIncomeBreakdownParams,
  GetReportsIncomeParams,
  GetSettingsKvKey200,
  GetSlingLocations200,
  GetSlingLocationsParams,
  GetSlingShifts200,
  GetSlingShiftsParams,
  GetSyncHistory200,
  GetSyncHistoryParams,
  GetSyncHistorySyncRunId200,
  GetSyncHistorySyncRunIdParams,
  GetTimesheets200,
  GetTimesheetsParams,
  GetTimesheetsUsersUserIdCurrentPeriodParams,
  GetTimezones200,
  GetUsers200,
  GetUsersParams,
  GetUsersUserIdSalesQuota200,
  GetVersion200,
  GetWebFormsSubmissions200,
  GetWebFormsSubmissionsParams,
  GoogleSheetsIntegration,
  HarvestSettings,
  HubSpotIntegration,
  IncomeFilterOptionsResponse,
  Invoice,
  Item,
  JsonPatchOperation,
  MarketingEmail,
  MarketingEmailSend,
  MercuryIntegration,
  MonitorCheckRequest,
  MonitorSettings,
  MonitorTestStage,
  MonitoredHost,
  MonitoredSite,
  NotFoundErrorResponse,
  Notification,
  NotificationPreferences,
  PatchCommissionPayments200,
  PatchCommissionPayments400,
  PatchEventsId400,
  PatchEventsId404,
  PatchMarketingEmailContactsId400,
  PatchMarketingEmailContactsId404,
  PatchTimesheets200,
  PatchUsersIdPreferencesSectionBody,
  PatchUsersIdPreferencesSectionParamsSection,
  PatchWebFormsSubmissionsSubmissionIdBody,
  PayPeriodInfo,
  Payee,
  Payment,
  PaymentRequestDetail,
  PayrollActivity,
  PayrollSettings,
  PerformanceMetrics,
  Pipeline,
  PipelineForecast,
  PostApplicantDocumentsRetry200,
  PostApplicantDocumentsRetryParams,
  PostApplicantsIdDocumentsBody,
  PostApplicantsIdDocumentsDocumentIdReassignBody,
  PostApplicantsImportBody,
  PostAuthGoogle200,
  PostAuthGoogleBody,
  PostAuthLogin200,
  PostAuthLoginBody,
  PostAuthLogout200,
  PostAuthRefresh200,
  PostAuthRefreshBody,
  PostBankTransactionPaymentsBody,
  PostCommissionsDiffRecompute200,
  PostCommissionsImportConfig200,
  PostCommissionsImportConfig400,
  PostCommissionsImportConfigBody,
  PostCommissionsProjectionsIdRecalculate200,
  PostCommissionsUploadsMapBatch200,
  PostCommissionsUploadsMapBatchBody,
  PostCommissionsUserIdPayBody,
  PostCustomersBody,
  PostEmailsRetry200,
  PostEmailsRetryParams,
  PostEventsIdShifts200,
  PostEventsIdShifts400,
  PostEventsIdShifts404,
  PostEventsIdShiftsBody,
  PostEventsSync200,
  PostIntegrationsFileBankAccountsUpload200,
  PostIntegrationsFileBankAccountsUpload400,
  PostIntegrationsFileBankAccountsUploadBody,
  PostIntegrationsGooglesheetsBody,
  PostIntegrationsGooglesheetsIntegrationIdSync200,
  PostIntegrationsGooglesheetsIntegrationIdTestConnection200,
  PostIntegrationsHubspot200,
  PostIntegrationsHubspotBody,
  PostIntegrationsHubspotIntegrationIdSync200,
  PostIntegrationsHubspotIntegrationIdTestConnection200,
  PostIntegrationsMercuryBody,
  PostIntegrationsMercuryIntegrationIdClearSync200,
  PostIntegrationsMercuryIntegrationIdSync200,
  PostIntegrationsMercuryIntegrationIdTestConnection200,
  PostIntegrationsQuickbooks200,
  PostIntegrationsQuickbooksBody,
  PostIntegrationsQuickbooksIntegrationIdReauthorize200,
  PostIntegrationsQuickbooksIntegrationIdSync200,
  PostIntegrationsQuickbooksIntegrationIdSyncParams,
  PostIntegrationsQuickbooksIntegrationIdTestConnection200,
  PostIntegrationsSendgridBody,
  PostIntegrationsSendgridIntegrationIdSync200,
  PostIntegrationsSendgridIntegrationIdTestConnection200,
  PostIntegrationsSlingBody,
  PostIntegrationsSlingIntegrationIdSync200,
  PostIntegrationsSlingIntegrationIdTestConnection200,
  PostIntegrationsUspsBody,
  PostIntegrationsUspsIntegrationIdTestConnection200,
  PostMarketingEmailContactsBody,
  PostMarketingEmailContactsBulkImportBody,
  PostMarketingEmailListsBody,
  PostMarketingEmailListsIdContacts200,
  PostMarketingEmailListsIdContactsBody,
  PostMarketingEmailListsIdSync200,
  PostMarketingEmailSync200,
  PostMarketingEmailsBody,
  PostMarketingEmailsEmailIdSend200,
  PostMarketingEmailsEmailIdSendBody,
  PostMonitoringCheck200,
  PostReportsGenerate202,
  PostSettingsKvKeyTest200,
  PostSettingsSmtpTestConnectionBody,
  PostSlingLocationMappingsBody,
  PostTimesheetsUsersUserId409,
  PostTimesheetsUsersUserIdBody,
  PostWebmonCheck200,
  Projection,
  ProjectionCreate,
  PublicSettings,
  PutIntegrationsGooglesheetsIntegrationIdBody,
  PutIntegrationsHubspotIntegrationIdBody,
  PutIntegrationsMercuryIntegrationIdBody,
  PutIntegrationsQuickbooksIntegrationIdBody,
  PutIntegrationsSendgridIntegrationIdBody,
  PutIntegrationsSlingIntegrationIdBody,
  PutIntegrationsUspsIntegrationIdBody,
  PutMarketingEmailListsIdBody,
  PutMarketingEmailsEmailIdBody,
  PutSettingsKvKey200,
  PutSettingsKvKeyBody,
  PutSlingLocationMappingsIdBody,
  PutWebmonSitesSiteIdChecksOrderBody,
  QuickBooksIntegration,
  RecordSyncResult,
  RemittanceLinesResponse,
  ReportGenerateRequest,
  RequestErrorResponse,
  SMTPSettings,
  SalesQuota,
  SalesStage,
  SendGridIntegration,
  SetPayeeUserRequest,
  SiteCheck,
  SiteCheckTryRequest,
  SiteCheckTryResult,
  SlingIntegration,
  SlingLocation,
  Timesheet,
  TimesheetPayment,
  TrendData,
  USPSIntegration,
  UnauthorizedErrorResponse,
  UpdateActivityDefaultRateRequest,
  UpdateDealRequest,
  UpdatePayrollActivityRequest,
  UpdatePayrollSettingsRequest,
  UpdateUserActivityRateRequest,
  UpdateUserActivityRequest,
  UpdateUserRequest,
  UpdateUserTimesheetConfigRequest,
  UploadsMapBatchConflictResponse,
  User,
  UserActivity,
  UserActivityRate,
  UserPreferences,
  UserTimesheetConfig,
  ValidationErrorResponse,
  WebFormDefinition,
  WebFormSecretValue,
  WebFormSettings,
  WebFormSubmission,
  WebFormSubmitRequest,
  WebFormSubmitResponse,
  WebFormTestResult,
  WebMonCheckRequest,
  WebMonSettings
} from './model';

import { customInstance } from '../custom-instance';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Quickbooks webhook
 */
export const postQuickbooksWebhook = (
    postQuickbooksWebhookBody: Blob,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/quickbooks/webhook`, method: 'POST',
      headers: {'Content-Type': 'application/octet-stream', },
      data: postQuickbooksWebhookBody, signal
    },
      options);
    }
  


export const getPostQuickbooksWebhookMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQuickbooksWebhook>>, TError,{data: Blob}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postQuickbooksWebhook>>, TError,{data: Blob}, TContext> => {

const mutationKey = ['postQuickbooksWebhook'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postQuickbooksWebhook>>, {data: Blob}> = (props) => {
          const {data} = props ?? {};

          return  postQuickbooksWebhook(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostQuickbooksWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof postQuickbooksWebhook>>>
    export type PostQuickbooksWebhookMutationBody = Blob
    export type PostQuickbooksWebhookMutationError = void

    /**
 * @summary Quickbooks webhook
 */
export const usePostQuickbooksWebhook = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postQuickbooksWebhook>>, TError,{data: Blob}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postQuickbooksWebhook>>,
        TError,
        {data: Blob},
        TContext
      > => {

      const mutationOptions = getPostQuickbooksWebhookMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Receives bounce, dropped, spam report, and blocked events from SendGrid
 * @summary SendGrid event webhook
 */
export const postSendgridWebhook = (
    postSendgridWebhookBody: Blob,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/sendgrid/webhook`, method: 'POST',
      headers: {'Content-Type': 'application/octet-stream', },
      data: postSendgridWebhookBody, signal
    },
      options);
    }
  


export const getPostSendgridWebhookMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSendgridWebhook>>, TError,{data: Blob}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postSendgridWebhook>>, TError,{data: Blob}, TContext> => {

const mutationKey = ['postSendgridWebhook'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSendgridWebhook>>, {data: Blob}> = (props) => {
          const {data} = props ?? {};

          return  postSendgridWebhook(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostSendgridWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof postSendgridWebhook>>>
    export type PostSendgridWebhookMutationBody = Blob
    export type PostSendgridWebhookMutationError = void

    /**
 * @summary SendGrid event webhook
 */
export const usePostSendgridWebhook = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSendgridWebhook>>, TError,{data: Blob}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postSendgridWebhook>>,
        TError,
        {data: Blob},
        TContext
      > => {

      const mutationOptions = getPostSendgridWebhookMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieve non-sensitive settings like company name (unauthenticated)
 * @summary Get public settings
 */
export const getPublicSettings = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PublicSettings>(
      {url: `/api/v1/public/settings`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPublicSettingsQueryKey = () => {
    return [
    `/api/v1/public/settings`
    ] as const;
    }

    
export const getGetPublicSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getPublicSettings>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicSettingsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicSettings>>> = ({ signal }) => getPublicSettings(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicSettings>>>
export type GetPublicSettingsQueryError = void


export function useGetPublicSettings<TData = Awaited<ReturnType<typeof getPublicSettings>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicSettings>>,
          TError,
          Awaited<ReturnType<typeof getPublicSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicSettings<TData = Awaited<ReturnType<typeof getPublicSettings>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicSettings>>,
          TError,
          Awaited<ReturnType<typeof getPublicSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicSettings<TData = Awaited<ReturnType<typeof getPublicSettings>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get public settings
 */

export function useGetPublicSettings<TData = Awaited<ReturnType<typeof getPublicSettings>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Receives contact-form submissions proxied from the arrayscape.com
static site container. Unauthenticated by design: Cloudflare Turnstile
is the caller gate. A valid, unreplayed token proves a real browser
solved the challenge on an allowlisted hostname; a bot POSTing here
directly cannot produce one.

The socket peer is the site's nginx, not the visitor, so the real
client IP comes from X-Real-IP / X-Forwarded-For — but ONLY when the
peer is inside the configured trusted-proxy CIDR allowlist. From an
untrusted source the headers are ignored and the socket peer is used
instead, degrading per-IP rate limiting to global rather than failing
the request.

Responses are deliberately uninformative: the honeypot path returns
200 exactly like a success, because telling a bot why it failed only
helps it retry successfully. A verification failure points the visitor
at the fallback contact address as well as suggesting a retry, since a
bot and a person hitting a broken configuration cannot be told apart
per-request.

 * @summary Submit a public website form
 */
export const postPublicWebFormsSubmissions = (
    webFormSubmitRequest: WebFormSubmitRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<WebFormSubmitResponse>(
      {url: `/api/v1/public/web-forms/submissions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: webFormSubmitRequest, signal
    },
      options);
    }
  


export const getPostPublicWebFormsSubmissionsMutationOptions = <TError = WebFormSubmitResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPublicWebFormsSubmissions>>, TError,{data: WebFormSubmitRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postPublicWebFormsSubmissions>>, TError,{data: WebFormSubmitRequest}, TContext> => {

const mutationKey = ['postPublicWebFormsSubmissions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPublicWebFormsSubmissions>>, {data: WebFormSubmitRequest}> = (props) => {
          const {data} = props ?? {};

          return  postPublicWebFormsSubmissions(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPublicWebFormsSubmissionsMutationResult = NonNullable<Awaited<ReturnType<typeof postPublicWebFormsSubmissions>>>
    export type PostPublicWebFormsSubmissionsMutationBody = WebFormSubmitRequest
    export type PostPublicWebFormsSubmissionsMutationError = WebFormSubmitResponse

    /**
 * @summary Submit a public website form
 */
export const usePostPublicWebFormsSubmissions = <TError = WebFormSubmitResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPublicWebFormsSubmissions>>, TError,{data: WebFormSubmitRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPublicWebFormsSubmissions>>,
        TError,
        {data: WebFormSubmitRequest},
        TContext
      > => {

      const mutationOptions = getPostPublicWebFormsSubmissionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Authenticate user and return access token
 * @summary User login
 */
export const postAuthLogin = (
    postAuthLoginBody: PostAuthLoginBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostAuthLogin200>(
      {url: `/api/v1/auth/login`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAuthLoginBody, signal
    },
      options);
    }
  


export const getPostAuthLoginMutationOptions = <TError = UnauthorizedErrorResponse | ValidationErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthLogin>>, TError,{data: PostAuthLoginBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAuthLogin>>, TError,{data: PostAuthLoginBody}, TContext> => {

const mutationKey = ['postAuthLogin'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthLogin>>, {data: PostAuthLoginBody}> = (props) => {
          const {data} = props ?? {};

          return  postAuthLogin(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthLoginMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthLogin>>>
    export type PostAuthLoginMutationBody = PostAuthLoginBody
    export type PostAuthLoginMutationError = UnauthorizedErrorResponse | ValidationErrorResponse

    /**
 * @summary User login
 */
export const usePostAuthLogin = <TError = UnauthorizedErrorResponse | ValidationErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthLogin>>, TError,{data: PostAuthLoginBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthLogin>>,
        TError,
        {data: PostAuthLoginBody},
        TContext
      > => {

      const mutationOptions = getPostAuthLoginMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Invalidate current user session
 * @summary User logout
 */
export const postAuthLogout = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostAuthLogout200>(
      {url: `/api/v1/auth/logout`, method: 'POST', signal
    },
      options);
    }
  


export const getPostAuthLogoutMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthLogout>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAuthLogout>>, TError,void, TContext> => {

const mutationKey = ['postAuthLogout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthLogout>>, void> = () => {
          

          return  postAuthLogout(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthLogoutMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthLogout>>>
    
    export type PostAuthLogoutMutationError = unknown

    /**
 * @summary User logout
 */
export const usePostAuthLogout = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthLogout>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthLogout>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostAuthLogoutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get new access token using refresh token
 * @summary Refresh access token
 */
export const postAuthRefresh = (
    postAuthRefreshBody: PostAuthRefreshBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostAuthRefresh200>(
      {url: `/api/v1/auth/refresh`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAuthRefreshBody, signal
    },
      options);
    }
  


export const getPostAuthRefreshMutationOptions = <TError = UnauthorizedErrorResponse | ValidationErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthRefresh>>, TError,{data: PostAuthRefreshBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAuthRefresh>>, TError,{data: PostAuthRefreshBody}, TContext> => {

const mutationKey = ['postAuthRefresh'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthRefresh>>, {data: PostAuthRefreshBody}> = (props) => {
          const {data} = props ?? {};

          return  postAuthRefresh(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthRefreshMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthRefresh>>>
    export type PostAuthRefreshMutationBody = PostAuthRefreshBody
    export type PostAuthRefreshMutationError = UnauthorizedErrorResponse | ValidationErrorResponse

    /**
 * @summary Refresh access token
 */
export const usePostAuthRefresh = <TError = UnauthorizedErrorResponse | ValidationErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthRefresh>>, TError,{data: PostAuthRefreshBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthRefresh>>,
        TError,
        {data: PostAuthRefreshBody},
        TContext
      > => {

      const mutationOptions = getPostAuthRefreshMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Authenticate user with Google ID token and return access token
 * @summary Google OAuth login
 */
export const postAuthGoogle = (
    postAuthGoogleBody: PostAuthGoogleBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostAuthGoogle200>(
      {url: `/api/v1/auth/google`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAuthGoogleBody, signal
    },
      options);
    }
  


export const getPostAuthGoogleMutationOptions = <TError = UnauthorizedErrorResponse | ValidationErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthGoogle>>, TError,{data: PostAuthGoogleBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postAuthGoogle>>, TError,{data: PostAuthGoogleBody}, TContext> => {

const mutationKey = ['postAuthGoogle'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthGoogle>>, {data: PostAuthGoogleBody}> = (props) => {
          const {data} = props ?? {};

          return  postAuthGoogle(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthGoogleMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthGoogle>>>
    export type PostAuthGoogleMutationBody = PostAuthGoogleBody
    export type PostAuthGoogleMutationError = UnauthorizedErrorResponse | ValidationErrorResponse

    /**
 * @summary Google OAuth login
 */
export const usePostAuthGoogle = <TError = UnauthorizedErrorResponse | ValidationErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthGoogle>>, TError,{data: PostAuthGoogleBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postAuthGoogle>>,
        TError,
        {data: PostAuthGoogleBody},
        TContext
      > => {

      const mutationOptions = getPostAuthGoogleMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieve current authenticated user information
 * @summary Get current user profile
 */
export const getAuthMe = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AuthMeResponse>(
      {url: `/api/v1/auth/me`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAuthMeQueryKey = () => {
    return [
    `/api/v1/auth/me`
    ] as const;
    }

    
export const getGetAuthMeQueryOptions = <TData = Awaited<ReturnType<typeof getAuthMe>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuthMeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthMe>>> = ({ signal }) => getAuthMe(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAuthMeQueryResult = NonNullable<Awaited<ReturnType<typeof getAuthMe>>>
export type GetAuthMeQueryError = unknown


export function useGetAuthMe<TData = Awaited<ReturnType<typeof getAuthMe>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthMe>>,
          TError,
          Awaited<ReturnType<typeof getAuthMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthMe<TData = Awaited<ReturnType<typeof getAuthMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthMe>>,
          TError,
          Awaited<ReturnType<typeof getAuthMe>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthMe<TData = Awaited<ReturnType<typeof getAuthMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current user profile
 */

export function useGetAuthMe<TData = Awaited<ReturnType<typeof getAuthMe>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthMe>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAuthMeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns every FBAI in the system, with summary stats (page count,
transaction count, last upload). Auto-discovered from uploads —
operators never create these manually; they just upload files.

 * @summary List file bank account integrations
 */
export const getIntegrationsFileBankAccounts = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetIntegrationsFileBankAccounts200>(
      {url: `/api/v1/integrations/file-bank-accounts`, method: 'GET', signal
    },
      options);
    }
  



export const getGetIntegrationsFileBankAccountsQueryKey = () => {
    return [
    `/api/v1/integrations/file-bank-accounts`
    ] as const;
    }

    
export const getGetIntegrationsFileBankAccountsQueryOptions = <TData = Awaited<ReturnType<typeof getIntegrationsFileBankAccounts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsFileBankAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntegrationsFileBankAccountsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntegrationsFileBankAccounts>>> = ({ signal }) => getIntegrationsFileBankAccounts(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsFileBankAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIntegrationsFileBankAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof getIntegrationsFileBankAccounts>>>
export type GetIntegrationsFileBankAccountsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetIntegrationsFileBankAccounts<TData = Awaited<ReturnType<typeof getIntegrationsFileBankAccounts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsFileBankAccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsFileBankAccounts>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsFileBankAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsFileBankAccounts<TData = Awaited<ReturnType<typeof getIntegrationsFileBankAccounts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsFileBankAccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsFileBankAccounts>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsFileBankAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsFileBankAccounts<TData = Awaited<ReturnType<typeof getIntegrationsFileBankAccounts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsFileBankAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List file bank account integrations
 */

export function useGetIntegrationsFileBankAccounts<TData = Awaited<ReturnType<typeof getIntegrationsFileBankAccounts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsFileBankAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIntegrationsFileBankAccountsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Single unified upload endpoint. The backend parses the file's
Account section, finds-or-creates an FBAI keyed on
(RoutingNumber, AccountNumber), then runs the standard two-pass
sync (raw file_bank_account_transactions → unified
bank_transactions → derived commission_payments). Returns
immediately with a sync_id; progress + final status are
delivered via SSE so the SyncButton can subscribe.

 * @summary Upload a file to auto-discover or update a file bank account
 */
export const postIntegrationsFileBankAccountsUpload = (
    postIntegrationsFileBankAccountsUploadBody: PostIntegrationsFileBankAccountsUploadBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostIntegrationsFileBankAccountsUpload200>(
      {url: `/api/v1/integrations/file-bank-accounts/upload`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postIntegrationsFileBankAccountsUploadBody, signal
    },
      options);
    }
  


export const getPostIntegrationsFileBankAccountsUploadMutationOptions = <TError = PostIntegrationsFileBankAccountsUpload400 | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsFileBankAccountsUpload>>, TError,{data: PostIntegrationsFileBankAccountsUploadBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsFileBankAccountsUpload>>, TError,{data: PostIntegrationsFileBankAccountsUploadBody}, TContext> => {

const mutationKey = ['postIntegrationsFileBankAccountsUpload'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIntegrationsFileBankAccountsUpload>>, {data: PostIntegrationsFileBankAccountsUploadBody}> = (props) => {
          const {data} = props ?? {};

          return  postIntegrationsFileBankAccountsUpload(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostIntegrationsFileBankAccountsUploadMutationResult = NonNullable<Awaited<ReturnType<typeof postIntegrationsFileBankAccountsUpload>>>
    export type PostIntegrationsFileBankAccountsUploadMutationBody = PostIntegrationsFileBankAccountsUploadBody
    export type PostIntegrationsFileBankAccountsUploadMutationError = PostIntegrationsFileBankAccountsUpload400 | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Upload a file to auto-discover or update a file bank account
 */
export const usePostIntegrationsFileBankAccountsUpload = <TError = PostIntegrationsFileBankAccountsUpload400 | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsFileBankAccountsUpload>>, TError,{data: PostIntegrationsFileBankAccountsUploadBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postIntegrationsFileBankAccountsUpload>>,
        TError,
        {data: PostIntegrationsFileBankAccountsUploadBody},
        TContext
      > => {

      const mutationOptions = getPostIntegrationsFileBankAccountsUploadMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Get a file bank account integration with its pages
 */
export const getIntegrationsFileBankAccountsIntegrationId = (
    integrationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FileBankAccountIntegrationDetail>(
      {url: `/api/v1/integrations/file-bank-accounts/${integrationId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetIntegrationsFileBankAccountsIntegrationIdQueryKey = (integrationId?: string,) => {
    return [
    `/api/v1/integrations/file-bank-accounts/${integrationId}`
    ] as const;
    }

    
export const getGetIntegrationsFileBankAccountsIntegrationIdQueryOptions = <TData = Awaited<ReturnType<typeof getIntegrationsFileBankAccountsIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsFileBankAccountsIntegrationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntegrationsFileBankAccountsIntegrationIdQueryKey(integrationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntegrationsFileBankAccountsIntegrationId>>> = ({ signal }) => getIntegrationsFileBankAccountsIntegrationId(integrationId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(integrationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsFileBankAccountsIntegrationId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIntegrationsFileBankAccountsIntegrationIdQueryResult = NonNullable<Awaited<ReturnType<typeof getIntegrationsFileBankAccountsIntegrationId>>>
export type GetIntegrationsFileBankAccountsIntegrationIdQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetIntegrationsFileBankAccountsIntegrationId<TData = Awaited<ReturnType<typeof getIntegrationsFileBankAccountsIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsFileBankAccountsIntegrationId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsFileBankAccountsIntegrationId>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsFileBankAccountsIntegrationId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsFileBankAccountsIntegrationId<TData = Awaited<ReturnType<typeof getIntegrationsFileBankAccountsIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsFileBankAccountsIntegrationId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsFileBankAccountsIntegrationId>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsFileBankAccountsIntegrationId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsFileBankAccountsIntegrationId<TData = Awaited<ReturnType<typeof getIntegrationsFileBankAccountsIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsFileBankAccountsIntegrationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a file bank account integration with its pages
 */

export function useGetIntegrationsFileBankAccountsIntegrationId<TData = Awaited<ReturnType<typeof getIntegrationsFileBankAccountsIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsFileBankAccountsIntegrationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIntegrationsFileBankAccountsIntegrationIdQueryOptions(integrationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Cascades through every related row: pages, raw file
transactions, unified bank_transactions for this integration,
and commission_payments derived from those bank transactions.
Use to retire a stale bucket — re-uploading any file for the
same RoutingNumber+AccountNumber will auto-discover a fresh one.

 * @summary Delete a file bank account integration
 */
export const deleteIntegrationsFileBankAccountsIntegrationId = (
    integrationId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<DeleteIntegrationsFileBankAccountsIntegrationId200>(
      {url: `/api/v1/integrations/file-bank-accounts/${integrationId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteIntegrationsFileBankAccountsIntegrationIdMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIntegrationsFileBankAccountsIntegrationId>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteIntegrationsFileBankAccountsIntegrationId>>, TError,{integrationId: string}, TContext> => {

const mutationKey = ['deleteIntegrationsFileBankAccountsIntegrationId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteIntegrationsFileBankAccountsIntegrationId>>, {integrationId: string}> = (props) => {
          const {integrationId} = props ?? {};

          return  deleteIntegrationsFileBankAccountsIntegrationId(integrationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteIntegrationsFileBankAccountsIntegrationIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteIntegrationsFileBankAccountsIntegrationId>>>
    
    export type DeleteIntegrationsFileBankAccountsIntegrationIdMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Delete a file bank account integration
 */
export const useDeleteIntegrationsFileBankAccountsIntegrationId = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIntegrationsFileBankAccountsIntegrationId>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteIntegrationsFileBankAccountsIntegrationId>>,
        TError,
        {integrationId: string},
        TContext
      > => {

      const mutationOptions = getDeleteIntegrationsFileBankAccountsIntegrationIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Removes one uploaded file from the integration without deleting the
integration itself — equivalent to re-uploading an empty file. The
file's raw transactions are wiped, the bank_transactions derived
from them are removed, and any commission_payments anchored to
those bank_transactions go away. The integration row stays so
future uploads under the same RoutingNumber+AccountNumber land on
the same bucket.

Runs async on the shared sync queue; returns sync_id immediately
and emits progress / completion via SSE.

 * @summary Delete a single uploaded file from a file bank account integration
 */
export const deleteIntegrationsFileBankAccountsIntegrationIdFilesFileId = (
    integrationId: string,
    fileId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<DeleteIntegrationsFileBankAccountsIntegrationIdFilesFileId200>(
      {url: `/api/v1/integrations/file-bank-accounts/${integrationId}/files/${fileId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteIntegrationsFileBankAccountsIntegrationIdFilesFileIdMutationOptions = <TError = DeleteIntegrationsFileBankAccountsIntegrationIdFilesFileId400 | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIntegrationsFileBankAccountsIntegrationIdFilesFileId>>, TError,{integrationId: string;fileId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteIntegrationsFileBankAccountsIntegrationIdFilesFileId>>, TError,{integrationId: string;fileId: string}, TContext> => {

const mutationKey = ['deleteIntegrationsFileBankAccountsIntegrationIdFilesFileId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteIntegrationsFileBankAccountsIntegrationIdFilesFileId>>, {integrationId: string;fileId: string}> = (props) => {
          const {integrationId,fileId} = props ?? {};

          return  deleteIntegrationsFileBankAccountsIntegrationIdFilesFileId(integrationId,fileId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteIntegrationsFileBankAccountsIntegrationIdFilesFileIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteIntegrationsFileBankAccountsIntegrationIdFilesFileId>>>
    
    export type DeleteIntegrationsFileBankAccountsIntegrationIdFilesFileIdMutationError = DeleteIntegrationsFileBankAccountsIntegrationIdFilesFileId400 | UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Delete a single uploaded file from a file bank account integration
 */
export const useDeleteIntegrationsFileBankAccountsIntegrationIdFilesFileId = <TError = DeleteIntegrationsFileBankAccountsIntegrationIdFilesFileId400 | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIntegrationsFileBankAccountsIntegrationIdFilesFileId>>, TError,{integrationId: string;fileId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteIntegrationsFileBankAccountsIntegrationIdFilesFileId>>,
        TError,
        {integrationId: string;fileId: string},
        TContext
      > => {

      const mutationOptions = getDeleteIntegrationsFileBankAccountsIntegrationIdFilesFileIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get list of user's QuickBooks integrations
 * @summary List QuickBooks integrations
 */
export const getIntegrationsQuickbooks = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetIntegrationsQuickbooks200>(
      {url: `/api/v1/integrations/quickbooks`, method: 'GET', signal
    },
      options);
    }
  



export const getGetIntegrationsQuickbooksQueryKey = () => {
    return [
    `/api/v1/integrations/quickbooks`
    ] as const;
    }

    
export const getGetIntegrationsQuickbooksQueryOptions = <TData = Awaited<ReturnType<typeof getIntegrationsQuickbooks>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsQuickbooks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntegrationsQuickbooksQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntegrationsQuickbooks>>> = ({ signal }) => getIntegrationsQuickbooks(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsQuickbooks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIntegrationsQuickbooksQueryResult = NonNullable<Awaited<ReturnType<typeof getIntegrationsQuickbooks>>>
export type GetIntegrationsQuickbooksQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetIntegrationsQuickbooks<TData = Awaited<ReturnType<typeof getIntegrationsQuickbooks>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsQuickbooks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsQuickbooks>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsQuickbooks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsQuickbooks<TData = Awaited<ReturnType<typeof getIntegrationsQuickbooks>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsQuickbooks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsQuickbooks>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsQuickbooks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsQuickbooks<TData = Awaited<ReturnType<typeof getIntegrationsQuickbooks>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsQuickbooks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List QuickBooks integrations
 */

export function useGetIntegrationsQuickbooks<TData = Awaited<ReturnType<typeof getIntegrationsQuickbooks>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsQuickbooks>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIntegrationsQuickbooksQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Start OAuth flow for new QuickBooks integration
 * @summary Create new QuickBooks integration
 */
export const postIntegrationsQuickbooks = (
    postIntegrationsQuickbooksBody: PostIntegrationsQuickbooksBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostIntegrationsQuickbooks200>(
      {url: `/api/v1/integrations/quickbooks`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postIntegrationsQuickbooksBody, signal
    },
      options);
    }
  


export const getPostIntegrationsQuickbooksMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsQuickbooks>>, TError,{data: PostIntegrationsQuickbooksBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsQuickbooks>>, TError,{data: PostIntegrationsQuickbooksBody}, TContext> => {

const mutationKey = ['postIntegrationsQuickbooks'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIntegrationsQuickbooks>>, {data: PostIntegrationsQuickbooksBody}> = (props) => {
          const {data} = props ?? {};

          return  postIntegrationsQuickbooks(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostIntegrationsQuickbooksMutationResult = NonNullable<Awaited<ReturnType<typeof postIntegrationsQuickbooks>>>
    export type PostIntegrationsQuickbooksMutationBody = PostIntegrationsQuickbooksBody
    export type PostIntegrationsQuickbooksMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Create new QuickBooks integration
 */
export const usePostIntegrationsQuickbooks = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsQuickbooks>>, TError,{data: PostIntegrationsQuickbooksBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postIntegrationsQuickbooks>>,
        TError,
        {data: PostIntegrationsQuickbooksBody},
        TContext
      > => {

      const mutationOptions = getPostIntegrationsQuickbooksMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get details of a specific QuickBooks integration
 * @summary Get QuickBooks integration details
 */
export const getIntegrationsQuickbooksIntegrationId = (
    integrationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<QuickBooksIntegration>(
      {url: `/api/v1/integrations/quickbooks/${integrationId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetIntegrationsQuickbooksIntegrationIdQueryKey = (integrationId?: string,) => {
    return [
    `/api/v1/integrations/quickbooks/${integrationId}`
    ] as const;
    }

    
export const getGetIntegrationsQuickbooksIntegrationIdQueryOptions = <TData = Awaited<ReturnType<typeof getIntegrationsQuickbooksIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsQuickbooksIntegrationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntegrationsQuickbooksIntegrationIdQueryKey(integrationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntegrationsQuickbooksIntegrationId>>> = ({ signal }) => getIntegrationsQuickbooksIntegrationId(integrationId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(integrationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsQuickbooksIntegrationId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIntegrationsQuickbooksIntegrationIdQueryResult = NonNullable<Awaited<ReturnType<typeof getIntegrationsQuickbooksIntegrationId>>>
export type GetIntegrationsQuickbooksIntegrationIdQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetIntegrationsQuickbooksIntegrationId<TData = Awaited<ReturnType<typeof getIntegrationsQuickbooksIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsQuickbooksIntegrationId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsQuickbooksIntegrationId>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsQuickbooksIntegrationId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsQuickbooksIntegrationId<TData = Awaited<ReturnType<typeof getIntegrationsQuickbooksIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsQuickbooksIntegrationId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsQuickbooksIntegrationId>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsQuickbooksIntegrationId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsQuickbooksIntegrationId<TData = Awaited<ReturnType<typeof getIntegrationsQuickbooksIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsQuickbooksIntegrationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get QuickBooks integration details
 */

export function useGetIntegrationsQuickbooksIntegrationId<TData = Awaited<ReturnType<typeof getIntegrationsQuickbooksIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsQuickbooksIntegrationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIntegrationsQuickbooksIntegrationIdQueryOptions(integrationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update QuickBooks integration settings
 * @summary Update QuickBooks integration
 */
export const putIntegrationsQuickbooksIntegrationId = (
    integrationId: string,
    putIntegrationsQuickbooksIntegrationIdBody: PutIntegrationsQuickbooksIntegrationIdBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<QuickBooksIntegration>(
      {url: `/api/v1/integrations/quickbooks/${integrationId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putIntegrationsQuickbooksIntegrationIdBody
    },
      options);
    }
  


export const getPutIntegrationsQuickbooksIntegrationIdMutationOptions = <TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putIntegrationsQuickbooksIntegrationId>>, TError,{integrationId: string;data: PutIntegrationsQuickbooksIntegrationIdBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putIntegrationsQuickbooksIntegrationId>>, TError,{integrationId: string;data: PutIntegrationsQuickbooksIntegrationIdBody}, TContext> => {

const mutationKey = ['putIntegrationsQuickbooksIntegrationId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putIntegrationsQuickbooksIntegrationId>>, {integrationId: string;data: PutIntegrationsQuickbooksIntegrationIdBody}> = (props) => {
          const {integrationId,data} = props ?? {};

          return  putIntegrationsQuickbooksIntegrationId(integrationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutIntegrationsQuickbooksIntegrationIdMutationResult = NonNullable<Awaited<ReturnType<typeof putIntegrationsQuickbooksIntegrationId>>>
    export type PutIntegrationsQuickbooksIntegrationIdMutationBody = PutIntegrationsQuickbooksIntegrationIdBody
    export type PutIntegrationsQuickbooksIntegrationIdMutationError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Update QuickBooks integration
 */
export const usePutIntegrationsQuickbooksIntegrationId = <TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putIntegrationsQuickbooksIntegrationId>>, TError,{integrationId: string;data: PutIntegrationsQuickbooksIntegrationIdBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putIntegrationsQuickbooksIntegrationId>>,
        TError,
        {integrationId: string;data: PutIntegrationsQuickbooksIntegrationIdBody},
        TContext
      > => {

      const mutationOptions = getPutIntegrationsQuickbooksIntegrationIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Revoke QuickBooks access tokens and delete integration
 * @summary Delete QuickBooks integration
 */
export const deleteIntegrationsQuickbooksIntegrationId = (
    integrationId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<DeleteIntegrationsQuickbooksIntegrationId200>(
      {url: `/api/v1/integrations/quickbooks/${integrationId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteIntegrationsQuickbooksIntegrationIdMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIntegrationsQuickbooksIntegrationId>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteIntegrationsQuickbooksIntegrationId>>, TError,{integrationId: string}, TContext> => {

const mutationKey = ['deleteIntegrationsQuickbooksIntegrationId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteIntegrationsQuickbooksIntegrationId>>, {integrationId: string}> = (props) => {
          const {integrationId} = props ?? {};

          return  deleteIntegrationsQuickbooksIntegrationId(integrationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteIntegrationsQuickbooksIntegrationIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteIntegrationsQuickbooksIntegrationId>>>
    
    export type DeleteIntegrationsQuickbooksIntegrationIdMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Delete QuickBooks integration
 */
export const useDeleteIntegrationsQuickbooksIntegrationId = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIntegrationsQuickbooksIntegrationId>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteIntegrationsQuickbooksIntegrationId>>,
        TError,
        {integrationId: string},
        TContext
      > => {

      const mutationOptions = getDeleteIntegrationsQuickbooksIntegrationIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Handle OAuth callback from QuickBooks
 * @summary QuickBooks OAuth callback
 */
export const getIntegrationsQuickbooksCallback = (
    params: GetIntegrationsQuickbooksCallbackParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/v1/integrations/quickbooks/callback`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetIntegrationsQuickbooksCallbackQueryKey = (params?: GetIntegrationsQuickbooksCallbackParams,) => {
    return [
    `/api/v1/integrations/quickbooks/callback`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetIntegrationsQuickbooksCallbackQueryOptions = <TData = Awaited<ReturnType<typeof getIntegrationsQuickbooksCallback>>, TError = RequestErrorResponse | void>(params: GetIntegrationsQuickbooksCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsQuickbooksCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntegrationsQuickbooksCallbackQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntegrationsQuickbooksCallback>>> = ({ signal }) => getIntegrationsQuickbooksCallback(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsQuickbooksCallback>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIntegrationsQuickbooksCallbackQueryResult = NonNullable<Awaited<ReturnType<typeof getIntegrationsQuickbooksCallback>>>
export type GetIntegrationsQuickbooksCallbackQueryError = RequestErrorResponse | void


export function useGetIntegrationsQuickbooksCallback<TData = Awaited<ReturnType<typeof getIntegrationsQuickbooksCallback>>, TError = RequestErrorResponse | void>(
 params: GetIntegrationsQuickbooksCallbackParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsQuickbooksCallback>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsQuickbooksCallback>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsQuickbooksCallback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsQuickbooksCallback<TData = Awaited<ReturnType<typeof getIntegrationsQuickbooksCallback>>, TError = RequestErrorResponse | void>(
 params: GetIntegrationsQuickbooksCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsQuickbooksCallback>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsQuickbooksCallback>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsQuickbooksCallback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsQuickbooksCallback<TData = Awaited<ReturnType<typeof getIntegrationsQuickbooksCallback>>, TError = RequestErrorResponse | void>(
 params: GetIntegrationsQuickbooksCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsQuickbooksCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary QuickBooks OAuth callback
 */

export function useGetIntegrationsQuickbooksCallback<TData = Awaited<ReturnType<typeof getIntegrationsQuickbooksCallback>>, TError = RequestErrorResponse | void>(
 params: GetIntegrationsQuickbooksCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsQuickbooksCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIntegrationsQuickbooksCallbackQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Fetch and update company information from QuickBooks
 * @summary Refresh QuickBooks company info
 */
export const postIntegrationsQuickbooksIntegrationIdRefreshInfo = (
    integrationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<QuickBooksIntegration>(
      {url: `/api/v1/integrations/quickbooks/${integrationId}/refresh-info`, method: 'POST', signal
    },
      options);
    }
  


export const getPostIntegrationsQuickbooksIntegrationIdRefreshInfoMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsQuickbooksIntegrationIdRefreshInfo>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsQuickbooksIntegrationIdRefreshInfo>>, TError,{integrationId: string}, TContext> => {

const mutationKey = ['postIntegrationsQuickbooksIntegrationIdRefreshInfo'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIntegrationsQuickbooksIntegrationIdRefreshInfo>>, {integrationId: string}> = (props) => {
          const {integrationId} = props ?? {};

          return  postIntegrationsQuickbooksIntegrationIdRefreshInfo(integrationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostIntegrationsQuickbooksIntegrationIdRefreshInfoMutationResult = NonNullable<Awaited<ReturnType<typeof postIntegrationsQuickbooksIntegrationIdRefreshInfo>>>
    
    export type PostIntegrationsQuickbooksIntegrationIdRefreshInfoMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Refresh QuickBooks company info
 */
export const usePostIntegrationsQuickbooksIntegrationIdRefreshInfo = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsQuickbooksIntegrationIdRefreshInfo>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postIntegrationsQuickbooksIntegrationIdRefreshInfo>>,
        TError,
        {integrationId: string},
        TContext
      > => {

      const mutationOptions = getPostIntegrationsQuickbooksIntegrationIdRefreshInfoMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Test the connection to QuickBooks and update status
 * @summary Test QuickBooks connection
 */
export const postIntegrationsQuickbooksIntegrationIdTestConnection = (
    integrationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostIntegrationsQuickbooksIntegrationIdTestConnection200>(
      {url: `/api/v1/integrations/quickbooks/${integrationId}/test-connection`, method: 'POST', signal
    },
      options);
    }
  


export const getPostIntegrationsQuickbooksIntegrationIdTestConnectionMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsQuickbooksIntegrationIdTestConnection>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsQuickbooksIntegrationIdTestConnection>>, TError,{integrationId: string}, TContext> => {

const mutationKey = ['postIntegrationsQuickbooksIntegrationIdTestConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIntegrationsQuickbooksIntegrationIdTestConnection>>, {integrationId: string}> = (props) => {
          const {integrationId} = props ?? {};

          return  postIntegrationsQuickbooksIntegrationIdTestConnection(integrationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostIntegrationsQuickbooksIntegrationIdTestConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof postIntegrationsQuickbooksIntegrationIdTestConnection>>>
    
    export type PostIntegrationsQuickbooksIntegrationIdTestConnectionMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Test QuickBooks connection
 */
export const usePostIntegrationsQuickbooksIntegrationIdTestConnection = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsQuickbooksIntegrationIdTestConnection>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postIntegrationsQuickbooksIntegrationIdTestConnection>>,
        TError,
        {integrationId: string},
        TContext
      > => {

      const mutationOptions = getPostIntegrationsQuickbooksIntegrationIdTestConnectionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Manually trigger data synchronization with QuickBooks
 * @summary Trigger QuickBooks sync
 */
export const postIntegrationsQuickbooksIntegrationIdSync = (
    integrationId: string,
    params?: PostIntegrationsQuickbooksIntegrationIdSyncParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostIntegrationsQuickbooksIntegrationIdSync200>(
      {url: `/api/v1/integrations/quickbooks/${integrationId}/sync`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostIntegrationsQuickbooksIntegrationIdSyncMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsQuickbooksIntegrationIdSync>>, TError,{integrationId: string;params?: PostIntegrationsQuickbooksIntegrationIdSyncParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsQuickbooksIntegrationIdSync>>, TError,{integrationId: string;params?: PostIntegrationsQuickbooksIntegrationIdSyncParams}, TContext> => {

const mutationKey = ['postIntegrationsQuickbooksIntegrationIdSync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIntegrationsQuickbooksIntegrationIdSync>>, {integrationId: string;params?: PostIntegrationsQuickbooksIntegrationIdSyncParams}> = (props) => {
          const {integrationId,params} = props ?? {};

          return  postIntegrationsQuickbooksIntegrationIdSync(integrationId,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostIntegrationsQuickbooksIntegrationIdSyncMutationResult = NonNullable<Awaited<ReturnType<typeof postIntegrationsQuickbooksIntegrationIdSync>>>
    
    export type PostIntegrationsQuickbooksIntegrationIdSyncMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Trigger QuickBooks sync
 */
export const usePostIntegrationsQuickbooksIntegrationIdSync = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsQuickbooksIntegrationIdSync>>, TError,{integrationId: string;params?: PostIntegrationsQuickbooksIntegrationIdSyncParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postIntegrationsQuickbooksIntegrationIdSync>>,
        TError,
        {integrationId: string;params?: PostIntegrationsQuickbooksIntegrationIdSyncParams},
        TContext
      > => {

      const mutationOptions = getPostIntegrationsQuickbooksIntegrationIdSyncMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Initiate OAuth reauthorization flow for an existing QuickBooks integration
 * @summary Reauthorize QuickBooks integration
 */
export const postIntegrationsQuickbooksIntegrationIdReauthorize = (
    integrationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostIntegrationsQuickbooksIntegrationIdReauthorize200>(
      {url: `/api/v1/integrations/quickbooks/${integrationId}/reauthorize`, method: 'POST', signal
    },
      options);
    }
  


export const getPostIntegrationsQuickbooksIntegrationIdReauthorizeMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsQuickbooksIntegrationIdReauthorize>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsQuickbooksIntegrationIdReauthorize>>, TError,{integrationId: string}, TContext> => {

const mutationKey = ['postIntegrationsQuickbooksIntegrationIdReauthorize'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIntegrationsQuickbooksIntegrationIdReauthorize>>, {integrationId: string}> = (props) => {
          const {integrationId} = props ?? {};

          return  postIntegrationsQuickbooksIntegrationIdReauthorize(integrationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostIntegrationsQuickbooksIntegrationIdReauthorizeMutationResult = NonNullable<Awaited<ReturnType<typeof postIntegrationsQuickbooksIntegrationIdReauthorize>>>
    
    export type PostIntegrationsQuickbooksIntegrationIdReauthorizeMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Reauthorize QuickBooks integration
 */
export const usePostIntegrationsQuickbooksIntegrationIdReauthorize = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsQuickbooksIntegrationIdReauthorize>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postIntegrationsQuickbooksIntegrationIdReauthorize>>,
        TError,
        {integrationId: string},
        TContext
      > => {

      const mutationOptions = getPostIntegrationsQuickbooksIntegrationIdReauthorizeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get list of user's HubSpot integrations
 * @summary List HubSpot integrations
 */
export const getIntegrationsHubspot = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetIntegrationsHubspot200>(
      {url: `/api/v1/integrations/hubspot`, method: 'GET', signal
    },
      options);
    }
  



export const getGetIntegrationsHubspotQueryKey = () => {
    return [
    `/api/v1/integrations/hubspot`
    ] as const;
    }

    
export const getGetIntegrationsHubspotQueryOptions = <TData = Awaited<ReturnType<typeof getIntegrationsHubspot>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsHubspot>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntegrationsHubspotQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntegrationsHubspot>>> = ({ signal }) => getIntegrationsHubspot(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsHubspot>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIntegrationsHubspotQueryResult = NonNullable<Awaited<ReturnType<typeof getIntegrationsHubspot>>>
export type GetIntegrationsHubspotQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetIntegrationsHubspot<TData = Awaited<ReturnType<typeof getIntegrationsHubspot>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsHubspot>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsHubspot>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsHubspot>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsHubspot<TData = Awaited<ReturnType<typeof getIntegrationsHubspot>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsHubspot>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsHubspot>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsHubspot>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsHubspot<TData = Awaited<ReturnType<typeof getIntegrationsHubspot>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsHubspot>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List HubSpot integrations
 */

export function useGetIntegrationsHubspot<TData = Awaited<ReturnType<typeof getIntegrationsHubspot>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsHubspot>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIntegrationsHubspotQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create integration with OAuth app credentials and start OAuth flow
 * @summary Create new HubSpot integration
 */
export const postIntegrationsHubspot = (
    postIntegrationsHubspotBody: PostIntegrationsHubspotBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostIntegrationsHubspot200>(
      {url: `/api/v1/integrations/hubspot`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postIntegrationsHubspotBody, signal
    },
      options);
    }
  


export const getPostIntegrationsHubspotMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsHubspot>>, TError,{data: PostIntegrationsHubspotBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsHubspot>>, TError,{data: PostIntegrationsHubspotBody}, TContext> => {

const mutationKey = ['postIntegrationsHubspot'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIntegrationsHubspot>>, {data: PostIntegrationsHubspotBody}> = (props) => {
          const {data} = props ?? {};

          return  postIntegrationsHubspot(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostIntegrationsHubspotMutationResult = NonNullable<Awaited<ReturnType<typeof postIntegrationsHubspot>>>
    export type PostIntegrationsHubspotMutationBody = PostIntegrationsHubspotBody
    export type PostIntegrationsHubspotMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Create new HubSpot integration
 */
export const usePostIntegrationsHubspot = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsHubspot>>, TError,{data: PostIntegrationsHubspotBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postIntegrationsHubspot>>,
        TError,
        {data: PostIntegrationsHubspotBody},
        TContext
      > => {

      const mutationOptions = getPostIntegrationsHubspotMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get details of a specific HubSpot integration
 * @summary Get HubSpot integration details
 */
export const getIntegrationsHubspotIntegrationId = (
    integrationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<HubSpotIntegration>(
      {url: `/api/v1/integrations/hubspot/${integrationId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetIntegrationsHubspotIntegrationIdQueryKey = (integrationId?: string,) => {
    return [
    `/api/v1/integrations/hubspot/${integrationId}`
    ] as const;
    }

    
export const getGetIntegrationsHubspotIntegrationIdQueryOptions = <TData = Awaited<ReturnType<typeof getIntegrationsHubspotIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsHubspotIntegrationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntegrationsHubspotIntegrationIdQueryKey(integrationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntegrationsHubspotIntegrationId>>> = ({ signal }) => getIntegrationsHubspotIntegrationId(integrationId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(integrationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsHubspotIntegrationId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIntegrationsHubspotIntegrationIdQueryResult = NonNullable<Awaited<ReturnType<typeof getIntegrationsHubspotIntegrationId>>>
export type GetIntegrationsHubspotIntegrationIdQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetIntegrationsHubspotIntegrationId<TData = Awaited<ReturnType<typeof getIntegrationsHubspotIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsHubspotIntegrationId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsHubspotIntegrationId>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsHubspotIntegrationId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsHubspotIntegrationId<TData = Awaited<ReturnType<typeof getIntegrationsHubspotIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsHubspotIntegrationId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsHubspotIntegrationId>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsHubspotIntegrationId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsHubspotIntegrationId<TData = Awaited<ReturnType<typeof getIntegrationsHubspotIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsHubspotIntegrationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get HubSpot integration details
 */

export function useGetIntegrationsHubspotIntegrationId<TData = Awaited<ReturnType<typeof getIntegrationsHubspotIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsHubspotIntegrationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIntegrationsHubspotIntegrationIdQueryOptions(integrationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update HubSpot integration settings
 * @summary Update HubSpot integration
 */
export const putIntegrationsHubspotIntegrationId = (
    integrationId: string,
    putIntegrationsHubspotIntegrationIdBody: PutIntegrationsHubspotIntegrationIdBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<HubSpotIntegration>(
      {url: `/api/v1/integrations/hubspot/${integrationId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putIntegrationsHubspotIntegrationIdBody
    },
      options);
    }
  


export const getPutIntegrationsHubspotIntegrationIdMutationOptions = <TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putIntegrationsHubspotIntegrationId>>, TError,{integrationId: string;data: PutIntegrationsHubspotIntegrationIdBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putIntegrationsHubspotIntegrationId>>, TError,{integrationId: string;data: PutIntegrationsHubspotIntegrationIdBody}, TContext> => {

const mutationKey = ['putIntegrationsHubspotIntegrationId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putIntegrationsHubspotIntegrationId>>, {integrationId: string;data: PutIntegrationsHubspotIntegrationIdBody}> = (props) => {
          const {integrationId,data} = props ?? {};

          return  putIntegrationsHubspotIntegrationId(integrationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutIntegrationsHubspotIntegrationIdMutationResult = NonNullable<Awaited<ReturnType<typeof putIntegrationsHubspotIntegrationId>>>
    export type PutIntegrationsHubspotIntegrationIdMutationBody = PutIntegrationsHubspotIntegrationIdBody
    export type PutIntegrationsHubspotIntegrationIdMutationError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Update HubSpot integration
 */
export const usePutIntegrationsHubspotIntegrationId = <TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putIntegrationsHubspotIntegrationId>>, TError,{integrationId: string;data: PutIntegrationsHubspotIntegrationIdBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putIntegrationsHubspotIntegrationId>>,
        TError,
        {integrationId: string;data: PutIntegrationsHubspotIntegrationIdBody},
        TContext
      > => {

      const mutationOptions = getPutIntegrationsHubspotIntegrationIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Revoke HubSpot access and delete integration
 * @summary Delete HubSpot integration
 */
export const deleteIntegrationsHubspotIntegrationId = (
    integrationId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<DeleteIntegrationsHubspotIntegrationId200>(
      {url: `/api/v1/integrations/hubspot/${integrationId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteIntegrationsHubspotIntegrationIdMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIntegrationsHubspotIntegrationId>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteIntegrationsHubspotIntegrationId>>, TError,{integrationId: string}, TContext> => {

const mutationKey = ['deleteIntegrationsHubspotIntegrationId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteIntegrationsHubspotIntegrationId>>, {integrationId: string}> = (props) => {
          const {integrationId} = props ?? {};

          return  deleteIntegrationsHubspotIntegrationId(integrationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteIntegrationsHubspotIntegrationIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteIntegrationsHubspotIntegrationId>>>
    
    export type DeleteIntegrationsHubspotIntegrationIdMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Delete HubSpot integration
 */
export const useDeleteIntegrationsHubspotIntegrationId = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIntegrationsHubspotIntegrationId>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteIntegrationsHubspotIntegrationId>>,
        TError,
        {integrationId: string},
        TContext
      > => {

      const mutationOptions = getDeleteIntegrationsHubspotIntegrationIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Handle OAuth callback from HubSpot
 * @summary HubSpot OAuth callback
 */
export const getIntegrationsHubspotCallback = (
    params: GetIntegrationsHubspotCallbackParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/v1/integrations/hubspot/callback`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetIntegrationsHubspotCallbackQueryKey = (params?: GetIntegrationsHubspotCallbackParams,) => {
    return [
    `/api/v1/integrations/hubspot/callback`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetIntegrationsHubspotCallbackQueryOptions = <TData = Awaited<ReturnType<typeof getIntegrationsHubspotCallback>>, TError = RequestErrorResponse | void>(params: GetIntegrationsHubspotCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsHubspotCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntegrationsHubspotCallbackQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntegrationsHubspotCallback>>> = ({ signal }) => getIntegrationsHubspotCallback(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsHubspotCallback>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIntegrationsHubspotCallbackQueryResult = NonNullable<Awaited<ReturnType<typeof getIntegrationsHubspotCallback>>>
export type GetIntegrationsHubspotCallbackQueryError = RequestErrorResponse | void


export function useGetIntegrationsHubspotCallback<TData = Awaited<ReturnType<typeof getIntegrationsHubspotCallback>>, TError = RequestErrorResponse | void>(
 params: GetIntegrationsHubspotCallbackParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsHubspotCallback>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsHubspotCallback>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsHubspotCallback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsHubspotCallback<TData = Awaited<ReturnType<typeof getIntegrationsHubspotCallback>>, TError = RequestErrorResponse | void>(
 params: GetIntegrationsHubspotCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsHubspotCallback>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsHubspotCallback>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsHubspotCallback>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsHubspotCallback<TData = Awaited<ReturnType<typeof getIntegrationsHubspotCallback>>, TError = RequestErrorResponse | void>(
 params: GetIntegrationsHubspotCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsHubspotCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary HubSpot OAuth callback
 */

export function useGetIntegrationsHubspotCallback<TData = Awaited<ReturnType<typeof getIntegrationsHubspotCallback>>, TError = RequestErrorResponse | void>(
 params: GetIntegrationsHubspotCallbackParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsHubspotCallback>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIntegrationsHubspotCallbackQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Test the connection to HubSpot and update status
 * @summary Test HubSpot connection
 */
export const postIntegrationsHubspotIntegrationIdTestConnection = (
    integrationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostIntegrationsHubspotIntegrationIdTestConnection200>(
      {url: `/api/v1/integrations/hubspot/${integrationId}/test-connection`, method: 'POST', signal
    },
      options);
    }
  


export const getPostIntegrationsHubspotIntegrationIdTestConnectionMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsHubspotIntegrationIdTestConnection>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsHubspotIntegrationIdTestConnection>>, TError,{integrationId: string}, TContext> => {

const mutationKey = ['postIntegrationsHubspotIntegrationIdTestConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIntegrationsHubspotIntegrationIdTestConnection>>, {integrationId: string}> = (props) => {
          const {integrationId} = props ?? {};

          return  postIntegrationsHubspotIntegrationIdTestConnection(integrationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostIntegrationsHubspotIntegrationIdTestConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof postIntegrationsHubspotIntegrationIdTestConnection>>>
    
    export type PostIntegrationsHubspotIntegrationIdTestConnectionMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Test HubSpot connection
 */
export const usePostIntegrationsHubspotIntegrationIdTestConnection = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsHubspotIntegrationIdTestConnection>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postIntegrationsHubspotIntegrationIdTestConnection>>,
        TError,
        {integrationId: string},
        TContext
      > => {

      const mutationOptions = getPostIntegrationsHubspotIntegrationIdTestConnectionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Manually trigger data synchronization with HubSpot
 * @summary Trigger HubSpot sync
 */
export const postIntegrationsHubspotIntegrationIdSync = (
    integrationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostIntegrationsHubspotIntegrationIdSync200>(
      {url: `/api/v1/integrations/hubspot/${integrationId}/sync`, method: 'POST', signal
    },
      options);
    }
  


export const getPostIntegrationsHubspotIntegrationIdSyncMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsHubspotIntegrationIdSync>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsHubspotIntegrationIdSync>>, TError,{integrationId: string}, TContext> => {

const mutationKey = ['postIntegrationsHubspotIntegrationIdSync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIntegrationsHubspotIntegrationIdSync>>, {integrationId: string}> = (props) => {
          const {integrationId} = props ?? {};

          return  postIntegrationsHubspotIntegrationIdSync(integrationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostIntegrationsHubspotIntegrationIdSyncMutationResult = NonNullable<Awaited<ReturnType<typeof postIntegrationsHubspotIntegrationIdSync>>>
    
    export type PostIntegrationsHubspotIntegrationIdSyncMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Trigger HubSpot sync
 */
export const usePostIntegrationsHubspotIntegrationIdSync = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsHubspotIntegrationIdSync>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postIntegrationsHubspotIntegrationIdSync>>,
        TError,
        {integrationId: string},
        TContext
      > => {

      const mutationOptions = getPostIntegrationsHubspotIntegrationIdSyncMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Receive webhook events from HubSpot
 * @summary HubSpot webhook
 */
export const postHubspotWebhook = (
    postHubspotWebhookBody: Blob,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/hubspot/webhook`, method: 'POST',
      headers: {'Content-Type': 'application/octet-stream', },
      data: postHubspotWebhookBody, signal
    },
      options);
    }
  


export const getPostHubspotWebhookMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postHubspotWebhook>>, TError,{data: Blob}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postHubspotWebhook>>, TError,{data: Blob}, TContext> => {

const mutationKey = ['postHubspotWebhook'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postHubspotWebhook>>, {data: Blob}> = (props) => {
          const {data} = props ?? {};

          return  postHubspotWebhook(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostHubspotWebhookMutationResult = NonNullable<Awaited<ReturnType<typeof postHubspotWebhook>>>
    export type PostHubspotWebhookMutationBody = Blob
    export type PostHubspotWebhookMutationError = void

    /**
 * @summary HubSpot webhook
 */
export const usePostHubspotWebhook = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postHubspotWebhook>>, TError,{data: Blob}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postHubspotWebhook>>,
        TError,
        {data: Blob},
        TContext
      > => {

      const mutationOptions = getPostHubspotWebhookMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get list of Mercury Bank integrations
 * @summary List Mercury Bank integrations
 */
export const getIntegrationsMercury = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetIntegrationsMercury200>(
      {url: `/api/v1/integrations/mercury`, method: 'GET', signal
    },
      options);
    }
  



export const getGetIntegrationsMercuryQueryKey = () => {
    return [
    `/api/v1/integrations/mercury`
    ] as const;
    }

    
export const getGetIntegrationsMercuryQueryOptions = <TData = Awaited<ReturnType<typeof getIntegrationsMercury>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsMercury>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntegrationsMercuryQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntegrationsMercury>>> = ({ signal }) => getIntegrationsMercury(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsMercury>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIntegrationsMercuryQueryResult = NonNullable<Awaited<ReturnType<typeof getIntegrationsMercury>>>
export type GetIntegrationsMercuryQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetIntegrationsMercury<TData = Awaited<ReturnType<typeof getIntegrationsMercury>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsMercury>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsMercury>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsMercury>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsMercury<TData = Awaited<ReturnType<typeof getIntegrationsMercury>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsMercury>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsMercury>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsMercury>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsMercury<TData = Awaited<ReturnType<typeof getIntegrationsMercury>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsMercury>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Mercury Bank integrations
 */

export function useGetIntegrationsMercury<TData = Awaited<ReturnType<typeof getIntegrationsMercury>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsMercury>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIntegrationsMercuryQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a new Mercury Bank integration with API token
 * @summary Create new Mercury Bank integration
 */
export const postIntegrationsMercury = (
    postIntegrationsMercuryBody: PostIntegrationsMercuryBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MercuryIntegration>(
      {url: `/api/v1/integrations/mercury`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postIntegrationsMercuryBody, signal
    },
      options);
    }
  


export const getPostIntegrationsMercuryMutationOptions = <TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsMercury>>, TError,{data: PostIntegrationsMercuryBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsMercury>>, TError,{data: PostIntegrationsMercuryBody}, TContext> => {

const mutationKey = ['postIntegrationsMercury'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIntegrationsMercury>>, {data: PostIntegrationsMercuryBody}> = (props) => {
          const {data} = props ?? {};

          return  postIntegrationsMercury(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostIntegrationsMercuryMutationResult = NonNullable<Awaited<ReturnType<typeof postIntegrationsMercury>>>
    export type PostIntegrationsMercuryMutationBody = PostIntegrationsMercuryBody
    export type PostIntegrationsMercuryMutationError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Create new Mercury Bank integration
 */
export const usePostIntegrationsMercury = <TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsMercury>>, TError,{data: PostIntegrationsMercuryBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postIntegrationsMercury>>,
        TError,
        {data: PostIntegrationsMercuryBody},
        TContext
      > => {

      const mutationOptions = getPostIntegrationsMercuryMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get detailed information about a specific Mercury Bank integration
 * @summary Get Mercury Bank integration details
 */
export const getIntegrationsMercuryIntegrationId = (
    integrationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MercuryIntegration>(
      {url: `/api/v1/integrations/mercury/${integrationId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetIntegrationsMercuryIntegrationIdQueryKey = (integrationId?: string,) => {
    return [
    `/api/v1/integrations/mercury/${integrationId}`
    ] as const;
    }

    
export const getGetIntegrationsMercuryIntegrationIdQueryOptions = <TData = Awaited<ReturnType<typeof getIntegrationsMercuryIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsMercuryIntegrationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntegrationsMercuryIntegrationIdQueryKey(integrationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntegrationsMercuryIntegrationId>>> = ({ signal }) => getIntegrationsMercuryIntegrationId(integrationId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(integrationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsMercuryIntegrationId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIntegrationsMercuryIntegrationIdQueryResult = NonNullable<Awaited<ReturnType<typeof getIntegrationsMercuryIntegrationId>>>
export type GetIntegrationsMercuryIntegrationIdQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetIntegrationsMercuryIntegrationId<TData = Awaited<ReturnType<typeof getIntegrationsMercuryIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsMercuryIntegrationId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsMercuryIntegrationId>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsMercuryIntegrationId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsMercuryIntegrationId<TData = Awaited<ReturnType<typeof getIntegrationsMercuryIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsMercuryIntegrationId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsMercuryIntegrationId>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsMercuryIntegrationId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsMercuryIntegrationId<TData = Awaited<ReturnType<typeof getIntegrationsMercuryIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsMercuryIntegrationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Mercury Bank integration details
 */

export function useGetIntegrationsMercuryIntegrationId<TData = Awaited<ReturnType<typeof getIntegrationsMercuryIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsMercuryIntegrationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIntegrationsMercuryIntegrationIdQueryOptions(integrationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update Mercury Bank integration settings
 * @summary Update Mercury Bank integration
 */
export const putIntegrationsMercuryIntegrationId = (
    integrationId: string,
    putIntegrationsMercuryIntegrationIdBody: PutIntegrationsMercuryIntegrationIdBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<MercuryIntegration>(
      {url: `/api/v1/integrations/mercury/${integrationId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putIntegrationsMercuryIntegrationIdBody
    },
      options);
    }
  


export const getPutIntegrationsMercuryIntegrationIdMutationOptions = <TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putIntegrationsMercuryIntegrationId>>, TError,{integrationId: string;data: PutIntegrationsMercuryIntegrationIdBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putIntegrationsMercuryIntegrationId>>, TError,{integrationId: string;data: PutIntegrationsMercuryIntegrationIdBody}, TContext> => {

const mutationKey = ['putIntegrationsMercuryIntegrationId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putIntegrationsMercuryIntegrationId>>, {integrationId: string;data: PutIntegrationsMercuryIntegrationIdBody}> = (props) => {
          const {integrationId,data} = props ?? {};

          return  putIntegrationsMercuryIntegrationId(integrationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutIntegrationsMercuryIntegrationIdMutationResult = NonNullable<Awaited<ReturnType<typeof putIntegrationsMercuryIntegrationId>>>
    export type PutIntegrationsMercuryIntegrationIdMutationBody = PutIntegrationsMercuryIntegrationIdBody
    export type PutIntegrationsMercuryIntegrationIdMutationError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Update Mercury Bank integration
 */
export const usePutIntegrationsMercuryIntegrationId = <TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putIntegrationsMercuryIntegrationId>>, TError,{integrationId: string;data: PutIntegrationsMercuryIntegrationIdBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putIntegrationsMercuryIntegrationId>>,
        TError,
        {integrationId: string;data: PutIntegrationsMercuryIntegrationIdBody},
        TContext
      > => {

      const mutationOptions = getPutIntegrationsMercuryIntegrationIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Soft delete a Mercury Bank integration
 * @summary Delete Mercury Bank integration
 */
export const deleteIntegrationsMercuryIntegrationId = (
    integrationId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<DeleteIntegrationsMercuryIntegrationId200>(
      {url: `/api/v1/integrations/mercury/${integrationId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteIntegrationsMercuryIntegrationIdMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIntegrationsMercuryIntegrationId>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteIntegrationsMercuryIntegrationId>>, TError,{integrationId: string}, TContext> => {

const mutationKey = ['deleteIntegrationsMercuryIntegrationId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteIntegrationsMercuryIntegrationId>>, {integrationId: string}> = (props) => {
          const {integrationId} = props ?? {};

          return  deleteIntegrationsMercuryIntegrationId(integrationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteIntegrationsMercuryIntegrationIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteIntegrationsMercuryIntegrationId>>>
    
    export type DeleteIntegrationsMercuryIntegrationIdMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Delete Mercury Bank integration
 */
export const useDeleteIntegrationsMercuryIntegrationId = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIntegrationsMercuryIntegrationId>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteIntegrationsMercuryIntegrationId>>,
        TError,
        {integrationId: string},
        TContext
      > => {

      const mutationOptions = getDeleteIntegrationsMercuryIntegrationIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Test the connection to Mercury Bank API and update connection status
 * @summary Test Mercury Bank connection
 */
export const postIntegrationsMercuryIntegrationIdTestConnection = (
    integrationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostIntegrationsMercuryIntegrationIdTestConnection200>(
      {url: `/api/v1/integrations/mercury/${integrationId}/test-connection`, method: 'POST', signal
    },
      options);
    }
  


export const getPostIntegrationsMercuryIntegrationIdTestConnectionMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsMercuryIntegrationIdTestConnection>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsMercuryIntegrationIdTestConnection>>, TError,{integrationId: string}, TContext> => {

const mutationKey = ['postIntegrationsMercuryIntegrationIdTestConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIntegrationsMercuryIntegrationIdTestConnection>>, {integrationId: string}> = (props) => {
          const {integrationId} = props ?? {};

          return  postIntegrationsMercuryIntegrationIdTestConnection(integrationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostIntegrationsMercuryIntegrationIdTestConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof postIntegrationsMercuryIntegrationIdTestConnection>>>
    
    export type PostIntegrationsMercuryIntegrationIdTestConnectionMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Test Mercury Bank connection
 */
export const usePostIntegrationsMercuryIntegrationIdTestConnection = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsMercuryIntegrationIdTestConnection>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postIntegrationsMercuryIntegrationIdTestConnection>>,
        TError,
        {integrationId: string},
        TContext
      > => {

      const mutationOptions = getPostIntegrationsMercuryIntegrationIdTestConnectionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Manually trigger data synchronization with Mercury Bank
 * @summary Trigger Mercury Bank sync
 */
export const postIntegrationsMercuryIntegrationIdSync = (
    integrationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostIntegrationsMercuryIntegrationIdSync200>(
      {url: `/api/v1/integrations/mercury/${integrationId}/sync`, method: 'POST', signal
    },
      options);
    }
  


export const getPostIntegrationsMercuryIntegrationIdSyncMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void | ConflictErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsMercuryIntegrationIdSync>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsMercuryIntegrationIdSync>>, TError,{integrationId: string}, TContext> => {

const mutationKey = ['postIntegrationsMercuryIntegrationIdSync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIntegrationsMercuryIntegrationIdSync>>, {integrationId: string}> = (props) => {
          const {integrationId} = props ?? {};

          return  postIntegrationsMercuryIntegrationIdSync(integrationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostIntegrationsMercuryIntegrationIdSyncMutationResult = NonNullable<Awaited<ReturnType<typeof postIntegrationsMercuryIntegrationIdSync>>>
    
    export type PostIntegrationsMercuryIntegrationIdSyncMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void | ConflictErrorResponse

    /**
 * @summary Trigger Mercury Bank sync
 */
export const usePostIntegrationsMercuryIntegrationIdSync = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void | ConflictErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsMercuryIntegrationIdSync>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postIntegrationsMercuryIntegrationIdSync>>,
        TError,
        {integrationId: string},
        TContext
      > => {

      const mutationOptions = getPostIntegrationsMercuryIntegrationIdSyncMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Clears a stuck sync-in-progress flag on a Mercury integration. Use this if a sync process crashed without releasing its lock.
 * @summary Clear Mercury sync lock
 */
export const postIntegrationsMercuryIntegrationIdClearSync = (
    integrationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostIntegrationsMercuryIntegrationIdClearSync200>(
      {url: `/api/v1/integrations/mercury/${integrationId}/clear-sync`, method: 'POST', signal
    },
      options);
    }
  


export const getPostIntegrationsMercuryIntegrationIdClearSyncMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsMercuryIntegrationIdClearSync>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsMercuryIntegrationIdClearSync>>, TError,{integrationId: string}, TContext> => {

const mutationKey = ['postIntegrationsMercuryIntegrationIdClearSync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIntegrationsMercuryIntegrationIdClearSync>>, {integrationId: string}> = (props) => {
          const {integrationId} = props ?? {};

          return  postIntegrationsMercuryIntegrationIdClearSync(integrationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostIntegrationsMercuryIntegrationIdClearSyncMutationResult = NonNullable<Awaited<ReturnType<typeof postIntegrationsMercuryIntegrationIdClearSync>>>
    
    export type PostIntegrationsMercuryIntegrationIdClearSyncMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Clear Mercury sync lock
 */
export const usePostIntegrationsMercuryIntegrationIdClearSync = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsMercuryIntegrationIdClearSync>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postIntegrationsMercuryIntegrationIdClearSync>>,
        TError,
        {integrationId: string},
        TContext
      > => {

      const mutationOptions = getPostIntegrationsMercuryIntegrationIdClearSyncMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Fetch accounts from the Mercury Bank API for this integration
 * @summary List Mercury Bank accounts
 */
export const getIntegrationsMercuryIntegrationIdAccounts = (
    integrationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetIntegrationsMercuryIntegrationIdAccounts200>(
      {url: `/api/v1/integrations/mercury/${integrationId}/accounts`, method: 'GET', signal
    },
      options);
    }
  



export const getGetIntegrationsMercuryIntegrationIdAccountsQueryKey = (integrationId?: string,) => {
    return [
    `/api/v1/integrations/mercury/${integrationId}/accounts`
    ] as const;
    }

    
export const getGetIntegrationsMercuryIntegrationIdAccountsQueryOptions = <TData = Awaited<ReturnType<typeof getIntegrationsMercuryIntegrationIdAccounts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsMercuryIntegrationIdAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntegrationsMercuryIntegrationIdAccountsQueryKey(integrationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntegrationsMercuryIntegrationIdAccounts>>> = ({ signal }) => getIntegrationsMercuryIntegrationIdAccounts(integrationId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(integrationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsMercuryIntegrationIdAccounts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIntegrationsMercuryIntegrationIdAccountsQueryResult = NonNullable<Awaited<ReturnType<typeof getIntegrationsMercuryIntegrationIdAccounts>>>
export type GetIntegrationsMercuryIntegrationIdAccountsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetIntegrationsMercuryIntegrationIdAccounts<TData = Awaited<ReturnType<typeof getIntegrationsMercuryIntegrationIdAccounts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsMercuryIntegrationIdAccounts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsMercuryIntegrationIdAccounts>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsMercuryIntegrationIdAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsMercuryIntegrationIdAccounts<TData = Awaited<ReturnType<typeof getIntegrationsMercuryIntegrationIdAccounts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsMercuryIntegrationIdAccounts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsMercuryIntegrationIdAccounts>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsMercuryIntegrationIdAccounts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsMercuryIntegrationIdAccounts<TData = Awaited<ReturnType<typeof getIntegrationsMercuryIntegrationIdAccounts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsMercuryIntegrationIdAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Mercury Bank accounts
 */

export function useGetIntegrationsMercuryIntegrationIdAccounts<TData = Awaited<ReturnType<typeof getIntegrationsMercuryIntegrationIdAccounts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsMercuryIntegrationIdAccounts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIntegrationsMercuryIntegrationIdAccountsQueryOptions(integrationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get list of USPS address validation integrations
 * @summary List USPS integrations
 */
export const getIntegrationsUsps = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetIntegrationsUsps200>(
      {url: `/api/v1/integrations/usps`, method: 'GET', signal
    },
      options);
    }
  



export const getGetIntegrationsUspsQueryKey = () => {
    return [
    `/api/v1/integrations/usps`
    ] as const;
    }

    
export const getGetIntegrationsUspsQueryOptions = <TData = Awaited<ReturnType<typeof getIntegrationsUsps>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsUsps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntegrationsUspsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntegrationsUsps>>> = ({ signal }) => getIntegrationsUsps(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsUsps>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIntegrationsUspsQueryResult = NonNullable<Awaited<ReturnType<typeof getIntegrationsUsps>>>
export type GetIntegrationsUspsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetIntegrationsUsps<TData = Awaited<ReturnType<typeof getIntegrationsUsps>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsUsps>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsUsps>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsUsps>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsUsps<TData = Awaited<ReturnType<typeof getIntegrationsUsps>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsUsps>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsUsps>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsUsps>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsUsps<TData = Awaited<ReturnType<typeof getIntegrationsUsps>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsUsps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List USPS integrations
 */

export function useGetIntegrationsUsps<TData = Awaited<ReturnType<typeof getIntegrationsUsps>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsUsps>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIntegrationsUspsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a new USPS integration with client credentials
 * @summary Create new USPS integration
 */
export const postIntegrationsUsps = (
    postIntegrationsUspsBody: PostIntegrationsUspsBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<USPSIntegration>(
      {url: `/api/v1/integrations/usps`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postIntegrationsUspsBody, signal
    },
      options);
    }
  


export const getPostIntegrationsUspsMutationOptions = <TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsUsps>>, TError,{data: PostIntegrationsUspsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsUsps>>, TError,{data: PostIntegrationsUspsBody}, TContext> => {

const mutationKey = ['postIntegrationsUsps'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIntegrationsUsps>>, {data: PostIntegrationsUspsBody}> = (props) => {
          const {data} = props ?? {};

          return  postIntegrationsUsps(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostIntegrationsUspsMutationResult = NonNullable<Awaited<ReturnType<typeof postIntegrationsUsps>>>
    export type PostIntegrationsUspsMutationBody = PostIntegrationsUspsBody
    export type PostIntegrationsUspsMutationError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Create new USPS integration
 */
export const usePostIntegrationsUsps = <TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsUsps>>, TError,{data: PostIntegrationsUspsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postIntegrationsUsps>>,
        TError,
        {data: PostIntegrationsUspsBody},
        TContext
      > => {

      const mutationOptions = getPostIntegrationsUspsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get detailed information about a specific USPS integration
 * @summary Get USPS integration details
 */
export const getIntegrationsUspsIntegrationId = (
    integrationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<USPSIntegration>(
      {url: `/api/v1/integrations/usps/${integrationId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetIntegrationsUspsIntegrationIdQueryKey = (integrationId?: string,) => {
    return [
    `/api/v1/integrations/usps/${integrationId}`
    ] as const;
    }

    
export const getGetIntegrationsUspsIntegrationIdQueryOptions = <TData = Awaited<ReturnType<typeof getIntegrationsUspsIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsUspsIntegrationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntegrationsUspsIntegrationIdQueryKey(integrationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntegrationsUspsIntegrationId>>> = ({ signal }) => getIntegrationsUspsIntegrationId(integrationId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(integrationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsUspsIntegrationId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIntegrationsUspsIntegrationIdQueryResult = NonNullable<Awaited<ReturnType<typeof getIntegrationsUspsIntegrationId>>>
export type GetIntegrationsUspsIntegrationIdQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetIntegrationsUspsIntegrationId<TData = Awaited<ReturnType<typeof getIntegrationsUspsIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsUspsIntegrationId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsUspsIntegrationId>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsUspsIntegrationId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsUspsIntegrationId<TData = Awaited<ReturnType<typeof getIntegrationsUspsIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsUspsIntegrationId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsUspsIntegrationId>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsUspsIntegrationId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsUspsIntegrationId<TData = Awaited<ReturnType<typeof getIntegrationsUspsIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsUspsIntegrationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get USPS integration details
 */

export function useGetIntegrationsUspsIntegrationId<TData = Awaited<ReturnType<typeof getIntegrationsUspsIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsUspsIntegrationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIntegrationsUspsIntegrationIdQueryOptions(integrationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update USPS integration settings
 * @summary Update USPS integration
 */
export const putIntegrationsUspsIntegrationId = (
    integrationId: string,
    putIntegrationsUspsIntegrationIdBody: PutIntegrationsUspsIntegrationIdBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<USPSIntegration>(
      {url: `/api/v1/integrations/usps/${integrationId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putIntegrationsUspsIntegrationIdBody
    },
      options);
    }
  


export const getPutIntegrationsUspsIntegrationIdMutationOptions = <TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putIntegrationsUspsIntegrationId>>, TError,{integrationId: string;data: PutIntegrationsUspsIntegrationIdBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putIntegrationsUspsIntegrationId>>, TError,{integrationId: string;data: PutIntegrationsUspsIntegrationIdBody}, TContext> => {

const mutationKey = ['putIntegrationsUspsIntegrationId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putIntegrationsUspsIntegrationId>>, {integrationId: string;data: PutIntegrationsUspsIntegrationIdBody}> = (props) => {
          const {integrationId,data} = props ?? {};

          return  putIntegrationsUspsIntegrationId(integrationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutIntegrationsUspsIntegrationIdMutationResult = NonNullable<Awaited<ReturnType<typeof putIntegrationsUspsIntegrationId>>>
    export type PutIntegrationsUspsIntegrationIdMutationBody = PutIntegrationsUspsIntegrationIdBody
    export type PutIntegrationsUspsIntegrationIdMutationError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Update USPS integration
 */
export const usePutIntegrationsUspsIntegrationId = <TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putIntegrationsUspsIntegrationId>>, TError,{integrationId: string;data: PutIntegrationsUspsIntegrationIdBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putIntegrationsUspsIntegrationId>>,
        TError,
        {integrationId: string;data: PutIntegrationsUspsIntegrationIdBody},
        TContext
      > => {

      const mutationOptions = getPutIntegrationsUspsIntegrationIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Soft delete a USPS integration
 * @summary Delete USPS integration
 */
export const deleteIntegrationsUspsIntegrationId = (
    integrationId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<DeleteIntegrationsUspsIntegrationId200>(
      {url: `/api/v1/integrations/usps/${integrationId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteIntegrationsUspsIntegrationIdMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIntegrationsUspsIntegrationId>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteIntegrationsUspsIntegrationId>>, TError,{integrationId: string}, TContext> => {

const mutationKey = ['deleteIntegrationsUspsIntegrationId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteIntegrationsUspsIntegrationId>>, {integrationId: string}> = (props) => {
          const {integrationId} = props ?? {};

          return  deleteIntegrationsUspsIntegrationId(integrationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteIntegrationsUspsIntegrationIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteIntegrationsUspsIntegrationId>>>
    
    export type DeleteIntegrationsUspsIntegrationIdMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Delete USPS integration
 */
export const useDeleteIntegrationsUspsIntegrationId = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIntegrationsUspsIntegrationId>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteIntegrationsUspsIntegrationId>>,
        TError,
        {integrationId: string},
        TContext
      > => {

      const mutationOptions = getDeleteIntegrationsUspsIntegrationIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Test the connection to USPS API and update connection status
 * @summary Test USPS connection
 */
export const postIntegrationsUspsIntegrationIdTestConnection = (
    integrationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostIntegrationsUspsIntegrationIdTestConnection200>(
      {url: `/api/v1/integrations/usps/${integrationId}/test-connection`, method: 'POST', signal
    },
      options);
    }
  


export const getPostIntegrationsUspsIntegrationIdTestConnectionMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsUspsIntegrationIdTestConnection>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsUspsIntegrationIdTestConnection>>, TError,{integrationId: string}, TContext> => {

const mutationKey = ['postIntegrationsUspsIntegrationIdTestConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIntegrationsUspsIntegrationIdTestConnection>>, {integrationId: string}> = (props) => {
          const {integrationId} = props ?? {};

          return  postIntegrationsUspsIntegrationIdTestConnection(integrationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostIntegrationsUspsIntegrationIdTestConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof postIntegrationsUspsIntegrationIdTestConnection>>>
    
    export type PostIntegrationsUspsIntegrationIdTestConnectionMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Test USPS connection
 */
export const usePostIntegrationsUspsIntegrationIdTestConnection = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsUspsIntegrationIdTestConnection>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postIntegrationsUspsIntegrationIdTestConnection>>,
        TError,
        {integrationId: string},
        TContext
      > => {

      const mutationOptions = getPostIntegrationsUspsIntegrationIdTestConnectionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get list of Google Sheets integrations
 * @summary List Google Sheets integrations
 */
export const getIntegrationsGooglesheets = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetIntegrationsGooglesheets200>(
      {url: `/api/v1/integrations/googlesheets`, method: 'GET', signal
    },
      options);
    }
  



export const getGetIntegrationsGooglesheetsQueryKey = () => {
    return [
    `/api/v1/integrations/googlesheets`
    ] as const;
    }

    
export const getGetIntegrationsGooglesheetsQueryOptions = <TData = Awaited<ReturnType<typeof getIntegrationsGooglesheets>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsGooglesheets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntegrationsGooglesheetsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntegrationsGooglesheets>>> = ({ signal }) => getIntegrationsGooglesheets(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsGooglesheets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIntegrationsGooglesheetsQueryResult = NonNullable<Awaited<ReturnType<typeof getIntegrationsGooglesheets>>>
export type GetIntegrationsGooglesheetsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetIntegrationsGooglesheets<TData = Awaited<ReturnType<typeof getIntegrationsGooglesheets>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsGooglesheets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsGooglesheets>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsGooglesheets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsGooglesheets<TData = Awaited<ReturnType<typeof getIntegrationsGooglesheets>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsGooglesheets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsGooglesheets>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsGooglesheets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsGooglesheets<TData = Awaited<ReturnType<typeof getIntegrationsGooglesheets>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsGooglesheets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Google Sheets integrations
 */

export function useGetIntegrationsGooglesheets<TData = Awaited<ReturnType<typeof getIntegrationsGooglesheets>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsGooglesheets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIntegrationsGooglesheetsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a new Google Sheets integration with service account credentials
 * @summary Create new Google Sheets integration
 */
export const postIntegrationsGooglesheets = (
    postIntegrationsGooglesheetsBody: PostIntegrationsGooglesheetsBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GoogleSheetsIntegration>(
      {url: `/api/v1/integrations/googlesheets`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postIntegrationsGooglesheetsBody, signal
    },
      options);
    }
  


export const getPostIntegrationsGooglesheetsMutationOptions = <TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsGooglesheets>>, TError,{data: PostIntegrationsGooglesheetsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsGooglesheets>>, TError,{data: PostIntegrationsGooglesheetsBody}, TContext> => {

const mutationKey = ['postIntegrationsGooglesheets'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIntegrationsGooglesheets>>, {data: PostIntegrationsGooglesheetsBody}> = (props) => {
          const {data} = props ?? {};

          return  postIntegrationsGooglesheets(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostIntegrationsGooglesheetsMutationResult = NonNullable<Awaited<ReturnType<typeof postIntegrationsGooglesheets>>>
    export type PostIntegrationsGooglesheetsMutationBody = PostIntegrationsGooglesheetsBody
    export type PostIntegrationsGooglesheetsMutationError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Create new Google Sheets integration
 */
export const usePostIntegrationsGooglesheets = <TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsGooglesheets>>, TError,{data: PostIntegrationsGooglesheetsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postIntegrationsGooglesheets>>,
        TError,
        {data: PostIntegrationsGooglesheetsBody},
        TContext
      > => {

      const mutationOptions = getPostIntegrationsGooglesheetsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get detailed information about a specific Google Sheets integration
 * @summary Get Google Sheets integration details
 */
export const getIntegrationsGooglesheetsIntegrationId = (
    integrationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GoogleSheetsIntegration>(
      {url: `/api/v1/integrations/googlesheets/${integrationId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetIntegrationsGooglesheetsIntegrationIdQueryKey = (integrationId?: string,) => {
    return [
    `/api/v1/integrations/googlesheets/${integrationId}`
    ] as const;
    }

    
export const getGetIntegrationsGooglesheetsIntegrationIdQueryOptions = <TData = Awaited<ReturnType<typeof getIntegrationsGooglesheetsIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsGooglesheetsIntegrationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntegrationsGooglesheetsIntegrationIdQueryKey(integrationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntegrationsGooglesheetsIntegrationId>>> = ({ signal }) => getIntegrationsGooglesheetsIntegrationId(integrationId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(integrationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsGooglesheetsIntegrationId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIntegrationsGooglesheetsIntegrationIdQueryResult = NonNullable<Awaited<ReturnType<typeof getIntegrationsGooglesheetsIntegrationId>>>
export type GetIntegrationsGooglesheetsIntegrationIdQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetIntegrationsGooglesheetsIntegrationId<TData = Awaited<ReturnType<typeof getIntegrationsGooglesheetsIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsGooglesheetsIntegrationId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsGooglesheetsIntegrationId>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsGooglesheetsIntegrationId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsGooglesheetsIntegrationId<TData = Awaited<ReturnType<typeof getIntegrationsGooglesheetsIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsGooglesheetsIntegrationId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsGooglesheetsIntegrationId>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsGooglesheetsIntegrationId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsGooglesheetsIntegrationId<TData = Awaited<ReturnType<typeof getIntegrationsGooglesheetsIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsGooglesheetsIntegrationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Google Sheets integration details
 */

export function useGetIntegrationsGooglesheetsIntegrationId<TData = Awaited<ReturnType<typeof getIntegrationsGooglesheetsIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsGooglesheetsIntegrationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIntegrationsGooglesheetsIntegrationIdQueryOptions(integrationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update Google Sheets integration settings
 * @summary Update Google Sheets integration
 */
export const putIntegrationsGooglesheetsIntegrationId = (
    integrationId: string,
    putIntegrationsGooglesheetsIntegrationIdBody: PutIntegrationsGooglesheetsIntegrationIdBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<GoogleSheetsIntegration>(
      {url: `/api/v1/integrations/googlesheets/${integrationId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putIntegrationsGooglesheetsIntegrationIdBody
    },
      options);
    }
  


export const getPutIntegrationsGooglesheetsIntegrationIdMutationOptions = <TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putIntegrationsGooglesheetsIntegrationId>>, TError,{integrationId: string;data: PutIntegrationsGooglesheetsIntegrationIdBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putIntegrationsGooglesheetsIntegrationId>>, TError,{integrationId: string;data: PutIntegrationsGooglesheetsIntegrationIdBody}, TContext> => {

const mutationKey = ['putIntegrationsGooglesheetsIntegrationId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putIntegrationsGooglesheetsIntegrationId>>, {integrationId: string;data: PutIntegrationsGooglesheetsIntegrationIdBody}> = (props) => {
          const {integrationId,data} = props ?? {};

          return  putIntegrationsGooglesheetsIntegrationId(integrationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutIntegrationsGooglesheetsIntegrationIdMutationResult = NonNullable<Awaited<ReturnType<typeof putIntegrationsGooglesheetsIntegrationId>>>
    export type PutIntegrationsGooglesheetsIntegrationIdMutationBody = PutIntegrationsGooglesheetsIntegrationIdBody
    export type PutIntegrationsGooglesheetsIntegrationIdMutationError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Update Google Sheets integration
 */
export const usePutIntegrationsGooglesheetsIntegrationId = <TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putIntegrationsGooglesheetsIntegrationId>>, TError,{integrationId: string;data: PutIntegrationsGooglesheetsIntegrationIdBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putIntegrationsGooglesheetsIntegrationId>>,
        TError,
        {integrationId: string;data: PutIntegrationsGooglesheetsIntegrationIdBody},
        TContext
      > => {

      const mutationOptions = getPutIntegrationsGooglesheetsIntegrationIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Soft delete a Google Sheets integration
 * @summary Delete Google Sheets integration
 */
export const deleteIntegrationsGooglesheetsIntegrationId = (
    integrationId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<DeleteIntegrationsGooglesheetsIntegrationId200>(
      {url: `/api/v1/integrations/googlesheets/${integrationId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteIntegrationsGooglesheetsIntegrationIdMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIntegrationsGooglesheetsIntegrationId>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteIntegrationsGooglesheetsIntegrationId>>, TError,{integrationId: string}, TContext> => {

const mutationKey = ['deleteIntegrationsGooglesheetsIntegrationId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteIntegrationsGooglesheetsIntegrationId>>, {integrationId: string}> = (props) => {
          const {integrationId} = props ?? {};

          return  deleteIntegrationsGooglesheetsIntegrationId(integrationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteIntegrationsGooglesheetsIntegrationIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteIntegrationsGooglesheetsIntegrationId>>>
    
    export type DeleteIntegrationsGooglesheetsIntegrationIdMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Delete Google Sheets integration
 */
export const useDeleteIntegrationsGooglesheetsIntegrationId = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIntegrationsGooglesheetsIntegrationId>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteIntegrationsGooglesheetsIntegrationId>>,
        TError,
        {integrationId: string},
        TContext
      > => {

      const mutationOptions = getDeleteIntegrationsGooglesheetsIntegrationIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Test the connection to Google Sheets API and update connection status
 * @summary Test Google Sheets connection
 */
export const postIntegrationsGooglesheetsIntegrationIdTestConnection = (
    integrationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostIntegrationsGooglesheetsIntegrationIdTestConnection200>(
      {url: `/api/v1/integrations/googlesheets/${integrationId}/test-connection`, method: 'POST', signal
    },
      options);
    }
  


export const getPostIntegrationsGooglesheetsIntegrationIdTestConnectionMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsGooglesheetsIntegrationIdTestConnection>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsGooglesheetsIntegrationIdTestConnection>>, TError,{integrationId: string}, TContext> => {

const mutationKey = ['postIntegrationsGooglesheetsIntegrationIdTestConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIntegrationsGooglesheetsIntegrationIdTestConnection>>, {integrationId: string}> = (props) => {
          const {integrationId} = props ?? {};

          return  postIntegrationsGooglesheetsIntegrationIdTestConnection(integrationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostIntegrationsGooglesheetsIntegrationIdTestConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof postIntegrationsGooglesheetsIntegrationIdTestConnection>>>
    
    export type PostIntegrationsGooglesheetsIntegrationIdTestConnectionMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Test Google Sheets connection
 */
export const usePostIntegrationsGooglesheetsIntegrationIdTestConnection = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsGooglesheetsIntegrationIdTestConnection>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postIntegrationsGooglesheetsIntegrationIdTestConnection>>,
        TError,
        {integrationId: string},
        TContext
      > => {

      const mutationOptions = getPostIntegrationsGooglesheetsIntegrationIdTestConnectionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Manually trigger data synchronization with Google Sheets
 * @summary Trigger Google Sheets sync
 */
export const postIntegrationsGooglesheetsIntegrationIdSync = (
    integrationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostIntegrationsGooglesheetsIntegrationIdSync200>(
      {url: `/api/v1/integrations/googlesheets/${integrationId}/sync`, method: 'POST', signal
    },
      options);
    }
  


export const getPostIntegrationsGooglesheetsIntegrationIdSyncMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsGooglesheetsIntegrationIdSync>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsGooglesheetsIntegrationIdSync>>, TError,{integrationId: string}, TContext> => {

const mutationKey = ['postIntegrationsGooglesheetsIntegrationIdSync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIntegrationsGooglesheetsIntegrationIdSync>>, {integrationId: string}> = (props) => {
          const {integrationId} = props ?? {};

          return  postIntegrationsGooglesheetsIntegrationIdSync(integrationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostIntegrationsGooglesheetsIntegrationIdSyncMutationResult = NonNullable<Awaited<ReturnType<typeof postIntegrationsGooglesheetsIntegrationIdSync>>>
    
    export type PostIntegrationsGooglesheetsIntegrationIdSyncMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Trigger Google Sheets sync
 */
export const usePostIntegrationsGooglesheetsIntegrationIdSync = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsGooglesheetsIntegrationIdSync>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postIntegrationsGooglesheetsIntegrationIdSync>>,
        TError,
        {integrationId: string},
        TContext
      > => {

      const mutationOptions = getPostIntegrationsGooglesheetsIntegrationIdSyncMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get list of users with optional filtering. All allowed roles see the full directory.
 * @summary List users
 */
export const getUsers = (
    params?: GetUsersParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetUsers200>(
      {url: `/api/v1/users`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetUsersQueryKey = (params?: GetUsersParams,) => {
    return [
    `/api/v1/users`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetUsersQueryOptions = <TData = Awaited<ReturnType<typeof getUsers>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(params?: GetUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsers>>> = ({ signal }) => getUsers(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getUsers>>>
export type GetUsersQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetUsers<TData = Awaited<ReturnType<typeof getUsers>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: undefined |  GetUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsers>>,
          TError,
          Awaited<ReturnType<typeof getUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsers<TData = Awaited<ReturnType<typeof getUsers>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsers>>,
          TError,
          Awaited<ReturnType<typeof getUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsers<TData = Awaited<ReturnType<typeof getUsers>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List users
 */

export function useGetUsers<TData = Awaited<ReturnType<typeof getUsers>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a new user account (admin only)
 * @summary Create new user
 */
export const postUsers = (
    createUserRequest: CreateUserRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<User>(
      {url: `/api/v1/users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUserRequest, signal
    },
      options);
    }
  


export const getPostUsersMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUsers>>, TError,{data: CreateUserRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postUsers>>, TError,{data: CreateUserRequest}, TContext> => {

const mutationKey = ['postUsers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postUsers>>, {data: CreateUserRequest}> = (props) => {
          const {data} = props ?? {};

          return  postUsers(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostUsersMutationResult = NonNullable<Awaited<ReturnType<typeof postUsers>>>
    export type PostUsersMutationBody = CreateUserRequest
    export type PostUsersMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Create new user
 */
export const usePostUsers = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postUsers>>, TError,{data: CreateUserRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postUsers>>,
        TError,
        {data: CreateUserRequest},
        TContext
      > => {

      const mutationOptions = getPostUsersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieve specific user information
 * @summary Get user details
 */
export const getUsersId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<User>(
      {url: `/api/v1/users/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetUsersIdQueryKey = (id?: string,) => {
    return [
    `/api/v1/users/${id}`
    ] as const;
    }

    
export const getGetUsersIdQueryOptions = <TData = Awaited<ReturnType<typeof getUsersId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsersId>>> = ({ signal }) => getUsersId(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUsersId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUsersIdQueryResult = NonNullable<Awaited<ReturnType<typeof getUsersId>>>
export type GetUsersIdQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse


export function useGetUsersId<TData = Awaited<ReturnType<typeof getUsersId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersId>>,
          TError,
          Awaited<ReturnType<typeof getUsersId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersId<TData = Awaited<ReturnType<typeof getUsersId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersId>>,
          TError,
          Awaited<ReturnType<typeof getUsersId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersId<TData = Awaited<ReturnType<typeof getUsersId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get user details
 */

export function useGetUsersId<TData = Awaited<ReturnType<typeof getUsersId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUsersIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update user information
 * @summary Update user
 */
export const putUsersId = (
    id: string,
    updateUserRequest: UpdateUserRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<User>(
      {url: `/api/v1/users/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateUserRequest
    },
      options);
    }
  


export const getPutUsersIdMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUsersId>>, TError,{id: string;data: UpdateUserRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putUsersId>>, TError,{id: string;data: UpdateUserRequest}, TContext> => {

const mutationKey = ['putUsersId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUsersId>>, {id: string;data: UpdateUserRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  putUsersId(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUsersIdMutationResult = NonNullable<Awaited<ReturnType<typeof putUsersId>>>
    export type PutUsersIdMutationBody = UpdateUserRequest
    export type PutUsersIdMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse

    /**
 * @summary Update user
 */
export const usePutUsersId = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUsersId>>, TError,{id: string;data: UpdateUserRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putUsersId>>,
        TError,
        {id: string;data: UpdateUserRequest},
        TContext
      > => {

      const mutationOptions = getPutUsersIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Delete user account (admin only)
 * @summary Delete user
 */
export const deleteUsersId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/users/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteUsersIdMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUsersId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUsersId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteUsersId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUsersId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteUsersId(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUsersIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUsersId>>>
    
    export type DeleteUsersIdMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Delete user
 */
export const useDeleteUsersId = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUsersId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUsersId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteUsersIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update user preferences (table column orders, dashboard settings, etc.)
 * @summary Update user preferences
 */
export const putUsersIdPreferences = (
    id: string,
    userPreferences: UserPreferences,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<UserPreferences>(
      {url: `/api/v1/users/${id}/preferences`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userPreferences
    },
      options);
    }
  


export const getPutUsersIdPreferencesMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUsersIdPreferences>>, TError,{id: string;data: UserPreferences}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putUsersIdPreferences>>, TError,{id: string;data: UserPreferences}, TContext> => {

const mutationKey = ['putUsersIdPreferences'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUsersIdPreferences>>, {id: string;data: UserPreferences}> = (props) => {
          const {id,data} = props ?? {};

          return  putUsersIdPreferences(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUsersIdPreferencesMutationResult = NonNullable<Awaited<ReturnType<typeof putUsersIdPreferences>>>
    export type PutUsersIdPreferencesMutationBody = UserPreferences
    export type PutUsersIdPreferencesMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Update user preferences
 */
export const usePutUsersIdPreferences = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUsersIdPreferences>>, TError,{id: string;data: UserPreferences}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putUsersIdPreferences>>,
        TError,
        {id: string;data: UserPreferences},
        TContext
      > => {

      const mutationOptions = getPutUsersIdPreferencesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update a specific section of user preferences
 * @summary Update specific preference section
 */
export const patchUsersIdPreferencesSection = (
    id: string,
    section: PatchUsersIdPreferencesSectionParamsSection,
    patchUsersIdPreferencesSectionBody: PatchUsersIdPreferencesSectionBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<UserPreferences>(
      {url: `/api/v1/users/${id}/preferences/${section}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchUsersIdPreferencesSectionBody
    },
      options);
    }
  


export const getPatchUsersIdPreferencesSectionMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchUsersIdPreferencesSection>>, TError,{id: string;section: PatchUsersIdPreferencesSectionParamsSection;data: PatchUsersIdPreferencesSectionBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchUsersIdPreferencesSection>>, TError,{id: string;section: PatchUsersIdPreferencesSectionParamsSection;data: PatchUsersIdPreferencesSectionBody}, TContext> => {

const mutationKey = ['patchUsersIdPreferencesSection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchUsersIdPreferencesSection>>, {id: string;section: PatchUsersIdPreferencesSectionParamsSection;data: PatchUsersIdPreferencesSectionBody}> = (props) => {
          const {id,section,data} = props ?? {};

          return  patchUsersIdPreferencesSection(id,section,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchUsersIdPreferencesSectionMutationResult = NonNullable<Awaited<ReturnType<typeof patchUsersIdPreferencesSection>>>
    export type PatchUsersIdPreferencesSectionMutationBody = PatchUsersIdPreferencesSectionBody
    export type PatchUsersIdPreferencesSectionMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Update specific preference section
 */
export const usePatchUsersIdPreferencesSection = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchUsersIdPreferencesSection>>, TError,{id: string;section: PatchUsersIdPreferencesSectionParamsSection;data: PatchUsersIdPreferencesSectionBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchUsersIdPreferencesSection>>,
        TError,
        {id: string;section: PatchUsersIdPreferencesSectionParamsSection;data: PatchUsersIdPreferencesSectionBody},
        TContext
      > => {

      const mutationOptions = getPatchUsersIdPreferencesSectionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get list of unified customers with optional filtering
 * @summary List customers
 */
export const getCustomers = (
    params?: GetCustomersParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetCustomers200>(
      {url: `/api/v1/customers`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetCustomersQueryKey = (params?: GetCustomersParams,) => {
    return [
    `/api/v1/customers`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCustomersQueryOptions = <TData = Awaited<ReturnType<typeof getCustomers>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(params?: GetCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomers>>> = ({ signal }) => getCustomers(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomersQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomers>>>
export type GetCustomersQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetCustomers<TData = Awaited<ReturnType<typeof getCustomers>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: undefined |  GetCustomersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomers>>,
          TError,
          Awaited<ReturnType<typeof getCustomers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomers<TData = Awaited<ReturnType<typeof getCustomers>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomers>>,
          TError,
          Awaited<ReturnType<typeof getCustomers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomers<TData = Awaited<ReturnType<typeof getCustomers>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List customers
 */

export function useGetCustomers<TData = Awaited<ReturnType<typeof getCustomers>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetCustomersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomers>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a new internal customer with source
 * @summary Create internal customer
 */
export const postCustomers = (
    postCustomersBody: PostCustomersBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AddressValidationResponse | Customer>(
      {url: `/api/v1/customers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postCustomersBody, signal
    },
      options);
    }
  


export const getPostCustomersMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomers>>, TError,{data: PostCustomersBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCustomers>>, TError,{data: PostCustomersBody}, TContext> => {

const mutationKey = ['postCustomers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCustomers>>, {data: PostCustomersBody}> = (props) => {
          const {data} = props ?? {};

          return  postCustomers(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCustomersMutationResult = NonNullable<Awaited<ReturnType<typeof postCustomers>>>
    export type PostCustomersMutationBody = PostCustomersBody
    export type PostCustomersMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Create internal customer
 */
export const usePostCustomers = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomers>>, TError,{data: PostCustomersBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCustomers>>,
        TError,
        {data: PostCustomersBody},
        TContext
      > => {

      const mutationOptions = getPostCustomersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieve a specific customer with all sources and conflicts
 * @summary Get customer by ID
 */
export const getCustomersId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Customer>(
      {url: `/api/v1/customers/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetCustomersIdQueryKey = (id?: string,) => {
    return [
    `/api/v1/customers/${id}`
    ] as const;
    }

    
export const getGetCustomersIdQueryOptions = <TData = Awaited<ReturnType<typeof getCustomersId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomersId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomersIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomersId>>> = ({ signal }) => getCustomersId(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomersId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomersIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomersId>>>
export type GetCustomersIdQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse


export function useGetCustomersId<TData = Awaited<ReturnType<typeof getCustomersId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomersId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomersId>>,
          TError,
          Awaited<ReturnType<typeof getCustomersId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomersId<TData = Awaited<ReturnType<typeof getCustomersId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomersId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomersId>>,
          TError,
          Awaited<ReturnType<typeof getCustomersId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomersId<TData = Awaited<ReturnType<typeof getCustomersId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomersId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get customer by ID
 */

export function useGetCustomersId<TData = Awaited<ReturnType<typeof getCustomersId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomersId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomersIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Validate an address using USPS and return the canonicalized version
 * @summary Validate and canonicalize address
 */
export const postCustomersValidateAddress = (
    addressValidationRequest: AddressValidationRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<AddressValidationResponse>(
      {url: `/api/v1/customers/validate-address`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: addressValidationRequest, signal
    },
      options);
    }
  


export const getPostCustomersValidateAddressMutationOptions = <TError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomersValidateAddress>>, TError,{data: AddressValidationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCustomersValidateAddress>>, TError,{data: AddressValidationRequest}, TContext> => {

const mutationKey = ['postCustomersValidateAddress'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCustomersValidateAddress>>, {data: AddressValidationRequest}> = (props) => {
          const {data} = props ?? {};

          return  postCustomersValidateAddress(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCustomersValidateAddressMutationResult = NonNullable<Awaited<ReturnType<typeof postCustomersValidateAddress>>>
    export type PostCustomersValidateAddressMutationBody = AddressValidationRequest
    export type PostCustomersValidateAddressMutationError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Validate and canonicalize address
 */
export const usePostCustomersValidateAddress = <TError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCustomersValidateAddress>>, TError,{data: AddressValidationRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCustomersValidateAddress>>,
        TError,
        {data: AddressValidationRequest},
        TContext
      > => {

      const mutationOptions = getPostCustomersValidateAddressMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Delete an internal customer source (only internal sources can be deleted)
 * @summary Delete internal customer source
 */
export const deleteCustomersSourcesSourceId = (
    sourceId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<DeleteCustomersSourcesSourceId200>(
      {url: `/api/v1/customers/sources/${sourceId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteCustomersSourcesSourceIdMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomersSourcesSourceId>>, TError,{sourceId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCustomersSourcesSourceId>>, TError,{sourceId: string}, TContext> => {

const mutationKey = ['deleteCustomersSourcesSourceId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCustomersSourcesSourceId>>, {sourceId: string}> = (props) => {
          const {sourceId} = props ?? {};

          return  deleteCustomersSourcesSourceId(sourceId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCustomersSourcesSourceIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCustomersSourcesSourceId>>>
    
    export type DeleteCustomersSourcesSourceIdMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse | void

    /**
 * @summary Delete internal customer source
 */
export const useDeleteCustomersSourcesSourceId = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomersSourcesSourceId>>, TError,{sourceId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCustomersSourcesSourceId>>,
        TError,
        {sourceId: string},
        TContext
      > => {

      const mutationOptions = getDeleteCustomersSourcesSourceIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns distinct Program.Location values from customer's events
 * @summary Get unique program locations for customer
 */
export const getCustomersIdLocations = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetCustomersIdLocations200>(
      {url: `/api/v1/customers/${id}/locations`, method: 'GET', signal
    },
      options);
    }
  



export const getGetCustomersIdLocationsQueryKey = (id?: string,) => {
    return [
    `/api/v1/customers/${id}/locations`
    ] as const;
    }

    
export const getGetCustomersIdLocationsQueryOptions = <TData = Awaited<ReturnType<typeof getCustomersIdLocations>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomersIdLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomersIdLocationsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomersIdLocations>>> = ({ signal }) => getCustomersIdLocations(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomersIdLocations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomersIdLocationsQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomersIdLocations>>>
export type GetCustomersIdLocationsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse


export function useGetCustomersIdLocations<TData = Awaited<ReturnType<typeof getCustomersIdLocations>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomersIdLocations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomersIdLocations>>,
          TError,
          Awaited<ReturnType<typeof getCustomersIdLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomersIdLocations<TData = Awaited<ReturnType<typeof getCustomersIdLocations>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomersIdLocations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomersIdLocations>>,
          TError,
          Awaited<ReturnType<typeof getCustomersIdLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomersIdLocations<TData = Awaited<ReturnType<typeof getCustomersIdLocations>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomersIdLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get unique program locations for customer
 */

export function useGetCustomersIdLocations<TData = Awaited<ReturnType<typeof getCustomersIdLocations>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomersIdLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomersIdLocationsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get all Sling location mappings for a customer (default and location-specific overrides)
 * @summary Get Sling location mappings for customer
 */
export const getCustomersIdSlingLocationMappings = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetCustomersIdSlingLocationMappings200>(
      {url: `/api/v1/customers/${id}/sling-location-mappings`, method: 'GET', signal
    },
      options);
    }
  



export const getGetCustomersIdSlingLocationMappingsQueryKey = (id?: string,) => {
    return [
    `/api/v1/customers/${id}/sling-location-mappings`
    ] as const;
    }

    
export const getGetCustomersIdSlingLocationMappingsQueryOptions = <TData = Awaited<ReturnType<typeof getCustomersIdSlingLocationMappings>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomersIdSlingLocationMappings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomersIdSlingLocationMappingsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomersIdSlingLocationMappings>>> = ({ signal }) => getCustomersIdSlingLocationMappings(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomersIdSlingLocationMappings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCustomersIdSlingLocationMappingsQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomersIdSlingLocationMappings>>>
export type GetCustomersIdSlingLocationMappingsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse


export function useGetCustomersIdSlingLocationMappings<TData = Awaited<ReturnType<typeof getCustomersIdSlingLocationMappings>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomersIdSlingLocationMappings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomersIdSlingLocationMappings>>,
          TError,
          Awaited<ReturnType<typeof getCustomersIdSlingLocationMappings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomersIdSlingLocationMappings<TData = Awaited<ReturnType<typeof getCustomersIdSlingLocationMappings>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomersIdSlingLocationMappings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomersIdSlingLocationMappings>>,
          TError,
          Awaited<ReturnType<typeof getCustomersIdSlingLocationMappings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCustomersIdSlingLocationMappings<TData = Awaited<ReturnType<typeof getCustomersIdSlingLocationMappings>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomersIdSlingLocationMappings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Sling location mappings for customer
 */

export function useGetCustomersIdSlingLocationMappings<TData = Awaited<ReturnType<typeof getCustomersIdSlingLocationMappings>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomersIdSlingLocationMappings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCustomersIdSlingLocationMappingsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get list of all Sling locations with pagination and sorting
 * @summary List Sling locations
 */
export const getSlingLocations = (
    params?: GetSlingLocationsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetSlingLocations200>(
      {url: `/api/v1/sling/locations`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetSlingLocationsQueryKey = (params?: GetSlingLocationsParams,) => {
    return [
    `/api/v1/sling/locations`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetSlingLocationsQueryOptions = <TData = Awaited<ReturnType<typeof getSlingLocations>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(params?: GetSlingLocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSlingLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSlingLocationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSlingLocations>>> = ({ signal }) => getSlingLocations(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSlingLocations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSlingLocationsQueryResult = NonNullable<Awaited<ReturnType<typeof getSlingLocations>>>
export type GetSlingLocationsQueryError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetSlingLocations<TData = Awaited<ReturnType<typeof getSlingLocations>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: undefined |  GetSlingLocationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSlingLocations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSlingLocations>>,
          TError,
          Awaited<ReturnType<typeof getSlingLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSlingLocations<TData = Awaited<ReturnType<typeof getSlingLocations>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetSlingLocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSlingLocations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSlingLocations>>,
          TError,
          Awaited<ReturnType<typeof getSlingLocations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSlingLocations<TData = Awaited<ReturnType<typeof getSlingLocations>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetSlingLocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSlingLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Sling locations
 */

export function useGetSlingLocations<TData = Awaited<ReturnType<typeof getSlingLocations>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetSlingLocationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSlingLocations>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSlingLocationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get details for a specific Sling location by source ID and location ID
 * @summary Get a single Sling location
 */
export const getSlingLocationsSrcIdId = (
    srcId: string,
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SlingLocation>(
      {url: `/api/v1/sling/locations/${srcId}/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetSlingLocationsSrcIdIdQueryKey = (srcId?: string,
    id?: number,) => {
    return [
    `/api/v1/sling/locations/${srcId}/${id}`
    ] as const;
    }

    
export const getGetSlingLocationsSrcIdIdQueryOptions = <TData = Awaited<ReturnType<typeof getSlingLocationsSrcIdId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(srcId: string,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSlingLocationsSrcIdId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSlingLocationsSrcIdIdQueryKey(srcId,id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSlingLocationsSrcIdId>>> = ({ signal }) => getSlingLocationsSrcIdId(srcId,id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(srcId && id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSlingLocationsSrcIdId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSlingLocationsSrcIdIdQueryResult = NonNullable<Awaited<ReturnType<typeof getSlingLocationsSrcIdId>>>
export type GetSlingLocationsSrcIdIdQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse


export function useGetSlingLocationsSrcIdId<TData = Awaited<ReturnType<typeof getSlingLocationsSrcIdId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 srcId: string,
    id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSlingLocationsSrcIdId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSlingLocationsSrcIdId>>,
          TError,
          Awaited<ReturnType<typeof getSlingLocationsSrcIdId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSlingLocationsSrcIdId<TData = Awaited<ReturnType<typeof getSlingLocationsSrcIdId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 srcId: string,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSlingLocationsSrcIdId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSlingLocationsSrcIdId>>,
          TError,
          Awaited<ReturnType<typeof getSlingLocationsSrcIdId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSlingLocationsSrcIdId<TData = Awaited<ReturnType<typeof getSlingLocationsSrcIdId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 srcId: string,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSlingLocationsSrcIdId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a single Sling location
 */

export function useGetSlingLocationsSrcIdId<TData = Awaited<ReturnType<typeof getSlingLocationsSrcIdId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 srcId: string,
    id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSlingLocationsSrcIdId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSlingLocationsSrcIdIdQueryOptions(srcId,id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get list of Sling shifts with pagination, sorting, and filtering
 * @summary List Sling shifts
 */
export const getSlingShifts = (
    params?: GetSlingShiftsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetSlingShifts200>(
      {url: `/api/v1/sling/shifts`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetSlingShiftsQueryKey = (params?: GetSlingShiftsParams,) => {
    return [
    `/api/v1/sling/shifts`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetSlingShiftsQueryOptions = <TData = Awaited<ReturnType<typeof getSlingShifts>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(params?: GetSlingShiftsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSlingShifts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSlingShiftsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSlingShifts>>> = ({ signal }) => getSlingShifts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSlingShifts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSlingShiftsQueryResult = NonNullable<Awaited<ReturnType<typeof getSlingShifts>>>
export type GetSlingShiftsQueryError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetSlingShifts<TData = Awaited<ReturnType<typeof getSlingShifts>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: undefined |  GetSlingShiftsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSlingShifts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSlingShifts>>,
          TError,
          Awaited<ReturnType<typeof getSlingShifts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSlingShifts<TData = Awaited<ReturnType<typeof getSlingShifts>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetSlingShiftsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSlingShifts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSlingShifts>>,
          TError,
          Awaited<ReturnType<typeof getSlingShifts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSlingShifts<TData = Awaited<ReturnType<typeof getSlingShifts>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetSlingShiftsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSlingShifts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Sling shifts
 */

export function useGetSlingShifts<TData = Awaited<ReturnType<typeof getSlingShifts>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetSlingShiftsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSlingShifts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSlingShiftsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a new Sling location mapping for a customer
 * @summary Create Sling location mapping
 */
export const postSlingLocationMappings = (
    postSlingLocationMappingsBody: PostSlingLocationMappingsBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerSlingLocationMap>(
      {url: `/api/v1/sling/location-mappings`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postSlingLocationMappingsBody, signal
    },
      options);
    }
  


export const getPostSlingLocationMappingsMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSlingLocationMappings>>, TError,{data: PostSlingLocationMappingsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postSlingLocationMappings>>, TError,{data: PostSlingLocationMappingsBody}, TContext> => {

const mutationKey = ['postSlingLocationMappings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSlingLocationMappings>>, {data: PostSlingLocationMappingsBody}> = (props) => {
          const {data} = props ?? {};

          return  postSlingLocationMappings(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostSlingLocationMappingsMutationResult = NonNullable<Awaited<ReturnType<typeof postSlingLocationMappings>>>
    export type PostSlingLocationMappingsMutationBody = PostSlingLocationMappingsBody
    export type PostSlingLocationMappingsMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse

    /**
 * @summary Create Sling location mapping
 */
export const usePostSlingLocationMappings = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSlingLocationMappings>>, TError,{data: PostSlingLocationMappingsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postSlingLocationMappings>>,
        TError,
        {data: PostSlingLocationMappingsBody},
        TContext
      > => {

      const mutationOptions = getPostSlingLocationMappingsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update an existing Sling location mapping
 * @summary Update Sling location mapping
 */
export const putSlingLocationMappingsId = (
    id: string,
    putSlingLocationMappingsIdBody: PutSlingLocationMappingsIdBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CustomerSlingLocationMap>(
      {url: `/api/v1/sling/location-mappings/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putSlingLocationMappingsIdBody
    },
      options);
    }
  


export const getPutSlingLocationMappingsIdMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSlingLocationMappingsId>>, TError,{id: string;data: PutSlingLocationMappingsIdBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putSlingLocationMappingsId>>, TError,{id: string;data: PutSlingLocationMappingsIdBody}, TContext> => {

const mutationKey = ['putSlingLocationMappingsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putSlingLocationMappingsId>>, {id: string;data: PutSlingLocationMappingsIdBody}> = (props) => {
          const {id,data} = props ?? {};

          return  putSlingLocationMappingsId(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutSlingLocationMappingsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putSlingLocationMappingsId>>>
    export type PutSlingLocationMappingsIdMutationBody = PutSlingLocationMappingsIdBody
    export type PutSlingLocationMappingsIdMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse

    /**
 * @summary Update Sling location mapping
 */
export const usePutSlingLocationMappingsId = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSlingLocationMappingsId>>, TError,{id: string;data: PutSlingLocationMappingsIdBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putSlingLocationMappingsId>>,
        TError,
        {id: string;data: PutSlingLocationMappingsIdBody},
        TContext
      > => {

      const mutationOptions = getPutSlingLocationMappingsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Delete a Sling location mapping
 * @summary Delete Sling location mapping
 */
export const deleteSlingLocationMappingsId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<DeleteSlingLocationMappingsId200>(
      {url: `/api/v1/sling/location-mappings/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteSlingLocationMappingsIdMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSlingLocationMappingsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSlingLocationMappingsId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteSlingLocationMappingsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSlingLocationMappingsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteSlingLocationMappingsId(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteSlingLocationMappingsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSlingLocationMappingsId>>>
    
    export type DeleteSlingLocationMappingsIdMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse

    /**
 * @summary Delete Sling location mapping
 */
export const useDeleteSlingLocationMappingsId = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSlingLocationMappingsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSlingLocationMappingsId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteSlingLocationMappingsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns all unified items (products/services) with their delivery configuration
 * @summary List all items
 */
export const getItems = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetItems200>(
      {url: `/api/v1/items`, method: 'GET', signal
    },
      options);
    }
  



export const getGetItemsQueryKey = () => {
    return [
    `/api/v1/items`
    ] as const;
    }

    
export const getGetItemsQueryOptions = <TData = Awaited<ReturnType<typeof getItems>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getItems>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetItemsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getItems>>> = ({ signal }) => getItems(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getItems>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetItemsQueryResult = NonNullable<Awaited<ReturnType<typeof getItems>>>
export type GetItemsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetItems<TData = Awaited<ReturnType<typeof getItems>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getItems>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getItems>>,
          TError,
          Awaited<ReturnType<typeof getItems>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetItems<TData = Awaited<ReturnType<typeof getItems>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getItems>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getItems>>,
          TError,
          Awaited<ReturnType<typeof getItems>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetItems<TData = Awaited<ReturnType<typeof getItems>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getItems>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all items
 */

export function useGetItems<TData = Awaited<ReturnType<typeof getItems>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getItems>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetItemsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update item delivery configuration using JSON-PATCH
 * @summary Update item configuration
 */
export const patchItemsId = (
    id: string,
    jsonPatchOperation: JsonPatchOperation[],
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<Item>(
      {url: `/api/v1/items/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: jsonPatchOperation
    },
      options);
    }
  


export const getPatchItemsIdMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchItemsId>>, TError,{id: string;data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchItemsId>>, TError,{id: string;data: JsonPatchOperation[]}, TContext> => {

const mutationKey = ['patchItemsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchItemsId>>, {id: string;data: JsonPatchOperation[]}> = (props) => {
          const {id,data} = props ?? {};

          return  patchItemsId(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchItemsIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchItemsId>>>
    export type PatchItemsIdMutationBody = JsonPatchOperation[]
    export type PatchItemsIdMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse

    /**
 * @summary Update item configuration
 */
export const usePatchItemsId = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchItemsId>>, TError,{id: string;data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchItemsId>>,
        TError,
        {id: string;data: JsonPatchOperation[]},
        TContext
      > => {

      const mutationOptions = getPatchItemsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns the alphabetically-sorted list of IANA timezone names
time.LoadLocation can resolve on this host. Used to populate the
Business Timezone dropdown in System Settings → General. Includes
both canonical names (e.g. America/Denver) and legacy aliases
(e.g. US/Mountain) the runtime knows about.

 * @summary List IANA timezones the backend can resolve
 */
export const getTimezones = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetTimezones200>(
      {url: `/api/v1/timezones`, method: 'GET', signal
    },
      options);
    }
  



export const getGetTimezonesQueryKey = () => {
    return [
    `/api/v1/timezones`
    ] as const;
    }

    
export const getGetTimezonesQueryOptions = <TData = Awaited<ReturnType<typeof getTimezones>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTimezones>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTimezonesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTimezones>>> = ({ signal }) => getTimezones(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTimezones>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTimezonesQueryResult = NonNullable<Awaited<ReturnType<typeof getTimezones>>>
export type GetTimezonesQueryError = void


export function useGetTimezones<TData = Awaited<ReturnType<typeof getTimezones>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTimezones>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTimezones>>,
          TError,
          Awaited<ReturnType<typeof getTimezones>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTimezones<TData = Awaited<ReturnType<typeof getTimezones>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTimezones>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTimezones>>,
          TError,
          Awaited<ReturnType<typeof getTimezones>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTimezones<TData = Awaited<ReturnType<typeof getTimezones>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTimezones>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List IANA timezones the backend can resolve
 */

export function useGetTimezones<TData = Awaited<ReturnType<typeof getTimezones>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTimezones>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTimezonesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieve general system settings
 * @summary Get general settings
 */
export const getSettingsGeneral = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GeneralSettings>(
      {url: `/api/v1/settings/general`, method: 'GET', signal
    },
      options);
    }
  



export const getGetSettingsGeneralQueryKey = () => {
    return [
    `/api/v1/settings/general`
    ] as const;
    }

    
export const getGetSettingsGeneralQueryOptions = <TData = Awaited<ReturnType<typeof getSettingsGeneral>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsGeneral>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSettingsGeneralQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsGeneral>>> = ({ signal }) => getSettingsGeneral(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSettingsGeneral>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsGeneralQueryResult = NonNullable<Awaited<ReturnType<typeof getSettingsGeneral>>>
export type GetSettingsGeneralQueryError = void


export function useGetSettingsGeneral<TData = Awaited<ReturnType<typeof getSettingsGeneral>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsGeneral>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsGeneral>>,
          TError,
          Awaited<ReturnType<typeof getSettingsGeneral>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsGeneral<TData = Awaited<ReturnType<typeof getSettingsGeneral>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsGeneral>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsGeneral>>,
          TError,
          Awaited<ReturnType<typeof getSettingsGeneral>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsGeneral<TData = Awaited<ReturnType<typeof getSettingsGeneral>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsGeneral>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get general settings
 */

export function useGetSettingsGeneral<TData = Awaited<ReturnType<typeof getSettingsGeneral>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsGeneral>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSettingsGeneralQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update general system settings
 * @summary Update general settings
 */
export const putSettingsGeneral = (
    generalSettings: GeneralSettings,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<GeneralSettings>(
      {url: `/api/v1/settings/general`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: generalSettings
    },
      options);
    }
  


export const getPutSettingsGeneralMutationOptions = <TError = RequestErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSettingsGeneral>>, TError,{data: GeneralSettings}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putSettingsGeneral>>, TError,{data: GeneralSettings}, TContext> => {

const mutationKey = ['putSettingsGeneral'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putSettingsGeneral>>, {data: GeneralSettings}> = (props) => {
          const {data} = props ?? {};

          return  putSettingsGeneral(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutSettingsGeneralMutationResult = NonNullable<Awaited<ReturnType<typeof putSettingsGeneral>>>
    export type PutSettingsGeneralMutationBody = GeneralSettings
    export type PutSettingsGeneralMutationError = RequestErrorResponse | void

    /**
 * @summary Update general settings
 */
export const usePutSettingsGeneral = <TError = RequestErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSettingsGeneral>>, TError,{data: GeneralSettings}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putSettingsGeneral>>,
        TError,
        {data: GeneralSettings},
        TContext
      > => {

      const mutationOptions = getPutSettingsGeneralMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Get payroll settings
 */
export const getPayrollSettings = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PayrollSettings>(
      {url: `/api/v1/payroll/settings`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPayrollSettingsQueryKey = () => {
    return [
    `/api/v1/payroll/settings`
    ] as const;
    }

    
export const getGetPayrollSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getPayrollSettings>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayrollSettingsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayrollSettings>>> = ({ signal }) => getPayrollSettings(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayrollSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayrollSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getPayrollSettings>>>
export type GetPayrollSettingsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetPayrollSettings<TData = Awaited<ReturnType<typeof getPayrollSettings>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollSettings>>,
          TError,
          Awaited<ReturnType<typeof getPayrollSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollSettings<TData = Awaited<ReturnType<typeof getPayrollSettings>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollSettings>>,
          TError,
          Awaited<ReturnType<typeof getPayrollSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollSettings<TData = Awaited<ReturnType<typeof getPayrollSettings>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get payroll settings
 */

export function useGetPayrollSettings<TData = Awaited<ReturnType<typeof getPayrollSettings>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayrollSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Update payroll settings
 */
export const putPayrollSettings = (
    updatePayrollSettingsRequest: UpdatePayrollSettingsRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<PayrollSettings>(
      {url: `/api/v1/payroll/settings`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePayrollSettingsRequest
    },
      options);
    }
  


export const getPutPayrollSettingsMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPayrollSettings>>, TError,{data: UpdatePayrollSettingsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putPayrollSettings>>, TError,{data: UpdatePayrollSettingsRequest}, TContext> => {

const mutationKey = ['putPayrollSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPayrollSettings>>, {data: UpdatePayrollSettingsRequest}> = (props) => {
          const {data} = props ?? {};

          return  putPayrollSettings(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutPayrollSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof putPayrollSettings>>>
    export type PutPayrollSettingsMutationBody = UpdatePayrollSettingsRequest
    export type PutPayrollSettingsMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Update payroll settings
 */
export const usePutPayrollSettings = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPayrollSettings>>, TError,{data: UpdatePayrollSettingsRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPayrollSettings>>,
        TError,
        {data: UpdatePayrollSettingsRequest},
        TContext
      > => {

      const mutationOptions = getPutPayrollSettingsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns activities assigned to the authenticated user. Use period param to resolve rate schedules.
 * @summary List user's assigned payroll activities
 */
export const getPayrollActivities = (
    params?: GetPayrollActivitiesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetPayrollActivities200>(
      {url: `/api/v1/payroll/activities`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetPayrollActivitiesQueryKey = (params?: GetPayrollActivitiesParams,) => {
    return [
    `/api/v1/payroll/activities`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPayrollActivitiesQueryOptions = <TData = Awaited<ReturnType<typeof getPayrollActivities>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(params?: GetPayrollActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollActivities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayrollActivitiesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayrollActivities>>> = ({ signal }) => getPayrollActivities(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayrollActivities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayrollActivitiesQueryResult = NonNullable<Awaited<ReturnType<typeof getPayrollActivities>>>
export type GetPayrollActivitiesQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetPayrollActivities<TData = Awaited<ReturnType<typeof getPayrollActivities>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: undefined |  GetPayrollActivitiesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollActivities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollActivities>>,
          TError,
          Awaited<ReturnType<typeof getPayrollActivities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollActivities<TData = Awaited<ReturnType<typeof getPayrollActivities>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetPayrollActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollActivities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollActivities>>,
          TError,
          Awaited<ReturnType<typeof getPayrollActivities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollActivities<TData = Awaited<ReturnType<typeof getPayrollActivities>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetPayrollActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollActivities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List user's assigned payroll activities
 */

export function useGetPayrollActivities<TData = Awaited<ReturnType<typeof getPayrollActivities>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetPayrollActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollActivities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayrollActivitiesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Create payroll activity
 */
export const postPayrollActivities = (
    createPayrollActivityRequest: CreatePayrollActivityRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PayrollActivity>(
      {url: `/api/v1/payroll/activities`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createPayrollActivityRequest, signal
    },
      options);
    }
  


export const getPostPayrollActivitiesMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayrollActivities>>, TError,{data: CreatePayrollActivityRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postPayrollActivities>>, TError,{data: CreatePayrollActivityRequest}, TContext> => {

const mutationKey = ['postPayrollActivities'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPayrollActivities>>, {data: CreatePayrollActivityRequest}> = (props) => {
          const {data} = props ?? {};

          return  postPayrollActivities(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPayrollActivitiesMutationResult = NonNullable<Awaited<ReturnType<typeof postPayrollActivities>>>
    export type PostPayrollActivitiesMutationBody = CreatePayrollActivityRequest
    export type PostPayrollActivitiesMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Create payroll activity
 */
export const usePostPayrollActivities = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayrollActivities>>, TError,{data: CreatePayrollActivityRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPayrollActivities>>,
        TError,
        {data: CreatePayrollActivityRequest},
        TContext
      > => {

      const mutationOptions = getPostPayrollActivitiesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns all activities regardless of user assignment. For admin config pages.
 * @summary List all payroll activities (admin)
 */
export const getPayrollActivitiesAll = (
    params?: GetPayrollActivitiesAllParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetPayrollActivitiesAll200>(
      {url: `/api/v1/payroll/activities/all`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetPayrollActivitiesAllQueryKey = (params?: GetPayrollActivitiesAllParams,) => {
    return [
    `/api/v1/payroll/activities/all`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPayrollActivitiesAllQueryOptions = <TData = Awaited<ReturnType<typeof getPayrollActivitiesAll>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(params?: GetPayrollActivitiesAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollActivitiesAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayrollActivitiesAllQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayrollActivitiesAll>>> = ({ signal }) => getPayrollActivitiesAll(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayrollActivitiesAll>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayrollActivitiesAllQueryResult = NonNullable<Awaited<ReturnType<typeof getPayrollActivitiesAll>>>
export type GetPayrollActivitiesAllQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetPayrollActivitiesAll<TData = Awaited<ReturnType<typeof getPayrollActivitiesAll>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: undefined |  GetPayrollActivitiesAllParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollActivitiesAll>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollActivitiesAll>>,
          TError,
          Awaited<ReturnType<typeof getPayrollActivitiesAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollActivitiesAll<TData = Awaited<ReturnType<typeof getPayrollActivitiesAll>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetPayrollActivitiesAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollActivitiesAll>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollActivitiesAll>>,
          TError,
          Awaited<ReturnType<typeof getPayrollActivitiesAll>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollActivitiesAll<TData = Awaited<ReturnType<typeof getPayrollActivitiesAll>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetPayrollActivitiesAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollActivitiesAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all payroll activities (admin)
 */

export function useGetPayrollActivitiesAll<TData = Awaited<ReturnType<typeof getPayrollActivitiesAll>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetPayrollActivitiesAllParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollActivitiesAll>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayrollActivitiesAllQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Get payroll activity
 */
export const getPayrollActivitiesActivityId = (
    activityId: string,
    params?: GetPayrollActivitiesActivityIdParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PayrollActivity>(
      {url: `/api/v1/payroll/activities/${activityId}`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetPayrollActivitiesActivityIdQueryKey = (activityId?: string,
    params?: GetPayrollActivitiesActivityIdParams,) => {
    return [
    `/api/v1/payroll/activities/${activityId}`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPayrollActivitiesActivityIdQueryOptions = <TData = Awaited<ReturnType<typeof getPayrollActivitiesActivityId>>, TError = NotFoundErrorResponse>(activityId: string,
    params?: GetPayrollActivitiesActivityIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollActivitiesActivityId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayrollActivitiesActivityIdQueryKey(activityId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayrollActivitiesActivityId>>> = ({ signal }) => getPayrollActivitiesActivityId(activityId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayrollActivitiesActivityId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayrollActivitiesActivityIdQueryResult = NonNullable<Awaited<ReturnType<typeof getPayrollActivitiesActivityId>>>
export type GetPayrollActivitiesActivityIdQueryError = NotFoundErrorResponse


export function useGetPayrollActivitiesActivityId<TData = Awaited<ReturnType<typeof getPayrollActivitiesActivityId>>, TError = NotFoundErrorResponse>(
 activityId: string,
    params: undefined |  GetPayrollActivitiesActivityIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollActivitiesActivityId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollActivitiesActivityId>>,
          TError,
          Awaited<ReturnType<typeof getPayrollActivitiesActivityId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollActivitiesActivityId<TData = Awaited<ReturnType<typeof getPayrollActivitiesActivityId>>, TError = NotFoundErrorResponse>(
 activityId: string,
    params?: GetPayrollActivitiesActivityIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollActivitiesActivityId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollActivitiesActivityId>>,
          TError,
          Awaited<ReturnType<typeof getPayrollActivitiesActivityId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollActivitiesActivityId<TData = Awaited<ReturnType<typeof getPayrollActivitiesActivityId>>, TError = NotFoundErrorResponse>(
 activityId: string,
    params?: GetPayrollActivitiesActivityIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollActivitiesActivityId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get payroll activity
 */

export function useGetPayrollActivitiesActivityId<TData = Awaited<ReturnType<typeof getPayrollActivitiesActivityId>>, TError = NotFoundErrorResponse>(
 activityId: string,
    params?: GetPayrollActivitiesActivityIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollActivitiesActivityId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayrollActivitiesActivityIdQueryOptions(activityId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Update payroll activity
 */
export const putPayrollActivitiesActivityId = (
    activityId: string,
    updatePayrollActivityRequest: UpdatePayrollActivityRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<PayrollActivity>(
      {url: `/api/v1/payroll/activities/${activityId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updatePayrollActivityRequest
    },
      options);
    }
  


export const getPutPayrollActivitiesActivityIdMutationOptions = <TError = RequestErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPayrollActivitiesActivityId>>, TError,{activityId: string;data: UpdatePayrollActivityRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putPayrollActivitiesActivityId>>, TError,{activityId: string;data: UpdatePayrollActivityRequest}, TContext> => {

const mutationKey = ['putPayrollActivitiesActivityId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPayrollActivitiesActivityId>>, {activityId: string;data: UpdatePayrollActivityRequest}> = (props) => {
          const {activityId,data} = props ?? {};

          return  putPayrollActivitiesActivityId(activityId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutPayrollActivitiesActivityIdMutationResult = NonNullable<Awaited<ReturnType<typeof putPayrollActivitiesActivityId>>>
    export type PutPayrollActivitiesActivityIdMutationBody = UpdatePayrollActivityRequest
    export type PutPayrollActivitiesActivityIdMutationError = RequestErrorResponse | NotFoundErrorResponse

    /**
 * @summary Update payroll activity
 */
export const usePutPayrollActivitiesActivityId = <TError = RequestErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPayrollActivitiesActivityId>>, TError,{activityId: string;data: UpdatePayrollActivityRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPayrollActivitiesActivityId>>,
        TError,
        {activityId: string;data: UpdatePayrollActivityRequest},
        TContext
      > => {

      const mutationOptions = getPutPayrollActivitiesActivityIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Delete payroll activity
 */
export const deletePayrollActivitiesActivityId = (
    activityId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/payroll/activities/${activityId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeletePayrollActivitiesActivityIdMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePayrollActivitiesActivityId>>, TError,{activityId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePayrollActivitiesActivityId>>, TError,{activityId: string}, TContext> => {

const mutationKey = ['deletePayrollActivitiesActivityId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePayrollActivitiesActivityId>>, {activityId: string}> = (props) => {
          const {activityId} = props ?? {};

          return  deletePayrollActivitiesActivityId(activityId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePayrollActivitiesActivityIdMutationResult = NonNullable<Awaited<ReturnType<typeof deletePayrollActivitiesActivityId>>>
    
    export type DeletePayrollActivitiesActivityIdMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Delete payroll activity
 */
export const useDeletePayrollActivitiesActivityId = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePayrollActivitiesActivityId>>, TError,{activityId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePayrollActivitiesActivityId>>,
        TError,
        {activityId: string},
        TContext
      > => {

      const mutationOptions = getDeletePayrollActivitiesActivityIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary List default rate history for an activity
 */
export const getPayrollActivitiesActivityIdRates = (
    activityId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetPayrollActivitiesActivityIdRates200>(
      {url: `/api/v1/payroll/activities/${activityId}/rates`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPayrollActivitiesActivityIdRatesQueryKey = (activityId?: string,) => {
    return [
    `/api/v1/payroll/activities/${activityId}/rates`
    ] as const;
    }

    
export const getGetPayrollActivitiesActivityIdRatesQueryOptions = <TData = Awaited<ReturnType<typeof getPayrollActivitiesActivityIdRates>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(activityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollActivitiesActivityIdRates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayrollActivitiesActivityIdRatesQueryKey(activityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayrollActivitiesActivityIdRates>>> = ({ signal }) => getPayrollActivitiesActivityIdRates(activityId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayrollActivitiesActivityIdRates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayrollActivitiesActivityIdRatesQueryResult = NonNullable<Awaited<ReturnType<typeof getPayrollActivitiesActivityIdRates>>>
export type GetPayrollActivitiesActivityIdRatesQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetPayrollActivitiesActivityIdRates<TData = Awaited<ReturnType<typeof getPayrollActivitiesActivityIdRates>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 activityId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollActivitiesActivityIdRates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollActivitiesActivityIdRates>>,
          TError,
          Awaited<ReturnType<typeof getPayrollActivitiesActivityIdRates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollActivitiesActivityIdRates<TData = Awaited<ReturnType<typeof getPayrollActivitiesActivityIdRates>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 activityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollActivitiesActivityIdRates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollActivitiesActivityIdRates>>,
          TError,
          Awaited<ReturnType<typeof getPayrollActivitiesActivityIdRates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollActivitiesActivityIdRates<TData = Awaited<ReturnType<typeof getPayrollActivitiesActivityIdRates>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 activityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollActivitiesActivityIdRates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List default rate history for an activity
 */

export function useGetPayrollActivitiesActivityIdRates<TData = Awaited<ReturnType<typeof getPayrollActivitiesActivityIdRates>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 activityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollActivitiesActivityIdRates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayrollActivitiesActivityIdRatesQueryOptions(activityId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Add default rate for an activity
 */
export const postPayrollActivitiesActivityIdRates = (
    activityId: string,
    createActivityDefaultRateRequest: CreateActivityDefaultRateRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ActivityDefaultRate>(
      {url: `/api/v1/payroll/activities/${activityId}/rates`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createActivityDefaultRateRequest, signal
    },
      options);
    }
  


export const getPostPayrollActivitiesActivityIdRatesMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayrollActivitiesActivityIdRates>>, TError,{activityId: string;data: CreateActivityDefaultRateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postPayrollActivitiesActivityIdRates>>, TError,{activityId: string;data: CreateActivityDefaultRateRequest}, TContext> => {

const mutationKey = ['postPayrollActivitiesActivityIdRates'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPayrollActivitiesActivityIdRates>>, {activityId: string;data: CreateActivityDefaultRateRequest}> = (props) => {
          const {activityId,data} = props ?? {};

          return  postPayrollActivitiesActivityIdRates(activityId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPayrollActivitiesActivityIdRatesMutationResult = NonNullable<Awaited<ReturnType<typeof postPayrollActivitiesActivityIdRates>>>
    export type PostPayrollActivitiesActivityIdRatesMutationBody = CreateActivityDefaultRateRequest
    export type PostPayrollActivitiesActivityIdRatesMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Add default rate for an activity
 */
export const usePostPayrollActivitiesActivityIdRates = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayrollActivitiesActivityIdRates>>, TError,{activityId: string;data: CreateActivityDefaultRateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPayrollActivitiesActivityIdRates>>,
        TError,
        {activityId: string;data: CreateActivityDefaultRateRequest},
        TContext
      > => {

      const mutationOptions = getPostPayrollActivitiesActivityIdRatesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Update a default rate entry
 */
export const putPayrollActivitiesActivityIdRatesRateId = (
    activityId: string,
    rateId: string,
    updateActivityDefaultRateRequest: UpdateActivityDefaultRateRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<ActivityDefaultRate>(
      {url: `/api/v1/payroll/activities/${activityId}/rates/${rateId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateActivityDefaultRateRequest
    },
      options);
    }
  


export const getPutPayrollActivitiesActivityIdRatesRateIdMutationOptions = <TError = RequestErrorResponse | NotFoundErrorResponse | ConflictErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPayrollActivitiesActivityIdRatesRateId>>, TError,{activityId: string;rateId: string;data: UpdateActivityDefaultRateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putPayrollActivitiesActivityIdRatesRateId>>, TError,{activityId: string;rateId: string;data: UpdateActivityDefaultRateRequest}, TContext> => {

const mutationKey = ['putPayrollActivitiesActivityIdRatesRateId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPayrollActivitiesActivityIdRatesRateId>>, {activityId: string;rateId: string;data: UpdateActivityDefaultRateRequest}> = (props) => {
          const {activityId,rateId,data} = props ?? {};

          return  putPayrollActivitiesActivityIdRatesRateId(activityId,rateId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutPayrollActivitiesActivityIdRatesRateIdMutationResult = NonNullable<Awaited<ReturnType<typeof putPayrollActivitiesActivityIdRatesRateId>>>
    export type PutPayrollActivitiesActivityIdRatesRateIdMutationBody = UpdateActivityDefaultRateRequest
    export type PutPayrollActivitiesActivityIdRatesRateIdMutationError = RequestErrorResponse | NotFoundErrorResponse | ConflictErrorResponse

    /**
 * @summary Update a default rate entry
 */
export const usePutPayrollActivitiesActivityIdRatesRateId = <TError = RequestErrorResponse | NotFoundErrorResponse | ConflictErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPayrollActivitiesActivityIdRatesRateId>>, TError,{activityId: string;rateId: string;data: UpdateActivityDefaultRateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPayrollActivitiesActivityIdRatesRateId>>,
        TError,
        {activityId: string;rateId: string;data: UpdateActivityDefaultRateRequest},
        TContext
      > => {

      const mutationOptions = getPutPayrollActivitiesActivityIdRatesRateIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Delete a default rate entry
 */
export const deletePayrollActivitiesActivityIdRatesRateId = (
    activityId: string,
    rateId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/payroll/activities/${activityId}/rates/${rateId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeletePayrollActivitiesActivityIdRatesRateIdMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | ConflictErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePayrollActivitiesActivityIdRatesRateId>>, TError,{activityId: string;rateId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePayrollActivitiesActivityIdRatesRateId>>, TError,{activityId: string;rateId: string}, TContext> => {

const mutationKey = ['deletePayrollActivitiesActivityIdRatesRateId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePayrollActivitiesActivityIdRatesRateId>>, {activityId: string;rateId: string}> = (props) => {
          const {activityId,rateId} = props ?? {};

          return  deletePayrollActivitiesActivityIdRatesRateId(activityId,rateId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePayrollActivitiesActivityIdRatesRateIdMutationResult = NonNullable<Awaited<ReturnType<typeof deletePayrollActivitiesActivityIdRatesRateId>>>
    
    export type DeletePayrollActivitiesActivityIdRatesRateIdMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | ConflictErrorResponse

    /**
 * @summary Delete a default rate entry
 */
export const useDeletePayrollActivitiesActivityIdRatesRateId = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | ConflictErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePayrollActivitiesActivityIdRatesRateId>>, TError,{activityId: string;rateId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePayrollActivitiesActivityIdRatesRateId>>,
        TError,
        {activityId: string;rateId: string},
        TContext
      > => {

      const mutationOptions = getDeletePayrollActivitiesActivityIdRatesRateIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Get rate history for a user
 */
export const getPayrollUsersUserIdRates = (
    userId: string,
    params?: GetPayrollUsersUserIdRatesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetPayrollUsersUserIdRates200>(
      {url: `/api/v1/payroll/users/${userId}/rates`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetPayrollUsersUserIdRatesQueryKey = (userId?: string,
    params?: GetPayrollUsersUserIdRatesParams,) => {
    return [
    `/api/v1/payroll/users/${userId}/rates`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPayrollUsersUserIdRatesQueryOptions = <TData = Awaited<ReturnType<typeof getPayrollUsersUserIdRates>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(userId: string,
    params?: GetPayrollUsersUserIdRatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollUsersUserIdRates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayrollUsersUserIdRatesQueryKey(userId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayrollUsersUserIdRates>>> = ({ signal }) => getPayrollUsersUserIdRates(userId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayrollUsersUserIdRates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayrollUsersUserIdRatesQueryResult = NonNullable<Awaited<ReturnType<typeof getPayrollUsersUserIdRates>>>
export type GetPayrollUsersUserIdRatesQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetPayrollUsersUserIdRates<TData = Awaited<ReturnType<typeof getPayrollUsersUserIdRates>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string,
    params: undefined |  GetPayrollUsersUserIdRatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollUsersUserIdRates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollUsersUserIdRates>>,
          TError,
          Awaited<ReturnType<typeof getPayrollUsersUserIdRates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollUsersUserIdRates<TData = Awaited<ReturnType<typeof getPayrollUsersUserIdRates>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string,
    params?: GetPayrollUsersUserIdRatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollUsersUserIdRates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollUsersUserIdRates>>,
          TError,
          Awaited<ReturnType<typeof getPayrollUsersUserIdRates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollUsersUserIdRates<TData = Awaited<ReturnType<typeof getPayrollUsersUserIdRates>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string,
    params?: GetPayrollUsersUserIdRatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollUsersUserIdRates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get rate history for a user
 */

export function useGetPayrollUsersUserIdRates<TData = Awaited<ReturnType<typeof getPayrollUsersUserIdRates>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string,
    params?: GetPayrollUsersUserIdRatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollUsersUserIdRates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayrollUsersUserIdRatesQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Create user activity rate
 */
export const postPayrollUsersUserIdRates = (
    userId: string,
    createUserActivityRateRequest: CreateUserActivityRateRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<UserActivityRate>(
      {url: `/api/v1/payroll/users/${userId}/rates`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createUserActivityRateRequest, signal
    },
      options);
    }
  


export const getPostPayrollUsersUserIdRatesMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayrollUsersUserIdRates>>, TError,{userId: string;data: CreateUserActivityRateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postPayrollUsersUserIdRates>>, TError,{userId: string;data: CreateUserActivityRateRequest}, TContext> => {

const mutationKey = ['postPayrollUsersUserIdRates'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPayrollUsersUserIdRates>>, {userId: string;data: CreateUserActivityRateRequest}> = (props) => {
          const {userId,data} = props ?? {};

          return  postPayrollUsersUserIdRates(userId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostPayrollUsersUserIdRatesMutationResult = NonNullable<Awaited<ReturnType<typeof postPayrollUsersUserIdRates>>>
    export type PostPayrollUsersUserIdRatesMutationBody = CreateUserActivityRateRequest
    export type PostPayrollUsersUserIdRatesMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Create user activity rate
 */
export const usePostPayrollUsersUserIdRates = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPayrollUsersUserIdRates>>, TError,{userId: string;data: CreateUserActivityRateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPayrollUsersUserIdRates>>,
        TError,
        {userId: string;data: CreateUserActivityRateRequest},
        TContext
      > => {

      const mutationOptions = getPostPayrollUsersUserIdRatesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Update user activity rate
 */
export const putPayrollUsersUserIdRatesRateId = (
    userId: string,
    rateId: string,
    updateUserActivityRateRequest: UpdateUserActivityRateRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<UserActivityRate>(
      {url: `/api/v1/payroll/users/${userId}/rates/${rateId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateUserActivityRateRequest
    },
      options);
    }
  


export const getPutPayrollUsersUserIdRatesRateIdMutationOptions = <TError = RequestErrorResponse | NotFoundErrorResponse | ConflictErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPayrollUsersUserIdRatesRateId>>, TError,{userId: string;rateId: string;data: UpdateUserActivityRateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putPayrollUsersUserIdRatesRateId>>, TError,{userId: string;rateId: string;data: UpdateUserActivityRateRequest}, TContext> => {

const mutationKey = ['putPayrollUsersUserIdRatesRateId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPayrollUsersUserIdRatesRateId>>, {userId: string;rateId: string;data: UpdateUserActivityRateRequest}> = (props) => {
          const {userId,rateId,data} = props ?? {};

          return  putPayrollUsersUserIdRatesRateId(userId,rateId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutPayrollUsersUserIdRatesRateIdMutationResult = NonNullable<Awaited<ReturnType<typeof putPayrollUsersUserIdRatesRateId>>>
    export type PutPayrollUsersUserIdRatesRateIdMutationBody = UpdateUserActivityRateRequest
    export type PutPayrollUsersUserIdRatesRateIdMutationError = RequestErrorResponse | NotFoundErrorResponse | ConflictErrorResponse

    /**
 * @summary Update user activity rate
 */
export const usePutPayrollUsersUserIdRatesRateId = <TError = RequestErrorResponse | NotFoundErrorResponse | ConflictErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPayrollUsersUserIdRatesRateId>>, TError,{userId: string;rateId: string;data: UpdateUserActivityRateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPayrollUsersUserIdRatesRateId>>,
        TError,
        {userId: string;rateId: string;data: UpdateUserActivityRateRequest},
        TContext
      > => {

      const mutationOptions = getPutPayrollUsersUserIdRatesRateIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Delete user activity rate
 */
export const deletePayrollUsersUserIdRatesRateId = (
    userId: string,
    rateId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/payroll/users/${userId}/rates/${rateId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeletePayrollUsersUserIdRatesRateIdMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | ConflictErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePayrollUsersUserIdRatesRateId>>, TError,{userId: string;rateId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePayrollUsersUserIdRatesRateId>>, TError,{userId: string;rateId: string}, TContext> => {

const mutationKey = ['deletePayrollUsersUserIdRatesRateId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePayrollUsersUserIdRatesRateId>>, {userId: string;rateId: string}> = (props) => {
          const {userId,rateId} = props ?? {};

          return  deletePayrollUsersUserIdRatesRateId(userId,rateId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePayrollUsersUserIdRatesRateIdMutationResult = NonNullable<Awaited<ReturnType<typeof deletePayrollUsersUserIdRatesRateId>>>
    
    export type DeletePayrollUsersUserIdRatesRateIdMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | ConflictErrorResponse

    /**
 * @summary Delete user activity rate
 */
export const useDeletePayrollUsersUserIdRatesRateId = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | ConflictErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePayrollUsersUserIdRatesRateId>>, TError,{userId: string;rateId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePayrollUsersUserIdRatesRateId>>,
        TError,
        {userId: string;rateId: string},
        TContext
      > => {

      const mutationOptions = getDeletePayrollUsersUserIdRatesRateIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary List all user timesheet configs
 */
export const getPayrollUsersConfigs = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetPayrollUsersConfigs200>(
      {url: `/api/v1/payroll/users/configs`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPayrollUsersConfigsQueryKey = () => {
    return [
    `/api/v1/payroll/users/configs`
    ] as const;
    }

    
export const getGetPayrollUsersConfigsQueryOptions = <TData = Awaited<ReturnType<typeof getPayrollUsersConfigs>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollUsersConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayrollUsersConfigsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayrollUsersConfigs>>> = ({ signal }) => getPayrollUsersConfigs(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayrollUsersConfigs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayrollUsersConfigsQueryResult = NonNullable<Awaited<ReturnType<typeof getPayrollUsersConfigs>>>
export type GetPayrollUsersConfigsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetPayrollUsersConfigs<TData = Awaited<ReturnType<typeof getPayrollUsersConfigs>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollUsersConfigs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollUsersConfigs>>,
          TError,
          Awaited<ReturnType<typeof getPayrollUsersConfigs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollUsersConfigs<TData = Awaited<ReturnType<typeof getPayrollUsersConfigs>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollUsersConfigs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollUsersConfigs>>,
          TError,
          Awaited<ReturnType<typeof getPayrollUsersConfigs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollUsersConfigs<TData = Awaited<ReturnType<typeof getPayrollUsersConfigs>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollUsersConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List all user timesheet configs
 */

export function useGetPayrollUsersConfigs<TData = Awaited<ReturnType<typeof getPayrollUsersConfigs>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollUsersConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayrollUsersConfigsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Get user timesheet config
 */
export const getPayrollUsersUserIdConfig = (
    userId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<UserTimesheetConfig>(
      {url: `/api/v1/payroll/users/${userId}/config`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPayrollUsersUserIdConfigQueryKey = (userId?: string,) => {
    return [
    `/api/v1/payroll/users/${userId}/config`
    ] as const;
    }

    
export const getGetPayrollUsersUserIdConfigQueryOptions = <TData = Awaited<ReturnType<typeof getPayrollUsersUserIdConfig>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollUsersUserIdConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayrollUsersUserIdConfigQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayrollUsersUserIdConfig>>> = ({ signal }) => getPayrollUsersUserIdConfig(userId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayrollUsersUserIdConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayrollUsersUserIdConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getPayrollUsersUserIdConfig>>>
export type GetPayrollUsersUserIdConfigQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetPayrollUsersUserIdConfig<TData = Awaited<ReturnType<typeof getPayrollUsersUserIdConfig>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollUsersUserIdConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollUsersUserIdConfig>>,
          TError,
          Awaited<ReturnType<typeof getPayrollUsersUserIdConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollUsersUserIdConfig<TData = Awaited<ReturnType<typeof getPayrollUsersUserIdConfig>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollUsersUserIdConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollUsersUserIdConfig>>,
          TError,
          Awaited<ReturnType<typeof getPayrollUsersUserIdConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollUsersUserIdConfig<TData = Awaited<ReturnType<typeof getPayrollUsersUserIdConfig>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollUsersUserIdConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get user timesheet config
 */

export function useGetPayrollUsersUserIdConfig<TData = Awaited<ReturnType<typeof getPayrollUsersUserIdConfig>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollUsersUserIdConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayrollUsersUserIdConfigQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Update user timesheet config
 */
export const putPayrollUsersUserIdConfig = (
    userId: string,
    updateUserTimesheetConfigRequest: UpdateUserTimesheetConfigRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<UserTimesheetConfig>(
      {url: `/api/v1/payroll/users/${userId}/config`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateUserTimesheetConfigRequest
    },
      options);
    }
  


export const getPutPayrollUsersUserIdConfigMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPayrollUsersUserIdConfig>>, TError,{userId: string;data: UpdateUserTimesheetConfigRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putPayrollUsersUserIdConfig>>, TError,{userId: string;data: UpdateUserTimesheetConfigRequest}, TContext> => {

const mutationKey = ['putPayrollUsersUserIdConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPayrollUsersUserIdConfig>>, {userId: string;data: UpdateUserTimesheetConfigRequest}> = (props) => {
          const {userId,data} = props ?? {};

          return  putPayrollUsersUserIdConfig(userId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutPayrollUsersUserIdConfigMutationResult = NonNullable<Awaited<ReturnType<typeof putPayrollUsersUserIdConfig>>>
    export type PutPayrollUsersUserIdConfigMutationBody = UpdateUserTimesheetConfigRequest
    export type PutPayrollUsersUserIdConfigMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Update user timesheet config
 */
export const usePutPayrollUsersUserIdConfig = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPayrollUsersUserIdConfig>>, TError,{userId: string;data: UpdateUserTimesheetConfigRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPayrollUsersUserIdConfig>>,
        TError,
        {userId: string;data: UpdateUserTimesheetConfigRequest},
        TContext
      > => {

      const mutationOptions = getPutPayrollUsersUserIdConfigMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary List enabled activities for a user
 */
export const getPayrollUsersUserIdActivities = (
    userId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetPayrollUsersUserIdActivities200>(
      {url: `/api/v1/payroll/users/${userId}/activities`, method: 'GET', signal
    },
      options);
    }
  



export const getGetPayrollUsersUserIdActivitiesQueryKey = (userId?: string,) => {
    return [
    `/api/v1/payroll/users/${userId}/activities`
    ] as const;
    }

    
export const getGetPayrollUsersUserIdActivitiesQueryOptions = <TData = Awaited<ReturnType<typeof getPayrollUsersUserIdActivities>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollUsersUserIdActivities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayrollUsersUserIdActivitiesQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayrollUsersUserIdActivities>>> = ({ signal }) => getPayrollUsersUserIdActivities(userId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayrollUsersUserIdActivities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayrollUsersUserIdActivitiesQueryResult = NonNullable<Awaited<ReturnType<typeof getPayrollUsersUserIdActivities>>>
export type GetPayrollUsersUserIdActivitiesQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetPayrollUsersUserIdActivities<TData = Awaited<ReturnType<typeof getPayrollUsersUserIdActivities>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollUsersUserIdActivities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollUsersUserIdActivities>>,
          TError,
          Awaited<ReturnType<typeof getPayrollUsersUserIdActivities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollUsersUserIdActivities<TData = Awaited<ReturnType<typeof getPayrollUsersUserIdActivities>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollUsersUserIdActivities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayrollUsersUserIdActivities>>,
          TError,
          Awaited<ReturnType<typeof getPayrollUsersUserIdActivities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayrollUsersUserIdActivities<TData = Awaited<ReturnType<typeof getPayrollUsersUserIdActivities>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollUsersUserIdActivities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List enabled activities for a user
 */

export function useGetPayrollUsersUserIdActivities<TData = Awaited<ReturnType<typeof getPayrollUsersUserIdActivities>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayrollUsersUserIdActivities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayrollUsersUserIdActivitiesQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Enable an activity for a user
 */
export const putPayrollUsersUserIdActivitiesActivityId = (
    userId: string,
    activityId: string,
    updateUserActivityRequest: UpdateUserActivityRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<UserActivity>(
      {url: `/api/v1/payroll/users/${userId}/activities/${activityId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateUserActivityRequest
    },
      options);
    }
  


export const getPutPayrollUsersUserIdActivitiesActivityIdMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPayrollUsersUserIdActivitiesActivityId>>, TError,{userId: string;activityId: string;data: UpdateUserActivityRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putPayrollUsersUserIdActivitiesActivityId>>, TError,{userId: string;activityId: string;data: UpdateUserActivityRequest}, TContext> => {

const mutationKey = ['putPayrollUsersUserIdActivitiesActivityId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPayrollUsersUserIdActivitiesActivityId>>, {userId: string;activityId: string;data: UpdateUserActivityRequest}> = (props) => {
          const {userId,activityId,data} = props ?? {};

          return  putPayrollUsersUserIdActivitiesActivityId(userId,activityId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutPayrollUsersUserIdActivitiesActivityIdMutationResult = NonNullable<Awaited<ReturnType<typeof putPayrollUsersUserIdActivitiesActivityId>>>
    export type PutPayrollUsersUserIdActivitiesActivityIdMutationBody = UpdateUserActivityRequest
    export type PutPayrollUsersUserIdActivitiesActivityIdMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Enable an activity for a user
 */
export const usePutPayrollUsersUserIdActivitiesActivityId = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPayrollUsersUserIdActivitiesActivityId>>, TError,{userId: string;activityId: string;data: UpdateUserActivityRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPayrollUsersUserIdActivitiesActivityId>>,
        TError,
        {userId: string;activityId: string;data: UpdateUserActivityRequest},
        TContext
      > => {

      const mutationOptions = getPutPayrollUsersUserIdActivitiesActivityIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Disable an activity for a user
 */
export const deletePayrollUsersUserIdActivitiesActivityId = (
    userId: string,
    activityId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/payroll/users/${userId}/activities/${activityId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeletePayrollUsersUserIdActivitiesActivityIdMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePayrollUsersUserIdActivitiesActivityId>>, TError,{userId: string;activityId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePayrollUsersUserIdActivitiesActivityId>>, TError,{userId: string;activityId: string}, TContext> => {

const mutationKey = ['deletePayrollUsersUserIdActivitiesActivityId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePayrollUsersUserIdActivitiesActivityId>>, {userId: string;activityId: string}> = (props) => {
          const {userId,activityId} = props ?? {};

          return  deletePayrollUsersUserIdActivitiesActivityId(userId,activityId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeletePayrollUsersUserIdActivitiesActivityIdMutationResult = NonNullable<Awaited<ReturnType<typeof deletePayrollUsersUserIdActivitiesActivityId>>>
    
    export type DeletePayrollUsersUserIdActivitiesActivityIdMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Disable an activity for a user
 */
export const useDeletePayrollUsersUserIdActivitiesActivityId = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePayrollUsersUserIdActivitiesActivityId>>, TError,{userId: string;activityId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePayrollUsersUserIdActivitiesActivityId>>,
        TError,
        {userId: string;activityId: string},
        TContext
      > => {

      const mutationOptions = getDeletePayrollUsersUserIdActivitiesActivityIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns all payees synced from external integrations (Mercury, QuickBooks, etc.)
 * @summary List payees
 */
export const getPayees = (
    params?: GetPayeesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetPayees200>(
      {url: `/api/v1/payees`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetPayeesQueryKey = (params?: GetPayeesParams,) => {
    return [
    `/api/v1/payees`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPayeesQueryOptions = <TData = Awaited<ReturnType<typeof getPayees>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(params?: GetPayeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPayeesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPayees>>> = ({ signal }) => getPayees(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPayees>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPayeesQueryResult = NonNullable<Awaited<ReturnType<typeof getPayees>>>
export type GetPayeesQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetPayees<TData = Awaited<ReturnType<typeof getPayees>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: undefined |  GetPayeesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayees>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayees>>,
          TError,
          Awaited<ReturnType<typeof getPayees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayees<TData = Awaited<ReturnType<typeof getPayees>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetPayeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayees>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPayees>>,
          TError,
          Awaited<ReturnType<typeof getPayees>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPayees<TData = Awaited<ReturnType<typeof getPayees>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetPayeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List payees
 */

export function useGetPayees<TData = Awaited<ReturnType<typeof getPayees>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetPayeesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPayees>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPayeesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Links a payee (Mercury/QB counterparty) to a dashboard user, or
unlinks it (pass null/empty body). One user can be linked to many
payees (different bank rails); one payee links to at most one user.
The bank-sync uses this mapping to attribute incoming commission
payments to the correct user.

 * @summary Set or clear the user linked to a payee
 */
export const putPayeesIdUser = (
    id: string,
    setPayeeUserRequest: SetPayeeUserRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<Payee>(
      {url: `/api/v1/payees/${id}/user`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: setPayeeUserRequest
    },
      options);
    }
  


export const getPutPayeesIdUserMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPayeesIdUser>>, TError,{id: string;data: SetPayeeUserRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putPayeesIdUser>>, TError,{id: string;data: SetPayeeUserRequest}, TContext> => {

const mutationKey = ['putPayeesIdUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPayeesIdUser>>, {id: string;data: SetPayeeUserRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  putPayeesIdUser(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutPayeesIdUserMutationResult = NonNullable<Awaited<ReturnType<typeof putPayeesIdUser>>>
    export type PutPayeesIdUserMutationBody = SetPayeeUserRequest
    export type PutPayeesIdUserMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Set or clear the user linked to a payee
 */
export const usePutPayeesIdUser = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPayeesIdUser>>, TError,{id: string;data: SetPayeeUserRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPayeesIdUser>>,
        TError,
        {id: string;data: SetPayeeUserRequest},
        TContext
      > => {

      const mutationOptions = getPutPayeesIdUserMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Cursor-paginated list of timesheets, scoped to what the caller may see:
an admin sees everyone, a manager sees their own plus their reports',
and everyone else sees only their own. `user_id` narrows within that
set — asking for someone outside it returns no rows rather than 403,
so the same URL is safe to share between roles.

Rows carry no entries. Fetch GET /timesheets/{timesheetId} for those.

 * @summary List timesheets
 */
export const getTimesheets = (
    params?: GetTimesheetsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetTimesheets200>(
      {url: `/api/v1/timesheets`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetTimesheetsQueryKey = (params?: GetTimesheetsParams,) => {
    return [
    `/api/v1/timesheets`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetTimesheetsQueryOptions = <TData = Awaited<ReturnType<typeof getTimesheets>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(params?: GetTimesheetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTimesheets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTimesheetsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTimesheets>>> = ({ signal }) => getTimesheets(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTimesheets>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTimesheetsQueryResult = NonNullable<Awaited<ReturnType<typeof getTimesheets>>>
export type GetTimesheetsQueryError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetTimesheets<TData = Awaited<ReturnType<typeof getTimesheets>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: undefined |  GetTimesheetsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTimesheets>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTimesheets>>,
          TError,
          Awaited<ReturnType<typeof getTimesheets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTimesheets<TData = Awaited<ReturnType<typeof getTimesheets>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetTimesheetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTimesheets>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTimesheets>>,
          TError,
          Awaited<ReturnType<typeof getTimesheets>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTimesheets<TData = Awaited<ReturnType<typeof getTimesheets>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetTimesheetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTimesheets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List timesheets
 */

export function useGetTimesheets<TData = Awaited<ReturnType<typeof getTimesheets>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetTimesheetsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTimesheets>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTimesheetsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Apply a JSON-PATCH (RFC 6902) across timesheets, each op path prefixed
by the timesheet id — `/{timesheetId}/status`. Replaces the old
batch-pay endpoint. The whole array applies in one transaction, so a
rejected op leaves nothing changed.

Each op is authorized against the transition it requests, the same way
PATCH /timesheets/{timesheetId} authorizes a single one.

 * @summary Update several timesheets at once
 */
export const patchTimesheets = (
    jsonPatchOperation: JsonPatchOperation[],
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<PatchTimesheets200>(
      {url: `/api/v1/timesheets`, method: 'PATCH',
      headers: {'Content-Type': 'application/json-patch+json', },
      data: jsonPatchOperation
    },
      options);
    }
  


export const getPatchTimesheetsMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTimesheets>>, TError,{data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchTimesheets>>, TError,{data: JsonPatchOperation[]}, TContext> => {

const mutationKey = ['patchTimesheets'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchTimesheets>>, {data: JsonPatchOperation[]}> = (props) => {
          const {data} = props ?? {};

          return  patchTimesheets(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchTimesheetsMutationResult = NonNullable<Awaited<ReturnType<typeof patchTimesheets>>>
    export type PatchTimesheetsMutationBody = JsonPatchOperation[]
    export type PatchTimesheetsMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse

    /**
 * @summary Update several timesheets at once
 */
export const usePatchTimesheets = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTimesheets>>, TError,{data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchTimesheets>>,
        TError,
        {data: JsonPatchOperation[]},
        TContext
      > => {

      const mutationOptions = getPatchTimesheetsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Creates a draft timesheet for the specified user and pay period. Use "me" for the authenticated user.
 * @summary Create timesheet for a pay period
 */
export const postTimesheetsUsersUserId = (
    userId: string,
    postTimesheetsUsersUserIdBody?: PostTimesheetsUsersUserIdBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Timesheet>(
      {url: `/api/v1/timesheets/users/${userId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postTimesheetsUsersUserIdBody, signal
    },
      options);
    }
  


export const getPostTimesheetsUsersUserIdMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | PostTimesheetsUsersUserId409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTimesheetsUsersUserId>>, TError,{userId: string;data: PostTimesheetsUsersUserIdBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postTimesheetsUsersUserId>>, TError,{userId: string;data: PostTimesheetsUsersUserIdBody}, TContext> => {

const mutationKey = ['postTimesheetsUsersUserId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTimesheetsUsersUserId>>, {userId: string;data: PostTimesheetsUsersUserIdBody}> = (props) => {
          const {userId,data} = props ?? {};

          return  postTimesheetsUsersUserId(userId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTimesheetsUsersUserIdMutationResult = NonNullable<Awaited<ReturnType<typeof postTimesheetsUsersUserId>>>
    export type PostTimesheetsUsersUserIdMutationBody = PostTimesheetsUsersUserIdBody
    export type PostTimesheetsUsersUserIdMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | PostTimesheetsUsersUserId409

    /**
 * @summary Create timesheet for a pay period
 */
export const usePostTimesheetsUsersUserId = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | PostTimesheetsUsersUserId409,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTimesheetsUsersUserId>>, TError,{userId: string;data: PostTimesheetsUsersUserIdBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postTimesheetsUsersUserId>>,
        TError,
        {userId: string;data: PostTimesheetsUsersUserIdBody},
        TContext
      > => {

      const mutationOptions = getPostTimesheetsUsersUserIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns the pay period start/end dates for the specified user. Use "me" for the authenticated user.
 * @summary Get current pay period info
 */
export const getTimesheetsUsersUserIdCurrentPeriod = (
    userId: string,
    params?: GetTimesheetsUsersUserIdCurrentPeriodParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PayPeriodInfo>(
      {url: `/api/v1/timesheets/users/${userId}/current-period`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetTimesheetsUsersUserIdCurrentPeriodQueryKey = (userId?: string,
    params?: GetTimesheetsUsersUserIdCurrentPeriodParams,) => {
    return [
    `/api/v1/timesheets/users/${userId}/current-period`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetTimesheetsUsersUserIdCurrentPeriodQueryOptions = <TData = Awaited<ReturnType<typeof getTimesheetsUsersUserIdCurrentPeriod>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(userId: string,
    params?: GetTimesheetsUsersUserIdCurrentPeriodParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTimesheetsUsersUserIdCurrentPeriod>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTimesheetsUsersUserIdCurrentPeriodQueryKey(userId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTimesheetsUsersUserIdCurrentPeriod>>> = ({ signal }) => getTimesheetsUsersUserIdCurrentPeriod(userId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTimesheetsUsersUserIdCurrentPeriod>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTimesheetsUsersUserIdCurrentPeriodQueryResult = NonNullable<Awaited<ReturnType<typeof getTimesheetsUsersUserIdCurrentPeriod>>>
export type GetTimesheetsUsersUserIdCurrentPeriodQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetTimesheetsUsersUserIdCurrentPeriod<TData = Awaited<ReturnType<typeof getTimesheetsUsersUserIdCurrentPeriod>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string,
    params: undefined |  GetTimesheetsUsersUserIdCurrentPeriodParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTimesheetsUsersUserIdCurrentPeriod>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTimesheetsUsersUserIdCurrentPeriod>>,
          TError,
          Awaited<ReturnType<typeof getTimesheetsUsersUserIdCurrentPeriod>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTimesheetsUsersUserIdCurrentPeriod<TData = Awaited<ReturnType<typeof getTimesheetsUsersUserIdCurrentPeriod>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string,
    params?: GetTimesheetsUsersUserIdCurrentPeriodParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTimesheetsUsersUserIdCurrentPeriod>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTimesheetsUsersUserIdCurrentPeriod>>,
          TError,
          Awaited<ReturnType<typeof getTimesheetsUsersUserIdCurrentPeriod>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTimesheetsUsersUserIdCurrentPeriod<TData = Awaited<ReturnType<typeof getTimesheetsUsersUserIdCurrentPeriod>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string,
    params?: GetTimesheetsUsersUserIdCurrentPeriodParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTimesheetsUsersUserIdCurrentPeriod>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get current pay period info
 */

export function useGetTimesheetsUsersUserIdCurrentPeriod<TData = Awaited<ReturnType<typeof getTimesheetsUsersUserIdCurrentPeriod>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string,
    params?: GetTimesheetsUsersUserIdCurrentPeriodParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTimesheetsUsersUserIdCurrentPeriod>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTimesheetsUsersUserIdCurrentPeriodQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns a full timesheet with all entries. Access restricted to owner, manager hierarchy, and admin.
 * @summary Get timesheet with entries
 */
export const getTimesheetsTimesheetId = (
    timesheetId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Timesheet>(
      {url: `/api/v1/timesheets/${timesheetId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetTimesheetsTimesheetIdQueryKey = (timesheetId?: string,) => {
    return [
    `/api/v1/timesheets/${timesheetId}`
    ] as const;
    }

    
export const getGetTimesheetsTimesheetIdQueryOptions = <TData = Awaited<ReturnType<typeof getTimesheetsTimesheetId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(timesheetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTimesheetsTimesheetId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTimesheetsTimesheetIdQueryKey(timesheetId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTimesheetsTimesheetId>>> = ({ signal }) => getTimesheetsTimesheetId(timesheetId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(timesheetId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTimesheetsTimesheetId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTimesheetsTimesheetIdQueryResult = NonNullable<Awaited<ReturnType<typeof getTimesheetsTimesheetId>>>
export type GetTimesheetsTimesheetIdQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse


export function useGetTimesheetsTimesheetId<TData = Awaited<ReturnType<typeof getTimesheetsTimesheetId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 timesheetId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTimesheetsTimesheetId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTimesheetsTimesheetId>>,
          TError,
          Awaited<ReturnType<typeof getTimesheetsTimesheetId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTimesheetsTimesheetId<TData = Awaited<ReturnType<typeof getTimesheetsTimesheetId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 timesheetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTimesheetsTimesheetId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTimesheetsTimesheetId>>,
          TError,
          Awaited<ReturnType<typeof getTimesheetsTimesheetId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTimesheetsTimesheetId<TData = Awaited<ReturnType<typeof getTimesheetsTimesheetId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 timesheetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTimesheetsTimesheetId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get timesheet with entries
 */

export function useGetTimesheetsTimesheetId<TData = Awaited<ReturnType<typeof getTimesheetsTimesheetId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 timesheetId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTimesheetsTimesheetId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetTimesheetsTimesheetIdQueryOptions(timesheetId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Apply a JSON-PATCH (RFC 6902) to one timesheet. `replace /status`
drives a state transition; companion ops in the same array carry what
that transition needs — `/rejection_reason` when rejecting,
`/payment_reference` when marking paid, `/payment_note` and
`/payment_external_memo` when dispatching a payment. `/notes` is an
ordinary field edit.

Replaces the submit, approve, unapprove, reject, pay, unpay and
send-payment endpoints. Each transition is authorized separately —
an owner may submit, a manager may approve, unapprove and reject, and
only an admin may move money — so the roles above are the union and
the real check happens per transition. An illegal pair is refused with
the transitions actually available from the current status.

 * @summary Update a timesheet
 */
export const patchTimesheetsTimesheetId = (
    timesheetId: string,
    jsonPatchOperation: JsonPatchOperation[],
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<Timesheet>(
      {url: `/api/v1/timesheets/${timesheetId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json-patch+json', },
      data: jsonPatchOperation
    },
      options);
    }
  


export const getPatchTimesheetsTimesheetIdMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTimesheetsTimesheetId>>, TError,{timesheetId: string;data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchTimesheetsTimesheetId>>, TError,{timesheetId: string;data: JsonPatchOperation[]}, TContext> => {

const mutationKey = ['patchTimesheetsTimesheetId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchTimesheetsTimesheetId>>, {timesheetId: string;data: JsonPatchOperation[]}> = (props) => {
          const {timesheetId,data} = props ?? {};

          return  patchTimesheetsTimesheetId(timesheetId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchTimesheetsTimesheetIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchTimesheetsTimesheetId>>>
    export type PatchTimesheetsTimesheetIdMutationBody = JsonPatchOperation[]
    export type PatchTimesheetsTimesheetIdMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse

    /**
 * @summary Update a timesheet
 */
export const usePatchTimesheetsTimesheetId = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTimesheetsTimesheetId>>, TError,{timesheetId: string;data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchTimesheetsTimesheetId>>,
        TError,
        {timesheetId: string;data: JsonPatchOperation[]},
        TContext
      > => {

      const mutationOptions = getPatchTimesheetsTimesheetIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Deletes a timesheet and all its entries. Only draft timesheets can be deleted. Owner or admin only.
 * @summary Delete a draft timesheet
 */
export const deleteTimesheetsTimesheetId = (
    timesheetId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/timesheets/${timesheetId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteTimesheetsTimesheetIdMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTimesheetsTimesheetId>>, TError,{timesheetId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTimesheetsTimesheetId>>, TError,{timesheetId: string}, TContext> => {

const mutationKey = ['deleteTimesheetsTimesheetId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTimesheetsTimesheetId>>, {timesheetId: string}> = (props) => {
          const {timesheetId} = props ?? {};

          return  deleteTimesheetsTimesheetId(timesheetId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteTimesheetsTimesheetIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTimesheetsTimesheetId>>>
    
    export type DeleteTimesheetsTimesheetIdMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse

    /**
 * @summary Delete a draft timesheet
 */
export const useDeleteTimesheetsTimesheetId = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTimesheetsTimesheetId>>, TError,{timesheetId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTimesheetsTimesheetId>>,
        TError,
        {timesheetId: string},
        TContext
      > => {

      const mutationOptions = getDeleteTimesheetsTimesheetIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Apply a JSON-PATCH (RFC 6902) to a timesheet's entries, each op
addressing one entry by id — `add` creates one, `remove /{entryId}`
deletes one, `replace /{entryId}/{field}` updates hours, description
or activity.

Replaces the old replace-all PUT, which deleted every entry and
recreated it on each save. That destroyed edit history and made a
mistaken deletion unrecoverable; a `remove` here soft-deletes exactly
the one row named.

Total hours and total amount are recomputed once at the end of the
patch, not per op.

 * @summary Edit timesheet entries
 */
export const patchTimesheetsTimesheetIdEntries = (
    timesheetId: string,
    jsonPatchOperation: JsonPatchOperation[],
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<Timesheet>(
      {url: `/api/v1/timesheets/${timesheetId}/entries`, method: 'PATCH',
      headers: {'Content-Type': 'application/json-patch+json', },
      data: jsonPatchOperation
    },
      options);
    }
  


export const getPatchTimesheetsTimesheetIdEntriesMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTimesheetsTimesheetIdEntries>>, TError,{timesheetId: string;data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchTimesheetsTimesheetIdEntries>>, TError,{timesheetId: string;data: JsonPatchOperation[]}, TContext> => {

const mutationKey = ['patchTimesheetsTimesheetIdEntries'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchTimesheetsTimesheetIdEntries>>, {timesheetId: string;data: JsonPatchOperation[]}> = (props) => {
          const {timesheetId,data} = props ?? {};

          return  patchTimesheetsTimesheetIdEntries(timesheetId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchTimesheetsTimesheetIdEntriesMutationResult = NonNullable<Awaited<ReturnType<typeof patchTimesheetsTimesheetIdEntries>>>
    export type PatchTimesheetsTimesheetIdEntriesMutationBody = JsonPatchOperation[]
    export type PatchTimesheetsTimesheetIdEntriesMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse

    /**
 * @summary Edit timesheet entries
 */
export const usePatchTimesheetsTimesheetIdEntries = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchTimesheetsTimesheetIdEntries>>, TError,{timesheetId: string;data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchTimesheetsTimesheetIdEntries>>,
        TError,
        {timesheetId: string;data: JsonPatchOperation[]},
        TContext
      > => {

      const mutationOptions = getPatchTimesheetsTimesheetIdEntriesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Re-reads the current status of a payment from the local database. Admin only.
 * @summary Refresh payment status
 */
export const postInvoicePaymentsPaymentIdRefresh = (
    paymentId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PaymentRequestDetail>(
      {url: `/api/v1/invoice-payments/${paymentId}/refresh`, method: 'POST', signal
    },
      options);
    }
  


export const getPostInvoicePaymentsPaymentIdRefreshMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInvoicePaymentsPaymentIdRefresh>>, TError,{paymentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postInvoicePaymentsPaymentIdRefresh>>, TError,{paymentId: string}, TContext> => {

const mutationKey = ['postInvoicePaymentsPaymentIdRefresh'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postInvoicePaymentsPaymentIdRefresh>>, {paymentId: string}> = (props) => {
          const {paymentId} = props ?? {};

          return  postInvoicePaymentsPaymentIdRefresh(paymentId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostInvoicePaymentsPaymentIdRefreshMutationResult = NonNullable<Awaited<ReturnType<typeof postInvoicePaymentsPaymentIdRefresh>>>
    
    export type PostInvoicePaymentsPaymentIdRefreshMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse

    /**
 * @summary Refresh payment status
 */
export const usePostInvoicePaymentsPaymentIdRefresh = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInvoicePaymentsPaymentIdRefresh>>, TError,{paymentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postInvoicePaymentsPaymentIdRefresh>>,
        TError,
        {paymentId: string},
        TContext
      > => {

      const mutationOptions = getPostInvoicePaymentsPaymentIdRefreshMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns payment requests with cursor-based pagination. Includes linked timesheet and user info. Admin only.
 * @summary List payment requests
 */
export const getPaymentsRequests = (
    params?: GetPaymentsRequestsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetPaymentsRequests200>(
      {url: `/api/v1/payments/requests`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetPaymentsRequestsQueryKey = (params?: GetPaymentsRequestsParams,) => {
    return [
    `/api/v1/payments/requests`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPaymentsRequestsQueryOptions = <TData = Awaited<ReturnType<typeof getPaymentsRequests>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(params?: GetPaymentsRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentsRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPaymentsRequestsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPaymentsRequests>>> = ({ signal }) => getPaymentsRequests(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPaymentsRequests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPaymentsRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof getPaymentsRequests>>>
export type GetPaymentsRequestsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetPaymentsRequests<TData = Awaited<ReturnType<typeof getPaymentsRequests>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: undefined |  GetPaymentsRequestsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentsRequests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentsRequests>>,
          TError,
          Awaited<ReturnType<typeof getPaymentsRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentsRequests<TData = Awaited<ReturnType<typeof getPaymentsRequests>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetPaymentsRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentsRequests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentsRequests>>,
          TError,
          Awaited<ReturnType<typeof getPaymentsRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPaymentsRequests<TData = Awaited<ReturnType<typeof getPaymentsRequests>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetPaymentsRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentsRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List payment requests
 */

export function useGetPaymentsRequests<TData = Awaited<ReturnType<typeof getPaymentsRequests>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetPaymentsRequestsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPaymentsRequests>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPaymentsRequestsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get list of Sling integrations
 * @summary List Sling integrations
 */
export const getIntegrationsSling = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetIntegrationsSling200>(
      {url: `/api/v1/integrations/sling`, method: 'GET', signal
    },
      options);
    }
  



export const getGetIntegrationsSlingQueryKey = () => {
    return [
    `/api/v1/integrations/sling`
    ] as const;
    }

    
export const getGetIntegrationsSlingQueryOptions = <TData = Awaited<ReturnType<typeof getIntegrationsSling>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsSling>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntegrationsSlingQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntegrationsSling>>> = ({ signal }) => getIntegrationsSling(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsSling>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIntegrationsSlingQueryResult = NonNullable<Awaited<ReturnType<typeof getIntegrationsSling>>>
export type GetIntegrationsSlingQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetIntegrationsSling<TData = Awaited<ReturnType<typeof getIntegrationsSling>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsSling>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsSling>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsSling>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsSling<TData = Awaited<ReturnType<typeof getIntegrationsSling>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsSling>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsSling>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsSling>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsSling<TData = Awaited<ReturnType<typeof getIntegrationsSling>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsSling>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Sling integrations
 */

export function useGetIntegrationsSling<TData = Awaited<ReturnType<typeof getIntegrationsSling>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsSling>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIntegrationsSlingQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a new Sling integration with email and password
 * @summary Create new Sling integration
 */
export const postIntegrationsSling = (
    postIntegrationsSlingBody: PostIntegrationsSlingBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SlingIntegration>(
      {url: `/api/v1/integrations/sling`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postIntegrationsSlingBody, signal
    },
      options);
    }
  


export const getPostIntegrationsSlingMutationOptions = <TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsSling>>, TError,{data: PostIntegrationsSlingBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsSling>>, TError,{data: PostIntegrationsSlingBody}, TContext> => {

const mutationKey = ['postIntegrationsSling'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIntegrationsSling>>, {data: PostIntegrationsSlingBody}> = (props) => {
          const {data} = props ?? {};

          return  postIntegrationsSling(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostIntegrationsSlingMutationResult = NonNullable<Awaited<ReturnType<typeof postIntegrationsSling>>>
    export type PostIntegrationsSlingMutationBody = PostIntegrationsSlingBody
    export type PostIntegrationsSlingMutationError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Create new Sling integration
 */
export const usePostIntegrationsSling = <TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsSling>>, TError,{data: PostIntegrationsSlingBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postIntegrationsSling>>,
        TError,
        {data: PostIntegrationsSlingBody},
        TContext
      > => {

      const mutationOptions = getPostIntegrationsSlingMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get detailed information about a specific Sling integration
 * @summary Get Sling integration details
 */
export const getIntegrationsSlingIntegrationId = (
    integrationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SlingIntegration>(
      {url: `/api/v1/integrations/sling/${integrationId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetIntegrationsSlingIntegrationIdQueryKey = (integrationId?: string,) => {
    return [
    `/api/v1/integrations/sling/${integrationId}`
    ] as const;
    }

    
export const getGetIntegrationsSlingIntegrationIdQueryOptions = <TData = Awaited<ReturnType<typeof getIntegrationsSlingIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsSlingIntegrationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntegrationsSlingIntegrationIdQueryKey(integrationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntegrationsSlingIntegrationId>>> = ({ signal }) => getIntegrationsSlingIntegrationId(integrationId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(integrationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsSlingIntegrationId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIntegrationsSlingIntegrationIdQueryResult = NonNullable<Awaited<ReturnType<typeof getIntegrationsSlingIntegrationId>>>
export type GetIntegrationsSlingIntegrationIdQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetIntegrationsSlingIntegrationId<TData = Awaited<ReturnType<typeof getIntegrationsSlingIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsSlingIntegrationId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsSlingIntegrationId>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsSlingIntegrationId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsSlingIntegrationId<TData = Awaited<ReturnType<typeof getIntegrationsSlingIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsSlingIntegrationId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsSlingIntegrationId>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsSlingIntegrationId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsSlingIntegrationId<TData = Awaited<ReturnType<typeof getIntegrationsSlingIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsSlingIntegrationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Sling integration details
 */

export function useGetIntegrationsSlingIntegrationId<TData = Awaited<ReturnType<typeof getIntegrationsSlingIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsSlingIntegrationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIntegrationsSlingIntegrationIdQueryOptions(integrationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update Sling integration settings
 * @summary Update Sling integration
 */
export const putIntegrationsSlingIntegrationId = (
    integrationId: string,
    putIntegrationsSlingIntegrationIdBody: PutIntegrationsSlingIntegrationIdBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<SlingIntegration>(
      {url: `/api/v1/integrations/sling/${integrationId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putIntegrationsSlingIntegrationIdBody
    },
      options);
    }
  


export const getPutIntegrationsSlingIntegrationIdMutationOptions = <TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putIntegrationsSlingIntegrationId>>, TError,{integrationId: string;data: PutIntegrationsSlingIntegrationIdBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putIntegrationsSlingIntegrationId>>, TError,{integrationId: string;data: PutIntegrationsSlingIntegrationIdBody}, TContext> => {

const mutationKey = ['putIntegrationsSlingIntegrationId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putIntegrationsSlingIntegrationId>>, {integrationId: string;data: PutIntegrationsSlingIntegrationIdBody}> = (props) => {
          const {integrationId,data} = props ?? {};

          return  putIntegrationsSlingIntegrationId(integrationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutIntegrationsSlingIntegrationIdMutationResult = NonNullable<Awaited<ReturnType<typeof putIntegrationsSlingIntegrationId>>>
    export type PutIntegrationsSlingIntegrationIdMutationBody = PutIntegrationsSlingIntegrationIdBody
    export type PutIntegrationsSlingIntegrationIdMutationError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Update Sling integration
 */
export const usePutIntegrationsSlingIntegrationId = <TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putIntegrationsSlingIntegrationId>>, TError,{integrationId: string;data: PutIntegrationsSlingIntegrationIdBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putIntegrationsSlingIntegrationId>>,
        TError,
        {integrationId: string;data: PutIntegrationsSlingIntegrationIdBody},
        TContext
      > => {

      const mutationOptions = getPutIntegrationsSlingIntegrationIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Soft delete a Sling integration
 * @summary Delete Sling integration
 */
export const deleteIntegrationsSlingIntegrationId = (
    integrationId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<DeleteIntegrationsSlingIntegrationId200>(
      {url: `/api/v1/integrations/sling/${integrationId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteIntegrationsSlingIntegrationIdMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIntegrationsSlingIntegrationId>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteIntegrationsSlingIntegrationId>>, TError,{integrationId: string}, TContext> => {

const mutationKey = ['deleteIntegrationsSlingIntegrationId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteIntegrationsSlingIntegrationId>>, {integrationId: string}> = (props) => {
          const {integrationId} = props ?? {};

          return  deleteIntegrationsSlingIntegrationId(integrationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteIntegrationsSlingIntegrationIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteIntegrationsSlingIntegrationId>>>
    
    export type DeleteIntegrationsSlingIntegrationIdMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Delete Sling integration
 */
export const useDeleteIntegrationsSlingIntegrationId = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIntegrationsSlingIntegrationId>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteIntegrationsSlingIntegrationId>>,
        TError,
        {integrationId: string},
        TContext
      > => {

      const mutationOptions = getDeleteIntegrationsSlingIntegrationIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Test the connection to Sling API and update connection status
 * @summary Test Sling connection
 */
export const postIntegrationsSlingIntegrationIdTestConnection = (
    integrationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostIntegrationsSlingIntegrationIdTestConnection200>(
      {url: `/api/v1/integrations/sling/${integrationId}/test-connection`, method: 'POST', signal
    },
      options);
    }
  


export const getPostIntegrationsSlingIntegrationIdTestConnectionMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsSlingIntegrationIdTestConnection>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsSlingIntegrationIdTestConnection>>, TError,{integrationId: string}, TContext> => {

const mutationKey = ['postIntegrationsSlingIntegrationIdTestConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIntegrationsSlingIntegrationIdTestConnection>>, {integrationId: string}> = (props) => {
          const {integrationId} = props ?? {};

          return  postIntegrationsSlingIntegrationIdTestConnection(integrationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostIntegrationsSlingIntegrationIdTestConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof postIntegrationsSlingIntegrationIdTestConnection>>>
    
    export type PostIntegrationsSlingIntegrationIdTestConnectionMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Test Sling connection
 */
export const usePostIntegrationsSlingIntegrationIdTestConnection = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsSlingIntegrationIdTestConnection>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postIntegrationsSlingIntegrationIdTestConnection>>,
        TError,
        {integrationId: string},
        TContext
      > => {

      const mutationOptions = getPostIntegrationsSlingIntegrationIdTestConnectionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Manually trigger data synchronization with Sling
 * @summary Trigger Sling sync
 */
export const postIntegrationsSlingIntegrationIdSync = (
    integrationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostIntegrationsSlingIntegrationIdSync200>(
      {url: `/api/v1/integrations/sling/${integrationId}/sync`, method: 'POST', signal
    },
      options);
    }
  


export const getPostIntegrationsSlingIntegrationIdSyncMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsSlingIntegrationIdSync>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsSlingIntegrationIdSync>>, TError,{integrationId: string}, TContext> => {

const mutationKey = ['postIntegrationsSlingIntegrationIdSync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIntegrationsSlingIntegrationIdSync>>, {integrationId: string}> = (props) => {
          const {integrationId} = props ?? {};

          return  postIntegrationsSlingIntegrationIdSync(integrationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostIntegrationsSlingIntegrationIdSyncMutationResult = NonNullable<Awaited<ReturnType<typeof postIntegrationsSlingIntegrationIdSync>>>
    
    export type PostIntegrationsSlingIntegrationIdSyncMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Trigger Sling sync
 */
export const usePostIntegrationsSlingIntegrationIdSync = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsSlingIntegrationIdSync>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postIntegrationsSlingIntegrationIdSync>>,
        TError,
        {integrationId: string},
        TContext
      > => {

      const mutationOptions = getPostIntegrationsSlingIntegrationIdSyncMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get list of SendGrid integrations
 * @summary List SendGrid integrations
 */
export const getIntegrationsSendgrid = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetIntegrationsSendgrid200>(
      {url: `/api/v1/integrations/sendgrid`, method: 'GET', signal
    },
      options);
    }
  



export const getGetIntegrationsSendgridQueryKey = () => {
    return [
    `/api/v1/integrations/sendgrid`
    ] as const;
    }

    
export const getGetIntegrationsSendgridQueryOptions = <TData = Awaited<ReturnType<typeof getIntegrationsSendgrid>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsSendgrid>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntegrationsSendgridQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntegrationsSendgrid>>> = ({ signal }) => getIntegrationsSendgrid(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsSendgrid>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIntegrationsSendgridQueryResult = NonNullable<Awaited<ReturnType<typeof getIntegrationsSendgrid>>>
export type GetIntegrationsSendgridQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetIntegrationsSendgrid<TData = Awaited<ReturnType<typeof getIntegrationsSendgrid>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsSendgrid>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsSendgrid>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsSendgrid>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsSendgrid<TData = Awaited<ReturnType<typeof getIntegrationsSendgrid>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsSendgrid>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsSendgrid>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsSendgrid>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsSendgrid<TData = Awaited<ReturnType<typeof getIntegrationsSendgrid>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsSendgrid>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List SendGrid integrations
 */

export function useGetIntegrationsSendgrid<TData = Awaited<ReturnType<typeof getIntegrationsSendgrid>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsSendgrid>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIntegrationsSendgridQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a new SendGrid integration with API key
 * @summary Create new SendGrid integration
 */
export const postIntegrationsSendgrid = (
    postIntegrationsSendgridBody: PostIntegrationsSendgridBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SendGridIntegration>(
      {url: `/api/v1/integrations/sendgrid`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postIntegrationsSendgridBody, signal
    },
      options);
    }
  


export const getPostIntegrationsSendgridMutationOptions = <TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsSendgrid>>, TError,{data: PostIntegrationsSendgridBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsSendgrid>>, TError,{data: PostIntegrationsSendgridBody}, TContext> => {

const mutationKey = ['postIntegrationsSendgrid'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIntegrationsSendgrid>>, {data: PostIntegrationsSendgridBody}> = (props) => {
          const {data} = props ?? {};

          return  postIntegrationsSendgrid(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostIntegrationsSendgridMutationResult = NonNullable<Awaited<ReturnType<typeof postIntegrationsSendgrid>>>
    export type PostIntegrationsSendgridMutationBody = PostIntegrationsSendgridBody
    export type PostIntegrationsSendgridMutationError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Create new SendGrid integration
 */
export const usePostIntegrationsSendgrid = <TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsSendgrid>>, TError,{data: PostIntegrationsSendgridBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postIntegrationsSendgrid>>,
        TError,
        {data: PostIntegrationsSendgridBody},
        TContext
      > => {

      const mutationOptions = getPostIntegrationsSendgridMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get detailed information about a specific SendGrid integration
 * @summary Get SendGrid integration details
 */
export const getIntegrationsSendgridIntegrationId = (
    integrationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SendGridIntegration>(
      {url: `/api/v1/integrations/sendgrid/${integrationId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetIntegrationsSendgridIntegrationIdQueryKey = (integrationId?: string,) => {
    return [
    `/api/v1/integrations/sendgrid/${integrationId}`
    ] as const;
    }

    
export const getGetIntegrationsSendgridIntegrationIdQueryOptions = <TData = Awaited<ReturnType<typeof getIntegrationsSendgridIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsSendgridIntegrationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntegrationsSendgridIntegrationIdQueryKey(integrationId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntegrationsSendgridIntegrationId>>> = ({ signal }) => getIntegrationsSendgridIntegrationId(integrationId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(integrationId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsSendgridIntegrationId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIntegrationsSendgridIntegrationIdQueryResult = NonNullable<Awaited<ReturnType<typeof getIntegrationsSendgridIntegrationId>>>
export type GetIntegrationsSendgridIntegrationIdQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetIntegrationsSendgridIntegrationId<TData = Awaited<ReturnType<typeof getIntegrationsSendgridIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsSendgridIntegrationId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsSendgridIntegrationId>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsSendgridIntegrationId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsSendgridIntegrationId<TData = Awaited<ReturnType<typeof getIntegrationsSendgridIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsSendgridIntegrationId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntegrationsSendgridIntegrationId>>,
          TError,
          Awaited<ReturnType<typeof getIntegrationsSendgridIntegrationId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrationsSendgridIntegrationId<TData = Awaited<ReturnType<typeof getIntegrationsSendgridIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsSendgridIntegrationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get SendGrid integration details
 */

export function useGetIntegrationsSendgridIntegrationId<TData = Awaited<ReturnType<typeof getIntegrationsSendgridIntegrationId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 integrationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntegrationsSendgridIntegrationId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetIntegrationsSendgridIntegrationIdQueryOptions(integrationId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update SendGrid integration settings
 * @summary Update SendGrid integration
 */
export const putIntegrationsSendgridIntegrationId = (
    integrationId: string,
    putIntegrationsSendgridIntegrationIdBody: PutIntegrationsSendgridIntegrationIdBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<SendGridIntegration>(
      {url: `/api/v1/integrations/sendgrid/${integrationId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putIntegrationsSendgridIntegrationIdBody
    },
      options);
    }
  


export const getPutIntegrationsSendgridIntegrationIdMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putIntegrationsSendgridIntegrationId>>, TError,{integrationId: string;data: PutIntegrationsSendgridIntegrationIdBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putIntegrationsSendgridIntegrationId>>, TError,{integrationId: string;data: PutIntegrationsSendgridIntegrationIdBody}, TContext> => {

const mutationKey = ['putIntegrationsSendgridIntegrationId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putIntegrationsSendgridIntegrationId>>, {integrationId: string;data: PutIntegrationsSendgridIntegrationIdBody}> = (props) => {
          const {integrationId,data} = props ?? {};

          return  putIntegrationsSendgridIntegrationId(integrationId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutIntegrationsSendgridIntegrationIdMutationResult = NonNullable<Awaited<ReturnType<typeof putIntegrationsSendgridIntegrationId>>>
    export type PutIntegrationsSendgridIntegrationIdMutationBody = PutIntegrationsSendgridIntegrationIdBody
    export type PutIntegrationsSendgridIntegrationIdMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Update SendGrid integration
 */
export const usePutIntegrationsSendgridIntegrationId = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putIntegrationsSendgridIntegrationId>>, TError,{integrationId: string;data: PutIntegrationsSendgridIntegrationIdBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putIntegrationsSendgridIntegrationId>>,
        TError,
        {integrationId: string;data: PutIntegrationsSendgridIntegrationIdBody},
        TContext
      > => {

      const mutationOptions = getPutIntegrationsSendgridIntegrationIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Soft delete a SendGrid integration
 * @summary Delete SendGrid integration
 */
export const deleteIntegrationsSendgridIntegrationId = (
    integrationId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<DeleteIntegrationsSendgridIntegrationId200>(
      {url: `/api/v1/integrations/sendgrid/${integrationId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteIntegrationsSendgridIntegrationIdMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIntegrationsSendgridIntegrationId>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteIntegrationsSendgridIntegrationId>>, TError,{integrationId: string}, TContext> => {

const mutationKey = ['deleteIntegrationsSendgridIntegrationId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteIntegrationsSendgridIntegrationId>>, {integrationId: string}> = (props) => {
          const {integrationId} = props ?? {};

          return  deleteIntegrationsSendgridIntegrationId(integrationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteIntegrationsSendgridIntegrationIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteIntegrationsSendgridIntegrationId>>>
    
    export type DeleteIntegrationsSendgridIntegrationIdMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Delete SendGrid integration
 */
export const useDeleteIntegrationsSendgridIntegrationId = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteIntegrationsSendgridIntegrationId>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteIntegrationsSendgridIntegrationId>>,
        TError,
        {integrationId: string},
        TContext
      > => {

      const mutationOptions = getDeleteIntegrationsSendgridIntegrationIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Test the connection to SendGrid API and update connection status
 * @summary Test SendGrid connection
 */
export const postIntegrationsSendgridIntegrationIdTestConnection = (
    integrationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostIntegrationsSendgridIntegrationIdTestConnection200>(
      {url: `/api/v1/integrations/sendgrid/${integrationId}/test-connection`, method: 'POST', signal
    },
      options);
    }
  


export const getPostIntegrationsSendgridIntegrationIdTestConnectionMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsSendgridIntegrationIdTestConnection>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsSendgridIntegrationIdTestConnection>>, TError,{integrationId: string}, TContext> => {

const mutationKey = ['postIntegrationsSendgridIntegrationIdTestConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIntegrationsSendgridIntegrationIdTestConnection>>, {integrationId: string}> = (props) => {
          const {integrationId} = props ?? {};

          return  postIntegrationsSendgridIntegrationIdTestConnection(integrationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostIntegrationsSendgridIntegrationIdTestConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof postIntegrationsSendgridIntegrationIdTestConnection>>>
    
    export type PostIntegrationsSendgridIntegrationIdTestConnectionMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Test SendGrid connection
 */
export const usePostIntegrationsSendgridIntegrationIdTestConnection = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsSendgridIntegrationIdTestConnection>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postIntegrationsSendgridIntegrationIdTestConnection>>,
        TError,
        {integrationId: string},
        TContext
      > => {

      const mutationOptions = getPostIntegrationsSendgridIntegrationIdTestConnectionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Sync verified senders from SendGrid.
 * @summary Sync SendGrid data
 */
export const postIntegrationsSendgridIntegrationIdSync = (
    integrationId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostIntegrationsSendgridIntegrationIdSync200>(
      {url: `/api/v1/integrations/sendgrid/${integrationId}/sync`, method: 'POST', signal
    },
      options);
    }
  


export const getPostIntegrationsSendgridIntegrationIdSyncMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsSendgridIntegrationIdSync>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsSendgridIntegrationIdSync>>, TError,{integrationId: string}, TContext> => {

const mutationKey = ['postIntegrationsSendgridIntegrationIdSync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postIntegrationsSendgridIntegrationIdSync>>, {integrationId: string}> = (props) => {
          const {integrationId} = props ?? {};

          return  postIntegrationsSendgridIntegrationIdSync(integrationId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostIntegrationsSendgridIntegrationIdSyncMutationResult = NonNullable<Awaited<ReturnType<typeof postIntegrationsSendgridIntegrationIdSync>>>
    
    export type PostIntegrationsSendgridIntegrationIdSyncMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Sync SendGrid data
 */
export const usePostIntegrationsSendgridIntegrationIdSync = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postIntegrationsSendgridIntegrationIdSync>>, TError,{integrationId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postIntegrationsSendgridIntegrationIdSync>>,
        TError,
        {integrationId: string},
        TContext
      > => {

      const mutationOptions = getPostIntegrationsSendgridIntegrationIdSyncMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get list of all marketing email templates
 * @summary List marketing email templates
 */
export const getMarketingEmails = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetMarketingEmails200>(
      {url: `/api/v1/marketing/emails`, method: 'GET', signal
    },
      options);
    }
  



export const getGetMarketingEmailsQueryKey = () => {
    return [
    `/api/v1/marketing/emails`
    ] as const;
    }

    
export const getGetMarketingEmailsQueryOptions = <TData = Awaited<ReturnType<typeof getMarketingEmails>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMarketingEmailsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingEmails>>> = ({ signal }) => getMarketingEmails(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMarketingEmailsQueryResult = NonNullable<Awaited<ReturnType<typeof getMarketingEmails>>>
export type GetMarketingEmailsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetMarketingEmails<TData = Awaited<ReturnType<typeof getMarketingEmails>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingEmails>>,
          TError,
          Awaited<ReturnType<typeof getMarketingEmails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingEmails<TData = Awaited<ReturnType<typeof getMarketingEmails>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingEmails>>,
          TError,
          Awaited<ReturnType<typeof getMarketingEmails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingEmails<TData = Awaited<ReturnType<typeof getMarketingEmails>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List marketing email templates
 */

export function useGetMarketingEmails<TData = Awaited<ReturnType<typeof getMarketingEmails>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMarketingEmailsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a new marketing email template
 * @summary Create marketing email template
 */
export const postMarketingEmails = (
    postMarketingEmailsBody: PostMarketingEmailsBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MarketingEmail>(
      {url: `/api/v1/marketing/emails`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postMarketingEmailsBody, signal
    },
      options);
    }
  


export const getPostMarketingEmailsMutationOptions = <TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMarketingEmails>>, TError,{data: PostMarketingEmailsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postMarketingEmails>>, TError,{data: PostMarketingEmailsBody}, TContext> => {

const mutationKey = ['postMarketingEmails'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMarketingEmails>>, {data: PostMarketingEmailsBody}> = (props) => {
          const {data} = props ?? {};

          return  postMarketingEmails(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMarketingEmailsMutationResult = NonNullable<Awaited<ReturnType<typeof postMarketingEmails>>>
    export type PostMarketingEmailsMutationBody = PostMarketingEmailsBody
    export type PostMarketingEmailsMutationError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Create marketing email template
 */
export const usePostMarketingEmails = <TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMarketingEmails>>, TError,{data: PostMarketingEmailsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMarketingEmails>>,
        TError,
        {data: PostMarketingEmailsBody},
        TContext
      > => {

      const mutationOptions = getPostMarketingEmailsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get a specific marketing email template by ID
 * @summary Get marketing email template
 */
export const getMarketingEmailsEmailId = (
    emailId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MarketingEmail>(
      {url: `/api/v1/marketing/emails/${emailId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetMarketingEmailsEmailIdQueryKey = (emailId?: string,) => {
    return [
    `/api/v1/marketing/emails/${emailId}`
    ] as const;
    }

    
export const getGetMarketingEmailsEmailIdQueryOptions = <TData = Awaited<ReturnType<typeof getMarketingEmailsEmailId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(emailId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailsEmailId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMarketingEmailsEmailIdQueryKey(emailId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingEmailsEmailId>>> = ({ signal }) => getMarketingEmailsEmailId(emailId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(emailId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailsEmailId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMarketingEmailsEmailIdQueryResult = NonNullable<Awaited<ReturnType<typeof getMarketingEmailsEmailId>>>
export type GetMarketingEmailsEmailIdQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetMarketingEmailsEmailId<TData = Awaited<ReturnType<typeof getMarketingEmailsEmailId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 emailId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailsEmailId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingEmailsEmailId>>,
          TError,
          Awaited<ReturnType<typeof getMarketingEmailsEmailId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingEmailsEmailId<TData = Awaited<ReturnType<typeof getMarketingEmailsEmailId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 emailId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailsEmailId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingEmailsEmailId>>,
          TError,
          Awaited<ReturnType<typeof getMarketingEmailsEmailId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingEmailsEmailId<TData = Awaited<ReturnType<typeof getMarketingEmailsEmailId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 emailId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailsEmailId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get marketing email template
 */

export function useGetMarketingEmailsEmailId<TData = Awaited<ReturnType<typeof getMarketingEmailsEmailId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 emailId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailsEmailId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMarketingEmailsEmailIdQueryOptions(emailId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update an existing marketing email template
 * @summary Update marketing email template
 */
export const putMarketingEmailsEmailId = (
    emailId: string,
    putMarketingEmailsEmailIdBody: PutMarketingEmailsEmailIdBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<MarketingEmail>(
      {url: `/api/v1/marketing/emails/${emailId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putMarketingEmailsEmailIdBody
    },
      options);
    }
  


export const getPutMarketingEmailsEmailIdMutationOptions = <TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMarketingEmailsEmailId>>, TError,{emailId: string;data: PutMarketingEmailsEmailIdBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putMarketingEmailsEmailId>>, TError,{emailId: string;data: PutMarketingEmailsEmailIdBody}, TContext> => {

const mutationKey = ['putMarketingEmailsEmailId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putMarketingEmailsEmailId>>, {emailId: string;data: PutMarketingEmailsEmailIdBody}> = (props) => {
          const {emailId,data} = props ?? {};

          return  putMarketingEmailsEmailId(emailId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutMarketingEmailsEmailIdMutationResult = NonNullable<Awaited<ReturnType<typeof putMarketingEmailsEmailId>>>
    export type PutMarketingEmailsEmailIdMutationBody = PutMarketingEmailsEmailIdBody
    export type PutMarketingEmailsEmailIdMutationError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Update marketing email template
 */
export const usePutMarketingEmailsEmailId = <TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMarketingEmailsEmailId>>, TError,{emailId: string;data: PutMarketingEmailsEmailIdBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putMarketingEmailsEmailId>>,
        TError,
        {emailId: string;data: PutMarketingEmailsEmailIdBody},
        TContext
      > => {

      const mutationOptions = getPutMarketingEmailsEmailIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Soft delete a marketing email template
 * @summary Delete marketing email template
 */
export const deleteMarketingEmailsEmailId = (
    emailId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<DeleteMarketingEmailsEmailId200>(
      {url: `/api/v1/marketing/emails/${emailId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteMarketingEmailsEmailIdMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMarketingEmailsEmailId>>, TError,{emailId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMarketingEmailsEmailId>>, TError,{emailId: string}, TContext> => {

const mutationKey = ['deleteMarketingEmailsEmailId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMarketingEmailsEmailId>>, {emailId: string}> = (props) => {
          const {emailId} = props ?? {};

          return  deleteMarketingEmailsEmailId(emailId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteMarketingEmailsEmailIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMarketingEmailsEmailId>>>
    
    export type DeleteMarketingEmailsEmailIdMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Delete marketing email template
 */
export const useDeleteMarketingEmailsEmailId = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMarketingEmailsEmailId>>, TError,{emailId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteMarketingEmailsEmailId>>,
        TError,
        {emailId: string},
        TContext
      > => {

      const mutationOptions = getDeleteMarketingEmailsEmailIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get list of verified senders available for marketing emails
 * @summary List available senders
 */
export const getMarketingEmailsSenders = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetMarketingEmailsSenders200>(
      {url: `/api/v1/marketing/emails/senders`, method: 'GET', signal
    },
      options);
    }
  



export const getGetMarketingEmailsSendersQueryKey = () => {
    return [
    `/api/v1/marketing/emails/senders`
    ] as const;
    }

    
export const getGetMarketingEmailsSendersQueryOptions = <TData = Awaited<ReturnType<typeof getMarketingEmailsSenders>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailsSenders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMarketingEmailsSendersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingEmailsSenders>>> = ({ signal }) => getMarketingEmailsSenders(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailsSenders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMarketingEmailsSendersQueryResult = NonNullable<Awaited<ReturnType<typeof getMarketingEmailsSenders>>>
export type GetMarketingEmailsSendersQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetMarketingEmailsSenders<TData = Awaited<ReturnType<typeof getMarketingEmailsSenders>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailsSenders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingEmailsSenders>>,
          TError,
          Awaited<ReturnType<typeof getMarketingEmailsSenders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingEmailsSenders<TData = Awaited<ReturnType<typeof getMarketingEmailsSenders>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailsSenders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingEmailsSenders>>,
          TError,
          Awaited<ReturnType<typeof getMarketingEmailsSenders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingEmailsSenders<TData = Awaited<ReturnType<typeof getMarketingEmailsSenders>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailsSenders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List available senders
 */

export function useGetMarketingEmailsSenders<TData = Awaited<ReturnType<typeof getMarketingEmailsSenders>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailsSenders>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMarketingEmailsSendersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Send a marketing email to specified lists
 * @summary Send marketing email
 */
export const postMarketingEmailsEmailIdSend = (
    emailId: string,
    postMarketingEmailsEmailIdSendBody: PostMarketingEmailsEmailIdSendBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostMarketingEmailsEmailIdSend200>(
      {url: `/api/v1/marketing/emails/${emailId}/send`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postMarketingEmailsEmailIdSendBody, signal
    },
      options);
    }
  


export const getPostMarketingEmailsEmailIdSendMutationOptions = <TError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMarketingEmailsEmailIdSend>>, TError,{emailId: string;data: PostMarketingEmailsEmailIdSendBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postMarketingEmailsEmailIdSend>>, TError,{emailId: string;data: PostMarketingEmailsEmailIdSendBody}, TContext> => {

const mutationKey = ['postMarketingEmailsEmailIdSend'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMarketingEmailsEmailIdSend>>, {emailId: string;data: PostMarketingEmailsEmailIdSendBody}> = (props) => {
          const {emailId,data} = props ?? {};

          return  postMarketingEmailsEmailIdSend(emailId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMarketingEmailsEmailIdSendMutationResult = NonNullable<Awaited<ReturnType<typeof postMarketingEmailsEmailIdSend>>>
    export type PostMarketingEmailsEmailIdSendMutationBody = PostMarketingEmailsEmailIdSendBody
    export type PostMarketingEmailsEmailIdSendMutationError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Send marketing email
 */
export const usePostMarketingEmailsEmailIdSend = <TError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMarketingEmailsEmailIdSend>>, TError,{emailId: string;data: PostMarketingEmailsEmailIdSendBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMarketingEmailsEmailIdSend>>,
        TError,
        {emailId: string;data: PostMarketingEmailsEmailIdSendBody},
        TContext
      > => {

      const mutationOptions = getPostMarketingEmailsEmailIdSendMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Imports quota configurations from the legacy commissions-config.json format used by asg-tool
 * @summary Import commission config from legacy JSON
 */
export const postCommissionsImportConfig = (
    postCommissionsImportConfigBody: PostCommissionsImportConfigBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostCommissionsImportConfig200>(
      {url: `/api/v1/commissions/import-config`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postCommissionsImportConfigBody, signal
    },
      options);
    }
  


export const getPostCommissionsImportConfigMutationOptions = <TError = PostCommissionsImportConfig400 | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCommissionsImportConfig>>, TError,{data: PostCommissionsImportConfigBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCommissionsImportConfig>>, TError,{data: PostCommissionsImportConfigBody}, TContext> => {

const mutationKey = ['postCommissionsImportConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCommissionsImportConfig>>, {data: PostCommissionsImportConfigBody}> = (props) => {
          const {data} = props ?? {};

          return  postCommissionsImportConfig(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCommissionsImportConfigMutationResult = NonNullable<Awaited<ReturnType<typeof postCommissionsImportConfig>>>
    export type PostCommissionsImportConfigMutationBody = PostCommissionsImportConfigBody
    export type PostCommissionsImportConfigMutationError = PostCommissionsImportConfig400 | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Import commission config from legacy JSON
 */
export const usePostCommissionsImportConfig = <TError = PostCommissionsImportConfig400 | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCommissionsImportConfig>>, TError,{data: PostCommissionsImportConfigBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCommissionsImportConfig>>,
        TError,
        {data: PostCommissionsImportConfigBody},
        TContext
      > => {

      const mutationOptions = getPostCommissionsImportConfigMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Surfaces "stranded" counterparties for the Issues view: bank
transactions whose memo matches the commission prefilter regex
and would normally derive a CommissionPayment, but whose
counterparty has no Payee linked to a dashboard user.

Aggregated by (src_type, src_id, counterparty_id). Each row
carries the BT count, total amount, and earliest/latest dates,
so the operator sees the scope of what's blocked behind a
single payee link without having to scroll through every BT.

payee_id is the existing Payee row when one exists (Mercury
usually has one because its sync auto-creates payees from
recipients; file source has one only after syncFileAccountPayees
has run i.e. after a re-upload under the new code). When
payee_id is null the operator must either re-upload the source
file (file source) or wait for the next Mercury sync to
materialize the payee row before they can link it.

 * @summary List counterparties whose commission bank-transactions can't derive payments
 */
export const getCommissionsStrandedBankTransactions = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetCommissionsStrandedBankTransactions200>(
      {url: `/api/v1/commissions/stranded-bank-transactions`, method: 'GET', signal
    },
      options);
    }
  



export const getGetCommissionsStrandedBankTransactionsQueryKey = () => {
    return [
    `/api/v1/commissions/stranded-bank-transactions`
    ] as const;
    }

    
export const getGetCommissionsStrandedBankTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof getCommissionsStrandedBankTransactions>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsStrandedBankTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCommissionsStrandedBankTransactionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCommissionsStrandedBankTransactions>>> = ({ signal }) => getCommissionsStrandedBankTransactions(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCommissionsStrandedBankTransactions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCommissionsStrandedBankTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof getCommissionsStrandedBankTransactions>>>
export type GetCommissionsStrandedBankTransactionsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetCommissionsStrandedBankTransactions<TData = Awaited<ReturnType<typeof getCommissionsStrandedBankTransactions>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsStrandedBankTransactions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommissionsStrandedBankTransactions>>,
          TError,
          Awaited<ReturnType<typeof getCommissionsStrandedBankTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommissionsStrandedBankTransactions<TData = Awaited<ReturnType<typeof getCommissionsStrandedBankTransactions>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsStrandedBankTransactions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommissionsStrandedBankTransactions>>,
          TError,
          Awaited<ReturnType<typeof getCommissionsStrandedBankTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommissionsStrandedBankTransactions<TData = Awaited<ReturnType<typeof getCommissionsStrandedBankTransactions>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsStrandedBankTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List counterparties whose commission bank-transactions can't derive payments
 */

export function useGetCommissionsStrandedBankTransactions<TData = Awaited<ReturnType<typeof getCommissionsStrandedBankTransactions>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsStrandedBankTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCommissionsStrandedBankTransactionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Returns every quota_config_uploads row, paired with its mapped
SalesQuota live row when one exists, plus a list of drift
messages naming any field where the upload's value differs
from the mapped live row. Empty drift_messages on a mapped
row means upload + live agree.

 * @summary List quota config upload rows (with mapped live row + drift)
 */
export const getCommissionsUploads = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetCommissionsUploads200>(
      {url: `/api/v1/commissions/uploads`, method: 'GET', signal
    },
      options);
    }
  



export const getGetCommissionsUploadsQueryKey = () => {
    return [
    `/api/v1/commissions/uploads`
    ] as const;
    }

    
export const getGetCommissionsUploadsQueryOptions = <TData = Awaited<ReturnType<typeof getCommissionsUploads>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsUploads>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCommissionsUploadsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCommissionsUploads>>> = ({ signal }) => getCommissionsUploads(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCommissionsUploads>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCommissionsUploadsQueryResult = NonNullable<Awaited<ReturnType<typeof getCommissionsUploads>>>
export type GetCommissionsUploadsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetCommissionsUploads<TData = Awaited<ReturnType<typeof getCommissionsUploads>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsUploads>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommissionsUploads>>,
          TError,
          Awaited<ReturnType<typeof getCommissionsUploads>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommissionsUploads<TData = Awaited<ReturnType<typeof getCommissionsUploads>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsUploads>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommissionsUploads>>,
          TError,
          Awaited<ReturnType<typeof getCommissionsUploads>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommissionsUploads<TData = Awaited<ReturnType<typeof getCommissionsUploads>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsUploads>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List quota config upload rows (with mapped live row + drift)
 */

export function useGetCommissionsUploads<TData = Awaited<ReturnType<typeof getCommissionsUploads>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsUploads>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCommissionsUploadsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Bulk-deletes every quota_config_uploads row whose
mapped_quota_id is null. Mapped uploads (those linked to a
live SalesQuota row) are not touched.

 * @summary Delete every unmapped quota config upload
 */
export const deleteCommissionsUploads = (
    
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<DeleteCommissionsUploads200>(
      {url: `/api/v1/commissions/uploads`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteCommissionsUploadsMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCommissionsUploads>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCommissionsUploads>>, TError,void, TContext> => {

const mutationKey = ['deleteCommissionsUploads'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCommissionsUploads>>, void> = () => {
          

          return  deleteCommissionsUploads(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCommissionsUploadsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCommissionsUploads>>>
    
    export type DeleteCommissionsUploadsMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Delete every unmapped quota config upload
 */
export const useDeleteCommissionsUploads = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCommissionsUploads>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCommissionsUploads>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getDeleteCommissionsUploadsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Deletes one quota_config_uploads row. If the row was mapped
(has mapped_quota_id), the linked SalesQuota live row is NOT
affected — only the upload provenance pointer is broken. The
live row keeps applying to commissions until separately
deleted via the per-user delete endpoint.

 * @summary Delete a quota config upload by id
 */
export const deleteCommissionsUploadsId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/commissions/uploads/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteCommissionsUploadsIdMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCommissionsUploadsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCommissionsUploadsId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteCommissionsUploadsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCommissionsUploadsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteCommissionsUploadsId(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCommissionsUploadsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCommissionsUploadsId>>>
    
    export type DeleteCommissionsUploadsIdMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Delete a quota config upload by id
 */
export const useDeleteCommissionsUploadsId = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCommissionsUploadsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCommissionsUploadsId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteCommissionsUploadsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Validates every supplied upload against existing live
SalesQuota rows AND against every other candidate in the
batch. If any candidate would overlap, the whole batch is
rejected (409, no writes) with a per-upload-id conflict map
so the operator can see exactly which rows fail and why.
Otherwise every upload is mapped in a single transaction —
all-or-none semantics, so a partial-success outcome is
impossible.

 * @summary Atomically map a batch of uploads to one user
 */
export const postCommissionsUploadsMapBatch = (
    postCommissionsUploadsMapBatchBody: PostCommissionsUploadsMapBatchBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostCommissionsUploadsMapBatch200>(
      {url: `/api/v1/commissions/uploads/map-batch`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postCommissionsUploadsMapBatchBody, signal
    },
      options);
    }
  


export const getPostCommissionsUploadsMapBatchMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void | UploadsMapBatchConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCommissionsUploadsMapBatch>>, TError,{data: PostCommissionsUploadsMapBatchBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCommissionsUploadsMapBatch>>, TError,{data: PostCommissionsUploadsMapBatchBody}, TContext> => {

const mutationKey = ['postCommissionsUploadsMapBatch'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCommissionsUploadsMapBatch>>, {data: PostCommissionsUploadsMapBatchBody}> = (props) => {
          const {data} = props ?? {};

          return  postCommissionsUploadsMapBatch(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCommissionsUploadsMapBatchMutationResult = NonNullable<Awaited<ReturnType<typeof postCommissionsUploadsMapBatch>>>
    export type PostCommissionsUploadsMapBatchMutationBody = PostCommissionsUploadsMapBatchBody
    export type PostCommissionsUploadsMapBatchMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void | UploadsMapBatchConflictResponse

    /**
 * @summary Atomically map a batch of uploads to one user
 */
export const usePostCommissionsUploadsMapBatch = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void | UploadsMapBatchConflictResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCommissionsUploadsMapBatch>>, TError,{data: PostCommissionsUploadsMapBatchBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCommissionsUploadsMapBatch>>,
        TError,
        {data: PostCommissionsUploadsMapBatchBody},
        TContext
      > => {

      const mutationOptions = getPostCommissionsUploadsMapBatchMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Deletes a sales_quotas row regardless of its user_id link state.
Use this to clean up imported entries — including unlinked ones
which the per-user delete endpoint cannot reach because it
requires a user_id path match.

 * @summary Delete a sales quota by id
 */
export const deleteCommissionsQuotasId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/commissions/quotas/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteCommissionsQuotasIdMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCommissionsQuotasId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCommissionsQuotasId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteCommissionsQuotasId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCommissionsQuotasId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteCommissionsQuotasId(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCommissionsQuotasIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCommissionsQuotasId>>>
    
    export type DeleteCommissionsQuotasIdMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Delete a sales quota by id
 */
export const useDeleteCommissionsQuotasId = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCommissionsQuotasId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCommissionsQuotasId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteCommissionsQuotasIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Lists per-(invoice, user, role) diff rows for the parallel-run
commissions_v2 engine. Each row pairs the new engine's
shadow_commission_rows output against what was actually paid
out (sum of commission_payment_invoices for the row) and runs
the classifier to tag explanatory categories.

Read-only — the shadow tables are written by the engine's sync
hooks. Pre-cutover this endpoint backs the operator review
surface; post-cutover the categories collapse to "no diff"
because the new engine is the source of truth for payouts.

No pagination yet — Phase 1 returns the full row set in one
response (current scale: 4 salespeople, hundreds of invoices).
Add pagination here if/when the row count justifies it.

 * @summary List commissions_v2 diff rows
 */
export const getCommissionsDiff = (
    params?: GetCommissionsDiffParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetCommissionsDiff200>(
      {url: `/api/v1/commissions/diff`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetCommissionsDiffQueryKey = (params?: GetCommissionsDiffParams,) => {
    return [
    `/api/v1/commissions/diff`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCommissionsDiffQueryOptions = <TData = Awaited<ReturnType<typeof getCommissionsDiff>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(params?: GetCommissionsDiffParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsDiff>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCommissionsDiffQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCommissionsDiff>>> = ({ signal }) => getCommissionsDiff(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCommissionsDiff>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCommissionsDiffQueryResult = NonNullable<Awaited<ReturnType<typeof getCommissionsDiff>>>
export type GetCommissionsDiffQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetCommissionsDiff<TData = Awaited<ReturnType<typeof getCommissionsDiff>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: undefined |  GetCommissionsDiffParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsDiff>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommissionsDiff>>,
          TError,
          Awaited<ReturnType<typeof getCommissionsDiff>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommissionsDiff<TData = Awaited<ReturnType<typeof getCommissionsDiff>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetCommissionsDiffParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsDiff>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommissionsDiff>>,
          TError,
          Awaited<ReturnType<typeof getCommissionsDiff>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommissionsDiff<TData = Awaited<ReturnType<typeof getCommissionsDiff>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetCommissionsDiffParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsDiff>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List commissions_v2 diff rows
 */

export function useGetCommissionsDiff<TData = Awaited<ReturnType<typeof getCommissionsDiff>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetCommissionsDiffParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsDiff>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCommissionsDiffQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Enqueues a commissions engine recompute on the shared sync
event manager and returns the sync ID immediately. The
recompute runs serialized against other sync work (QB,
Mercury, events) on the same goroutine, gets a sync_runs
row, and broadcasts progress / completion over SSE under
the returned sync_id.

Same code path the auto-triggers (QB / Mercury sync PostSync
hooks, CRUD edits, periodic) use — this is the operator
button on the diff page.

 * @summary Enqueue a commissions engine recompute
 */
export const postCommissionsDiffRecompute = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostCommissionsDiffRecompute200>(
      {url: `/api/v1/commissions/diff/recompute`, method: 'POST', signal
    },
      options);
    }
  


export const getPostCommissionsDiffRecomputeMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCommissionsDiffRecompute>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCommissionsDiffRecompute>>, TError,void, TContext> => {

const mutationKey = ['postCommissionsDiffRecompute'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCommissionsDiffRecompute>>, void> = () => {
          

          return  postCommissionsDiffRecompute(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCommissionsDiffRecomputeMutationResult = NonNullable<Awaited<ReturnType<typeof postCommissionsDiffRecompute>>>
    
    export type PostCommissionsDiffRecomputeMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Enqueue a commissions engine recompute
 */
export const usePostCommissionsDiffRecompute = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCommissionsDiffRecompute>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCommissionsDiffRecompute>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostCommissionsDiffRecomputeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Upserts a commission_diff_reviews row keyed by (invoice_src_id,
invoice_id, user_id, role). Status transitions: pending →
expected (operator confirmed the new-engine result is correct)
or pending → investigate (operator flagged for follow-up).

Sets reviewed_by_user_id + reviewed_at to the caller + now on
every write so the audit trail captures who reviewed and when.

 * @summary Set review state on a commissions_v2 diff row
 */
export const putCommissionsDiffReview = (
    commissionDiffReviewWrite: CommissionDiffReviewWrite,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CommissionDiff>(
      {url: `/api/v1/commissions/diff/review`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: commissionDiffReviewWrite
    },
      options);
    }
  


export const getPutCommissionsDiffReviewMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCommissionsDiffReview>>, TError,{data: CommissionDiffReviewWrite}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putCommissionsDiffReview>>, TError,{data: CommissionDiffReviewWrite}, TContext> => {

const mutationKey = ['putCommissionsDiffReview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putCommissionsDiffReview>>, {data: CommissionDiffReviewWrite}> = (props) => {
          const {data} = props ?? {};

          return  putCommissionsDiffReview(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutCommissionsDiffReviewMutationResult = NonNullable<Awaited<ReturnType<typeof putCommissionsDiffReview>>>
    export type PutCommissionsDiffReviewMutationBody = CommissionDiffReviewWrite
    export type PutCommissionsDiffReviewMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse

    /**
 * @summary Set review state on a commissions_v2 diff row
 */
export const usePutCommissionsDiffReview = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putCommissionsDiffReview>>, TError,{data: CommissionDiffReviewWrite}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putCommissionsDiffReview>>,
        TError,
        {data: CommissionDiffReviewWrite},
        TContext
      > => {

      const mutationOptions = getPutCommissionsDiffReviewMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Cursor-paginated list of named, persistent projection scenarios.
Each projection holds gate-override params + a date range and a
snapshot of computed projection_commissions rows. Shared across
all admin/finance/vp_sales/sales_manager (no per-user ownership).

 * @summary List commission projections
 */
export const getCommissionsProjections = (
    params?: GetCommissionsProjectionsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetCommissionsProjections200>(
      {url: `/api/v1/commissions/projections`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetCommissionsProjectionsQueryKey = (params?: GetCommissionsProjectionsParams,) => {
    return [
    `/api/v1/commissions/projections`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCommissionsProjectionsQueryOptions = <TData = Awaited<ReturnType<typeof getCommissionsProjections>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(params?: GetCommissionsProjectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsProjections>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCommissionsProjectionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCommissionsProjections>>> = ({ signal }) => getCommissionsProjections(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCommissionsProjections>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCommissionsProjectionsQueryResult = NonNullable<Awaited<ReturnType<typeof getCommissionsProjections>>>
export type GetCommissionsProjectionsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetCommissionsProjections<TData = Awaited<ReturnType<typeof getCommissionsProjections>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: undefined |  GetCommissionsProjectionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsProjections>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommissionsProjections>>,
          TError,
          Awaited<ReturnType<typeof getCommissionsProjections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommissionsProjections<TData = Awaited<ReturnType<typeof getCommissionsProjections>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetCommissionsProjectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsProjections>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommissionsProjections>>,
          TError,
          Awaited<ReturnType<typeof getCommissionsProjections>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommissionsProjections<TData = Awaited<ReturnType<typeof getCommissionsProjections>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetCommissionsProjectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsProjections>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List commission projections
 */

export function useGetCommissionsProjections<TData = Awaited<ReturnType<typeof getCommissionsProjections>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetCommissionsProjectionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsProjections>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCommissionsProjectionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Creates a new projection with the supplied params. Does NOT
auto-recalculate — caller follows up with POST
/commissions/projections/{id}/recalculate when ready.

 * @summary Create a commission projection
 */
export const postCommissionsProjections = (
    projectionCreate: ProjectionCreate,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Projection>(
      {url: `/api/v1/commissions/projections`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: projectionCreate, signal
    },
      options);
    }
  


export const getPostCommissionsProjectionsMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCommissionsProjections>>, TError,{data: ProjectionCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCommissionsProjections>>, TError,{data: ProjectionCreate}, TContext> => {

const mutationKey = ['postCommissionsProjections'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCommissionsProjections>>, {data: ProjectionCreate}> = (props) => {
          const {data} = props ?? {};

          return  postCommissionsProjections(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCommissionsProjectionsMutationResult = NonNullable<Awaited<ReturnType<typeof postCommissionsProjections>>>
    export type PostCommissionsProjectionsMutationBody = ProjectionCreate
    export type PostCommissionsProjectionsMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Create a commission projection
 */
export const usePostCommissionsProjections = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCommissionsProjections>>, TError,{data: ProjectionCreate}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCommissionsProjections>>,
        TError,
        {data: ProjectionCreate},
        TContext
      > => {

      const mutationOptions = getPostCommissionsProjectionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Fetch a single commission projection
 */
export const getCommissionsProjectionsId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Projection>(
      {url: `/api/v1/commissions/projections/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetCommissionsProjectionsIdQueryKey = (id?: string,) => {
    return [
    `/api/v1/commissions/projections/${id}`
    ] as const;
    }

    
export const getGetCommissionsProjectionsIdQueryOptions = <TData = Awaited<ReturnType<typeof getCommissionsProjectionsId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsProjectionsId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCommissionsProjectionsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCommissionsProjectionsId>>> = ({ signal }) => getCommissionsProjectionsId(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCommissionsProjectionsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCommissionsProjectionsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCommissionsProjectionsId>>>
export type GetCommissionsProjectionsIdQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse


export function useGetCommissionsProjectionsId<TData = Awaited<ReturnType<typeof getCommissionsProjectionsId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsProjectionsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommissionsProjectionsId>>,
          TError,
          Awaited<ReturnType<typeof getCommissionsProjectionsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommissionsProjectionsId<TData = Awaited<ReturnType<typeof getCommissionsProjectionsId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsProjectionsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommissionsProjectionsId>>,
          TError,
          Awaited<ReturnType<typeof getCommissionsProjectionsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommissionsProjectionsId<TData = Awaited<ReturnType<typeof getCommissionsProjectionsId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsProjectionsId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Fetch a single commission projection
 */

export function useGetCommissionsProjectionsId<TData = Awaited<ReturnType<typeof getCommissionsProjectionsId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsProjectionsId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCommissionsProjectionsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Updates name / date range / gate overrides / show_mode via
JSON-PATCH (RFC 6902). Does NOT auto-recalculate — operator
explicitly hits Save & Recalculate.

 * @summary Update a commission projection (JSON-PATCH)
 */
export const patchCommissionsProjectionsId = (
    id: string,
    jsonPatchOperation: JsonPatchOperation[],
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<Projection>(
      {url: `/api/v1/commissions/projections/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json-patch+json', },
      data: jsonPatchOperation
    },
      options);
    }
  


export const getPatchCommissionsProjectionsIdMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCommissionsProjectionsId>>, TError,{id: string;data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchCommissionsProjectionsId>>, TError,{id: string;data: JsonPatchOperation[]}, TContext> => {

const mutationKey = ['patchCommissionsProjectionsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchCommissionsProjectionsId>>, {id: string;data: JsonPatchOperation[]}> = (props) => {
          const {id,data} = props ?? {};

          return  patchCommissionsProjectionsId(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchCommissionsProjectionsIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchCommissionsProjectionsId>>>
    export type PatchCommissionsProjectionsIdMutationBody = JsonPatchOperation[]
    export type PatchCommissionsProjectionsIdMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse

    /**
 * @summary Update a commission projection (JSON-PATCH)
 */
export const usePatchCommissionsProjectionsId = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCommissionsProjectionsId>>, TError,{id: string;data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchCommissionsProjectionsId>>,
        TError,
        {id: string;data: JsonPatchOperation[]},
        TContext
      > => {

      const mutationOptions = getPatchCommissionsProjectionsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Soft-deletes the projection. The projection_commissions /
projection_commission_entries rows are NOT deleted but no longer
accessible (list endpoint filters by deleted_at IS NULL; the
invoices endpoint 404s the parent projection).

 * @summary Soft-delete a commission projection
 */
export const deleteCommissionsProjectionsId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<DeleteCommissionsProjectionsId200>(
      {url: `/api/v1/commissions/projections/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteCommissionsProjectionsIdMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCommissionsProjectionsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCommissionsProjectionsId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteCommissionsProjectionsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCommissionsProjectionsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteCommissionsProjectionsId(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCommissionsProjectionsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCommissionsProjectionsId>>>
    
    export type DeleteCommissionsProjectionsIdMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse

    /**
 * @summary Soft-delete a commission projection
 */
export const useDeleteCommissionsProjectionsId = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCommissionsProjectionsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCommissionsProjectionsId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteCommissionsProjectionsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Kicks off the engine in projection mode for this projection_id.
Returns the sync_id immediately; subscribe via SSE for progress.
Writes scoped to projection_commissions /
projection_commission_entries — live commissions tables untouched.

 * @summary Enqueue a projection recompute
 */
export const postCommissionsProjectionsIdRecalculate = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostCommissionsProjectionsIdRecalculate200>(
      {url: `/api/v1/commissions/projections/${id}/recalculate`, method: 'POST', signal
    },
      options);
    }
  


export const getPostCommissionsProjectionsIdRecalculateMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCommissionsProjectionsIdRecalculate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCommissionsProjectionsIdRecalculate>>, TError,{id: string}, TContext> => {

const mutationKey = ['postCommissionsProjectionsIdRecalculate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCommissionsProjectionsIdRecalculate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postCommissionsProjectionsIdRecalculate(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCommissionsProjectionsIdRecalculateMutationResult = NonNullable<Awaited<ReturnType<typeof postCommissionsProjectionsIdRecalculate>>>
    
    export type PostCommissionsProjectionsIdRecalculateMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse

    /**
 * @summary Enqueue a projection recompute
 */
export const usePostCommissionsProjectionsIdRecalculate = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCommissionsProjectionsIdRecalculate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCommissionsProjectionsIdRecalculate>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostCommissionsProjectionsIdRecalculateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns per-period commission summaries for a user over a date range.
Cursor-paginated; each record is one period's rollup (quota, revenue,
commissions, paid, owed, per-role breakdown). Single-period queries
simply request a 1-period range and read data[0].

 * @summary List commission period summaries
 */
export const getCommissionsUserId = (
    userId: string,
    params?: GetCommissionsUserIdParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetCommissionsUserId200>(
      {url: `/api/v1/commissions/${userId}`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetCommissionsUserIdQueryKey = (userId?: string,
    params?: GetCommissionsUserIdParams,) => {
    return [
    `/api/v1/commissions/${userId}`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCommissionsUserIdQueryOptions = <TData = Awaited<ReturnType<typeof getCommissionsUserId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(userId: string,
    params?: GetCommissionsUserIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsUserId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCommissionsUserIdQueryKey(userId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCommissionsUserId>>> = ({ signal }) => getCommissionsUserId(userId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCommissionsUserId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCommissionsUserIdQueryResult = NonNullable<Awaited<ReturnType<typeof getCommissionsUserId>>>
export type GetCommissionsUserIdQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetCommissionsUserId<TData = Awaited<ReturnType<typeof getCommissionsUserId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string,
    params: undefined |  GetCommissionsUserIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsUserId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommissionsUserId>>,
          TError,
          Awaited<ReturnType<typeof getCommissionsUserId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommissionsUserId<TData = Awaited<ReturnType<typeof getCommissionsUserId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string,
    params?: GetCommissionsUserIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsUserId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommissionsUserId>>,
          TError,
          Awaited<ReturnType<typeof getCommissionsUserId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommissionsUserId<TData = Awaited<ReturnType<typeof getCommissionsUserId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string,
    params?: GetCommissionsUserIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsUserId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List commission period summaries
 */

export function useGetCommissionsUserId<TData = Awaited<ReturnType<typeof getCommissionsUserId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string,
    params?: GetCommissionsUserIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsUserId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCommissionsUserIdQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Cursor-paginated list of invoices attributed to the given user
for the period. One row per attribution (a user with both a
salesperson AND a sales-lead attribution on the same invoice
gets two rows). Per-row commission_status / commission_due /
commission_paid / commission_last_paid_at fields come from the
same enrichment used by the per-period summary.

user_id sentinels:
  - "me"   → the caller's own user_id
  - "team" → cross-team scope: admin/finance/vp_sales see every
             commissionable attribution; sales_manager sees self
             plus their recursive direct/indirect reports.

period_start / period_end are optional. When omitted, no date
filter is applied (matches the DatePeriodNavigation 'all' mode).

 * @summary List commissionable invoices for a user (or team)
 */
export const getCommissionsUserIdInvoices = (
    userId: string,
    params?: GetCommissionsUserIdInvoicesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetCommissionsUserIdInvoices200>(
      {url: `/api/v1/commissions/${userId}/invoices`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetCommissionsUserIdInvoicesQueryKey = (userId?: string,
    params?: GetCommissionsUserIdInvoicesParams,) => {
    return [
    `/api/v1/commissions/${userId}/invoices`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCommissionsUserIdInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof getCommissionsUserIdInvoices>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(userId: string,
    params?: GetCommissionsUserIdInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsUserIdInvoices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCommissionsUserIdInvoicesQueryKey(userId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCommissionsUserIdInvoices>>> = ({ signal }) => getCommissionsUserIdInvoices(userId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCommissionsUserIdInvoices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCommissionsUserIdInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof getCommissionsUserIdInvoices>>>
export type GetCommissionsUserIdInvoicesQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetCommissionsUserIdInvoices<TData = Awaited<ReturnType<typeof getCommissionsUserIdInvoices>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string,
    params: undefined |  GetCommissionsUserIdInvoicesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsUserIdInvoices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommissionsUserIdInvoices>>,
          TError,
          Awaited<ReturnType<typeof getCommissionsUserIdInvoices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommissionsUserIdInvoices<TData = Awaited<ReturnType<typeof getCommissionsUserIdInvoices>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string,
    params?: GetCommissionsUserIdInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsUserIdInvoices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommissionsUserIdInvoices>>,
          TError,
          Awaited<ReturnType<typeof getCommissionsUserIdInvoices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommissionsUserIdInvoices<TData = Awaited<ReturnType<typeof getCommissionsUserIdInvoices>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string,
    params?: GetCommissionsUserIdInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsUserIdInvoices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List commissionable invoices for a user (or team)
 */

export function useGetCommissionsUserIdInvoices<TData = Awaited<ReturnType<typeof getCommissionsUserIdInvoices>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string,
    params?: GetCommissionsUserIdInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsUserIdInvoices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCommissionsUserIdInvoicesQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * List commission payouts for this user and period
 * @summary List commission payouts
 */
export const getCommissionsUserIdPayouts = (
    userId: string,
    params?: GetCommissionsUserIdPayoutsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetCommissionsUserIdPayouts200>(
      {url: `/api/v1/commissions/${userId}/payouts`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetCommissionsUserIdPayoutsQueryKey = (userId?: string,
    params?: GetCommissionsUserIdPayoutsParams,) => {
    return [
    `/api/v1/commissions/${userId}/payouts`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCommissionsUserIdPayoutsQueryOptions = <TData = Awaited<ReturnType<typeof getCommissionsUserIdPayouts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(userId: string,
    params?: GetCommissionsUserIdPayoutsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsUserIdPayouts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCommissionsUserIdPayoutsQueryKey(userId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCommissionsUserIdPayouts>>> = ({ signal }) => getCommissionsUserIdPayouts(userId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCommissionsUserIdPayouts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCommissionsUserIdPayoutsQueryResult = NonNullable<Awaited<ReturnType<typeof getCommissionsUserIdPayouts>>>
export type GetCommissionsUserIdPayoutsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetCommissionsUserIdPayouts<TData = Awaited<ReturnType<typeof getCommissionsUserIdPayouts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string,
    params: undefined |  GetCommissionsUserIdPayoutsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsUserIdPayouts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommissionsUserIdPayouts>>,
          TError,
          Awaited<ReturnType<typeof getCommissionsUserIdPayouts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommissionsUserIdPayouts<TData = Awaited<ReturnType<typeof getCommissionsUserIdPayouts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string,
    params?: GetCommissionsUserIdPayoutsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsUserIdPayouts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommissionsUserIdPayouts>>,
          TError,
          Awaited<ReturnType<typeof getCommissionsUserIdPayouts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommissionsUserIdPayouts<TData = Awaited<ReturnType<typeof getCommissionsUserIdPayouts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string,
    params?: GetCommissionsUserIdPayoutsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsUserIdPayouts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List commission payouts
 */

export function useGetCommissionsUserIdPayouts<TData = Awaited<ReturnType<typeof getCommissionsUserIdPayouts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string,
    params?: GetCommissionsUserIdPayoutsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsUserIdPayouts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCommissionsUserIdPayoutsQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Cursor-paginated list of CommissionPayment records for a single user.
Same response shape as GET /commission-payments, but scoped to the path
user_id. Self, admin, finance, vp_sales, and the user's manager chain
(for sales_manager role) may view.

 * @summary List commission payments for a user
 */
export const getCommissionsUserIdPayments = (
    userId: string,
    params?: GetCommissionsUserIdPaymentsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetCommissionsUserIdPayments200>(
      {url: `/api/v1/commissions/${userId}/payments`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetCommissionsUserIdPaymentsQueryKey = (userId?: string,
    params?: GetCommissionsUserIdPaymentsParams,) => {
    return [
    `/api/v1/commissions/${userId}/payments`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCommissionsUserIdPaymentsQueryOptions = <TData = Awaited<ReturnType<typeof getCommissionsUserIdPayments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(userId: string,
    params?: GetCommissionsUserIdPaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsUserIdPayments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCommissionsUserIdPaymentsQueryKey(userId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCommissionsUserIdPayments>>> = ({ signal }) => getCommissionsUserIdPayments(userId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCommissionsUserIdPayments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCommissionsUserIdPaymentsQueryResult = NonNullable<Awaited<ReturnType<typeof getCommissionsUserIdPayments>>>
export type GetCommissionsUserIdPaymentsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetCommissionsUserIdPayments<TData = Awaited<ReturnType<typeof getCommissionsUserIdPayments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string,
    params: undefined |  GetCommissionsUserIdPaymentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsUserIdPayments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommissionsUserIdPayments>>,
          TError,
          Awaited<ReturnType<typeof getCommissionsUserIdPayments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommissionsUserIdPayments<TData = Awaited<ReturnType<typeof getCommissionsUserIdPayments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string,
    params?: GetCommissionsUserIdPaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsUserIdPayments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommissionsUserIdPayments>>,
          TError,
          Awaited<ReturnType<typeof getCommissionsUserIdPayments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommissionsUserIdPayments<TData = Awaited<ReturnType<typeof getCommissionsUserIdPayments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string,
    params?: GetCommissionsUserIdPaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsUserIdPayments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List commission payments for a user
 */

export function useGetCommissionsUserIdPayments<TData = Awaited<ReturnType<typeof getCommissionsUserIdPayments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string,
    params?: GetCommissionsUserIdPaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionsUserIdPayments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCommissionsUserIdPaymentsQueryOptions(userId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a commission payment via Mercury or QuickBooks
 * @summary Initiate commission payout
 */
export const postCommissionsUserIdPay = (
    userId: string,
    postCommissionsUserIdPayBody: PostCommissionsUserIdPayBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TimesheetPayment>(
      {url: `/api/v1/commissions/${userId}/pay`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postCommissionsUserIdPayBody, signal
    },
      options);
    }
  


export const getPostCommissionsUserIdPayMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCommissionsUserIdPay>>, TError,{userId: string;data: PostCommissionsUserIdPayBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCommissionsUserIdPay>>, TError,{userId: string;data: PostCommissionsUserIdPayBody}, TContext> => {

const mutationKey = ['postCommissionsUserIdPay'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCommissionsUserIdPay>>, {userId: string;data: PostCommissionsUserIdPayBody}> = (props) => {
          const {userId,data} = props ?? {};

          return  postCommissionsUserIdPay(userId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCommissionsUserIdPayMutationResult = NonNullable<Awaited<ReturnType<typeof postCommissionsUserIdPay>>>
    export type PostCommissionsUserIdPayMutationBody = PostCommissionsUserIdPayBody
    export type PostCommissionsUserIdPayMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Initiate commission payout
 */
export const usePostCommissionsUserIdPay = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCommissionsUserIdPay>>, TError,{userId: string;data: PostCommissionsUserIdPayBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCommissionsUserIdPay>>,
        TError,
        {userId: string;data: PostCommissionsUserIdPayBody},
        TContext
      > => {

      const mutationOptions = getPostCommissionsUserIdPayMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Cursor-paginated list of CommissionPayment records across all users and sources
 * @summary List commission payment records
 */
export const getCommissionPayments = (
    params?: GetCommissionPaymentsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetCommissionPayments200>(
      {url: `/api/v1/commission-payments`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetCommissionPaymentsQueryKey = (params?: GetCommissionPaymentsParams,) => {
    return [
    `/api/v1/commission-payments`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCommissionPaymentsQueryOptions = <TData = Awaited<ReturnType<typeof getCommissionPayments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(params?: GetCommissionPaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionPayments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCommissionPaymentsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCommissionPayments>>> = ({ signal }) => getCommissionPayments(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCommissionPayments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCommissionPaymentsQueryResult = NonNullable<Awaited<ReturnType<typeof getCommissionPayments>>>
export type GetCommissionPaymentsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetCommissionPayments<TData = Awaited<ReturnType<typeof getCommissionPayments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: undefined |  GetCommissionPaymentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionPayments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommissionPayments>>,
          TError,
          Awaited<ReturnType<typeof getCommissionPayments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommissionPayments<TData = Awaited<ReturnType<typeof getCommissionPayments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetCommissionPaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionPayments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCommissionPayments>>,
          TError,
          Awaited<ReturnType<typeof getCommissionPayments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCommissionPayments<TData = Awaited<ReturnType<typeof getCommissionPayments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetCommissionPaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionPayments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List commission payment records
 */

export function useGetCommissionPayments<TData = Awaited<ReturnType<typeof getCommissionPayments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetCommissionPaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCommissionPayments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCommissionPaymentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Bulk operations on commission_payments. Currently the only supported op
is `remove`, where `path` is a JSON Pointer of the form "/<id>" naming
the row to delete. The PATCH applies all operations in a single
transaction (all-or-nothing).

 * @summary Apply JSON-PATCH (RFC 6902) operations to commission payments
 */
export const patchCommissionPayments = (
    jsonPatchOperation: JsonPatchOperation[],
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<PatchCommissionPayments200>(
      {url: `/api/v1/commission-payments`, method: 'PATCH',
      headers: {'Content-Type': 'application/json-patch+json', },
      data: jsonPatchOperation
    },
      options);
    }
  


export const getPatchCommissionPaymentsMutationOptions = <TError = PatchCommissionPayments400 | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCommissionPayments>>, TError,{data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchCommissionPayments>>, TError,{data: JsonPatchOperation[]}, TContext> => {

const mutationKey = ['patchCommissionPayments'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchCommissionPayments>>, {data: JsonPatchOperation[]}> = (props) => {
          const {data} = props ?? {};

          return  patchCommissionPayments(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchCommissionPaymentsMutationResult = NonNullable<Awaited<ReturnType<typeof patchCommissionPayments>>>
    export type PatchCommissionPaymentsMutationBody = JsonPatchOperation[]
    export type PatchCommissionPaymentsMutationError = PatchCommissionPayments400 | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Apply JSON-PATCH (RFC 6902) operations to commission payments
 */
export const usePatchCommissionPayments = <TError = PatchCommissionPayments400 | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchCommissionPayments>>, TError,{data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchCommissionPayments>>,
        TError,
        {data: JsonPatchOperation[]},
        TContext
      > => {

      const mutationOptions = getPatchCommissionPaymentsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Hard-deletes one row from commission_payments by id.
 * @summary Delete a single CommissionPayment record
 */
export const deleteCommissionPaymentsId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<DeleteCommissionPaymentsId200>(
      {url: `/api/v1/commission-payments/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteCommissionPaymentsIdMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCommissionPaymentsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCommissionPaymentsId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteCommissionPaymentsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCommissionPaymentsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteCommissionPaymentsId(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCommissionPaymentsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCommissionPaymentsId>>>
    
    export type DeleteCommissionPaymentsIdMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Delete a single CommissionPayment record
 */
export const useDeleteCommissionPaymentsId = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCommissionPaymentsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCommissionPaymentsId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteCommissionPaymentsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Recomputes validation_errors for every commission_payment_invoices
link that currently carries one, against the current state of its
linked invoice's attribution. Used after fixing invoice attribution
issues so the issues view reflects the fix without manual DB edits
or a re-import.

No body — this is a bulk "fix everything that's flagged" action.
Use POST /commission-payments/{id}/sync to target a single
payment.

Runs through the shared sync queue, so it cannot race with a QB
sync mutating the same invoices.

 * @summary Re-run validation against current invoice state
 */
export const postCommissionPaymentsSync = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CommissionPaymentSyncResult>(
      {url: `/api/v1/commission-payments/sync`, method: 'POST', signal
    },
      options);
    }
  


export const getPostCommissionPaymentsSyncMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCommissionPaymentsSync>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCommissionPaymentsSync>>, TError,void, TContext> => {

const mutationKey = ['postCommissionPaymentsSync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCommissionPaymentsSync>>, void> = () => {
          

          return  postCommissionPaymentsSync(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCommissionPaymentsSyncMutationResult = NonNullable<Awaited<ReturnType<typeof postCommissionPaymentsSync>>>
    
    export type PostCommissionPaymentsSyncMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Re-run validation against current invoice state
 */
export const usePostCommissionPaymentsSync = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCommissionPaymentsSync>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCommissionPaymentsSync>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostCommissionPaymentsSyncMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Per-row variant of POST /commission-payments/sync. Same code
path, scoped to a single id. Used by the per-row "Re-validate"
button on the commission issues table.

 * @summary Re-run validation for a single CommissionPayment
 */
export const postCommissionPaymentsIdSync = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CommissionPaymentSyncResult>(
      {url: `/api/v1/commission-payments/${id}/sync`, method: 'POST', signal
    },
      options);
    }
  


export const getPostCommissionPaymentsIdSyncMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCommissionPaymentsIdSync>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postCommissionPaymentsIdSync>>, TError,{id: string}, TContext> => {

const mutationKey = ['postCommissionPaymentsIdSync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postCommissionPaymentsIdSync>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postCommissionPaymentsIdSync(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostCommissionPaymentsIdSyncMutationResult = NonNullable<Awaited<ReturnType<typeof postCommissionPaymentsIdSync>>>
    
    export type PostCommissionPaymentsIdSyncMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Re-run validation for a single CommissionPayment
 */
export const usePostCommissionPaymentsIdSync = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postCommissionPaymentsIdSync>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postCommissionPaymentsIdSync>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostCommissionPaymentsIdSyncMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get all attachments for an invoice
 * @summary List invoice attachments
 */
export const getInvoicesInvoiceIdAttachments = (
    invoiceId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetInvoicesInvoiceIdAttachments200>(
      {url: `/api/v1/invoices/${invoiceId}/attachments`, method: 'GET', signal
    },
      options);
    }
  



export const getGetInvoicesInvoiceIdAttachmentsQueryKey = (invoiceId?: string,) => {
    return [
    `/api/v1/invoices/${invoiceId}/attachments`
    ] as const;
    }

    
export const getGetInvoicesInvoiceIdAttachmentsQueryOptions = <TData = Awaited<ReturnType<typeof getInvoicesInvoiceIdAttachments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicesInvoiceIdAttachments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoicesInvoiceIdAttachmentsQueryKey(invoiceId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoicesInvoiceIdAttachments>>> = ({ signal }) => getInvoicesInvoiceIdAttachments(invoiceId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(invoiceId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoicesInvoiceIdAttachments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvoicesInvoiceIdAttachmentsQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoicesInvoiceIdAttachments>>>
export type GetInvoicesInvoiceIdAttachmentsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetInvoicesInvoiceIdAttachments<TData = Awaited<ReturnType<typeof getInvoicesInvoiceIdAttachments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 invoiceId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicesInvoiceIdAttachments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoicesInvoiceIdAttachments>>,
          TError,
          Awaited<ReturnType<typeof getInvoicesInvoiceIdAttachments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoicesInvoiceIdAttachments<TData = Awaited<ReturnType<typeof getInvoicesInvoiceIdAttachments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicesInvoiceIdAttachments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoicesInvoiceIdAttachments>>,
          TError,
          Awaited<ReturnType<typeof getInvoicesInvoiceIdAttachments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoicesInvoiceIdAttachments<TData = Awaited<ReturnType<typeof getInvoicesInvoiceIdAttachments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicesInvoiceIdAttachments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List invoice attachments
 */

export function useGetInvoicesInvoiceIdAttachments<TData = Awaited<ReturnType<typeof getInvoicesInvoiceIdAttachments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 invoiceId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicesInvoiceIdAttachments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvoicesInvoiceIdAttachmentsQueryOptions(invoiceId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Download an invoice attachment file
 * @summary Download invoice attachment
 */
export const getInvoicesInvoiceIdAttachmentsAttachmentId = (
    invoiceId: string,
    attachmentId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Blob>(
      {url: `/api/v1/invoices/${invoiceId}/attachments/${attachmentId}`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }
  



export const getGetInvoicesInvoiceIdAttachmentsAttachmentIdQueryKey = (invoiceId?: string,
    attachmentId?: string,) => {
    return [
    `/api/v1/invoices/${invoiceId}/attachments/${attachmentId}`
    ] as const;
    }

    
export const getGetInvoicesInvoiceIdAttachmentsAttachmentIdQueryOptions = <TData = Awaited<ReturnType<typeof getInvoicesInvoiceIdAttachmentsAttachmentId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(invoiceId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicesInvoiceIdAttachmentsAttachmentId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoicesInvoiceIdAttachmentsAttachmentIdQueryKey(invoiceId,attachmentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoicesInvoiceIdAttachmentsAttachmentId>>> = ({ signal }) => getInvoicesInvoiceIdAttachmentsAttachmentId(invoiceId,attachmentId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(invoiceId && attachmentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoicesInvoiceIdAttachmentsAttachmentId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvoicesInvoiceIdAttachmentsAttachmentIdQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoicesInvoiceIdAttachmentsAttachmentId>>>
export type GetInvoicesInvoiceIdAttachmentsAttachmentIdQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse


export function useGetInvoicesInvoiceIdAttachmentsAttachmentId<TData = Awaited<ReturnType<typeof getInvoicesInvoiceIdAttachmentsAttachmentId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 invoiceId: string,
    attachmentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicesInvoiceIdAttachmentsAttachmentId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoicesInvoiceIdAttachmentsAttachmentId>>,
          TError,
          Awaited<ReturnType<typeof getInvoicesInvoiceIdAttachmentsAttachmentId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoicesInvoiceIdAttachmentsAttachmentId<TData = Awaited<ReturnType<typeof getInvoicesInvoiceIdAttachmentsAttachmentId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 invoiceId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicesInvoiceIdAttachmentsAttachmentId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoicesInvoiceIdAttachmentsAttachmentId>>,
          TError,
          Awaited<ReturnType<typeof getInvoicesInvoiceIdAttachmentsAttachmentId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoicesInvoiceIdAttachmentsAttachmentId<TData = Awaited<ReturnType<typeof getInvoicesInvoiceIdAttachmentsAttachmentId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 invoiceId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicesInvoiceIdAttachmentsAttachmentId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download invoice attachment
 */

export function useGetInvoicesInvoiceIdAttachmentsAttachmentId<TData = Awaited<ReturnType<typeof getInvoicesInvoiceIdAttachmentsAttachmentId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 invoiceId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicesInvoiceIdAttachmentsAttachmentId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvoicesInvoiceIdAttachmentsAttachmentIdQueryOptions(invoiceId,attachmentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * List all quota configurations for a user
 * @summary Get sales quotas for user
 */
export const getUsersUserIdSalesQuota = (
    userId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetUsersUserIdSalesQuota200>(
      {url: `/api/v1/users/${userId}/sales-quota`, method: 'GET', signal
    },
      options);
    }
  



export const getGetUsersUserIdSalesQuotaQueryKey = (userId?: string,) => {
    return [
    `/api/v1/users/${userId}/sales-quota`
    ] as const;
    }

    
export const getGetUsersUserIdSalesQuotaQueryOptions = <TData = Awaited<ReturnType<typeof getUsersUserIdSalesQuota>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersUserIdSalesQuota>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersUserIdSalesQuotaQueryKey(userId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsersUserIdSalesQuota>>> = ({ signal }) => getUsersUserIdSalesQuota(userId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(userId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUsersUserIdSalesQuota>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUsersUserIdSalesQuotaQueryResult = NonNullable<Awaited<ReturnType<typeof getUsersUserIdSalesQuota>>>
export type GetUsersUserIdSalesQuotaQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetUsersUserIdSalesQuota<TData = Awaited<ReturnType<typeof getUsersUserIdSalesQuota>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersUserIdSalesQuota>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersUserIdSalesQuota>>,
          TError,
          Awaited<ReturnType<typeof getUsersUserIdSalesQuota>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersUserIdSalesQuota<TData = Awaited<ReturnType<typeof getUsersUserIdSalesQuota>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersUserIdSalesQuota>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsersUserIdSalesQuota>>,
          TError,
          Awaited<ReturnType<typeof getUsersUserIdSalesQuota>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsersUserIdSalesQuota<TData = Awaited<ReturnType<typeof getUsersUserIdSalesQuota>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersUserIdSalesQuota>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get sales quotas for user
 */

export function useGetUsersUserIdSalesQuota<TData = Awaited<ReturnType<typeof getUsersUserIdSalesQuota>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 userId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsersUserIdSalesQuota>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUsersUserIdSalesQuotaQueryOptions(userId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Set quota configuration for a user and period
 * @summary Create or update sales quota
 */
export const putUsersUserIdSalesQuota = (
    userId: string,
    salesQuota: SalesQuota,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<SalesQuota>(
      {url: `/api/v1/users/${userId}/sales-quota`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: salesQuota
    },
      options);
    }
  


export const getPutUsersUserIdSalesQuotaMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUsersUserIdSalesQuota>>, TError,{userId: string;data: SalesQuota}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putUsersUserIdSalesQuota>>, TError,{userId: string;data: SalesQuota}, TContext> => {

const mutationKey = ['putUsersUserIdSalesQuota'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putUsersUserIdSalesQuota>>, {userId: string;data: SalesQuota}> = (props) => {
          const {userId,data} = props ?? {};

          return  putUsersUserIdSalesQuota(userId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutUsersUserIdSalesQuotaMutationResult = NonNullable<Awaited<ReturnType<typeof putUsersUserIdSalesQuota>>>
    export type PutUsersUserIdSalesQuotaMutationBody = SalesQuota
    export type PutUsersUserIdSalesQuotaMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Create or update sales quota
 */
export const usePutUsersUserIdSalesQuota = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putUsersUserIdSalesQuota>>, TError,{userId: string;data: SalesQuota}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putUsersUserIdSalesQuota>>,
        TError,
        {userId: string;data: SalesQuota},
        TContext
      > => {

      const mutationOptions = getPutUsersUserIdSalesQuotaMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Delete sales quota
 */
export const deleteUsersUserIdSalesQuotaId = (
    userId: string,
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/users/${userId}/sales-quota/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteUsersUserIdSalesQuotaIdMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUsersUserIdSalesQuotaId>>, TError,{userId: string;id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUsersUserIdSalesQuotaId>>, TError,{userId: string;id: string}, TContext> => {

const mutationKey = ['deleteUsersUserIdSalesQuotaId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUsersUserIdSalesQuotaId>>, {userId: string;id: string}> = (props) => {
          const {userId,id} = props ?? {};

          return  deleteUsersUserIdSalesQuotaId(userId,id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUsersUserIdSalesQuotaIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUsersUserIdSalesQuotaId>>>
    
    export type DeleteUsersUserIdSalesQuotaIdMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Delete sales quota
 */
export const useDeleteUsersUserIdSalesQuotaId = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUsersUserIdSalesQuotaId>>, TError,{userId: string;id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUsersUserIdSalesQuotaId>>,
        TError,
        {userId: string;id: string},
        TContext
      > => {

      const mutationOptions = getDeleteUsersUserIdSalesQuotaIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get list of deals with filtering and pagination
 * @summary List deals
 */
export const getDeals = (
    params?: GetDealsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetDeals200>(
      {url: `/api/v1/deals`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetDealsQueryKey = (params?: GetDealsParams,) => {
    return [
    `/api/v1/deals`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetDealsQueryOptions = <TData = Awaited<ReturnType<typeof getDeals>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(params?: GetDealsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeals>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDealsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDeals>>> = ({ signal }) => getDeals(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDeals>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDealsQueryResult = NonNullable<Awaited<ReturnType<typeof getDeals>>>
export type GetDealsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetDeals<TData = Awaited<ReturnType<typeof getDeals>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: undefined |  GetDealsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeals>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeals>>,
          TError,
          Awaited<ReturnType<typeof getDeals>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDeals<TData = Awaited<ReturnType<typeof getDeals>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetDealsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeals>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDeals>>,
          TError,
          Awaited<ReturnType<typeof getDeals>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDeals<TData = Awaited<ReturnType<typeof getDeals>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetDealsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeals>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List deals
 */

export function useGetDeals<TData = Awaited<ReturnType<typeof getDeals>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetDealsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDeals>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDealsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a new sales deal
 * @summary Create new deal
 */
export const postDeals = (
    createDealRequest: CreateDealRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Deal>(
      {url: `/api/v1/deals`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createDealRequest, signal
    },
      options);
    }
  


export const getPostDealsMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDeals>>, TError,{data: CreateDealRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postDeals>>, TError,{data: CreateDealRequest}, TContext> => {

const mutationKey = ['postDeals'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postDeals>>, {data: CreateDealRequest}> = (props) => {
          const {data} = props ?? {};

          return  postDeals(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostDealsMutationResult = NonNullable<Awaited<ReturnType<typeof postDeals>>>
    export type PostDealsMutationBody = CreateDealRequest
    export type PostDealsMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Create new deal
 */
export const usePostDeals = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postDeals>>, TError,{data: CreateDealRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postDeals>>,
        TError,
        {data: CreateDealRequest},
        TContext
      > => {

      const mutationOptions = getPostDealsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieve specific deal information
 * @summary Get deal details
 */
export const getDealsId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Deal>(
      {url: `/api/v1/deals/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetDealsIdQueryKey = (id?: string,) => {
    return [
    `/api/v1/deals/${id}`
    ] as const;
    }

    
export const getGetDealsIdQueryOptions = <TData = Awaited<ReturnType<typeof getDealsId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDealsId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDealsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDealsId>>> = ({ signal }) => getDealsId(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDealsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDealsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getDealsId>>>
export type GetDealsIdQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetDealsId<TData = Awaited<ReturnType<typeof getDealsId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDealsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDealsId>>,
          TError,
          Awaited<ReturnType<typeof getDealsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDealsId<TData = Awaited<ReturnType<typeof getDealsId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDealsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDealsId>>,
          TError,
          Awaited<ReturnType<typeof getDealsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDealsId<TData = Awaited<ReturnType<typeof getDealsId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDealsId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get deal details
 */

export function useGetDealsId<TData = Awaited<ReturnType<typeof getDealsId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDealsId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDealsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update existing deal
 * @summary Update deal
 */
export const putDealsId = (
    id: string,
    updateDealRequest: UpdateDealRequest,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<Deal>(
      {url: `/api/v1/deals/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateDealRequest
    },
      options);
    }
  


export const getPutDealsIdMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putDealsId>>, TError,{id: string;data: UpdateDealRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putDealsId>>, TError,{id: string;data: UpdateDealRequest}, TContext> => {

const mutationKey = ['putDealsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putDealsId>>, {id: string;data: UpdateDealRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  putDealsId(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutDealsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putDealsId>>>
    export type PutDealsIdMutationBody = UpdateDealRequest
    export type PutDealsIdMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Update deal
 */
export const usePutDealsId = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putDealsId>>, TError,{id: string;data: UpdateDealRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putDealsId>>,
        TError,
        {id: string;data: UpdateDealRequest},
        TContext
      > => {

      const mutationOptions = getPutDealsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Delete a deal
 * @summary Delete deal
 */
export const deleteDealsId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/deals/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteDealsIdMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDealsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDealsId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteDealsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDealsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteDealsId(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteDealsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDealsId>>>
    
    export type DeleteDealsIdMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Delete deal
 */
export const useDeleteDealsId = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDealsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteDealsId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteDealsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieve activity history for a specific deal
 * @summary Get deal activity history
 */
export const getDealsIdActivities = (
    id: string,
    params?: GetDealsIdActivitiesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetDealsIdActivities200>(
      {url: `/api/v1/deals/${id}/activities`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetDealsIdActivitiesQueryKey = (id?: string,
    params?: GetDealsIdActivitiesParams,) => {
    return [
    `/api/v1/deals/${id}/activities`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetDealsIdActivitiesQueryOptions = <TData = Awaited<ReturnType<typeof getDealsIdActivities>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(id: string,
    params?: GetDealsIdActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDealsIdActivities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDealsIdActivitiesQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDealsIdActivities>>> = ({ signal }) => getDealsIdActivities(id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDealsIdActivities>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDealsIdActivitiesQueryResult = NonNullable<Awaited<ReturnType<typeof getDealsIdActivities>>>
export type GetDealsIdActivitiesQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetDealsIdActivities<TData = Awaited<ReturnType<typeof getDealsIdActivities>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 id: string,
    params: undefined |  GetDealsIdActivitiesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDealsIdActivities>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDealsIdActivities>>,
          TError,
          Awaited<ReturnType<typeof getDealsIdActivities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDealsIdActivities<TData = Awaited<ReturnType<typeof getDealsIdActivities>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 id: string,
    params?: GetDealsIdActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDealsIdActivities>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDealsIdActivities>>,
          TError,
          Awaited<ReturnType<typeof getDealsIdActivities>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDealsIdActivities<TData = Awaited<ReturnType<typeof getDealsIdActivities>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 id: string,
    params?: GetDealsIdActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDealsIdActivities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get deal activity history
 */

export function useGetDealsIdActivities<TData = Awaited<ReturnType<typeof getDealsIdActivities>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 id: string,
    params?: GetDealsIdActivitiesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDealsIdActivities>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDealsIdActivitiesQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieve pipeline overview and metrics
 * @summary Get pipeline data
 */
export const getPipeline = (
    params?: GetPipelineParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Pipeline>(
      {url: `/api/v1/pipeline`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetPipelineQueryKey = (params?: GetPipelineParams,) => {
    return [
    `/api/v1/pipeline`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPipelineQueryOptions = <TData = Awaited<ReturnType<typeof getPipeline>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(params?: GetPipelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPipeline>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPipelineQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPipeline>>> = ({ signal }) => getPipeline(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPipeline>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPipelineQueryResult = NonNullable<Awaited<ReturnType<typeof getPipeline>>>
export type GetPipelineQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetPipeline<TData = Awaited<ReturnType<typeof getPipeline>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: undefined |  GetPipelineParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPipeline>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPipeline>>,
          TError,
          Awaited<ReturnType<typeof getPipeline>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPipeline<TData = Awaited<ReturnType<typeof getPipeline>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetPipelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPipeline>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPipeline>>,
          TError,
          Awaited<ReturnType<typeof getPipeline>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPipeline<TData = Awaited<ReturnType<typeof getPipeline>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetPipelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPipeline>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get pipeline data
 */

export function useGetPipeline<TData = Awaited<ReturnType<typeof getPipeline>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetPipelineParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPipeline>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPipelineQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get pipeline forecast based on current deals and probabilities
 * @summary Get pipeline forecast
 */
export const getPipelineForecast = (
    params?: GetPipelineForecastParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PipelineForecast>(
      {url: `/api/v1/pipeline/forecast`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetPipelineForecastQueryKey = (params?: GetPipelineForecastParams,) => {
    return [
    `/api/v1/pipeline/forecast`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPipelineForecastQueryOptions = <TData = Awaited<ReturnType<typeof getPipelineForecast>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(params?: GetPipelineForecastParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPipelineForecast>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPipelineForecastQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPipelineForecast>>> = ({ signal }) => getPipelineForecast(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPipelineForecast>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPipelineForecastQueryResult = NonNullable<Awaited<ReturnType<typeof getPipelineForecast>>>
export type GetPipelineForecastQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetPipelineForecast<TData = Awaited<ReturnType<typeof getPipelineForecast>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: undefined |  GetPipelineForecastParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPipelineForecast>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPipelineForecast>>,
          TError,
          Awaited<ReturnType<typeof getPipelineForecast>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPipelineForecast<TData = Awaited<ReturnType<typeof getPipelineForecast>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetPipelineForecastParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPipelineForecast>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPipelineForecast>>,
          TError,
          Awaited<ReturnType<typeof getPipelineForecast>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPipelineForecast<TData = Awaited<ReturnType<typeof getPipelineForecast>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetPipelineForecastParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPipelineForecast>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get pipeline forecast
 */

export function useGetPipelineForecast<TData = Awaited<ReturnType<typeof getPipelineForecast>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetPipelineForecastParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPipelineForecast>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPipelineForecastQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieve sales pipeline stage definitions
 * @summary Get sales stages configuration
 */
export const getPipelineStages = (
    params?: GetPipelineStagesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetPipelineStages200>(
      {url: `/api/v1/pipeline/stages`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetPipelineStagesQueryKey = (params?: GetPipelineStagesParams,) => {
    return [
    `/api/v1/pipeline/stages`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPipelineStagesQueryOptions = <TData = Awaited<ReturnType<typeof getPipelineStages>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(params?: GetPipelineStagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPipelineStages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPipelineStagesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPipelineStages>>> = ({ signal }) => getPipelineStages(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPipelineStages>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPipelineStagesQueryResult = NonNullable<Awaited<ReturnType<typeof getPipelineStages>>>
export type GetPipelineStagesQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetPipelineStages<TData = Awaited<ReturnType<typeof getPipelineStages>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: undefined |  GetPipelineStagesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPipelineStages>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPipelineStages>>,
          TError,
          Awaited<ReturnType<typeof getPipelineStages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPipelineStages<TData = Awaited<ReturnType<typeof getPipelineStages>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetPipelineStagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPipelineStages>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPipelineStages>>,
          TError,
          Awaited<ReturnType<typeof getPipelineStages>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPipelineStages<TData = Awaited<ReturnType<typeof getPipelineStages>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetPipelineStagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPipelineStages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get sales stages configuration
 */

export function useGetPipelineStages<TData = Awaited<ReturnType<typeof getPipelineStages>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetPipelineStagesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPipelineStages>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPipelineStagesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update sales pipeline stage configuration (admin only)
 * @summary Update sales stages
 */
export const putPipelineStages = (
    salesStage: SalesStage[],
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<SalesStage[]>(
      {url: `/api/v1/pipeline/stages`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: salesStage
    },
      options);
    }
  


export const getPutPipelineStagesMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPipelineStages>>, TError,{data: SalesStage[]}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putPipelineStages>>, TError,{data: SalesStage[]}, TContext> => {

const mutationKey = ['putPipelineStages'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putPipelineStages>>, {data: SalesStage[]}> = (props) => {
          const {data} = props ?? {};

          return  putPipelineStages(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutPipelineStagesMutationResult = NonNullable<Awaited<ReturnType<typeof putPipelineStages>>>
    export type PutPipelineStagesMutationBody = SalesStage[]
    export type PutPipelineStagesMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Update sales stages
 */
export const usePutPipelineStages = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putPipelineStages>>, TError,{data: SalesStage[]}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putPipelineStages>>,
        TError,
        {data: SalesStage[]},
        TContext
      > => {

      const mutationOptions = getPutPipelineStagesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get list of invoices with filtering
 * @summary List invoices
 */
export const getInvoices = (
    params?: GetInvoicesParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetInvoices200>(
      {url: `/api/v1/invoices`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetInvoicesQueryKey = (params?: GetInvoicesParams,) => {
    return [
    `/api/v1/invoices`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetInvoicesQueryOptions = <TData = Awaited<ReturnType<typeof getInvoices>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(params?: GetInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoicesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoices>>> = ({ signal }) => getInvoices(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvoicesQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoices>>>
export type GetInvoicesQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetInvoices<TData = Awaited<ReturnType<typeof getInvoices>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: undefined |  GetInvoicesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoices>>,
          TError,
          Awaited<ReturnType<typeof getInvoices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoices<TData = Awaited<ReturnType<typeof getInvoices>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoices>>,
          TError,
          Awaited<ReturnType<typeof getInvoices>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoices<TData = Awaited<ReturnType<typeof getInvoices>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List invoices
 */

export function useGetInvoices<TData = Awaited<ReturnType<typeof getInvoices>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetInvoicesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoices>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvoicesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Download the full filtered invoice set as a CSV file. Accepts the
same filter params as GET /invoices (no pagination — the server
iterates the entire result set), plus sort_field/sort_direction
and a comma-separated `fields` list selecting and ordering the
CSV columns.

 * @summary Export invoices as CSV
 */
export const getInvoicesExport = (
    params?: GetInvoicesExportParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Blob>(
      {url: `/api/v1/invoices/export`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      options);
    }
  



export const getGetInvoicesExportQueryKey = (params?: GetInvoicesExportParams,) => {
    return [
    `/api/v1/invoices/export`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetInvoicesExportQueryOptions = <TData = Awaited<ReturnType<typeof getInvoicesExport>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(params?: GetInvoicesExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicesExport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoicesExportQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoicesExport>>> = ({ signal }) => getInvoicesExport(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoicesExport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvoicesExportQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoicesExport>>>
export type GetInvoicesExportQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetInvoicesExport<TData = Awaited<ReturnType<typeof getInvoicesExport>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: undefined |  GetInvoicesExportParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicesExport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoicesExport>>,
          TError,
          Awaited<ReturnType<typeof getInvoicesExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoicesExport<TData = Awaited<ReturnType<typeof getInvoicesExport>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetInvoicesExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicesExport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoicesExport>>,
          TError,
          Awaited<ReturnType<typeof getInvoicesExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoicesExport<TData = Awaited<ReturnType<typeof getInvoicesExport>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetInvoicesExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicesExport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export invoices as CSV
 */

export function useGetInvoicesExport<TData = Awaited<ReturnType<typeof getInvoicesExport>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetInvoicesExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicesExport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvoicesExportQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieve specific invoice information
 * @summary Get invoice details
 */
export const getInvoicesId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Invoice>(
      {url: `/api/v1/invoices/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetInvoicesIdQueryKey = (id?: string,) => {
    return [
    `/api/v1/invoices/${id}`
    ] as const;
    }

    
export const getGetInvoicesIdQueryOptions = <TData = Awaited<ReturnType<typeof getInvoicesId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicesId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoicesIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoicesId>>> = ({ signal }) => getInvoicesId(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoicesId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvoicesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoicesId>>>
export type GetInvoicesIdQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetInvoicesId<TData = Awaited<ReturnType<typeof getInvoicesId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicesId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoicesId>>,
          TError,
          Awaited<ReturnType<typeof getInvoicesId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoicesId<TData = Awaited<ReturnType<typeof getInvoicesId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicesId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoicesId>>,
          TError,
          Awaited<ReturnType<typeof getInvoicesId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoicesId<TData = Awaited<ReturnType<typeof getInvoicesId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicesId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get invoice details
 */

export function useGetInvoicesId<TData = Awaited<ReturnType<typeof getInvoicesId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicesId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvoicesIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update invoice-level approval fields and per-line delivery status using JSON-PATCH (RFC 6902).
Valid paths: /has_valid_po, /has_vp_waiver, /has_valid_invoice, /lines/{line_num}/delivered

 * @summary Update invoice approval and delivery status
 */
export const patchInvoicesId = (
    id: string,
    jsonPatchOperation: JsonPatchOperation[],
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<Invoice>(
      {url: `/api/v1/invoices/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json-patch+json', },
      data: jsonPatchOperation
    },
      options);
    }
  


export const getPatchInvoicesIdMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchInvoicesId>>, TError,{id: string;data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchInvoicesId>>, TError,{id: string;data: JsonPatchOperation[]}, TContext> => {

const mutationKey = ['patchInvoicesId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchInvoicesId>>, {id: string;data: JsonPatchOperation[]}> = (props) => {
          const {id,data} = props ?? {};

          return  patchInvoicesId(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchInvoicesIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchInvoicesId>>>
    export type PatchInvoicesIdMutationBody = JsonPatchOperation[]
    export type PatchInvoicesIdMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Update invoice approval and delivery status
 */
export const usePatchInvoicesId = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchInvoicesId>>, TError,{id: string;data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchInvoicesId>>,
        TError,
        {id: string;data: JsonPatchOperation[]},
        TContext
      > => {

      const mutationOptions = getPatchInvoicesIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Refetches the Invoice from upstream (QuickBooks today) and re-runs
the per-row sync pipeline scoped to this invoice. As a convenience
for the "I just edited this invoice in QB and want everything
related to catch up" workflow, also refetches each of the invoice's
linked Payments. Finally runs the auto-linker so any candidate
match whose blockers just cleared gets a real BankTransactionPayment
row written. Backs the per-row "Resync" button on the Invoice
detail modal / page.

 * @summary Sync a single invoice (and its linked payments) from upstream
 */
export const postInvoicesIdSync = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RecordSyncResult>(
      {url: `/api/v1/invoices/${id}/sync`, method: 'POST', signal
    },
      options);
    }
  


export const getPostInvoicesIdSyncMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInvoicesIdSync>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postInvoicesIdSync>>, TError,{id: string}, TContext> => {

const mutationKey = ['postInvoicesIdSync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postInvoicesIdSync>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postInvoicesIdSync(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostInvoicesIdSyncMutationResult = NonNullable<Awaited<ReturnType<typeof postInvoicesIdSync>>>
    
    export type PostInvoicesIdSyncMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Sync a single invoice (and its linked payments) from upstream
 */
export const usePostInvoicesIdSync = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInvoicesIdSync>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postInvoicesIdSync>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostInvoicesIdSyncMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get list of source-agnostic Payment records with filtering and pagination.
 * @summary List unified payments
 */
export const getInvoicePayments = (
    params?: GetInvoicePaymentsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetInvoicePayments200>(
      {url: `/api/v1/invoice-payments`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetInvoicePaymentsQueryKey = (params?: GetInvoicePaymentsParams,) => {
    return [
    `/api/v1/invoice-payments`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetInvoicePaymentsQueryOptions = <TData = Awaited<ReturnType<typeof getInvoicePayments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(params?: GetInvoicePaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicePayments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoicePaymentsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoicePayments>>> = ({ signal }) => getInvoicePayments(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoicePayments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvoicePaymentsQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoicePayments>>>
export type GetInvoicePaymentsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetInvoicePayments<TData = Awaited<ReturnType<typeof getInvoicePayments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: undefined |  GetInvoicePaymentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicePayments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoicePayments>>,
          TError,
          Awaited<ReturnType<typeof getInvoicePayments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoicePayments<TData = Awaited<ReturnType<typeof getInvoicePayments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetInvoicePaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicePayments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoicePayments>>,
          TError,
          Awaited<ReturnType<typeof getInvoicePayments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoicePayments<TData = Awaited<ReturnType<typeof getInvoicePayments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetInvoicePaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicePayments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List unified payments
 */

export function useGetInvoicePayments<TData = Awaited<ReturnType<typeof getInvoicePayments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetInvoicePaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicePayments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvoicePaymentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieve a single unified Payment by composite ID "<src_id>:<id>".
 * @summary Get payment detail
 */
export const getInvoicePaymentsPaymentId = (
    paymentId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Payment>(
      {url: `/api/v1/invoice-payments/${paymentId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetInvoicePaymentsPaymentIdQueryKey = (paymentId?: string,) => {
    return [
    `/api/v1/invoice-payments/${paymentId}`
    ] as const;
    }

    
export const getGetInvoicePaymentsPaymentIdQueryOptions = <TData = Awaited<ReturnType<typeof getInvoicePaymentsPaymentId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(paymentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicePaymentsPaymentId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoicePaymentsPaymentIdQueryKey(paymentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoicePaymentsPaymentId>>> = ({ signal }) => getInvoicePaymentsPaymentId(paymentId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(paymentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoicePaymentsPaymentId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvoicePaymentsPaymentIdQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoicePaymentsPaymentId>>>
export type GetInvoicePaymentsPaymentIdQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetInvoicePaymentsPaymentId<TData = Awaited<ReturnType<typeof getInvoicePaymentsPaymentId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 paymentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicePaymentsPaymentId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoicePaymentsPaymentId>>,
          TError,
          Awaited<ReturnType<typeof getInvoicePaymentsPaymentId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoicePaymentsPaymentId<TData = Awaited<ReturnType<typeof getInvoicePaymentsPaymentId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 paymentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicePaymentsPaymentId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoicePaymentsPaymentId>>,
          TError,
          Awaited<ReturnType<typeof getInvoicePaymentsPaymentId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoicePaymentsPaymentId<TData = Awaited<ReturnType<typeof getInvoicePaymentsPaymentId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 paymentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicePaymentsPaymentId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get payment detail
 */

export function useGetInvoicePaymentsPaymentId<TData = Awaited<ReturnType<typeof getInvoicePaymentsPaymentId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 paymentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicePaymentsPaymentId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvoicePaymentsPaymentIdQueryOptions(paymentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * JSON-PATCH (RFC 6902). Source-agnostic — dispatches by Payment.SrcType
when the patch triggers a source-side action.

Supported ops (any combination, applied as one transaction):
  - replace /status with "voided" — voids the Payment in its source
    system (QB: POST /v3/company/<realm>/payment?operation=void).
    Source-side void propagates to the unified row on next sync.
  - replace /unlinkable with true|false — workflow flag flip;
    hides this Payment from the default Unlinked review list.
    Setting true requires /unlinkable_reason to be non-empty (set
    in the same patch). Setting false clears /unlinkable_reason.
  - replace /unlinkable_reason with "<text>" — the human note
    explaining why the Payment is unlinkable. Empty/whitespace
    is rejected when /unlinkable is being set true.

Any other op / path / value returns 400.

 * @summary Update workflow flags or status on a unified Payment
 */
export const patchInvoicePaymentsPaymentId = (
    paymentId: string,
    jsonPatchOperation: JsonPatchOperation[],
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<Payment>(
      {url: `/api/v1/invoice-payments/${paymentId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json-patch+json', },
      data: jsonPatchOperation
    },
      options);
    }
  


export const getPatchInvoicePaymentsPaymentIdMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchInvoicePaymentsPaymentId>>, TError,{paymentId: string;data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchInvoicePaymentsPaymentId>>, TError,{paymentId: string;data: JsonPatchOperation[]}, TContext> => {

const mutationKey = ['patchInvoicePaymentsPaymentId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchInvoicePaymentsPaymentId>>, {paymentId: string;data: JsonPatchOperation[]}> = (props) => {
          const {paymentId,data} = props ?? {};

          return  patchInvoicePaymentsPaymentId(paymentId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchInvoicePaymentsPaymentIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchInvoicePaymentsPaymentId>>>
    export type PatchInvoicePaymentsPaymentIdMutationBody = JsonPatchOperation[]
    export type PatchInvoicePaymentsPaymentIdMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Update workflow flags or status on a unified Payment
 */
export const usePatchInvoicePaymentsPaymentId = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchInvoicePaymentsPaymentId>>, TError,{paymentId: string;data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchInvoicePaymentsPaymentId>>,
        TError,
        {paymentId: string;data: JsonPatchOperation[]},
        TContext
      > => {

      const mutationOptions = getPatchInvoicePaymentsPaymentIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Source-agnostic. Dispatches by Payment.SrcType to the source-side
delete (QB: POST /v3/company/<realm>/payment?operation=delete).
Source-side delete propagates to the unified table on next sync.

 * @summary Delete a unified Payment in its source system
 */
export const deleteInvoicePaymentsPaymentId = (
    paymentId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/invoice-payments/${paymentId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteInvoicePaymentsPaymentIdMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInvoicePaymentsPaymentId>>, TError,{paymentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteInvoicePaymentsPaymentId>>, TError,{paymentId: string}, TContext> => {

const mutationKey = ['deleteInvoicePaymentsPaymentId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteInvoicePaymentsPaymentId>>, {paymentId: string}> = (props) => {
          const {paymentId} = props ?? {};

          return  deleteInvoicePaymentsPaymentId(paymentId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteInvoicePaymentsPaymentIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteInvoicePaymentsPaymentId>>>
    
    export type DeleteInvoicePaymentsPaymentIdMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Delete a unified Payment in its source system
 */
export const useDeleteInvoicePaymentsPaymentId = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteInvoicePaymentsPaymentId>>, TError,{paymentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteInvoicePaymentsPaymentId>>,
        TError,
        {paymentId: string},
        TContext
      > => {

      const mutationOptions = getDeleteInvoicePaymentsPaymentIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieve performance metrics and KPIs for a specific date range
 * @summary Get performance metrics
 */
export const getAnalyticsPerformance = (
    params?: GetAnalyticsPerformanceParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PerformanceMetrics>(
      {url: `/api/v1/analytics/performance`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetAnalyticsPerformanceQueryKey = (params?: GetAnalyticsPerformanceParams,) => {
    return [
    `/api/v1/analytics/performance`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAnalyticsPerformanceQueryOptions = <TData = Awaited<ReturnType<typeof getAnalyticsPerformance>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(params?: GetAnalyticsPerformanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsPerformance>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnalyticsPerformanceQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalyticsPerformance>>> = ({ signal }) => getAnalyticsPerformance(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsPerformance>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalyticsPerformanceQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalyticsPerformance>>>
export type GetAnalyticsPerformanceQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetAnalyticsPerformance<TData = Awaited<ReturnType<typeof getAnalyticsPerformance>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: undefined |  GetAnalyticsPerformanceParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsPerformance>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsPerformance>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsPerformance>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsPerformance<TData = Awaited<ReturnType<typeof getAnalyticsPerformance>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetAnalyticsPerformanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsPerformance>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsPerformance>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsPerformance>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsPerformance<TData = Awaited<ReturnType<typeof getAnalyticsPerformance>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetAnalyticsPerformanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsPerformance>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get performance metrics
 */

export function useGetAnalyticsPerformance<TData = Awaited<ReturnType<typeof getAnalyticsPerformance>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetAnalyticsPerformanceParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsPerformance>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnalyticsPerformanceQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieve historical performance trends
 * @summary Get historical trends
 */
export const getAnalyticsTrends = (
    params?: GetAnalyticsTrendsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TrendData>(
      {url: `/api/v1/analytics/trends`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetAnalyticsTrendsQueryKey = (params?: GetAnalyticsTrendsParams,) => {
    return [
    `/api/v1/analytics/trends`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAnalyticsTrendsQueryOptions = <TData = Awaited<ReturnType<typeof getAnalyticsTrends>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(params?: GetAnalyticsTrendsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsTrends>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnalyticsTrendsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalyticsTrends>>> = ({ signal }) => getAnalyticsTrends(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsTrends>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalyticsTrendsQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalyticsTrends>>>
export type GetAnalyticsTrendsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetAnalyticsTrends<TData = Awaited<ReturnType<typeof getAnalyticsTrends>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: undefined |  GetAnalyticsTrendsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsTrends>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsTrends>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsTrends>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsTrends<TData = Awaited<ReturnType<typeof getAnalyticsTrends>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetAnalyticsTrendsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsTrends>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsTrends>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsTrends>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsTrends<TData = Awaited<ReturnType<typeof getAnalyticsTrends>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetAnalyticsTrendsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsTrends>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get historical trends
 */

export function useGetAnalyticsTrends<TData = Awaited<ReturnType<typeof getAnalyticsTrends>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetAnalyticsTrendsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsTrends>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnalyticsTrendsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieve forecast and predictive analytics
 * @summary Get forecast data
 */
export const getAnalyticsForecasts = (
    params?: GetAnalyticsForecastsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ForecastData>(
      {url: `/api/v1/analytics/forecasts`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetAnalyticsForecastsQueryKey = (params?: GetAnalyticsForecastsParams,) => {
    return [
    `/api/v1/analytics/forecasts`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAnalyticsForecastsQueryOptions = <TData = Awaited<ReturnType<typeof getAnalyticsForecasts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(params?: GetAnalyticsForecastsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsForecasts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAnalyticsForecastsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAnalyticsForecasts>>> = ({ signal }) => getAnalyticsForecasts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsForecasts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAnalyticsForecastsQueryResult = NonNullable<Awaited<ReturnType<typeof getAnalyticsForecasts>>>
export type GetAnalyticsForecastsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetAnalyticsForecasts<TData = Awaited<ReturnType<typeof getAnalyticsForecasts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: undefined |  GetAnalyticsForecastsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsForecasts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsForecasts>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsForecasts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsForecasts<TData = Awaited<ReturnType<typeof getAnalyticsForecasts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetAnalyticsForecastsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsForecasts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAnalyticsForecasts>>,
          TError,
          Awaited<ReturnType<typeof getAnalyticsForecasts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAnalyticsForecasts<TData = Awaited<ReturnType<typeof getAnalyticsForecasts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetAnalyticsForecastsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsForecasts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get forecast data
 */

export function useGetAnalyticsForecasts<TData = Awaited<ReturnType<typeof getAnalyticsForecasts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetAnalyticsForecastsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAnalyticsForecasts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAnalyticsForecastsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Generate a custom report based on specified parameters
 * @summary Generate custom report
 */
export const postReportsGenerate = (
    reportGenerateRequest: ReportGenerateRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostReportsGenerate202>(
      {url: `/api/v1/reports/generate`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: reportGenerateRequest, signal
    },
      options);
    }
  


export const getPostReportsGenerateMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postReportsGenerate>>, TError,{data: ReportGenerateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postReportsGenerate>>, TError,{data: ReportGenerateRequest}, TContext> => {

const mutationKey = ['postReportsGenerate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postReportsGenerate>>, {data: ReportGenerateRequest}> = (props) => {
          const {data} = props ?? {};

          return  postReportsGenerate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostReportsGenerateMutationResult = NonNullable<Awaited<ReturnType<typeof postReportsGenerate>>>
    export type PostReportsGenerateMutationBody = ReportGenerateRequest
    export type PostReportsGenerateMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Generate custom report
 */
export const usePostReportsGenerate = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postReportsGenerate>>, TError,{data: ReportGenerateRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postReportsGenerate>>,
        TError,
        {data: ReportGenerateRequest},
        TContext
      > => {

      const mutationOptions = getPostReportsGenerateMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Export report data in specified format
 * @summary Export report data
 */
export const getReportsIdExport = (
    id: string,
    params?: GetReportsIdExportParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Blob | string | GetReportsIdExport200Three>(
      {url: `/api/v1/reports/${id}/export`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetReportsIdExportQueryKey = (id?: string,
    params?: GetReportsIdExportParams,) => {
    return [
    `/api/v1/reports/${id}/export`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetReportsIdExportQueryOptions = <TData = Awaited<ReturnType<typeof getReportsIdExport>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(id: string,
    params?: GetReportsIdExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIdExport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportsIdExportQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsIdExport>>> = ({ signal }) => getReportsIdExport(id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReportsIdExport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportsIdExportQueryResult = NonNullable<Awaited<ReturnType<typeof getReportsIdExport>>>
export type GetReportsIdExportQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetReportsIdExport<TData = Awaited<ReturnType<typeof getReportsIdExport>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 id: string,
    params: undefined |  GetReportsIdExportParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIdExport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsIdExport>>,
          TError,
          Awaited<ReturnType<typeof getReportsIdExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsIdExport<TData = Awaited<ReturnType<typeof getReportsIdExport>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 id: string,
    params?: GetReportsIdExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIdExport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsIdExport>>,
          TError,
          Awaited<ReturnType<typeof getReportsIdExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsIdExport<TData = Awaited<ReturnType<typeof getReportsIdExport>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 id: string,
    params?: GetReportsIdExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIdExport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export report data
 */

export function useGetReportsIdExport<TData = Awaited<ReturnType<typeof getReportsIdExport>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 id: string,
    params?: GetReportsIdExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIdExport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReportsIdExportQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Calculate burn rate from Mercury transactions, grouped by the specified bucket size
 * @summary Get burn rate report
 */
export const getReportsBurnRate = (
    params: GetReportsBurnRateParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<BurnRateReport>(
      {url: `/api/v1/reports/burn-rate`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetReportsBurnRateQueryKey = (params?: GetReportsBurnRateParams,) => {
    return [
    `/api/v1/reports/burn-rate`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetReportsBurnRateQueryOptions = <TData = Awaited<ReturnType<typeof getReportsBurnRate>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(params: GetReportsBurnRateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsBurnRate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportsBurnRateQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsBurnRate>>> = ({ signal }) => getReportsBurnRate(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReportsBurnRate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportsBurnRateQueryResult = NonNullable<Awaited<ReturnType<typeof getReportsBurnRate>>>
export type GetReportsBurnRateQueryError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetReportsBurnRate<TData = Awaited<ReturnType<typeof getReportsBurnRate>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: GetReportsBurnRateParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsBurnRate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsBurnRate>>,
          TError,
          Awaited<ReturnType<typeof getReportsBurnRate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsBurnRate<TData = Awaited<ReturnType<typeof getReportsBurnRate>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: GetReportsBurnRateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsBurnRate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsBurnRate>>,
          TError,
          Awaited<ReturnType<typeof getReportsBurnRate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsBurnRate<TData = Awaited<ReturnType<typeof getReportsBurnRate>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: GetReportsBurnRateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsBurnRate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get burn rate report
 */

export function useGetReportsBurnRate<TData = Awaited<ReturnType<typeof getReportsBurnRate>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: GetReportsBurnRateParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsBurnRate>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReportsBurnRateQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * List individual outgoing Mercury transactions for a date range (same filters as burn rate report)
 * @summary List burn rate transactions
 */
export const getReportsBurnRateTransactions = (
    params?: GetReportsBurnRateTransactionsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<BurnRateTransaction[]>(
      {url: `/api/v1/reports/burn-rate/transactions`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetReportsBurnRateTransactionsQueryKey = (params?: GetReportsBurnRateTransactionsParams,) => {
    return [
    `/api/v1/reports/burn-rate/transactions`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetReportsBurnRateTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof getReportsBurnRateTransactions>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(params?: GetReportsBurnRateTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsBurnRateTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportsBurnRateTransactionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsBurnRateTransactions>>> = ({ signal }) => getReportsBurnRateTransactions(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReportsBurnRateTransactions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportsBurnRateTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof getReportsBurnRateTransactions>>>
export type GetReportsBurnRateTransactionsQueryError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetReportsBurnRateTransactions<TData = Awaited<ReturnType<typeof getReportsBurnRateTransactions>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: undefined |  GetReportsBurnRateTransactionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsBurnRateTransactions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsBurnRateTransactions>>,
          TError,
          Awaited<ReturnType<typeof getReportsBurnRateTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsBurnRateTransactions<TData = Awaited<ReturnType<typeof getReportsBurnRateTransactions>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetReportsBurnRateTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsBurnRateTransactions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsBurnRateTransactions>>,
          TError,
          Awaited<ReturnType<typeof getReportsBurnRateTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsBurnRateTransactions<TData = Awaited<ReturnType<typeof getReportsBurnRateTransactions>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetReportsBurnRateTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsBurnRateTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List burn rate transactions
 */

export function useGetReportsBurnRateTransactions<TData = Awaited<ReturnType<typeof getReportsBurnRateTransactions>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetReportsBurnRateTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsBurnRateTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReportsBurnRateTransactionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Time-bucketed income for a date range. Cursor-paginated; each record
is one bucket's revenue summary. Aggregation is line-level — the SQL
groups invoice_lines by invoice, then by bucket, applying the
invoice-level discount appropriately.

- In `program_date` mode (and only that mode), the discount is
  pro-rated across an invoice's lines by line.amount, since one
  invoice's lines can fall in different program-date buckets.
  Non-program lines (lines with no event row) are excluded.
- In invoice-level date modes (invoice_date / due_date / booking_date),
  all of an invoice's lines fall in the same bucket, so the discount
  is subtracted once per invoice (no pro-rata).

Returns gross, net_amount (= gross − discount), net_revenue
(= sum of revenue-flagged line amounts − discount), and discount
on every bucket and in the cross-bucket summary.

 * @summary List income buckets
 */
export const getReportsIncome = (
    params?: GetReportsIncomeParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetReportsIncome200>(
      {url: `/api/v1/reports/income`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetReportsIncomeQueryKey = (params?: GetReportsIncomeParams,) => {
    return [
    `/api/v1/reports/income`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetReportsIncomeQueryOptions = <TData = Awaited<ReturnType<typeof getReportsIncome>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(params?: GetReportsIncomeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIncome>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportsIncomeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsIncome>>> = ({ signal }) => getReportsIncome(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReportsIncome>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportsIncomeQueryResult = NonNullable<Awaited<ReturnType<typeof getReportsIncome>>>
export type GetReportsIncomeQueryError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetReportsIncome<TData = Awaited<ReturnType<typeof getReportsIncome>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: undefined |  GetReportsIncomeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIncome>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsIncome>>,
          TError,
          Awaited<ReturnType<typeof getReportsIncome>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsIncome<TData = Awaited<ReturnType<typeof getReportsIncome>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetReportsIncomeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIncome>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsIncome>>,
          TError,
          Awaited<ReturnType<typeof getReportsIncome>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsIncome<TData = Awaited<ReturnType<typeof getReportsIncome>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetReportsIncomeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIncome>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List income buckets
 */

export function useGetReportsIncome<TData = Awaited<ReturnType<typeof getReportsIncome>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetReportsIncomeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIncome>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReportsIncomeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Aggregates events in scope by one of state / activity type
(program_type) / program / customer. The standard date range
and existing income filter set are applied to narrow the row
set; `breakdown_by` picks the GROUP BY column.

Every event is one events.id row joined to its invoice line.
When multiple events share one invoice line, the line's
allocated net (post-discount, per Invoice.AllocatedLineNets)
is split equally per event so totals reconcile.

Returns one row per distinct dimension value, with event count
and revenue. Cursor-paginated.

 * @summary Events + revenue grouped by a single dimension
 */
export const getReportsIncomeBreakdown = (
    params: GetReportsIncomeBreakdownParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetReportsIncomeBreakdown200>(
      {url: `/api/v1/reports/income/breakdown`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetReportsIncomeBreakdownQueryKey = (params?: GetReportsIncomeBreakdownParams,) => {
    return [
    `/api/v1/reports/income/breakdown`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetReportsIncomeBreakdownQueryOptions = <TData = Awaited<ReturnType<typeof getReportsIncomeBreakdown>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(params: GetReportsIncomeBreakdownParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIncomeBreakdown>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportsIncomeBreakdownQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsIncomeBreakdown>>> = ({ signal }) => getReportsIncomeBreakdown(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReportsIncomeBreakdown>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportsIncomeBreakdownQueryResult = NonNullable<Awaited<ReturnType<typeof getReportsIncomeBreakdown>>>
export type GetReportsIncomeBreakdownQueryError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetReportsIncomeBreakdown<TData = Awaited<ReturnType<typeof getReportsIncomeBreakdown>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: GetReportsIncomeBreakdownParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIncomeBreakdown>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsIncomeBreakdown>>,
          TError,
          Awaited<ReturnType<typeof getReportsIncomeBreakdown>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsIncomeBreakdown<TData = Awaited<ReturnType<typeof getReportsIncomeBreakdown>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: GetReportsIncomeBreakdownParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIncomeBreakdown>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsIncomeBreakdown>>,
          TError,
          Awaited<ReturnType<typeof getReportsIncomeBreakdown>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsIncomeBreakdown<TData = Awaited<ReturnType<typeof getReportsIncomeBreakdown>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: GetReportsIncomeBreakdownParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIncomeBreakdown>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Events + revenue grouped by a single dimension
 */

export function useGetReportsIncomeBreakdown<TData = Awaited<ReturnType<typeof getReportsIncomeBreakdown>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: GetReportsIncomeBreakdownParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIncomeBreakdown>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReportsIncomeBreakdownQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Distinct events.program_program for non-deleted events. Sorted by name. Used to populate the Program Name multiselect on Financial Reports.
 * @summary List distinct program names for the income report filter
 */
export const getReportsIncomeFilterOptionsProgramNames = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<IncomeFilterOptionsResponse>(
      {url: `/api/v1/reports/income/filter-options/program-names`, method: 'GET', signal
    },
      options);
    }
  



export const getGetReportsIncomeFilterOptionsProgramNamesQueryKey = () => {
    return [
    `/api/v1/reports/income/filter-options/program-names`
    ] as const;
    }

    
export const getGetReportsIncomeFilterOptionsProgramNamesQueryOptions = <TData = Awaited<ReturnType<typeof getReportsIncomeFilterOptionsProgramNames>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIncomeFilterOptionsProgramNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportsIncomeFilterOptionsProgramNamesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsIncomeFilterOptionsProgramNames>>> = ({ signal }) => getReportsIncomeFilterOptionsProgramNames(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReportsIncomeFilterOptionsProgramNames>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportsIncomeFilterOptionsProgramNamesQueryResult = NonNullable<Awaited<ReturnType<typeof getReportsIncomeFilterOptionsProgramNames>>>
export type GetReportsIncomeFilterOptionsProgramNamesQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetReportsIncomeFilterOptionsProgramNames<TData = Awaited<ReturnType<typeof getReportsIncomeFilterOptionsProgramNames>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIncomeFilterOptionsProgramNames>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsIncomeFilterOptionsProgramNames>>,
          TError,
          Awaited<ReturnType<typeof getReportsIncomeFilterOptionsProgramNames>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsIncomeFilterOptionsProgramNames<TData = Awaited<ReturnType<typeof getReportsIncomeFilterOptionsProgramNames>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIncomeFilterOptionsProgramNames>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsIncomeFilterOptionsProgramNames>>,
          TError,
          Awaited<ReturnType<typeof getReportsIncomeFilterOptionsProgramNames>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsIncomeFilterOptionsProgramNames<TData = Awaited<ReturnType<typeof getReportsIncomeFilterOptionsProgramNames>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIncomeFilterOptionsProgramNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List distinct program names for the income report filter
 */

export function useGetReportsIncomeFilterOptionsProgramNames<TData = Awaited<ReturnType<typeof getReportsIncomeFilterOptionsProgramNames>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIncomeFilterOptionsProgramNames>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReportsIncomeFilterOptionsProgramNamesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Distinct customer_sources.address_state for customers' primary sources, non-empty values only.
 * @summary List distinct states (from customer primary sources)
 */
export const getReportsIncomeFilterOptionsStates = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<IncomeFilterOptionsResponse>(
      {url: `/api/v1/reports/income/filter-options/states`, method: 'GET', signal
    },
      options);
    }
  



export const getGetReportsIncomeFilterOptionsStatesQueryKey = () => {
    return [
    `/api/v1/reports/income/filter-options/states`
    ] as const;
    }

    
export const getGetReportsIncomeFilterOptionsStatesQueryOptions = <TData = Awaited<ReturnType<typeof getReportsIncomeFilterOptionsStates>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIncomeFilterOptionsStates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportsIncomeFilterOptionsStatesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsIncomeFilterOptionsStates>>> = ({ signal }) => getReportsIncomeFilterOptionsStates(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReportsIncomeFilterOptionsStates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportsIncomeFilterOptionsStatesQueryResult = NonNullable<Awaited<ReturnType<typeof getReportsIncomeFilterOptionsStates>>>
export type GetReportsIncomeFilterOptionsStatesQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetReportsIncomeFilterOptionsStates<TData = Awaited<ReturnType<typeof getReportsIncomeFilterOptionsStates>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIncomeFilterOptionsStates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsIncomeFilterOptionsStates>>,
          TError,
          Awaited<ReturnType<typeof getReportsIncomeFilterOptionsStates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsIncomeFilterOptionsStates<TData = Awaited<ReturnType<typeof getReportsIncomeFilterOptionsStates>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIncomeFilterOptionsStates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsIncomeFilterOptionsStates>>,
          TError,
          Awaited<ReturnType<typeof getReportsIncomeFilterOptionsStates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsIncomeFilterOptionsStates<TData = Awaited<ReturnType<typeof getReportsIncomeFilterOptionsStates>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIncomeFilterOptionsStates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List distinct states (from customer primary sources)
 */

export function useGetReportsIncomeFilterOptionsStates<TData = Awaited<ReturnType<typeof getReportsIncomeFilterOptionsStates>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIncomeFilterOptionsStates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReportsIncomeFilterOptionsStatesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Distinct invoice_attributions.name where role='salesperson'.
 * @summary List distinct attributed salesperson names
 */
export const getReportsIncomeFilterOptionsSalespeople = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<IncomeFilterOptionsResponse>(
      {url: `/api/v1/reports/income/filter-options/salespeople`, method: 'GET', signal
    },
      options);
    }
  



export const getGetReportsIncomeFilterOptionsSalespeopleQueryKey = () => {
    return [
    `/api/v1/reports/income/filter-options/salespeople`
    ] as const;
    }

    
export const getGetReportsIncomeFilterOptionsSalespeopleQueryOptions = <TData = Awaited<ReturnType<typeof getReportsIncomeFilterOptionsSalespeople>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIncomeFilterOptionsSalespeople>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportsIncomeFilterOptionsSalespeopleQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsIncomeFilterOptionsSalespeople>>> = ({ signal }) => getReportsIncomeFilterOptionsSalespeople(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReportsIncomeFilterOptionsSalespeople>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportsIncomeFilterOptionsSalespeopleQueryResult = NonNullable<Awaited<ReturnType<typeof getReportsIncomeFilterOptionsSalespeople>>>
export type GetReportsIncomeFilterOptionsSalespeopleQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetReportsIncomeFilterOptionsSalespeople<TData = Awaited<ReturnType<typeof getReportsIncomeFilterOptionsSalespeople>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIncomeFilterOptionsSalespeople>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsIncomeFilterOptionsSalespeople>>,
          TError,
          Awaited<ReturnType<typeof getReportsIncomeFilterOptionsSalespeople>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsIncomeFilterOptionsSalespeople<TData = Awaited<ReturnType<typeof getReportsIncomeFilterOptionsSalespeople>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIncomeFilterOptionsSalespeople>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsIncomeFilterOptionsSalespeople>>,
          TError,
          Awaited<ReturnType<typeof getReportsIncomeFilterOptionsSalespeople>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsIncomeFilterOptionsSalespeople<TData = Awaited<ReturnType<typeof getReportsIncomeFilterOptionsSalespeople>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIncomeFilterOptionsSalespeople>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List distinct attributed salesperson names
 */

export function useGetReportsIncomeFilterOptionsSalespeople<TData = Awaited<ReturnType<typeof getReportsIncomeFilterOptionsSalespeople>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIncomeFilterOptionsSalespeople>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReportsIncomeFilterOptionsSalespeopleQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Distinct invoice_attributions.name where role='sales_lead'.
 * @summary List distinct attributed sales-lead names
 */
export const getReportsIncomeFilterOptionsSalesLeads = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<IncomeFilterOptionsResponse>(
      {url: `/api/v1/reports/income/filter-options/sales-leads`, method: 'GET', signal
    },
      options);
    }
  



export const getGetReportsIncomeFilterOptionsSalesLeadsQueryKey = () => {
    return [
    `/api/v1/reports/income/filter-options/sales-leads`
    ] as const;
    }

    
export const getGetReportsIncomeFilterOptionsSalesLeadsQueryOptions = <TData = Awaited<ReturnType<typeof getReportsIncomeFilterOptionsSalesLeads>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIncomeFilterOptionsSalesLeads>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportsIncomeFilterOptionsSalesLeadsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getReportsIncomeFilterOptionsSalesLeads>>> = ({ signal }) => getReportsIncomeFilterOptionsSalesLeads(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getReportsIncomeFilterOptionsSalesLeads>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportsIncomeFilterOptionsSalesLeadsQueryResult = NonNullable<Awaited<ReturnType<typeof getReportsIncomeFilterOptionsSalesLeads>>>
export type GetReportsIncomeFilterOptionsSalesLeadsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetReportsIncomeFilterOptionsSalesLeads<TData = Awaited<ReturnType<typeof getReportsIncomeFilterOptionsSalesLeads>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIncomeFilterOptionsSalesLeads>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsIncomeFilterOptionsSalesLeads>>,
          TError,
          Awaited<ReturnType<typeof getReportsIncomeFilterOptionsSalesLeads>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsIncomeFilterOptionsSalesLeads<TData = Awaited<ReturnType<typeof getReportsIncomeFilterOptionsSalesLeads>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIncomeFilterOptionsSalesLeads>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportsIncomeFilterOptionsSalesLeads>>,
          TError,
          Awaited<ReturnType<typeof getReportsIncomeFilterOptionsSalesLeads>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportsIncomeFilterOptionsSalesLeads<TData = Awaited<ReturnType<typeof getReportsIncomeFilterOptionsSalesLeads>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIncomeFilterOptionsSalesLeads>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List distinct attributed sales-lead names
 */

export function useGetReportsIncomeFilterOptionsSalesLeads<TData = Awaited<ReturnType<typeof getReportsIncomeFilterOptionsSalesLeads>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getReportsIncomeFilterOptionsSalesLeads>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetReportsIncomeFilterOptionsSalesLeadsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieve notifications for current user
 * @summary Get user notifications
 */
export const getNotifications = (
    params?: GetNotificationsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetNotifications200>(
      {url: `/api/v1/notifications`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetNotificationsQueryKey = (params?: GetNotificationsParams,) => {
    return [
    `/api/v1/notifications`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof getNotifications>>, TError = UnauthorizedErrorResponse>(params?: GetNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotifications>>> = ({ signal }) => getNotifications(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof getNotifications>>>
export type GetNotificationsQueryError = UnauthorizedErrorResponse


export function useGetNotifications<TData = Awaited<ReturnType<typeof getNotifications>>, TError = UnauthorizedErrorResponse>(
 params: undefined |  GetNotificationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotifications>>,
          TError,
          Awaited<ReturnType<typeof getNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotifications<TData = Awaited<ReturnType<typeof getNotifications>>, TError = UnauthorizedErrorResponse>(
 params?: GetNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotifications>>,
          TError,
          Awaited<ReturnType<typeof getNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotifications<TData = Awaited<ReturnType<typeof getNotifications>>, TError = UnauthorizedErrorResponse>(
 params?: GetNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get user notifications
 */

export function useGetNotifications<TData = Awaited<ReturnType<typeof getNotifications>>, TError = UnauthorizedErrorResponse>(
 params?: GetNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNotificationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Mark a specific notification as read
 * @summary Mark notification as read
 */
export const putNotificationsIdRead = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<Notification>(
      {url: `/api/v1/notifications/${id}/read`, method: 'PUT'
    },
      options);
    }
  


export const getPutNotificationsIdReadMutationOptions = <TError = UnauthorizedErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putNotificationsIdRead>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putNotificationsIdRead>>, TError,{id: string}, TContext> => {

const mutationKey = ['putNotificationsIdRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putNotificationsIdRead>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  putNotificationsIdRead(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutNotificationsIdReadMutationResult = NonNullable<Awaited<ReturnType<typeof putNotificationsIdRead>>>
    
    export type PutNotificationsIdReadMutationError = UnauthorizedErrorResponse | NotFoundErrorResponse

    /**
 * @summary Mark notification as read
 */
export const usePutNotificationsIdRead = <TError = UnauthorizedErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putNotificationsIdRead>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putNotificationsIdRead>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPutNotificationsIdReadMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Archive a specific notification so it no longer appears in the list
 * @summary Archive notification
 */
export const putNotificationsIdArchive = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<Notification>(
      {url: `/api/v1/notifications/${id}/archive`, method: 'PUT'
    },
      options);
    }
  


export const getPutNotificationsIdArchiveMutationOptions = <TError = UnauthorizedErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putNotificationsIdArchive>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putNotificationsIdArchive>>, TError,{id: string}, TContext> => {

const mutationKey = ['putNotificationsIdArchive'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putNotificationsIdArchive>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  putNotificationsIdArchive(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutNotificationsIdArchiveMutationResult = NonNullable<Awaited<ReturnType<typeof putNotificationsIdArchive>>>
    
    export type PutNotificationsIdArchiveMutationError = UnauthorizedErrorResponse | NotFoundErrorResponse

    /**
 * @summary Archive notification
 */
export const usePutNotificationsIdArchive = <TError = UnauthorizedErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putNotificationsIdArchive>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putNotificationsIdArchive>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPutNotificationsIdArchiveMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Delete a specific notification
 * @summary Delete notification
 */
export const deleteNotificationsId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/notifications/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteNotificationsIdMutationOptions = <TError = UnauthorizedErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNotificationsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteNotificationsId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteNotificationsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteNotificationsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteNotificationsId(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteNotificationsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteNotificationsId>>>
    
    export type DeleteNotificationsIdMutationError = UnauthorizedErrorResponse | NotFoundErrorResponse

    /**
 * @summary Delete notification
 */
export const useDeleteNotificationsId = <TError = UnauthorizedErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNotificationsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteNotificationsId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteNotificationsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update user notification preferences
 * @summary Update notification preferences
 */
export const postNotificationsPreferences = (
    notificationPreferences: NotificationPreferences,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<NotificationPreferences>(
      {url: `/api/v1/notifications/preferences`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: notificationPreferences, signal
    },
      options);
    }
  


export const getPostNotificationsPreferencesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationsPreferences>>, TError,{data: NotificationPreferences}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postNotificationsPreferences>>, TError,{data: NotificationPreferences}, TContext> => {

const mutationKey = ['postNotificationsPreferences'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postNotificationsPreferences>>, {data: NotificationPreferences}> = (props) => {
          const {data} = props ?? {};

          return  postNotificationsPreferences(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostNotificationsPreferencesMutationResult = NonNullable<Awaited<ReturnType<typeof postNotificationsPreferences>>>
    export type PostNotificationsPreferencesMutationBody = NotificationPreferences
    export type PostNotificationsPreferencesMutationError = unknown

    /**
 * @summary Update notification preferences
 */
export const usePostNotificationsPreferences = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postNotificationsPreferences>>, TError,{data: NotificationPreferences}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postNotificationsPreferences>>,
        TError,
        {data: NotificationPreferences},
        TContext
      > => {

      const mutationOptions = getPostNotificationsPreferencesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Server-Sent Events stream for real-time notifications. Authentication via token query parameter since EventSource cannot send custom headers.
 * @summary Stream notifications via SSE
 */
export const getNotificationsStream = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/v1/notifications/stream`, method: 'GET', signal
    },
      options);
    }
  



export const getGetNotificationsStreamQueryKey = () => {
    return [
    `/api/v1/notifications/stream`
    ] as const;
    }

    
export const getGetNotificationsStreamQueryOptions = <TData = Awaited<ReturnType<typeof getNotificationsStream>>, TError = UnauthorizedErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationsStream>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationsStreamQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationsStream>>> = ({ signal }) => getNotificationsStream(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNotificationsStream>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetNotificationsStreamQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationsStream>>>
export type GetNotificationsStreamQueryError = UnauthorizedErrorResponse


export function useGetNotificationsStream<TData = Awaited<ReturnType<typeof getNotificationsStream>>, TError = UnauthorizedErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationsStream>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationsStream>>,
          TError,
          Awaited<ReturnType<typeof getNotificationsStream>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotificationsStream<TData = Awaited<ReturnType<typeof getNotificationsStream>>, TError = UnauthorizedErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationsStream>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationsStream>>,
          TError,
          Awaited<ReturnType<typeof getNotificationsStream>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetNotificationsStream<TData = Awaited<ReturnType<typeof getNotificationsStream>>, TError = UnauthorizedErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationsStream>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Stream notifications via SSE
 */

export function useGetNotificationsStream<TData = Awaited<ReturnType<typeof getNotificationsStream>>, TError = UnauthorizedErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationsStream>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetNotificationsStreamQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get list of events with filtering and pagination
 * @summary List events
 */
export const getEvents = (
    params?: GetEventsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetEvents200>(
      {url: `/api/v1/events`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetEventsQueryKey = (params?: GetEventsParams,) => {
    return [
    `/api/v1/events`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetEventsQueryOptions = <TData = Awaited<ReturnType<typeof getEvents>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(params?: GetEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEvents>>> = ({ signal }) => getEvents(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEventsQueryResult = NonNullable<Awaited<ReturnType<typeof getEvents>>>
export type GetEventsQueryError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetEvents<TData = Awaited<ReturnType<typeof getEvents>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 params: undefined |  GetEventsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvents>>,
          TError,
          Awaited<ReturnType<typeof getEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvents<TData = Awaited<ReturnType<typeof getEvents>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 params?: GetEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEvents>>,
          TError,
          Awaited<ReturnType<typeof getEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEvents<TData = Awaited<ReturnType<typeof getEvents>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 params?: GetEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List events
 */

export function useGetEvents<TData = Awaited<ReturnType<typeof getEvents>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 params?: GetEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEventsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * events.program_devices is a pipe-separated composite string
("Customer Provided | BYOD | 10 ASG Tablets") sourced from
free-text in the QuickBooks line description. This endpoint
splits every non-deleted row on `|`, trims whitespace, and
dedupes case-insensitively (first-seen casing wins). Returns
the resulting token set sorted by frequency desc so common
types lead the dropdown. Used to populate the Device Types
multiselect on the Events page.

 * @summary List distinct device-type tokens for the events filter
 */
export const getEventsFilterOptionsDeviceTypes = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<EventsFilterOptionsResponse>(
      {url: `/api/v1/events/filter-options/device-types`, method: 'GET', signal
    },
      options);
    }
  



export const getGetEventsFilterOptionsDeviceTypesQueryKey = () => {
    return [
    `/api/v1/events/filter-options/device-types`
    ] as const;
    }

    
export const getGetEventsFilterOptionsDeviceTypesQueryOptions = <TData = Awaited<ReturnType<typeof getEventsFilterOptionsDeviceTypes>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsFilterOptionsDeviceTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventsFilterOptionsDeviceTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventsFilterOptionsDeviceTypes>>> = ({ signal }) => getEventsFilterOptionsDeviceTypes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEventsFilterOptionsDeviceTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEventsFilterOptionsDeviceTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getEventsFilterOptionsDeviceTypes>>>
export type GetEventsFilterOptionsDeviceTypesQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetEventsFilterOptionsDeviceTypes<TData = Awaited<ReturnType<typeof getEventsFilterOptionsDeviceTypes>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsFilterOptionsDeviceTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventsFilterOptionsDeviceTypes>>,
          TError,
          Awaited<ReturnType<typeof getEventsFilterOptionsDeviceTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventsFilterOptionsDeviceTypes<TData = Awaited<ReturnType<typeof getEventsFilterOptionsDeviceTypes>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsFilterOptionsDeviceTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventsFilterOptionsDeviceTypes>>,
          TError,
          Awaited<ReturnType<typeof getEventsFilterOptionsDeviceTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventsFilterOptionsDeviceTypes<TData = Awaited<ReturnType<typeof getEventsFilterOptionsDeviceTypes>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsFilterOptionsDeviceTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List distinct device-type tokens for the events filter
 */

export function useGetEventsFilterOptionsDeviceTypes<TData = Awaited<ReturnType<typeof getEventsFilterOptionsDeviceTypes>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsFilterOptionsDeviceTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEventsFilterOptionsDeviceTypesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieve specific event information
 * @summary Get event details
 */
export const getEventsId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Event>(
      {url: `/api/v1/events/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetEventsIdQueryKey = (id?: string,) => {
    return [
    `/api/v1/events/${id}`
    ] as const;
    }

    
export const getGetEventsIdQueryOptions = <TData = Awaited<ReturnType<typeof getEventsId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEventsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEventsId>>> = ({ signal }) => getEventsId(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEventsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEventsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getEventsId>>>
export type GetEventsIdQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetEventsId<TData = Awaited<ReturnType<typeof getEventsId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventsId>>,
          TError,
          Awaited<ReturnType<typeof getEventsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventsId<TData = Awaited<ReturnType<typeof getEventsId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEventsId>>,
          TError,
          Awaited<ReturnType<typeof getEventsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEventsId<TData = Awaited<ReturnType<typeof getEventsId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get event details
 */

export function useGetEventsId<TData = Awaited<ReturnType<typeof getEventsId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEventsId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEventsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update editable fields for a specific event using JSON Patch (RFC 6902).
Only the following fields can be modified:
- /reviewed
- /tech_setup_required
- /tech_setup_completed
- /pre_program_setup_email_sent
- /pre_program_reminder_email_sent
- /owner_id

 * @summary Update event fields
 */
export const patchEventsId = (
    id: string,
    jsonPatchOperation: JsonPatchOperation[],
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<Event>(
      {url: `/api/v1/events/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json-patch+json', },
      data: jsonPatchOperation
    },
      options);
    }
  


export const getPatchEventsIdMutationOptions = <TError = PatchEventsId400 | UnauthorizedErrorResponse | ForbiddenErrorResponse | PatchEventsId404 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchEventsId>>, TError,{id: string;data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchEventsId>>, TError,{id: string;data: JsonPatchOperation[]}, TContext> => {

const mutationKey = ['patchEventsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchEventsId>>, {id: string;data: JsonPatchOperation[]}> = (props) => {
          const {id,data} = props ?? {};

          return  patchEventsId(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchEventsIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchEventsId>>>
    export type PatchEventsIdMutationBody = JsonPatchOperation[]
    export type PatchEventsIdMutationError = PatchEventsId400 | UnauthorizedErrorResponse | ForbiddenErrorResponse | PatchEventsId404 | void

    /**
 * @summary Update event fields
 */
export const usePatchEventsId = <TError = PatchEventsId400 | UnauthorizedErrorResponse | ForbiddenErrorResponse | PatchEventsId404 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchEventsId>>, TError,{id: string;data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchEventsId>>,
        TError,
        {id: string;data: JsonPatchOperation[]},
        TContext
      > => {

      const mutationOptions = getPatchEventsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Add a Sling shift assignment to an event. Multiple shifts can be assigned to the same event.
 * @summary Add a shift to an event
 */
export const postEventsIdShifts = (
    id: string,
    postEventsIdShiftsBody: PostEventsIdShiftsBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostEventsIdShifts200>(
      {url: `/api/v1/events/${id}/shifts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postEventsIdShiftsBody, signal
    },
      options);
    }
  


export const getPostEventsIdShiftsMutationOptions = <TError = PostEventsIdShifts400 | UnauthorizedErrorResponse | ForbiddenErrorResponse | PostEventsIdShifts404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEventsIdShifts>>, TError,{id: string;data: PostEventsIdShiftsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postEventsIdShifts>>, TError,{id: string;data: PostEventsIdShiftsBody}, TContext> => {

const mutationKey = ['postEventsIdShifts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEventsIdShifts>>, {id: string;data: PostEventsIdShiftsBody}> = (props) => {
          const {id,data} = props ?? {};

          return  postEventsIdShifts(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEventsIdShiftsMutationResult = NonNullable<Awaited<ReturnType<typeof postEventsIdShifts>>>
    export type PostEventsIdShiftsMutationBody = PostEventsIdShiftsBody
    export type PostEventsIdShiftsMutationError = PostEventsIdShifts400 | UnauthorizedErrorResponse | ForbiddenErrorResponse | PostEventsIdShifts404

    /**
 * @summary Add a shift to an event
 */
export const usePostEventsIdShifts = <TError = PostEventsIdShifts400 | UnauthorizedErrorResponse | ForbiddenErrorResponse | PostEventsIdShifts404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEventsIdShifts>>, TError,{id: string;data: PostEventsIdShiftsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEventsIdShifts>>,
        TError,
        {id: string;data: PostEventsIdShiftsBody},
        TContext
      > => {

      const mutationOptions = getPostEventsIdShiftsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Remove a Sling shift assignment from an event.
 * @summary Remove a shift from an event
 */
export const deleteEventsIdShifts = (
    id: string,
    deleteEventsIdShiftsBody: DeleteEventsIdShiftsBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<Event>(
      {url: `/api/v1/events/${id}/shifts`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteEventsIdShiftsBody
    },
      options);
    }
  


export const getDeleteEventsIdShiftsMutationOptions = <TError = DeleteEventsIdShifts400 | UnauthorizedErrorResponse | ForbiddenErrorResponse | DeleteEventsIdShifts404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEventsIdShifts>>, TError,{id: string;data: DeleteEventsIdShiftsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteEventsIdShifts>>, TError,{id: string;data: DeleteEventsIdShiftsBody}, TContext> => {

const mutationKey = ['deleteEventsIdShifts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteEventsIdShifts>>, {id: string;data: DeleteEventsIdShiftsBody}> = (props) => {
          const {id,data} = props ?? {};

          return  deleteEventsIdShifts(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteEventsIdShiftsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteEventsIdShifts>>>
    export type DeleteEventsIdShiftsMutationBody = DeleteEventsIdShiftsBody
    export type DeleteEventsIdShiftsMutationError = DeleteEventsIdShifts400 | UnauthorizedErrorResponse | ForbiddenErrorResponse | DeleteEventsIdShifts404

    /**
 * @summary Remove a shift from an event
 */
export const useDeleteEventsIdShifts = <TError = DeleteEventsIdShifts400 | UnauthorizedErrorResponse | ForbiddenErrorResponse | DeleteEventsIdShifts404,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteEventsIdShifts>>, TError,{id: string;data: DeleteEventsIdShiftsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteEventsIdShifts>>,
        TError,
        {id: string;data: DeleteEventsIdShiftsBody},
        TContext
      > => {

      const mutationOptions = getDeleteEventsIdShiftsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Manually trigger event synchronization across all connected QuickBooks accounts
 * @summary Sync events from all QuickBooks integrations
 */
export const postEventsSync = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostEventsSync200>(
      {url: `/api/v1/events/sync`, method: 'POST', signal
    },
      options);
    }
  


export const getPostEventsSyncMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEventsSync>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postEventsSync>>, TError,void, TContext> => {

const mutationKey = ['postEventsSync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEventsSync>>, void> = () => {
          

          return  postEventsSync(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEventsSyncMutationResult = NonNullable<Awaited<ReturnType<typeof postEventsSync>>>
    
    export type PostEventsSyncMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Sync events from all QuickBooks integrations
 */
export const usePostEventsSync = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEventsSync>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEventsSync>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostEventsSyncMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get a list of all email contacts with their status, supporting cursor-based pagination and filtering
 * @summary List email contacts
 */
export const getMarketingEmailContacts = (
    params?: GetMarketingEmailContactsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetMarketingEmailContacts200>(
      {url: `/api/v1/marketing/email/contacts`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetMarketingEmailContactsQueryKey = (params?: GetMarketingEmailContactsParams,) => {
    return [
    `/api/v1/marketing/email/contacts`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetMarketingEmailContactsQueryOptions = <TData = Awaited<ReturnType<typeof getMarketingEmailContacts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(params?: GetMarketingEmailContactsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMarketingEmailContactsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingEmailContacts>>> = ({ signal }) => getMarketingEmailContacts(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailContacts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMarketingEmailContactsQueryResult = NonNullable<Awaited<ReturnType<typeof getMarketingEmailContacts>>>
export type GetMarketingEmailContactsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetMarketingEmailContacts<TData = Awaited<ReturnType<typeof getMarketingEmailContacts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 params: undefined |  GetMarketingEmailContactsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailContacts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingEmailContacts>>,
          TError,
          Awaited<ReturnType<typeof getMarketingEmailContacts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingEmailContacts<TData = Awaited<ReturnType<typeof getMarketingEmailContacts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 params?: GetMarketingEmailContactsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailContacts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingEmailContacts>>,
          TError,
          Awaited<ReturnType<typeof getMarketingEmailContacts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingEmailContacts<TData = Awaited<ReturnType<typeof getMarketingEmailContacts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 params?: GetMarketingEmailContactsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List email contacts
 */

export function useGetMarketingEmailContacts<TData = Awaited<ReturnType<typeof getMarketingEmailContacts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 params?: GetMarketingEmailContactsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMarketingEmailContactsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a new email contact
 * @summary Create email contact
 */
export const postMarketingEmailContacts = (
    postMarketingEmailContactsBody: PostMarketingEmailContactsBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<EmailContact>(
      {url: `/api/v1/marketing/email/contacts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postMarketingEmailContactsBody, signal
    },
      options);
    }
  


export const getPostMarketingEmailContactsMutationOptions = <TError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMarketingEmailContacts>>, TError,{data: PostMarketingEmailContactsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postMarketingEmailContacts>>, TError,{data: PostMarketingEmailContactsBody}, TContext> => {

const mutationKey = ['postMarketingEmailContacts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMarketingEmailContacts>>, {data: PostMarketingEmailContactsBody}> = (props) => {
          const {data} = props ?? {};

          return  postMarketingEmailContacts(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMarketingEmailContactsMutationResult = NonNullable<Awaited<ReturnType<typeof postMarketingEmailContacts>>>
    export type PostMarketingEmailContactsMutationBody = PostMarketingEmailContactsBody
    export type PostMarketingEmailContactsMutationError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Create email contact
 */
export const usePostMarketingEmailContacts = <TError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMarketingEmailContacts>>, TError,{data: PostMarketingEmailContactsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMarketingEmailContacts>>,
        TError,
        {data: PostMarketingEmailContactsBody},
        TContext
      > => {

      const mutationOptions = getPostMarketingEmailContactsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Delete email contacts matching the specified filter criteria. If no filters are provided, all contacts will be deleted.
 * @summary Delete contacts matching filters
 */
export const deleteMarketingEmailContacts = (
    params?: DeleteMarketingEmailContactsParams,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<DeleteMarketingEmailContacts200>(
      {url: `/api/v1/marketing/email/contacts`, method: 'DELETE',
        params
    },
      options);
    }
  


export const getDeleteMarketingEmailContactsMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMarketingEmailContacts>>, TError,{params?: DeleteMarketingEmailContactsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMarketingEmailContacts>>, TError,{params?: DeleteMarketingEmailContactsParams}, TContext> => {

const mutationKey = ['deleteMarketingEmailContacts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMarketingEmailContacts>>, {params?: DeleteMarketingEmailContactsParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteMarketingEmailContacts(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteMarketingEmailContactsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMarketingEmailContacts>>>
    
    export type DeleteMarketingEmailContactsMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Delete contacts matching filters
 */
export const useDeleteMarketingEmailContacts = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMarketingEmailContacts>>, TError,{params?: DeleteMarketingEmailContactsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteMarketingEmailContacts>>,
        TError,
        {params?: DeleteMarketingEmailContactsParams},
        TContext
      > => {

      const mutationOptions = getDeleteMarketingEmailContactsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Upload a CSV file with email addresses (required) and optional arrayscape_id column. Process all emails transactionally. Optionally specify list IDs and/or new list names to add all imported contacts to.
 * @summary Bulk import email contacts
 */
export const postMarketingEmailContactsBulkImport = (
    postMarketingEmailContactsBulkImportBody: PostMarketingEmailContactsBulkImportBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append(`file`, postMarketingEmailContactsBulkImportBody.file)
if(postMarketingEmailContactsBulkImportBody.list_ids !== undefined) {
 formData.append(`list_ids`, postMarketingEmailContactsBulkImportBody.list_ids)
 }
if(postMarketingEmailContactsBulkImportBody.new_list_names !== undefined) {
 formData.append(`new_list_names`, postMarketingEmailContactsBulkImportBody.new_list_names)
 }

      return customInstance<EmailContactsBulkImportResult>(
      {url: `/api/v1/marketing/email/contacts/bulk-import`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }
  


export const getPostMarketingEmailContactsBulkImportMutationOptions = <TError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMarketingEmailContactsBulkImport>>, TError,{data: PostMarketingEmailContactsBulkImportBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postMarketingEmailContactsBulkImport>>, TError,{data: PostMarketingEmailContactsBulkImportBody}, TContext> => {

const mutationKey = ['postMarketingEmailContactsBulkImport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMarketingEmailContactsBulkImport>>, {data: PostMarketingEmailContactsBulkImportBody}> = (props) => {
          const {data} = props ?? {};

          return  postMarketingEmailContactsBulkImport(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMarketingEmailContactsBulkImportMutationResult = NonNullable<Awaited<ReturnType<typeof postMarketingEmailContactsBulkImport>>>
    export type PostMarketingEmailContactsBulkImportMutationBody = PostMarketingEmailContactsBulkImportBody
    export type PostMarketingEmailContactsBulkImportMutationError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Bulk import email contacts
 */
export const usePostMarketingEmailContactsBulkImport = <TError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMarketingEmailContactsBulkImport>>, TError,{data: PostMarketingEmailContactsBulkImportBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMarketingEmailContactsBulkImport>>,
        TError,
        {data: PostMarketingEmailContactsBulkImportBody},
        TContext
      > => {

      const mutationOptions = getPostMarketingEmailContactsBulkImportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Download CSV with all email contacts (email, id, unsubscribed columns)
 * @summary Export email contacts
 */
export const getMarketingEmailContactsExport = (
    params?: GetMarketingEmailContactsExportParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Blob>(
      {url: `/api/v1/marketing/email/contacts/export`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      options);
    }
  



export const getGetMarketingEmailContactsExportQueryKey = (params?: GetMarketingEmailContactsExportParams,) => {
    return [
    `/api/v1/marketing/email/contacts/export`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetMarketingEmailContactsExportQueryOptions = <TData = Awaited<ReturnType<typeof getMarketingEmailContactsExport>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(params?: GetMarketingEmailContactsExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailContactsExport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMarketingEmailContactsExportQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingEmailContactsExport>>> = ({ signal }) => getMarketingEmailContactsExport(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailContactsExport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMarketingEmailContactsExportQueryResult = NonNullable<Awaited<ReturnType<typeof getMarketingEmailContactsExport>>>
export type GetMarketingEmailContactsExportQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetMarketingEmailContactsExport<TData = Awaited<ReturnType<typeof getMarketingEmailContactsExport>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 params: undefined |  GetMarketingEmailContactsExportParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailContactsExport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingEmailContactsExport>>,
          TError,
          Awaited<ReturnType<typeof getMarketingEmailContactsExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingEmailContactsExport<TData = Awaited<ReturnType<typeof getMarketingEmailContactsExport>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 params?: GetMarketingEmailContactsExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailContactsExport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingEmailContactsExport>>,
          TError,
          Awaited<ReturnType<typeof getMarketingEmailContactsExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingEmailContactsExport<TData = Awaited<ReturnType<typeof getMarketingEmailContactsExport>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 params?: GetMarketingEmailContactsExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailContactsExport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export email contacts
 */

export function useGetMarketingEmailContactsExport<TData = Awaited<ReturnType<typeof getMarketingEmailContactsExport>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 params?: GetMarketingEmailContactsExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailContactsExport>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMarketingEmailContactsExportQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Update editable fields for an email contact using JSON Patch (RFC 6902).
The following fields can be modified:
- /id (string - use to fix SendGrid external_id mismatches)
- /unsubscribed (boolean)
- /first_name (string or null)
- /last_name (string or null)
- /address_line_1 (string or null)
- /address_line_2 (string or null)
- /city (string or null)
- /state_province_region (string or null)
- /postal_code (string or null)
- /lists (array of {id, name} objects)

 * @summary Update email contact fields
 */
export const patchMarketingEmailContactsId = (
    id: string,
    jsonPatchOperation: JsonPatchOperation[],
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<EmailContact>(
      {url: `/api/v1/marketing/email/contacts/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json-patch+json', },
      data: jsonPatchOperation
    },
      options);
    }
  


export const getPatchMarketingEmailContactsIdMutationOptions = <TError = PatchMarketingEmailContactsId400 | UnauthorizedErrorResponse | ForbiddenErrorResponse | PatchMarketingEmailContactsId404 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchMarketingEmailContactsId>>, TError,{id: string;data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchMarketingEmailContactsId>>, TError,{id: string;data: JsonPatchOperation[]}, TContext> => {

const mutationKey = ['patchMarketingEmailContactsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchMarketingEmailContactsId>>, {id: string;data: JsonPatchOperation[]}> = (props) => {
          const {id,data} = props ?? {};

          return  patchMarketingEmailContactsId(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchMarketingEmailContactsIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchMarketingEmailContactsId>>>
    export type PatchMarketingEmailContactsIdMutationBody = JsonPatchOperation[]
    export type PatchMarketingEmailContactsIdMutationError = PatchMarketingEmailContactsId400 | UnauthorizedErrorResponse | ForbiddenErrorResponse | PatchMarketingEmailContactsId404 | void

    /**
 * @summary Update email contact fields
 */
export const usePatchMarketingEmailContactsId = <TError = PatchMarketingEmailContactsId400 | UnauthorizedErrorResponse | ForbiddenErrorResponse | PatchMarketingEmailContactsId404 | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchMarketingEmailContactsId>>, TError,{id: string;data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchMarketingEmailContactsId>>,
        TError,
        {id: string;data: JsonPatchOperation[]},
        TContext
      > => {

      const mutationOptions = getPatchMarketingEmailContactsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Schedules a full sync of all email lists and contacts to SendGrid.
This is an asynchronous operation - the endpoint returns immediately
and progress is reported via SSE events.

 * @summary Sync all lists and contacts to SendGrid
 */
export const postMarketingEmailSync = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostMarketingEmailSync200>(
      {url: `/api/v1/marketing/email/sync`, method: 'POST', signal
    },
      options);
    }
  


export const getPostMarketingEmailSyncMutationOptions = <TError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMarketingEmailSync>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postMarketingEmailSync>>, TError,void, TContext> => {

const mutationKey = ['postMarketingEmailSync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMarketingEmailSync>>, void> = () => {
          

          return  postMarketingEmailSync(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMarketingEmailSyncMutationResult = NonNullable<Awaited<ReturnType<typeof postMarketingEmailSync>>>
    
    export type PostMarketingEmailSyncMutationError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Sync all lists and contacts to SendGrid
 */
export const usePostMarketingEmailSync = <TError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMarketingEmailSync>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMarketingEmailSync>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostMarketingEmailSyncMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Get a list of marketing email sends with stats and filtering
 * @summary List marketing email sends
 */
export const getMarketingEmailSends = (
    params?: GetMarketingEmailSendsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetMarketingEmailSends200>(
      {url: `/api/v1/marketing/email/sends`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetMarketingEmailSendsQueryKey = (params?: GetMarketingEmailSendsParams,) => {
    return [
    `/api/v1/marketing/email/sends`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetMarketingEmailSendsQueryOptions = <TData = Awaited<ReturnType<typeof getMarketingEmailSends>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(params?: GetMarketingEmailSendsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailSends>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMarketingEmailSendsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingEmailSends>>> = ({ signal }) => getMarketingEmailSends(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailSends>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMarketingEmailSendsQueryResult = NonNullable<Awaited<ReturnType<typeof getMarketingEmailSends>>>
export type GetMarketingEmailSendsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetMarketingEmailSends<TData = Awaited<ReturnType<typeof getMarketingEmailSends>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 params: undefined |  GetMarketingEmailSendsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailSends>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingEmailSends>>,
          TError,
          Awaited<ReturnType<typeof getMarketingEmailSends>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingEmailSends<TData = Awaited<ReturnType<typeof getMarketingEmailSends>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 params?: GetMarketingEmailSendsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailSends>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingEmailSends>>,
          TError,
          Awaited<ReturnType<typeof getMarketingEmailSends>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingEmailSends<TData = Awaited<ReturnType<typeof getMarketingEmailSends>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 params?: GetMarketingEmailSendsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailSends>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List marketing email sends
 */

export function useGetMarketingEmailSends<TData = Awaited<ReturnType<typeof getMarketingEmailSends>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 params?: GetMarketingEmailSendsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailSends>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMarketingEmailSendsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get details of a specific marketing email send including stats
 * @summary Get marketing email send details
 */
export const getMarketingEmailSendsId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MarketingEmailSend>(
      {url: `/api/v1/marketing/email/sends/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetMarketingEmailSendsIdQueryKey = (id?: string,) => {
    return [
    `/api/v1/marketing/email/sends/${id}`
    ] as const;
    }

    
export const getGetMarketingEmailSendsIdQueryOptions = <TData = Awaited<ReturnType<typeof getMarketingEmailSendsId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailSendsId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMarketingEmailSendsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingEmailSendsId>>> = ({ signal }) => getMarketingEmailSendsId(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailSendsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMarketingEmailSendsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getMarketingEmailSendsId>>>
export type GetMarketingEmailSendsIdQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetMarketingEmailSendsId<TData = Awaited<ReturnType<typeof getMarketingEmailSendsId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailSendsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingEmailSendsId>>,
          TError,
          Awaited<ReturnType<typeof getMarketingEmailSendsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingEmailSendsId<TData = Awaited<ReturnType<typeof getMarketingEmailSendsId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailSendsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingEmailSendsId>>,
          TError,
          Awaited<ReturnType<typeof getMarketingEmailSendsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingEmailSendsId<TData = Awaited<ReturnType<typeof getMarketingEmailSendsId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailSendsId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get marketing email send details
 */

export function useGetMarketingEmailSendsId<TData = Awaited<ReturnType<typeof getMarketingEmailSendsId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailSendsId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMarketingEmailSendsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get all events for a specific marketing email send with filtering
 * @summary Get events for a marketing email send
 */
export const getMarketingEmailSendsIdEvents = (
    id: string,
    params?: GetMarketingEmailSendsIdEventsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetMarketingEmailSendsIdEvents200>(
      {url: `/api/v1/marketing/email/sends/${id}/events`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetMarketingEmailSendsIdEventsQueryKey = (id?: string,
    params?: GetMarketingEmailSendsIdEventsParams,) => {
    return [
    `/api/v1/marketing/email/sends/${id}/events`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetMarketingEmailSendsIdEventsQueryOptions = <TData = Awaited<ReturnType<typeof getMarketingEmailSendsIdEvents>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(id: string,
    params?: GetMarketingEmailSendsIdEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailSendsIdEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMarketingEmailSendsIdEventsQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingEmailSendsIdEvents>>> = ({ signal }) => getMarketingEmailSendsIdEvents(id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailSendsIdEvents>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMarketingEmailSendsIdEventsQueryResult = NonNullable<Awaited<ReturnType<typeof getMarketingEmailSendsIdEvents>>>
export type GetMarketingEmailSendsIdEventsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetMarketingEmailSendsIdEvents<TData = Awaited<ReturnType<typeof getMarketingEmailSendsIdEvents>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 id: string,
    params: undefined |  GetMarketingEmailSendsIdEventsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailSendsIdEvents>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingEmailSendsIdEvents>>,
          TError,
          Awaited<ReturnType<typeof getMarketingEmailSendsIdEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingEmailSendsIdEvents<TData = Awaited<ReturnType<typeof getMarketingEmailSendsIdEvents>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 id: string,
    params?: GetMarketingEmailSendsIdEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailSendsIdEvents>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingEmailSendsIdEvents>>,
          TError,
          Awaited<ReturnType<typeof getMarketingEmailSendsIdEvents>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingEmailSendsIdEvents<TData = Awaited<ReturnType<typeof getMarketingEmailSendsIdEvents>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 id: string,
    params?: GetMarketingEmailSendsIdEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailSendsIdEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get events for a marketing email send
 */

export function useGetMarketingEmailSendsIdEvents<TData = Awaited<ReturnType<typeof getMarketingEmailSendsIdEvents>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 id: string,
    params?: GetMarketingEmailSendsIdEventsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailSendsIdEvents>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMarketingEmailSendsIdEventsQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Retrieve all email lists (excluding the virtual "All Contacts" list)
 * @summary Get all email lists
 */
export const getMarketingEmailLists = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<EmailList[]>(
      {url: `/api/v1/marketing/email/lists`, method: 'GET', signal
    },
      options);
    }
  



export const getGetMarketingEmailListsQueryKey = () => {
    return [
    `/api/v1/marketing/email/lists`
    ] as const;
    }

    
export const getGetMarketingEmailListsQueryOptions = <TData = Awaited<ReturnType<typeof getMarketingEmailLists>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailLists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMarketingEmailListsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingEmailLists>>> = ({ signal }) => getMarketingEmailLists(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailLists>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMarketingEmailListsQueryResult = NonNullable<Awaited<ReturnType<typeof getMarketingEmailLists>>>
export type GetMarketingEmailListsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetMarketingEmailLists<TData = Awaited<ReturnType<typeof getMarketingEmailLists>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailLists>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingEmailLists>>,
          TError,
          Awaited<ReturnType<typeof getMarketingEmailLists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingEmailLists<TData = Awaited<ReturnType<typeof getMarketingEmailLists>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailLists>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingEmailLists>>,
          TError,
          Awaited<ReturnType<typeof getMarketingEmailLists>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingEmailLists<TData = Awaited<ReturnType<typeof getMarketingEmailLists>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailLists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get all email lists
 */

export function useGetMarketingEmailLists<TData = Awaited<ReturnType<typeof getMarketingEmailLists>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailLists>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMarketingEmailListsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create a new email list
 * @summary Create email list
 */
export const postMarketingEmailLists = (
    postMarketingEmailListsBody: PostMarketingEmailListsBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<EmailList>(
      {url: `/api/v1/marketing/email/lists`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postMarketingEmailListsBody, signal
    },
      options);
    }
  


export const getPostMarketingEmailListsMutationOptions = <TError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMarketingEmailLists>>, TError,{data: PostMarketingEmailListsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postMarketingEmailLists>>, TError,{data: PostMarketingEmailListsBody}, TContext> => {

const mutationKey = ['postMarketingEmailLists'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMarketingEmailLists>>, {data: PostMarketingEmailListsBody}> = (props) => {
          const {data} = props ?? {};

          return  postMarketingEmailLists(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMarketingEmailListsMutationResult = NonNullable<Awaited<ReturnType<typeof postMarketingEmailLists>>>
    export type PostMarketingEmailListsMutationBody = PostMarketingEmailListsBody
    export type PostMarketingEmailListsMutationError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Create email list
 */
export const usePostMarketingEmailLists = <TError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMarketingEmailLists>>, TError,{data: PostMarketingEmailListsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMarketingEmailLists>>,
        TError,
        {data: PostMarketingEmailListsBody},
        TContext
      > => {

      const mutationOptions = getPostMarketingEmailListsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Update an email list's name
 * @summary Update email list
 */
export const putMarketingEmailListsId = (
    id: string,
    putMarketingEmailListsIdBody: PutMarketingEmailListsIdBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<EmailList>(
      {url: `/api/v1/marketing/email/lists/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putMarketingEmailListsIdBody
    },
      options);
    }
  


export const getPutMarketingEmailListsIdMutationOptions = <TError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMarketingEmailListsId>>, TError,{id: string;data: PutMarketingEmailListsIdBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putMarketingEmailListsId>>, TError,{id: string;data: PutMarketingEmailListsIdBody}, TContext> => {

const mutationKey = ['putMarketingEmailListsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putMarketingEmailListsId>>, {id: string;data: PutMarketingEmailListsIdBody}> = (props) => {
          const {id,data} = props ?? {};

          return  putMarketingEmailListsId(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutMarketingEmailListsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putMarketingEmailListsId>>>
    export type PutMarketingEmailListsIdMutationBody = PutMarketingEmailListsIdBody
    export type PutMarketingEmailListsIdMutationError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Update email list
 */
export const usePutMarketingEmailListsId = <TError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMarketingEmailListsId>>, TError,{id: string;data: PutMarketingEmailListsIdBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putMarketingEmailListsId>>,
        TError,
        {id: string;data: PutMarketingEmailListsIdBody},
        TContext
      > => {

      const mutationOptions = getPutMarketingEmailListsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Delete an email list
 * @summary Delete email list
 */
export const deleteMarketingEmailListsId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/marketing/email/lists/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteMarketingEmailListsIdMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMarketingEmailListsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMarketingEmailListsId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteMarketingEmailListsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMarketingEmailListsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteMarketingEmailListsId(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteMarketingEmailListsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMarketingEmailListsId>>>
    
    export type DeleteMarketingEmailListsIdMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Delete email list
 */
export const useDeleteMarketingEmailListsId = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMarketingEmailListsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteMarketingEmailListsId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteMarketingEmailListsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Retrieve all email contacts in a specific list
 * @summary Get contacts in list
 */
export const getMarketingEmailListsIdContacts = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<EmailContact[]>(
      {url: `/api/v1/marketing/email/lists/${id}/contacts`, method: 'GET', signal
    },
      options);
    }
  



export const getGetMarketingEmailListsIdContactsQueryKey = (id?: string,) => {
    return [
    `/api/v1/marketing/email/lists/${id}/contacts`
    ] as const;
    }

    
export const getGetMarketingEmailListsIdContactsQueryOptions = <TData = Awaited<ReturnType<typeof getMarketingEmailListsIdContacts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailListsIdContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMarketingEmailListsIdContactsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMarketingEmailListsIdContacts>>> = ({ signal }) => getMarketingEmailListsIdContacts(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailListsIdContacts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMarketingEmailListsIdContactsQueryResult = NonNullable<Awaited<ReturnType<typeof getMarketingEmailListsIdContacts>>>
export type GetMarketingEmailListsIdContactsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetMarketingEmailListsIdContacts<TData = Awaited<ReturnType<typeof getMarketingEmailListsIdContacts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailListsIdContacts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingEmailListsIdContacts>>,
          TError,
          Awaited<ReturnType<typeof getMarketingEmailListsIdContacts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingEmailListsIdContacts<TData = Awaited<ReturnType<typeof getMarketingEmailListsIdContacts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailListsIdContacts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMarketingEmailListsIdContacts>>,
          TError,
          Awaited<ReturnType<typeof getMarketingEmailListsIdContacts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMarketingEmailListsIdContacts<TData = Awaited<ReturnType<typeof getMarketingEmailListsIdContacts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailListsIdContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get contacts in list
 */

export function useGetMarketingEmailListsIdContacts<TData = Awaited<ReturnType<typeof getMarketingEmailListsIdContacts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMarketingEmailListsIdContacts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMarketingEmailListsIdContactsQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Add contacts to a list. Contacts can be specified by:
- contact_ids: Array of specific contact IDs to add
- list_ids: Array of source list IDs - all contacts from these lists will be added
At least one of contact_ids or list_ids must be provided. Both can be provided to combine.

 * @summary Add contacts to list
 */
export const postMarketingEmailListsIdContacts = (
    id: string,
    postMarketingEmailListsIdContactsBody: PostMarketingEmailListsIdContactsBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostMarketingEmailListsIdContacts200>(
      {url: `/api/v1/marketing/email/lists/${id}/contacts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postMarketingEmailListsIdContactsBody, signal
    },
      options);
    }
  


export const getPostMarketingEmailListsIdContactsMutationOptions = <TError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMarketingEmailListsIdContacts>>, TError,{id: string;data: PostMarketingEmailListsIdContactsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postMarketingEmailListsIdContacts>>, TError,{id: string;data: PostMarketingEmailListsIdContactsBody}, TContext> => {

const mutationKey = ['postMarketingEmailListsIdContacts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMarketingEmailListsIdContacts>>, {id: string;data: PostMarketingEmailListsIdContactsBody}> = (props) => {
          const {id,data} = props ?? {};

          return  postMarketingEmailListsIdContacts(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMarketingEmailListsIdContactsMutationResult = NonNullable<Awaited<ReturnType<typeof postMarketingEmailListsIdContacts>>>
    export type PostMarketingEmailListsIdContactsMutationBody = PostMarketingEmailListsIdContactsBody
    export type PostMarketingEmailListsIdContactsMutationError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Add contacts to list
 */
export const usePostMarketingEmailListsIdContacts = <TError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMarketingEmailListsIdContacts>>, TError,{id: string;data: PostMarketingEmailListsIdContactsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMarketingEmailListsIdContacts>>,
        TError,
        {id: string;data: PostMarketingEmailListsIdContactsBody},
        TContext
      > => {

      const mutationOptions = getPostMarketingEmailListsIdContactsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Remove one or more email contacts from a list
 * @summary Remove contacts from list
 */
export const deleteMarketingEmailListsIdContacts = (
    id: string,
    deleteMarketingEmailListsIdContactsBody: DeleteMarketingEmailListsIdContactsBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<DeleteMarketingEmailListsIdContacts200>(
      {url: `/api/v1/marketing/email/lists/${id}/contacts`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: deleteMarketingEmailListsIdContactsBody
    },
      options);
    }
  


export const getDeleteMarketingEmailListsIdContactsMutationOptions = <TError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMarketingEmailListsIdContacts>>, TError,{id: string;data: DeleteMarketingEmailListsIdContactsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMarketingEmailListsIdContacts>>, TError,{id: string;data: DeleteMarketingEmailListsIdContactsBody}, TContext> => {

const mutationKey = ['deleteMarketingEmailListsIdContacts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMarketingEmailListsIdContacts>>, {id: string;data: DeleteMarketingEmailListsIdContactsBody}> = (props) => {
          const {id,data} = props ?? {};

          return  deleteMarketingEmailListsIdContacts(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteMarketingEmailListsIdContactsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMarketingEmailListsIdContacts>>>
    export type DeleteMarketingEmailListsIdContactsMutationBody = DeleteMarketingEmailListsIdContactsBody
    export type DeleteMarketingEmailListsIdContactsMutationError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Remove contacts from list
 */
export const useDeleteMarketingEmailListsIdContacts = <TError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMarketingEmailListsIdContacts>>, TError,{id: string;data: DeleteMarketingEmailListsIdContactsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteMarketingEmailListsIdContacts>>,
        TError,
        {id: string;data: DeleteMarketingEmailListsIdContactsBody},
        TContext
      > => {

      const mutationOptions = getDeleteMarketingEmailListsIdContactsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Synchronize the email list and its contacts to SendGrid. Creates or finds the list in SendGrid and syncs all contacts.
 * @summary Sync list to SendGrid
 */
export const postMarketingEmailListsIdSync = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostMarketingEmailListsIdSync200>(
      {url: `/api/v1/marketing/email/lists/${id}/sync`, method: 'POST', signal
    },
      options);
    }
  


export const getPostMarketingEmailListsIdSyncMutationOptions = <TError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMarketingEmailListsIdSync>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postMarketingEmailListsIdSync>>, TError,{id: string}, TContext> => {

const mutationKey = ['postMarketingEmailListsIdSync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMarketingEmailListsIdSync>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  postMarketingEmailListsIdSync(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMarketingEmailListsIdSyncMutationResult = NonNullable<Awaited<ReturnType<typeof postMarketingEmailListsIdSync>>>
    
    export type PostMarketingEmailListsIdSyncMutationError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Sync list to SendGrid
 */
export const usePostMarketingEmailListsIdSync = <TError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMarketingEmailListsIdSync>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMarketingEmailListsIdSync>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getPostMarketingEmailListsIdSyncMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Check API health status
 * @summary Health check
 */
export const getHealth = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetHealth200>(
      {url: `/api/v1/health`, method: 'GET', signal
    },
      options);
    }
  



export const getGetHealthQueryKey = () => {
    return [
    `/api/v1/health`
    ] as const;
    }

    
export const getGetHealthQueryOptions = <TData = Awaited<ReturnType<typeof getHealth>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHealthQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHealth>>> = ({ signal }) => getHealth(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHealthQueryResult = NonNullable<Awaited<ReturnType<typeof getHealth>>>
export type GetHealthQueryError = unknown


export function useGetHealth<TData = Awaited<ReturnType<typeof getHealth>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHealth>>,
          TError,
          Awaited<ReturnType<typeof getHealth>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHealth<TData = Awaited<ReturnType<typeof getHealth>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHealth>>,
          TError,
          Awaited<ReturnType<typeof getHealth>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHealth<TData = Awaited<ReturnType<typeof getHealth>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Health check
 */

export function useGetHealth<TData = Awaited<ReturnType<typeof getHealth>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHealthQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get the current semantic version of the API
 * @summary Get API version
 */
export const getVersion = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetVersion200>(
      {url: `/api/v1/version`, method: 'GET', signal
    },
      options);
    }
  



export const getGetVersionQueryKey = () => {
    return [
    `/api/v1/version`
    ] as const;
    }

    
export const getGetVersionQueryOptions = <TData = Awaited<ReturnType<typeof getVersion>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVersionQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVersion>>> = ({ signal }) => getVersion(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVersionQueryResult = NonNullable<Awaited<ReturnType<typeof getVersion>>>
export type GetVersionQueryError = unknown


export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVersion>>,
          TError,
          Awaited<ReturnType<typeof getVersion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVersion>>,
          TError,
          Awaited<ReturnType<typeof getVersion>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get API version
 */

export function useGetVersion<TData = Awaited<ReturnType<typeof getVersion>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVersion>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVersionQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get a key-value setting by key
 * @summary Get a setting value
 */
export const getSettingsKvKey = (
    key: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetSettingsKvKey200>(
      {url: `/api/v1/settings/kv/${key}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetSettingsKvKeyQueryKey = (key?: string,) => {
    return [
    `/api/v1/settings/kv/${key}`
    ] as const;
    }

    
export const getGetSettingsKvKeyQueryOptions = <TData = Awaited<ReturnType<typeof getSettingsKvKey>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsKvKey>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSettingsKvKeyQueryKey(key);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsKvKey>>> = ({ signal }) => getSettingsKvKey(key, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(key), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSettingsKvKey>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsKvKeyQueryResult = NonNullable<Awaited<ReturnType<typeof getSettingsKvKey>>>
export type GetSettingsKvKeyQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetSettingsKvKey<TData = Awaited<ReturnType<typeof getSettingsKvKey>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 key: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsKvKey>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsKvKey>>,
          TError,
          Awaited<ReturnType<typeof getSettingsKvKey>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsKvKey<TData = Awaited<ReturnType<typeof getSettingsKvKey>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsKvKey>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsKvKey>>,
          TError,
          Awaited<ReturnType<typeof getSettingsKvKey>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsKvKey<TData = Awaited<ReturnType<typeof getSettingsKvKey>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsKvKey>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a setting value
 */

export function useGetSettingsKvKey<TData = Awaited<ReturnType<typeof getSettingsKvKey>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsKvKey>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSettingsKvKeyQueryOptions(key,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Create or update a key-value setting
 * @summary Set a setting value
 */
export const putSettingsKvKey = (
    key: string,
    putSettingsKvKeyBody: PutSettingsKvKeyBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<PutSettingsKvKey200>(
      {url: `/api/v1/settings/kv/${key}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putSettingsKvKeyBody
    },
      options);
    }
  


export const getPutSettingsKvKeyMutationOptions = <TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSettingsKvKey>>, TError,{key: string;data: PutSettingsKvKeyBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putSettingsKvKey>>, TError,{key: string;data: PutSettingsKvKeyBody}, TContext> => {

const mutationKey = ['putSettingsKvKey'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putSettingsKvKey>>, {key: string;data: PutSettingsKvKeyBody}> = (props) => {
          const {key,data} = props ?? {};

          return  putSettingsKvKey(key,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutSettingsKvKeyMutationResult = NonNullable<Awaited<ReturnType<typeof putSettingsKvKey>>>
    export type PutSettingsKvKeyMutationBody = PutSettingsKvKeyBody
    export type PutSettingsKvKeyMutationError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Set a setting value
 */
export const usePutSettingsKvKey = <TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putSettingsKvKey>>, TError,{key: string;data: PutSettingsKvKeyBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putSettingsKvKey>>,
        TError,
        {key: string;data: PutSettingsKvKeyBody},
        TContext
      > => {

      const mutationOptions = getPutSettingsKvKeyMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Test a setting value (e.g., send a test Slack message)
 * @summary Test a setting
 */
export const postSettingsKvKeyTest = (
    key: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostSettingsKvKeyTest200>(
      {url: `/api/v1/settings/kv/${key}/test`, method: 'POST', signal
    },
      options);
    }
  


export const getPostSettingsKvKeyTestMutationOptions = <TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSettingsKvKeyTest>>, TError,{key: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postSettingsKvKeyTest>>, TError,{key: string}, TContext> => {

const mutationKey = ['postSettingsKvKeyTest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSettingsKvKeyTest>>, {key: string}> = (props) => {
          const {key} = props ?? {};

          return  postSettingsKvKeyTest(key,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostSettingsKvKeyTestMutationResult = NonNullable<Awaited<ReturnType<typeof postSettingsKvKeyTest>>>
    
    export type PostSettingsKvKeyTestMutationError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Test a setting
 */
export const usePostSettingsKvKeyTest = <TError = void | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSettingsKvKeyTest>>, TError,{key: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postSettingsKvKeyTest>>,
        TError,
        {key: string},
        TContext
      > => {

      const mutationOptions = getPostSettingsKvKeyTestMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * List all bank transactions with filtering and cursor pagination
 * @summary List bank transactions
 */
export const getBankTransactions = (
    params?: GetBankTransactionsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetBankTransactions200>(
      {url: `/api/v1/bank-transactions`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetBankTransactionsQueryKey = (params?: GetBankTransactionsParams,) => {
    return [
    `/api/v1/bank-transactions`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetBankTransactionsQueryOptions = <TData = Awaited<ReturnType<typeof getBankTransactions>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(params?: GetBankTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBankTransactionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBankTransactions>>> = ({ signal }) => getBankTransactions(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBankTransactions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBankTransactionsQueryResult = NonNullable<Awaited<ReturnType<typeof getBankTransactions>>>
export type GetBankTransactionsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetBankTransactions<TData = Awaited<ReturnType<typeof getBankTransactions>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: undefined |  GetBankTransactionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankTransactions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBankTransactions>>,
          TError,
          Awaited<ReturnType<typeof getBankTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBankTransactions<TData = Awaited<ReturnType<typeof getBankTransactions>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetBankTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankTransactions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBankTransactions>>,
          TError,
          Awaited<ReturnType<typeof getBankTransactions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBankTransactions<TData = Awaited<ReturnType<typeof getBankTransactions>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetBankTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List bank transactions
 */

export function useGetBankTransactions<TData = Awaited<ReturnType<typeof getBankTransactions>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetBankTransactionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankTransactions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBankTransactionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get full details for a single bank transaction
 * @summary Get bank transaction detail
 */
export const getBankTransactionsTransactionId = (
    transactionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<BankTransaction>(
      {url: `/api/v1/bank-transactions/${transactionId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetBankTransactionsTransactionIdQueryKey = (transactionId?: string,) => {
    return [
    `/api/v1/bank-transactions/${transactionId}`
    ] as const;
    }

    
export const getGetBankTransactionsTransactionIdQueryOptions = <TData = Awaited<ReturnType<typeof getBankTransactionsTransactionId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(transactionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankTransactionsTransactionId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBankTransactionsTransactionIdQueryKey(transactionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBankTransactionsTransactionId>>> = ({ signal }) => getBankTransactionsTransactionId(transactionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(transactionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBankTransactionsTransactionId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBankTransactionsTransactionIdQueryResult = NonNullable<Awaited<ReturnType<typeof getBankTransactionsTransactionId>>>
export type GetBankTransactionsTransactionIdQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse


export function useGetBankTransactionsTransactionId<TData = Awaited<ReturnType<typeof getBankTransactionsTransactionId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 transactionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankTransactionsTransactionId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBankTransactionsTransactionId>>,
          TError,
          Awaited<ReturnType<typeof getBankTransactionsTransactionId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBankTransactionsTransactionId<TData = Awaited<ReturnType<typeof getBankTransactionsTransactionId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 transactionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankTransactionsTransactionId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBankTransactionsTransactionId>>,
          TError,
          Awaited<ReturnType<typeof getBankTransactionsTransactionId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBankTransactionsTransactionId<TData = Awaited<ReturnType<typeof getBankTransactionsTransactionId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 transactionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankTransactionsTransactionId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get bank transaction detail
 */

export function useGetBankTransactionsTransactionId<TData = Awaited<ReturnType<typeof getBankTransactionsTransactionId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 transactionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankTransactionsTransactionId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBankTransactionsTransactionIdQueryOptions(transactionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Apply a JSON-PATCH (RFC 6902) to a bank transaction. Currently the
only mutable field is `/category`, with values `other` (admin
marked "not an invoice payment") or `null` (revert to pending).
The `invoice_payment` value is server-managed — it is set
automatically when a `bank_transaction_payment` row exists for
the transaction and cleared when the last one is removed; it
cannot be patched directly. Patching `/category` to a non-null
value is rejected if any BTPs currently exist for the transaction.

 * @summary Update bank transaction (JSON-PATCH)
 */
export const patchBankTransactionsTransactionId = (
    transactionId: string,
    jsonPatchOperation: JsonPatchOperation[],
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<BankTransaction>(
      {url: `/api/v1/bank-transactions/${transactionId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: jsonPatchOperation
    },
      options);
    }
  


export const getPatchBankTransactionsTransactionIdMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBankTransactionsTransactionId>>, TError,{transactionId: string;data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchBankTransactionsTransactionId>>, TError,{transactionId: string;data: JsonPatchOperation[]}, TContext> => {

const mutationKey = ['patchBankTransactionsTransactionId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchBankTransactionsTransactionId>>, {transactionId: string;data: JsonPatchOperation[]}> = (props) => {
          const {transactionId,data} = props ?? {};

          return  patchBankTransactionsTransactionId(transactionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchBankTransactionsTransactionIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchBankTransactionsTransactionId>>>
    export type PatchBankTransactionsTransactionIdMutationBody = JsonPatchOperation[]
    export type PatchBankTransactionsTransactionIdMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse | void

    /**
 * @summary Update bank transaction (JSON-PATCH)
 */
export const usePatchBankTransactionsTransactionId = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBankTransactionsTransactionId>>, TError,{transactionId: string;data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchBankTransactionsTransactionId>>,
        TError,
        {transactionId: string;data: JsonPatchOperation[]},
        TContext
      > => {

      const mutationOptions = getPatchBankTransactionsTransactionIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Map a bank transaction to invoice payment(s) and create a QuickBooks payment
 * @summary Create payment mapping for bank transaction
 */
export const postBankTransactionsTransactionIdPayment = (
    transactionId: string,
    createBankTransactionPaymentRequest: CreateBankTransactionPaymentRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<BankTransaction>(
      {url: `/api/v1/bank-transactions/${transactionId}/payment`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createBankTransactionPaymentRequest, signal
    },
      options);
    }
  


export const getPostBankTransactionsTransactionIdPaymentMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBankTransactionsTransactionIdPayment>>, TError,{transactionId: string;data: CreateBankTransactionPaymentRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postBankTransactionsTransactionIdPayment>>, TError,{transactionId: string;data: CreateBankTransactionPaymentRequest}, TContext> => {

const mutationKey = ['postBankTransactionsTransactionIdPayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBankTransactionsTransactionIdPayment>>, {transactionId: string;data: CreateBankTransactionPaymentRequest}> = (props) => {
          const {transactionId,data} = props ?? {};

          return  postBankTransactionsTransactionIdPayment(transactionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBankTransactionsTransactionIdPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof postBankTransactionsTransactionIdPayment>>>
    export type PostBankTransactionsTransactionIdPaymentMutationBody = CreateBankTransactionPaymentRequest
    export type PostBankTransactionsTransactionIdPaymentMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse | void

    /**
 * @summary Create payment mapping for bank transaction
 */
export const usePostBankTransactionsTransactionIdPayment = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBankTransactionsTransactionIdPayment>>, TError,{transactionId: string;data: CreateBankTransactionPaymentRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBankTransactionsTransactionIdPayment>>,
        TError,
        {transactionId: string;data: CreateBankTransactionPaymentRequest},
        TContext
      > => {

      const mutationOptions = getPostBankTransactionsTransactionIdPaymentMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns all remittance lines (both bank-decoded and admin-written
manual entries) for the transaction. Used by the Transaction Detail
Remittance panel.

 * @summary List remittance lines for a bank transaction
 */
export const getBankTransactionsTransactionIdRemittanceLines = (
    transactionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RemittanceLinesResponse>(
      {url: `/api/v1/bank-transactions/${transactionId}/remittance-lines`, method: 'GET', signal
    },
      options);
    }
  



export const getGetBankTransactionsTransactionIdRemittanceLinesQueryKey = (transactionId?: string,) => {
    return [
    `/api/v1/bank-transactions/${transactionId}/remittance-lines`
    ] as const;
    }

    
export const getGetBankTransactionsTransactionIdRemittanceLinesQueryOptions = <TData = Awaited<ReturnType<typeof getBankTransactionsTransactionIdRemittanceLines>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(transactionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankTransactionsTransactionIdRemittanceLines>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBankTransactionsTransactionIdRemittanceLinesQueryKey(transactionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBankTransactionsTransactionIdRemittanceLines>>> = ({ signal }) => getBankTransactionsTransactionIdRemittanceLines(transactionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(transactionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBankTransactionsTransactionIdRemittanceLines>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBankTransactionsTransactionIdRemittanceLinesQueryResult = NonNullable<Awaited<ReturnType<typeof getBankTransactionsTransactionIdRemittanceLines>>>
export type GetBankTransactionsTransactionIdRemittanceLinesQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse


export function useGetBankTransactionsTransactionIdRemittanceLines<TData = Awaited<ReturnType<typeof getBankTransactionsTransactionIdRemittanceLines>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 transactionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankTransactionsTransactionIdRemittanceLines>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBankTransactionsTransactionIdRemittanceLines>>,
          TError,
          Awaited<ReturnType<typeof getBankTransactionsTransactionIdRemittanceLines>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBankTransactionsTransactionIdRemittanceLines<TData = Awaited<ReturnType<typeof getBankTransactionsTransactionIdRemittanceLines>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 transactionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankTransactionsTransactionIdRemittanceLines>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBankTransactionsTransactionIdRemittanceLines>>,
          TError,
          Awaited<ReturnType<typeof getBankTransactionsTransactionIdRemittanceLines>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBankTransactionsTransactionIdRemittanceLines<TData = Awaited<ReturnType<typeof getBankTransactionsTransactionIdRemittanceLines>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 transactionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankTransactionsTransactionIdRemittanceLines>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List remittance lines for a bank transaction
 */

export function useGetBankTransactionsTransactionIdRemittanceLines<TData = Awaited<ReturnType<typeof getBankTransactionsTransactionIdRemittanceLines>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 transactionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankTransactionsTransactionIdRemittanceLines>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBankTransactionsTransactionIdRemittanceLinesQueryOptions(transactionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * JSON-PATCH (RFC 6902) edits to the manual subset only. Bank-source
lines (edi820_rmr, external_memo, note) are read-only via this API.
Admin overrides bank-source claims by adding manual lines (the
manual-trumps-bank rule silences the bank set entirely).

Supported ops:
- add: creates a new manual line (server assigns id, source='manual',
  created_by_user_id, timestamps).
- remove: removes a manual line by uuid path.
- replace: replaces a field on a manual line by uuid/field path.

Targeting a bank-source line returns 400.

 * @summary Edit manual remittance lines for a bank transaction
 */
export const patchBankTransactionsTransactionIdRemittanceLines = (
    transactionId: string,
    jsonPatchOperation: JsonPatchOperation[],
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<RemittanceLinesResponse>(
      {url: `/api/v1/bank-transactions/${transactionId}/remittance-lines`, method: 'PATCH',
      headers: {'Content-Type': 'application/json-patch+json', },
      data: jsonPatchOperation
    },
      options);
    }
  


export const getPatchBankTransactionsTransactionIdRemittanceLinesMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBankTransactionsTransactionIdRemittanceLines>>, TError,{transactionId: string;data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchBankTransactionsTransactionIdRemittanceLines>>, TError,{transactionId: string;data: JsonPatchOperation[]}, TContext> => {

const mutationKey = ['patchBankTransactionsTransactionIdRemittanceLines'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchBankTransactionsTransactionIdRemittanceLines>>, {transactionId: string;data: JsonPatchOperation[]}> = (props) => {
          const {transactionId,data} = props ?? {};

          return  patchBankTransactionsTransactionIdRemittanceLines(transactionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchBankTransactionsTransactionIdRemittanceLinesMutationResult = NonNullable<Awaited<ReturnType<typeof patchBankTransactionsTransactionIdRemittanceLines>>>
    export type PatchBankTransactionsTransactionIdRemittanceLinesMutationBody = JsonPatchOperation[]
    export type PatchBankTransactionsTransactionIdRemittanceLinesMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse

    /**
 * @summary Edit manual remittance lines for a bank transaction
 */
export const usePatchBankTransactionsTransactionIdRemittanceLines = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchBankTransactionsTransactionIdRemittanceLines>>, TError,{transactionId: string;data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchBankTransactionsTransactionIdRemittanceLines>>,
        TError,
        {transactionId: string;data: JsonPatchOperation[]},
        TContext
      > => {

      const mutationOptions = getPatchBankTransactionsTransactionIdRemittanceLinesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Creates a BTP row tying a bank transaction to a Payment. Used by the
Unlinked Payments review UI ("Link to Bank Transaction") and any
manual reconciliation flow. Composite uniqueness (transaction_id,
payment_src_id, payment_id) is enforced — duplicate links return 409.

 * @summary Manually link a bank transaction to a unified Payment
 */
export const postBankTransactionPayments = (
    postBankTransactionPaymentsBody: PostBankTransactionPaymentsBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<BankTransactionPaymentRecord>(
      {url: `/api/v1/bank-transaction-payments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postBankTransactionPaymentsBody, signal
    },
      options);
    }
  


export const getPostBankTransactionPaymentsMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | BankTransactionPaymentRecord,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBankTransactionPayments>>, TError,{data: PostBankTransactionPaymentsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postBankTransactionPayments>>, TError,{data: PostBankTransactionPaymentsBody}, TContext> => {

const mutationKey = ['postBankTransactionPayments'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBankTransactionPayments>>, {data: PostBankTransactionPaymentsBody}> = (props) => {
          const {data} = props ?? {};

          return  postBankTransactionPayments(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBankTransactionPaymentsMutationResult = NonNullable<Awaited<ReturnType<typeof postBankTransactionPayments>>>
    export type PostBankTransactionPaymentsMutationBody = PostBankTransactionPaymentsBody
    export type PostBankTransactionPaymentsMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | BankTransactionPaymentRecord

    /**
 * @summary Manually link a bank transaction to a unified Payment
 */
export const usePostBankTransactionPayments = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | BankTransactionPaymentRecord,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBankTransactionPayments>>, TError,{data: PostBankTransactionPaymentsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBankTransactionPayments>>,
        TError,
        {data: PostBankTransactionPaymentsBody},
        TContext
      > => {

      const mutationOptions = getPostBankTransactionPaymentsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Soft-deletes a BTP row, breaking the link between the bank
transaction and the unified Payment without touching either side.
Restricted to BTPs whose `matched_by` is `manual` — auto-linked
rows must be corrected by fixing the underlying remittance data
(memo at source or a manual remittance entry that overrides the
bad bank-decoded reference). Returns 409 for auto-linked rows.

 * @summary Unlink a manual bank-transaction ↔ payment link
 */
export const deleteBankTransactionPaymentsId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/bank-transaction-payments/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteBankTransactionPaymentsIdMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse | RequestErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBankTransactionPaymentsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteBankTransactionPaymentsId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteBankTransactionPaymentsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteBankTransactionPaymentsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteBankTransactionPaymentsId(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteBankTransactionPaymentsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteBankTransactionPaymentsId>>>
    
    export type DeleteBankTransactionPaymentsIdMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse | RequestErrorResponse

    /**
 * @summary Unlink a manual bank-transaction ↔ payment link
 */
export const useDeleteBankTransactionPaymentsId = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse | RequestErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteBankTransactionPaymentsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteBankTransactionPaymentsId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteBankTransactionPaymentsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Two-step user-facing action: (1) refetch the Payment from upstream
(QuickBooks today) and re-run the per-row QB → unified projection
so changes the operator just made (method set, customer linked,
memo edited) land in the local DB; (2) run the auto-linker so any
BankTransaction whose candidate blockers just cleared gets a real
BTP row written. Backs the per-row "Revalidate" button in the
Match Issues column.

 * @summary Sync a single Payment from upstream
 */
export const postInvoicePaymentsPaymentIdSync = (
    paymentId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RecordSyncResult>(
      {url: `/api/v1/invoice-payments/${paymentId}/sync`, method: 'POST', signal
    },
      options);
    }
  


export const getPostInvoicePaymentsPaymentIdSyncMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInvoicePaymentsPaymentIdSync>>, TError,{paymentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postInvoicePaymentsPaymentIdSync>>, TError,{paymentId: string}, TContext> => {

const mutationKey = ['postInvoicePaymentsPaymentIdSync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postInvoicePaymentsPaymentIdSync>>, {paymentId: string}> = (props) => {
          const {paymentId} = props ?? {};

          return  postInvoicePaymentsPaymentIdSync(paymentId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostInvoicePaymentsPaymentIdSyncMutationResult = NonNullable<Awaited<ReturnType<typeof postInvoicePaymentsPaymentIdSync>>>
    
    export type PostInvoicePaymentsPaymentIdSyncMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Sync a single Payment from upstream
 */
export const usePostInvoicePaymentsPaymentIdSync = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postInvoicePaymentsPaymentIdSync>>, TError,{paymentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postInvoicePaymentsPaymentIdSync>>,
        TError,
        {paymentId: string},
        TContext
      > => {

      const mutationOptions = getPostInvoicePaymentsPaymentIdSyncMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns the candidate bank transactions the auto-linker would surface
for this Payment, ranked by match strength (strong → weak). Used by
the payment-detail modal to pre-populate a "Candidates only" view
before the user decides which BT(s) to link.

 * @summary Candidate bank transactions for linking to a Payment
 */
export const getInvoicePaymentsPaymentIdBankTransactionCandidates = (
    paymentId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetInvoicePaymentsPaymentIdBankTransactionCandidates200>(
      {url: `/api/v1/invoice-payments/${paymentId}/bank-transaction-candidates`, method: 'GET', signal
    },
      options);
    }
  



export const getGetInvoicePaymentsPaymentIdBankTransactionCandidatesQueryKey = (paymentId?: string,) => {
    return [
    `/api/v1/invoice-payments/${paymentId}/bank-transaction-candidates`
    ] as const;
    }

    
export const getGetInvoicePaymentsPaymentIdBankTransactionCandidatesQueryOptions = <TData = Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdBankTransactionCandidates>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(paymentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdBankTransactionCandidates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoicePaymentsPaymentIdBankTransactionCandidatesQueryKey(paymentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdBankTransactionCandidates>>> = ({ signal }) => getInvoicePaymentsPaymentIdBankTransactionCandidates(paymentId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(paymentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdBankTransactionCandidates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvoicePaymentsPaymentIdBankTransactionCandidatesQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdBankTransactionCandidates>>>
export type GetInvoicePaymentsPaymentIdBankTransactionCandidatesQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetInvoicePaymentsPaymentIdBankTransactionCandidates<TData = Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdBankTransactionCandidates>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 paymentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdBankTransactionCandidates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdBankTransactionCandidates>>,
          TError,
          Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdBankTransactionCandidates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoicePaymentsPaymentIdBankTransactionCandidates<TData = Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdBankTransactionCandidates>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 paymentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdBankTransactionCandidates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdBankTransactionCandidates>>,
          TError,
          Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdBankTransactionCandidates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoicePaymentsPaymentIdBankTransactionCandidates<TData = Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdBankTransactionCandidates>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 paymentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdBankTransactionCandidates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Candidate bank transactions for linking to a Payment
 */

export function useGetInvoicePaymentsPaymentIdBankTransactionCandidates<TData = Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdBankTransactionCandidates>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 paymentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdBankTransactionCandidates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvoicePaymentsPaymentIdBankTransactionCandidatesQueryOptions(paymentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get all attachments for a payment (synced from QuickBooks)
 * @summary List payment attachments
 */
export const getInvoicePaymentsPaymentIdAttachments = (
    paymentId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetInvoicePaymentsPaymentIdAttachments200>(
      {url: `/api/v1/invoice-payments/${paymentId}/attachments`, method: 'GET', signal
    },
      options);
    }
  



export const getGetInvoicePaymentsPaymentIdAttachmentsQueryKey = (paymentId?: string,) => {
    return [
    `/api/v1/invoice-payments/${paymentId}/attachments`
    ] as const;
    }

    
export const getGetInvoicePaymentsPaymentIdAttachmentsQueryOptions = <TData = Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdAttachments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(paymentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdAttachments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoicePaymentsPaymentIdAttachmentsQueryKey(paymentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdAttachments>>> = ({ signal }) => getInvoicePaymentsPaymentIdAttachments(paymentId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(paymentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdAttachments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvoicePaymentsPaymentIdAttachmentsQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdAttachments>>>
export type GetInvoicePaymentsPaymentIdAttachmentsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetInvoicePaymentsPaymentIdAttachments<TData = Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdAttachments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 paymentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdAttachments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdAttachments>>,
          TError,
          Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdAttachments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoicePaymentsPaymentIdAttachments<TData = Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdAttachments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 paymentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdAttachments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdAttachments>>,
          TError,
          Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdAttachments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoicePaymentsPaymentIdAttachments<TData = Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdAttachments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 paymentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdAttachments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List payment attachments
 */

export function useGetInvoicePaymentsPaymentIdAttachments<TData = Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdAttachments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 paymentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdAttachments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvoicePaymentsPaymentIdAttachmentsQueryOptions(paymentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Download a payment attachment file
 * @summary Download payment attachment
 */
export const getInvoicePaymentsPaymentIdAttachmentsAttachmentId = (
    paymentId: string,
    attachmentId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Blob>(
      {url: `/api/v1/invoice-payments/${paymentId}/attachments/${attachmentId}`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }
  



export const getGetInvoicePaymentsPaymentIdAttachmentsAttachmentIdQueryKey = (paymentId?: string,
    attachmentId?: string,) => {
    return [
    `/api/v1/invoice-payments/${paymentId}/attachments/${attachmentId}`
    ] as const;
    }

    
export const getGetInvoicePaymentsPaymentIdAttachmentsAttachmentIdQueryOptions = <TData = Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdAttachmentsAttachmentId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(paymentId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdAttachmentsAttachmentId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInvoicePaymentsPaymentIdAttachmentsAttachmentIdQueryKey(paymentId,attachmentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdAttachmentsAttachmentId>>> = ({ signal }) => getInvoicePaymentsPaymentIdAttachmentsAttachmentId(paymentId,attachmentId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(paymentId && attachmentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdAttachmentsAttachmentId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetInvoicePaymentsPaymentIdAttachmentsAttachmentIdQueryResult = NonNullable<Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdAttachmentsAttachmentId>>>
export type GetInvoicePaymentsPaymentIdAttachmentsAttachmentIdQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse


export function useGetInvoicePaymentsPaymentIdAttachmentsAttachmentId<TData = Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdAttachmentsAttachmentId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 paymentId: string,
    attachmentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdAttachmentsAttachmentId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdAttachmentsAttachmentId>>,
          TError,
          Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdAttachmentsAttachmentId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoicePaymentsPaymentIdAttachmentsAttachmentId<TData = Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdAttachmentsAttachmentId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 paymentId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdAttachmentsAttachmentId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdAttachmentsAttachmentId>>,
          TError,
          Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdAttachmentsAttachmentId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetInvoicePaymentsPaymentIdAttachmentsAttachmentId<TData = Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdAttachmentsAttachmentId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 paymentId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdAttachmentsAttachmentId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download payment attachment
 */

export function useGetInvoicePaymentsPaymentIdAttachmentsAttachmentId<TData = Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdAttachmentsAttachmentId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 paymentId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getInvoicePaymentsPaymentIdAttachmentsAttachmentId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetInvoicePaymentsPaymentIdAttachmentsAttachmentIdQueryOptions(paymentId,attachmentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Two-step user-facing action: (1) refetch the BankTransaction from
its upstream source (Mercury for live accounts; file-source FBAIs
return a "re-upload to refresh" message), running the per-row sync
pipeline scoped to just that transaction; (2) run the auto-linker
so any candidate Payment whose blockers just cleared gets a real
BTP row written. Backs the per-row "Revalidate" button in the
Match Issues column and the "Resync" button on the BT detail modal.

 * @summary Sync a single bank transaction from upstream
 */
export const postBankTransactionsTransactionIdSync = (
    transactionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<RecordSyncResult>(
      {url: `/api/v1/bank-transactions/${transactionId}/sync`, method: 'POST', signal
    },
      options);
    }
  


export const getPostBankTransactionsTransactionIdSyncMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBankTransactionsTransactionIdSync>>, TError,{transactionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postBankTransactionsTransactionIdSync>>, TError,{transactionId: string}, TContext> => {

const mutationKey = ['postBankTransactionsTransactionIdSync'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postBankTransactionsTransactionIdSync>>, {transactionId: string}> = (props) => {
          const {transactionId} = props ?? {};

          return  postBankTransactionsTransactionIdSync(transactionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostBankTransactionsTransactionIdSyncMutationResult = NonNullable<Awaited<ReturnType<typeof postBankTransactionsTransactionIdSync>>>
    
    export type PostBankTransactionsTransactionIdSyncMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Sync a single bank transaction from upstream
 */
export const usePostBankTransactionsTransactionIdSync = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postBankTransactionsTransactionIdSync>>, TError,{transactionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postBankTransactionsTransactionIdSync>>,
        TError,
        {transactionId: string},
        TContext
      > => {

      const mutationOptions = getPostBankTransactionsTransactionIdSyncMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns the candidate Payments the auto-linker would surface for
this bank transaction, ranked by match strength (strong → weak).
Used by the transaction-detail modal's Link-Existing flow to
pre-populate a "Candidates only" view before the user picks
which Payment(s) to link.

 * @summary Candidate Payments for linking to a bank transaction
 */
export const getBankTransactionsTransactionIdPaymentCandidates = (
    transactionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetBankTransactionsTransactionIdPaymentCandidates200>(
      {url: `/api/v1/bank-transactions/${transactionId}/payment-candidates`, method: 'GET', signal
    },
      options);
    }
  



export const getGetBankTransactionsTransactionIdPaymentCandidatesQueryKey = (transactionId?: string,) => {
    return [
    `/api/v1/bank-transactions/${transactionId}/payment-candidates`
    ] as const;
    }

    
export const getGetBankTransactionsTransactionIdPaymentCandidatesQueryOptions = <TData = Awaited<ReturnType<typeof getBankTransactionsTransactionIdPaymentCandidates>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(transactionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankTransactionsTransactionIdPaymentCandidates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBankTransactionsTransactionIdPaymentCandidatesQueryKey(transactionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBankTransactionsTransactionIdPaymentCandidates>>> = ({ signal }) => getBankTransactionsTransactionIdPaymentCandidates(transactionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(transactionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBankTransactionsTransactionIdPaymentCandidates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBankTransactionsTransactionIdPaymentCandidatesQueryResult = NonNullable<Awaited<ReturnType<typeof getBankTransactionsTransactionIdPaymentCandidates>>>
export type GetBankTransactionsTransactionIdPaymentCandidatesQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetBankTransactionsTransactionIdPaymentCandidates<TData = Awaited<ReturnType<typeof getBankTransactionsTransactionIdPaymentCandidates>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 transactionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankTransactionsTransactionIdPaymentCandidates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBankTransactionsTransactionIdPaymentCandidates>>,
          TError,
          Awaited<ReturnType<typeof getBankTransactionsTransactionIdPaymentCandidates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBankTransactionsTransactionIdPaymentCandidates<TData = Awaited<ReturnType<typeof getBankTransactionsTransactionIdPaymentCandidates>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 transactionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankTransactionsTransactionIdPaymentCandidates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBankTransactionsTransactionIdPaymentCandidates>>,
          TError,
          Awaited<ReturnType<typeof getBankTransactionsTransactionIdPaymentCandidates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBankTransactionsTransactionIdPaymentCandidates<TData = Awaited<ReturnType<typeof getBankTransactionsTransactionIdPaymentCandidates>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 transactionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankTransactionsTransactionIdPaymentCandidates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Candidate Payments for linking to a bank transaction
 */

export function useGetBankTransactionsTransactionIdPaymentCandidates<TData = Awaited<ReturnType<typeof getBankTransactionsTransactionIdPaymentCandidates>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 transactionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankTransactionsTransactionIdPaymentCandidates>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBankTransactionsTransactionIdPaymentCandidatesQueryOptions(transactionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get all attachments for a bank transaction
 * @summary List bank transaction attachments
 */
export const getBankTransactionsTransactionIdAttachments = (
    transactionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetBankTransactionsTransactionIdAttachments200>(
      {url: `/api/v1/bank-transactions/${transactionId}/attachments`, method: 'GET', signal
    },
      options);
    }
  



export const getGetBankTransactionsTransactionIdAttachmentsQueryKey = (transactionId?: string,) => {
    return [
    `/api/v1/bank-transactions/${transactionId}/attachments`
    ] as const;
    }

    
export const getGetBankTransactionsTransactionIdAttachmentsQueryOptions = <TData = Awaited<ReturnType<typeof getBankTransactionsTransactionIdAttachments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(transactionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankTransactionsTransactionIdAttachments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBankTransactionsTransactionIdAttachmentsQueryKey(transactionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBankTransactionsTransactionIdAttachments>>> = ({ signal }) => getBankTransactionsTransactionIdAttachments(transactionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(transactionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBankTransactionsTransactionIdAttachments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBankTransactionsTransactionIdAttachmentsQueryResult = NonNullable<Awaited<ReturnType<typeof getBankTransactionsTransactionIdAttachments>>>
export type GetBankTransactionsTransactionIdAttachmentsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse


export function useGetBankTransactionsTransactionIdAttachments<TData = Awaited<ReturnType<typeof getBankTransactionsTransactionIdAttachments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 transactionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankTransactionsTransactionIdAttachments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBankTransactionsTransactionIdAttachments>>,
          TError,
          Awaited<ReturnType<typeof getBankTransactionsTransactionIdAttachments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBankTransactionsTransactionIdAttachments<TData = Awaited<ReturnType<typeof getBankTransactionsTransactionIdAttachments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 transactionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankTransactionsTransactionIdAttachments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBankTransactionsTransactionIdAttachments>>,
          TError,
          Awaited<ReturnType<typeof getBankTransactionsTransactionIdAttachments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBankTransactionsTransactionIdAttachments<TData = Awaited<ReturnType<typeof getBankTransactionsTransactionIdAttachments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 transactionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankTransactionsTransactionIdAttachments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List bank transaction attachments
 */

export function useGetBankTransactionsTransactionIdAttachments<TData = Awaited<ReturnType<typeof getBankTransactionsTransactionIdAttachments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 transactionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankTransactionsTransactionIdAttachments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBankTransactionsTransactionIdAttachmentsQueryOptions(transactionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Download a bank transaction attachment file
 * @summary Download bank transaction attachment
 */
export const getBankTransactionsTransactionIdAttachmentsAttachmentId = (
    transactionId: string,
    attachmentId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Blob>(
      {url: `/api/v1/bank-transactions/${transactionId}/attachments/${attachmentId}`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }
  



export const getGetBankTransactionsTransactionIdAttachmentsAttachmentIdQueryKey = (transactionId?: string,
    attachmentId?: string,) => {
    return [
    `/api/v1/bank-transactions/${transactionId}/attachments/${attachmentId}`
    ] as const;
    }

    
export const getGetBankTransactionsTransactionIdAttachmentsAttachmentIdQueryOptions = <TData = Awaited<ReturnType<typeof getBankTransactionsTransactionIdAttachmentsAttachmentId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(transactionId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankTransactionsTransactionIdAttachmentsAttachmentId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBankTransactionsTransactionIdAttachmentsAttachmentIdQueryKey(transactionId,attachmentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getBankTransactionsTransactionIdAttachmentsAttachmentId>>> = ({ signal }) => getBankTransactionsTransactionIdAttachmentsAttachmentId(transactionId,attachmentId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(transactionId && attachmentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getBankTransactionsTransactionIdAttachmentsAttachmentId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBankTransactionsTransactionIdAttachmentsAttachmentIdQueryResult = NonNullable<Awaited<ReturnType<typeof getBankTransactionsTransactionIdAttachmentsAttachmentId>>>
export type GetBankTransactionsTransactionIdAttachmentsAttachmentIdQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse


export function useGetBankTransactionsTransactionIdAttachmentsAttachmentId<TData = Awaited<ReturnType<typeof getBankTransactionsTransactionIdAttachmentsAttachmentId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 transactionId: string,
    attachmentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankTransactionsTransactionIdAttachmentsAttachmentId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBankTransactionsTransactionIdAttachmentsAttachmentId>>,
          TError,
          Awaited<ReturnType<typeof getBankTransactionsTransactionIdAttachmentsAttachmentId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBankTransactionsTransactionIdAttachmentsAttachmentId<TData = Awaited<ReturnType<typeof getBankTransactionsTransactionIdAttachmentsAttachmentId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 transactionId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankTransactionsTransactionIdAttachmentsAttachmentId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBankTransactionsTransactionIdAttachmentsAttachmentId>>,
          TError,
          Awaited<ReturnType<typeof getBankTransactionsTransactionIdAttachmentsAttachmentId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBankTransactionsTransactionIdAttachmentsAttachmentId<TData = Awaited<ReturnType<typeof getBankTransactionsTransactionIdAttachmentsAttachmentId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 transactionId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankTransactionsTransactionIdAttachmentsAttachmentId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download bank transaction attachment
 */

export function useGetBankTransactionsTransactionIdAttachmentsAttachmentId<TData = Awaited<ReturnType<typeof getBankTransactionsTransactionIdAttachmentsAttachmentId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | NotFoundErrorResponse>(
 transactionId: string,
    attachmentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getBankTransactionsTransactionIdAttachmentsAttachmentId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetBankTransactionsTransactionIdAttachmentsAttachmentIdQueryOptions(transactionId,attachmentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * List sync history with optional filters
 * @summary List sync runs
 */
export const getSyncHistory = (
    params?: GetSyncHistoryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetSyncHistory200>(
      {url: `/api/v1/sync-history`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetSyncHistoryQueryKey = (params?: GetSyncHistoryParams,) => {
    return [
    `/api/v1/sync-history`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetSyncHistoryQueryOptions = <TData = Awaited<ReturnType<typeof getSyncHistory>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(params?: GetSyncHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSyncHistoryQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSyncHistory>>> = ({ signal }) => getSyncHistory(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSyncHistory>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSyncHistoryQueryResult = NonNullable<Awaited<ReturnType<typeof getSyncHistory>>>
export type GetSyncHistoryQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetSyncHistory<TData = Awaited<ReturnType<typeof getSyncHistory>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: undefined |  GetSyncHistoryParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncHistory>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSyncHistory>>,
          TError,
          Awaited<ReturnType<typeof getSyncHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSyncHistory<TData = Awaited<ReturnType<typeof getSyncHistory>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetSyncHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncHistory>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSyncHistory>>,
          TError,
          Awaited<ReturnType<typeof getSyncHistory>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSyncHistory<TData = Awaited<ReturnType<typeof getSyncHistory>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetSyncHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List sync runs
 */

export function useGetSyncHistory<TData = Awaited<ReturnType<typeof getSyncHistory>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetSyncHistoryParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncHistory>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSyncHistoryQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Get a sync run with its individual item changes
 * @summary Get sync run details
 */
export const getSyncHistorySyncRunId = (
    syncRunId: string,
    params?: GetSyncHistorySyncRunIdParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetSyncHistorySyncRunId200>(
      {url: `/api/v1/sync-history/${syncRunId}`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetSyncHistorySyncRunIdQueryKey = (syncRunId?: string,
    params?: GetSyncHistorySyncRunIdParams,) => {
    return [
    `/api/v1/sync-history/${syncRunId}`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetSyncHistorySyncRunIdQueryOptions = <TData = Awaited<ReturnType<typeof getSyncHistorySyncRunId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(syncRunId: string,
    params?: GetSyncHistorySyncRunIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncHistorySyncRunId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSyncHistorySyncRunIdQueryKey(syncRunId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSyncHistorySyncRunId>>> = ({ signal }) => getSyncHistorySyncRunId(syncRunId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(syncRunId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSyncHistorySyncRunId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSyncHistorySyncRunIdQueryResult = NonNullable<Awaited<ReturnType<typeof getSyncHistorySyncRunId>>>
export type GetSyncHistorySyncRunIdQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetSyncHistorySyncRunId<TData = Awaited<ReturnType<typeof getSyncHistorySyncRunId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 syncRunId: string,
    params: undefined |  GetSyncHistorySyncRunIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncHistorySyncRunId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSyncHistorySyncRunId>>,
          TError,
          Awaited<ReturnType<typeof getSyncHistorySyncRunId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSyncHistorySyncRunId<TData = Awaited<ReturnType<typeof getSyncHistorySyncRunId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 syncRunId: string,
    params?: GetSyncHistorySyncRunIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncHistorySyncRunId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSyncHistorySyncRunId>>,
          TError,
          Awaited<ReturnType<typeof getSyncHistorySyncRunId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSyncHistorySyncRunId<TData = Awaited<ReturnType<typeof getSyncHistorySyncRunId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 syncRunId: string,
    params?: GetSyncHistorySyncRunIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncHistorySyncRunId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get sync run details
 */

export function useGetSyncHistorySyncRunId<TData = Awaited<ReturnType<typeof getSyncHistorySyncRunId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 syncRunId: string,
    params?: GetSyncHistorySyncRunIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSyncHistorySyncRunId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSyncHistorySyncRunIdQueryOptions(syncRunId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Delete a sync run and all its associated items
 * @summary Delete a sync run
 */
export const deleteSyncHistorySyncRunId = (
    syncRunId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/sync-history/${syncRunId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteSyncHistorySyncRunIdMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSyncHistorySyncRunId>>, TError,{syncRunId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteSyncHistorySyncRunId>>, TError,{syncRunId: string}, TContext> => {

const mutationKey = ['deleteSyncHistorySyncRunId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteSyncHistorySyncRunId>>, {syncRunId: string}> = (props) => {
          const {syncRunId} = props ?? {};

          return  deleteSyncHistorySyncRunId(syncRunId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteSyncHistorySyncRunIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteSyncHistorySyncRunId>>>
    
    export type DeleteSyncHistorySyncRunIdMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Delete a sync run
 */
export const useDeleteSyncHistorySyncRunId = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteSyncHistorySyncRunId>>, TError,{syncRunId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteSyncHistorySyncRunId>>,
        TError,
        {syncRunId: string},
        TContext
      > => {

      const mutationOptions = getDeleteSyncHistorySyncRunIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Entry point for the per-recruiter AppScript forwarder. The forwarder is
STATELESS — the dashboard owns the watermark and backfill cursor and
hands back everything needed for one scan cycle. Read this whole
description plus `POST /emails`; together they are the complete protocol.

AUTH (both endpoints): a Google OpenID Connect identity token —
`Authorization: Bearer <ScriptApp.getIdentityToken()>`. The server
verifies the signature against Google's JWKS and checks `iss`, `exp`,
`email_verified`, and pins `aud` to the configured Apps Script GCP
OAuth client id — so only tokens minted by THIS forwarder project are
accepted, not any Google ID token bearing a recruiter's email. That
client id is provisioned at setup via the admin config UI/API (not a
static secret). The recruiter is resolved from the `email` claim and
must map to an active user with the events_manager or admin role. No
shared secret, no API key.

ONE SCAN CYCLE:
  1. GET /emails/scan-next → { scan_key, scan_window, known_message_ids,
     label_message_ids }.
  2. Render scan_window into your provider's native search (Gmail:
     `has:attachment after:<after_epoch> before:<before_epoch>`) and run
     it. CRUCIAL: search returns whole threads, so also window in memory
     — keep only messages with after_epoch <= send-time < before_epoch;
     skip out-of-window thread siblings entirely (not forwarded, not
     counted in scan_result), or they fake a "caught up".
  3. For each in-window message whose id is NOT in known_message_ids,
     collect it (see EmailIngestMessage — send the raw From header and
     the Date header; do NOT unwrap senders or dedup, the server does
     that). Skip ids that ARE in known_message_ids — already recorded;
     never resend them.
  4. Apply your "job application" label to each id in label_message_ids
     (idempotent), and remember them to ack in step 5.
  5. POST /emails with { scan_key, emails:[...collected...],
     scan_result:{...}, labeled_message_ids:[...from step 4...] } to
     ingest the batch, ack the labels, AND close the cycle. The body
     MUST echo this scan_key.
  6. On the 200 response, if has_more is true, loop to step 1 (more
     history remains) — only while the run has execution-time budget
     left. If false, the mailbox is caught up; stop and wait for the
     next scheduled trigger.

scan_key is STABLE: repeated GETs return the same scan_key, query, and
known_message_ids until a matching POST /emails closes the cycle. So a
crashed/retried run simply GETs again and gets the same instructions.
After a successful POST, the NEXT GET mints a fresh scan_key reflecting
the advanced state.

ERROR HANDLING: if POST /emails returns 409 (scan_key mismatch — e.g.
this run is stale because another already closed the cycle), discard the
batch, GET /emails/scan-next again for the current key, and continue.

 * @summary Get the next Gmail scan instructions for the calling recruiter
 */
export const getEmailsScanNext = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<EmailScanInstructions>(
      {url: `/api/v1/emails/scan-next`, method: 'GET', signal
    },
      options);
    }
  



export const getGetEmailsScanNextQueryKey = () => {
    return [
    `/api/v1/emails/scan-next`
    ] as const;
    }

    
export const getGetEmailsScanNextQueryOptions = <TData = Awaited<ReturnType<typeof getEmailsScanNext>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailsScanNext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmailsScanNextQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmailsScanNext>>> = ({ signal }) => getEmailsScanNext(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmailsScanNext>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmailsScanNextQueryResult = NonNullable<Awaited<ReturnType<typeof getEmailsScanNext>>>
export type GetEmailsScanNextQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetEmailsScanNext<TData = Awaited<ReturnType<typeof getEmailsScanNext>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailsScanNext>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmailsScanNext>>,
          TError,
          Awaited<ReturnType<typeof getEmailsScanNext>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmailsScanNext<TData = Awaited<ReturnType<typeof getEmailsScanNext>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailsScanNext>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmailsScanNext>>,
          TError,
          Awaited<ReturnType<typeof getEmailsScanNext>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmailsScanNext<TData = Awaited<ReturnType<typeof getEmailsScanNext>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailsScanNext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the next Gmail scan instructions for the calling recruiter
 */

export function useGetEmailsScanNext<TData = Awaited<ReturnType<typeof getEmailsScanNext>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmailsScanNext>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmailsScanNextQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Per-recruiter visibility into forwarded-email processing. An
events_manager sees only their own rows (recruiter_user_id is forced to
the caller); an admin sees all and may filter by recruiter_user_id.
Cursor-paginated; all filters/sorts/counts server-side.

 * @summary List recruiter email processing log
 */
export const getEmails = (
    params?: GetEmailsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetEmails200>(
      {url: `/api/v1/emails`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetEmailsQueryKey = (params?: GetEmailsParams,) => {
    return [
    `/api/v1/emails`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetEmailsQueryOptions = <TData = Awaited<ReturnType<typeof getEmails>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(params?: GetEmailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetEmailsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getEmails>>> = ({ signal }) => getEmails(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getEmails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetEmailsQueryResult = NonNullable<Awaited<ReturnType<typeof getEmails>>>
export type GetEmailsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetEmails<TData = Awaited<ReturnType<typeof getEmails>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: undefined |  GetEmailsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmails>>,
          TError,
          Awaited<ReturnType<typeof getEmails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmails<TData = Awaited<ReturnType<typeof getEmails>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetEmailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEmails>>,
          TError,
          Awaited<ReturnType<typeof getEmails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetEmails<TData = Awaited<ReturnType<typeof getEmails>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetEmailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List recruiter email processing log
 */

export function useGetEmails<TData = Awaited<ReturnType<typeof getEmails>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetEmailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getEmails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetEmailsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Called by the forwarder to (1) ingest the new messages it found and
(2) close the scan cycle so the dashboard advances scan state. Same OIDC
auth as `/emails/scan-next`.

The body MUST carry the `scan_key` from the matching `scan-next`. The
server rejects a mismatched key with 409 (a stale retry, a second batch,
or a crashed-and-restarted run) — no ingest, no state advancement.

Email ingest is idempotent per `(recruiter, message_id)`: a message
already recorded returns `status: duplicate`; a new one returns
`status: stored`, is staged to disk, and is classified asynchronously
(resume/cover dedup and verdict land later, visible in the email log —
NOT in this response). On the matching key, the server applies
`scan_result` to advance the watermark/cursor exactly once and retires
the key (the next `scan-next` mints a fresh one).

 * @summary Forward a batch of applicant emails and close the scan cycle
 */
export const postEmails = (
    emailIngestRequest: EmailIngestRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<EmailIngestResult>(
      {url: `/api/v1/emails`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: emailIngestRequest, signal
    },
      options);
    }
  


export const getPostEmailsMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmails>>, TError,{data: EmailIngestRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postEmails>>, TError,{data: EmailIngestRequest}, TContext> => {

const mutationKey = ['postEmails'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEmails>>, {data: EmailIngestRequest}> = (props) => {
          const {data} = props ?? {};

          return  postEmails(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEmailsMutationResult = NonNullable<Awaited<ReturnType<typeof postEmails>>>
    export type PostEmailsMutationBody = EmailIngestRequest
    export type PostEmailsMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Forward a batch of applicant emails and close the scan cycle
 */
export const usePostEmails = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmails>>, TError,{data: EmailIngestRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEmails>>,
        TError,
        {data: EmailIngestRequest},
        TContext
      > => {

      const mutationOptions = getPostEmailsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Reset terminal 'error' messages back to 'received' so the classifier
reprocesses them (e.g. after a Gemini outage exhausted the retry budget).
Scope mirrors GET /emails: an events_manager retries only their own; an
admin may target another user via recruiter_user_id.

 * @summary Retry errored email-log messages
 */
export const postEmailsRetry = (
    params?: PostEmailsRetryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostEmailsRetry200>(
      {url: `/api/v1/emails/retry`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostEmailsRetryMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmailsRetry>>, TError,{params?: PostEmailsRetryParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postEmailsRetry>>, TError,{params?: PostEmailsRetryParams}, TContext> => {

const mutationKey = ['postEmailsRetry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postEmailsRetry>>, {params?: PostEmailsRetryParams}> = (props) => {
          const {params} = props ?? {};

          return  postEmailsRetry(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostEmailsRetryMutationResult = NonNullable<Awaited<ReturnType<typeof postEmailsRetry>>>
    
    export type PostEmailsRetryMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Retry errored email-log messages
 */
export const usePostEmailsRetry = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postEmailsRetry>>, TError,{params?: PostEmailsRetryParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postEmailsRetry>>,
        TError,
        {params?: PostEmailsRetryParams},
        TContext
      > => {

      const mutationOptions = getPostEmailsRetryMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Cursor-paginated shared applicant registry (one row per person).
 * @summary List applicants
 */
export const getApplicants = (
    params?: GetApplicantsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetApplicants200>(
      {url: `/api/v1/applicants`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetApplicantsQueryKey = (params?: GetApplicantsParams,) => {
    return [
    `/api/v1/applicants`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApplicantsQueryOptions = <TData = Awaited<ReturnType<typeof getApplicants>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(params?: GetApplicantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApplicantsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApplicants>>> = ({ signal }) => getApplicants(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApplicants>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApplicantsQueryResult = NonNullable<Awaited<ReturnType<typeof getApplicants>>>
export type GetApplicantsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetApplicants<TData = Awaited<ReturnType<typeof getApplicants>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: undefined |  GetApplicantsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicants>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApplicants>>,
          TError,
          Awaited<ReturnType<typeof getApplicants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApplicants<TData = Awaited<ReturnType<typeof getApplicants>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetApplicantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicants>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApplicants>>,
          TError,
          Awaited<ReturnType<typeof getApplicants>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApplicants<TData = Awaited<ReturnType<typeof getApplicants>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetApplicantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List applicants
 */

export function useGetApplicants<TData = Awaited<ReturnType<typeof getApplicants>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetApplicantsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicants>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApplicantsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Upload one resume/cover-letter file (PDF/DOCX/TXT). The file is staged
and an applicant_file_uploads row is queued; the shared classification
worker then verifies the role, extracts the applicant from content, dedups
(source manual_import), and attaches to (or creates) the applicant —
asynchronously. The outcome shows in the file-upload log, NOT this response,
which returns status "queued". Replaces the old watched Raw Drive folder;
callers may upload many files in parallel.

 * @summary Manually upload a resume or cover letter
 */
export const postApplicantsImport = (
    postApplicantsImportBody: PostApplicantsImportBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append(`file`, postApplicantsImportBody.file)

      return customInstance<ApplicantImportResult>(
      {url: `/api/v1/applicants/import`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }
  


export const getPostApplicantsImportMutationOptions = <TError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApplicantsImport>>, TError,{data: PostApplicantsImportBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApplicantsImport>>, TError,{data: PostApplicantsImportBody}, TContext> => {

const mutationKey = ['postApplicantsImport'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApplicantsImport>>, {data: PostApplicantsImportBody}> = (props) => {
          const {data} = props ?? {};

          return  postApplicantsImport(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApplicantsImportMutationResult = NonNullable<Awaited<ReturnType<typeof postApplicantsImport>>>
    export type PostApplicantsImportMutationBody = PostApplicantsImportBody
    export type PostApplicantsImportMutationError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Manually upload a resume or cover letter
 */
export const usePostApplicantsImport = <TError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApplicantsImport>>, TError,{data: PostApplicantsImportBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApplicantsImport>>,
        TError,
        {data: PostApplicantsImportBody},
        TContext
      > => {

      const mutationOptions = getPostApplicantsImportMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * The documents log: every harvested/uploaded document (résumés, cover
letters) and its lifecycle state, filterable by source (manual | email |
all) and status (pending | needs_review | resolved | all). Scope mirrors
GET /emails: an events_manager sees only their own; an admin sees all, or
may filter by recruiter_user_id. Cursor-paginated; all filters/sorts
server-side.

 * @summary List the documents log
 */
export const getApplicantDocuments = (
    params?: GetApplicantDocumentsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetApplicantDocuments200>(
      {url: `/api/v1/applicant-documents`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetApplicantDocumentsQueryKey = (params?: GetApplicantDocumentsParams,) => {
    return [
    `/api/v1/applicant-documents`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApplicantDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof getApplicantDocuments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(params?: GetApplicantDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicantDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApplicantDocumentsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApplicantDocuments>>> = ({ signal }) => getApplicantDocuments(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApplicantDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApplicantDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof getApplicantDocuments>>>
export type GetApplicantDocumentsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetApplicantDocuments<TData = Awaited<ReturnType<typeof getApplicantDocuments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: undefined |  GetApplicantDocumentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicantDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApplicantDocuments>>,
          TError,
          Awaited<ReturnType<typeof getApplicantDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApplicantDocuments<TData = Awaited<ReturnType<typeof getApplicantDocuments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetApplicantDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicantDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApplicantDocuments>>,
          TError,
          Awaited<ReturnType<typeof getApplicantDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApplicantDocuments<TData = Awaited<ReturnType<typeof getApplicantDocuments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetApplicantDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicantDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the documents log
 */

export function useGetApplicantDocuments<TData = Awaited<ReturnType<typeof getApplicantDocuments>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetApplicantDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicantDocuments>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApplicantDocumentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Fetch one document by id — used to poll an in-flight document's status in
place. Non-admins may only fetch their own.

 * @summary Get a single document
 */
export const getApplicantDocumentsId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApplicantDocument>(
      {url: `/api/v1/applicant-documents/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetApplicantDocumentsIdQueryKey = (id?: string,) => {
    return [
    `/api/v1/applicant-documents/${id}`
    ] as const;
    }

    
export const getGetApplicantDocumentsIdQueryOptions = <TData = Awaited<ReturnType<typeof getApplicantDocumentsId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicantDocumentsId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApplicantDocumentsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApplicantDocumentsId>>> = ({ signal }) => getApplicantDocumentsId(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApplicantDocumentsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApplicantDocumentsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApplicantDocumentsId>>>
export type GetApplicantDocumentsIdQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetApplicantDocumentsId<TData = Awaited<ReturnType<typeof getApplicantDocumentsId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicantDocumentsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApplicantDocumentsId>>,
          TError,
          Awaited<ReturnType<typeof getApplicantDocumentsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApplicantDocumentsId<TData = Awaited<ReturnType<typeof getApplicantDocumentsId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicantDocumentsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApplicantDocumentsId>>,
          TError,
          Awaited<ReturnType<typeof getApplicantDocumentsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApplicantDocumentsId<TData = Awaited<ReturnType<typeof getApplicantDocumentsId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicantDocumentsId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get a single document
 */

export function useGetApplicantDocumentsId<TData = Awaited<ReturnType<typeof getApplicantDocumentsId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicantDocumentsId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApplicantDocumentsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Remove a document (row + file). Non-admins may only delete their own.

 * @summary Delete a document
 */
export const deleteApplicantDocumentsId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/applicant-documents/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteApplicantDocumentsIdMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApplicantDocumentsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApplicantDocumentsId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteApplicantDocumentsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApplicantDocumentsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteApplicantDocumentsId(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApplicantDocumentsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApplicantDocumentsId>>>
    
    export type DeleteApplicantDocumentsIdMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Delete a document
 */
export const useDeleteApplicantDocumentsId = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApplicantDocumentsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApplicantDocumentsId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteApplicantDocumentsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Re-queue a recruiter's failed documents (extraction/verification failures)
for re-extraction by the single scheduler. Scope mirrors the log: an
events_manager retries only their own; an admin may target another user via
recruiter_user_id.

 * @summary Retry failed documents
 */
export const postApplicantDocumentsRetry = (
    params?: PostApplicantDocumentsRetryParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostApplicantDocumentsRetry200>(
      {url: `/api/v1/applicant-documents/retry`, method: 'POST',
        params, signal
    },
      options);
    }
  


export const getPostApplicantDocumentsRetryMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApplicantDocumentsRetry>>, TError,{params?: PostApplicantDocumentsRetryParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApplicantDocumentsRetry>>, TError,{params?: PostApplicantDocumentsRetryParams}, TContext> => {

const mutationKey = ['postApplicantDocumentsRetry'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApplicantDocumentsRetry>>, {params?: PostApplicantDocumentsRetryParams}> = (props) => {
          const {params} = props ?? {};

          return  postApplicantDocumentsRetry(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApplicantDocumentsRetryMutationResult = NonNullable<Awaited<ReturnType<typeof postApplicantDocumentsRetry>>>
    
    export type PostApplicantDocumentsRetryMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Retry failed documents
 */
export const usePostApplicantDocumentsRetry = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApplicantDocumentsRetry>>, TError,{params?: PostApplicantDocumentsRetryParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApplicantDocumentsRetry>>,
        TError,
        {params?: PostApplicantDocumentsRetryParams},
        TContext
      > => {

      const mutationOptions = getPostApplicantDocumentsRetryMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Streams the document file. Non-admins may only fetch their own.

 * @summary Download a document's file
 */
export const getApplicantDocumentsIdFile = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Blob>(
      {url: `/api/v1/applicant-documents/${id}/file`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }
  



export const getGetApplicantDocumentsIdFileQueryKey = (id?: string,) => {
    return [
    `/api/v1/applicant-documents/${id}/file`
    ] as const;
    }

    
export const getGetApplicantDocumentsIdFileQueryOptions = <TData = Awaited<ReturnType<typeof getApplicantDocumentsIdFile>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicantDocumentsIdFile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApplicantDocumentsIdFileQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApplicantDocumentsIdFile>>> = ({ signal }) => getApplicantDocumentsIdFile(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApplicantDocumentsIdFile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApplicantDocumentsIdFileQueryResult = NonNullable<Awaited<ReturnType<typeof getApplicantDocumentsIdFile>>>
export type GetApplicantDocumentsIdFileQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetApplicantDocumentsIdFile<TData = Awaited<ReturnType<typeof getApplicantDocumentsIdFile>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicantDocumentsIdFile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApplicantDocumentsIdFile>>,
          TError,
          Awaited<ReturnType<typeof getApplicantDocumentsIdFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApplicantDocumentsIdFile<TData = Awaited<ReturnType<typeof getApplicantDocumentsIdFile>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicantDocumentsIdFile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApplicantDocumentsIdFile>>,
          TError,
          Awaited<ReturnType<typeof getApplicantDocumentsIdFile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApplicantDocumentsIdFile<TData = Awaited<ReturnType<typeof getApplicantDocumentsIdFile>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicantDocumentsIdFile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download a document's file
 */

export function useGetApplicantDocumentsIdFile<TData = Awaited<ReturnType<typeof getApplicantDocumentsIdFile>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicantDocumentsIdFile>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApplicantDocumentsIdFileQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Resolve an unresolved document (a bare upload the scheduler couldn't attach):
attach it under the chosen doc_type to an existing applicant (applicant_id)
or a newly-created one (new_applicant). Non-admins may only assign their own.

 * @summary Manually resolve a document to an applicant
 */
export const postApplicantDocumentsIdAssign = (
    id: string,
    applicantAssignRequest: ApplicantAssignRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<ApplicantDocument>(
      {url: `/api/v1/applicant-documents/${id}/assign`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: applicantAssignRequest, signal
    },
      options);
    }
  


export const getPostApplicantDocumentsIdAssignMutationOptions = <TError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApplicantDocumentsIdAssign>>, TError,{id: string;data: ApplicantAssignRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApplicantDocumentsIdAssign>>, TError,{id: string;data: ApplicantAssignRequest}, TContext> => {

const mutationKey = ['postApplicantDocumentsIdAssign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApplicantDocumentsIdAssign>>, {id: string;data: ApplicantAssignRequest}> = (props) => {
          const {id,data} = props ?? {};

          return  postApplicantDocumentsIdAssign(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApplicantDocumentsIdAssignMutationResult = NonNullable<Awaited<ReturnType<typeof postApplicantDocumentsIdAssign>>>
    export type PostApplicantDocumentsIdAssignMutationBody = ApplicantAssignRequest
    export type PostApplicantDocumentsIdAssignMutationError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Manually resolve a document to an applicant
 */
export const usePostApplicantDocumentsIdAssign = <TError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApplicantDocumentsIdAssign>>, TError,{id: string;data: ApplicantAssignRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApplicantDocumentsIdAssign>>,
        TError,
        {id: string;data: ApplicantAssignRequest},
        TContext
      > => {

      const mutationOptions = getPostApplicantDocumentsIdAssignMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * One applicant including their document ledger.
 * @summary Get an applicant
 */
export const getApplicantsId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Applicant>(
      {url: `/api/v1/applicants/${id}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetApplicantsIdQueryKey = (id?: string,) => {
    return [
    `/api/v1/applicants/${id}`
    ] as const;
    }

    
export const getGetApplicantsIdQueryOptions = <TData = Awaited<ReturnType<typeof getApplicantsId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicantsId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApplicantsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApplicantsId>>> = ({ signal }) => getApplicantsId(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApplicantsId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApplicantsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApplicantsId>>>
export type GetApplicantsIdQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetApplicantsId<TData = Awaited<ReturnType<typeof getApplicantsId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicantsId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApplicantsId>>,
          TError,
          Awaited<ReturnType<typeof getApplicantsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApplicantsId<TData = Awaited<ReturnType<typeof getApplicantsId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicantsId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApplicantsId>>,
          TError,
          Awaited<ReturnType<typeof getApplicantsId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApplicantsId<TData = Awaited<ReturnType<typeof getApplicantsId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicantsId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get an applicant
 */

export function useGetApplicantsId<TData = Awaited<ReturnType<typeof getApplicantsId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicantsId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApplicantsIdQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Edit the editable fields (first_name, last_name, email, phone, address,
linkedin, github) via JSON-PATCH. Derived summary fields are ignored.

 * @summary Update an applicant (JSON-PATCH)
 */
export const patchApplicantsId = (
    id: string,
    jsonPatchOperation: JsonPatchOperation[],
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<Applicant>(
      {url: `/api/v1/applicants/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json-patch+json', },
      data: jsonPatchOperation
    },
      options);
    }
  


export const getPatchApplicantsIdMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApplicantsId>>, TError,{id: string;data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchApplicantsId>>, TError,{id: string;data: JsonPatchOperation[]}, TContext> => {

const mutationKey = ['patchApplicantsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApplicantsId>>, {id: string;data: JsonPatchOperation[]}> = (props) => {
          const {id,data} = props ?? {};

          return  patchApplicantsId(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchApplicantsIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApplicantsId>>>
    export type PatchApplicantsIdMutationBody = JsonPatchOperation[]
    export type PatchApplicantsIdMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Update an applicant (JSON-PATCH)
 */
export const usePatchApplicantsId = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApplicantsId>>, TError,{id: string;data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchApplicantsId>>,
        TError,
        {id: string;data: JsonPatchOperation[]},
        TContext
      > => {

      const mutationOptions = getPatchApplicantsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Permanently delete an applicant and everything tied to it: its document
rows and their files on disk, plus the file-upload log rows promoted into
(or assigned to) this applicant and any files those still hold staged.

 * @summary Delete an applicant
 */
export const deleteApplicantsId = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/applicants/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteApplicantsIdMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApplicantsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApplicantsId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteApplicantsId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApplicantsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteApplicantsId(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApplicantsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApplicantsId>>>
    
    export type DeleteApplicantsIdMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Delete an applicant
 */
export const useDeleteApplicantsId = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApplicantsId>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApplicantsId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteApplicantsIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Resolve a contact field's conflict: optionally pick a value (sets its
curation override) and acknowledge the document variants currently on file
(clears the needs-review flag until a genuinely new variant appears). Omit
value to "keep current" — acknowledge without changing the value.

 * @summary Resolve or acknowledge one contact field
 */
export const postApplicantsIdContactAcknowledge = (
    id: string,
    contactAcknowledgeInput: ContactAcknowledgeInput,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Applicant>(
      {url: `/api/v1/applicants/${id}/contact/acknowledge`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: contactAcknowledgeInput, signal
    },
      options);
    }
  


export const getPostApplicantsIdContactAcknowledgeMutationOptions = <TError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApplicantsIdContactAcknowledge>>, TError,{id: string;data: ContactAcknowledgeInput}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApplicantsIdContactAcknowledge>>, TError,{id: string;data: ContactAcknowledgeInput}, TContext> => {

const mutationKey = ['postApplicantsIdContactAcknowledge'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApplicantsIdContactAcknowledge>>, {id: string;data: ContactAcknowledgeInput}> = (props) => {
          const {id,data} = props ?? {};

          return  postApplicantsIdContactAcknowledge(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApplicantsIdContactAcknowledgeMutationResult = NonNullable<Awaited<ReturnType<typeof postApplicantsIdContactAcknowledge>>>
    export type PostApplicantsIdContactAcknowledgeMutationBody = ContactAcknowledgeInput
    export type PostApplicantsIdContactAcknowledgeMutationError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Resolve or acknowledge one contact field
 */
export const usePostApplicantsIdContactAcknowledge = <TError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApplicantsIdContactAcknowledge>>, TError,{id: string;data: ContactAcknowledgeInput}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApplicantsIdContactAcknowledge>>,
        TError,
        {id: string;data: ContactAcknowledgeInput},
        TContext
      > => {

      const mutationOptions = getPostApplicantsIdContactAcknowledgeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Set the full address list for an applicant — add, remove, edit, and choose
the primary. Exactly one entry should be is_primary=true; if none is, the
first becomes primary. An address already owned by another applicant is
rejected.

 * @summary Replace an applicant's email addresses
 */
export const putApplicantsIdEmails = (
    id: string,
    applicantEmailInput: ApplicantEmailInput[],
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<Applicant>(
      {url: `/api/v1/applicants/${id}/emails`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: applicantEmailInput
    },
      options);
    }
  


export const getPutApplicantsIdEmailsMutationOptions = <TError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApplicantsIdEmails>>, TError,{id: string;data: ApplicantEmailInput[]}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putApplicantsIdEmails>>, TError,{id: string;data: ApplicantEmailInput[]}, TContext> => {

const mutationKey = ['putApplicantsIdEmails'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApplicantsIdEmails>>, {id: string;data: ApplicantEmailInput[]}> = (props) => {
          const {id,data} = props ?? {};

          return  putApplicantsIdEmails(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApplicantsIdEmailsMutationResult = NonNullable<Awaited<ReturnType<typeof putApplicantsIdEmails>>>
    export type PutApplicantsIdEmailsMutationBody = ApplicantEmailInput[]
    export type PutApplicantsIdEmailsMutationError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Replace an applicant's email addresses
 */
export const usePutApplicantsIdEmails = <TError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApplicantsIdEmails>>, TError,{id: string;data: ApplicantEmailInput[]}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putApplicantsIdEmails>>,
        TError,
        {id: string;data: ApplicantEmailInput[]},
        TContext
      > => {

      const mutationOptions = getPutApplicantsIdEmailsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Store a resume/cover file (PDF/DOCX/TXT) directly under this applicant.
 * @summary Upload a document to an applicant
 */
export const postApplicantsIdDocuments = (
    id: string,
    postApplicantsIdDocumentsBody: PostApplicantsIdDocumentsBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      const formData = new FormData();
formData.append(`file`, postApplicantsIdDocumentsBody.file)
formData.append(`doc_type`, postApplicantsIdDocumentsBody.doc_type)

      return customInstance<Applicant>(
      {url: `/api/v1/applicants/${id}/documents`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }
  


export const getPostApplicantsIdDocumentsMutationOptions = <TError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApplicantsIdDocuments>>, TError,{id: string;data: PostApplicantsIdDocumentsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApplicantsIdDocuments>>, TError,{id: string;data: PostApplicantsIdDocumentsBody}, TContext> => {

const mutationKey = ['postApplicantsIdDocuments'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApplicantsIdDocuments>>, {id: string;data: PostApplicantsIdDocumentsBody}> = (props) => {
          const {id,data} = props ?? {};

          return  postApplicantsIdDocuments(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApplicantsIdDocumentsMutationResult = NonNullable<Awaited<ReturnType<typeof postApplicantsIdDocuments>>>
    export type PostApplicantsIdDocumentsMutationBody = PostApplicantsIdDocumentsBody
    export type PostApplicantsIdDocumentsMutationError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Upload a document to an applicant
 */
export const usePostApplicantsIdDocuments = <TError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApplicantsIdDocuments>>, TError,{id: string;data: PostApplicantsIdDocumentsBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApplicantsIdDocuments>>,
        TError,
        {id: string;data: PostApplicantsIdDocumentsBody},
        TContext
      > => {

      const mutationOptions = getPostApplicantsIdDocumentsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Streams the stored resume or cover-letter file.
 * @summary Download an applicant document
 */
export const getApplicantsIdDocumentsDocumentId = (
    id: string,
    documentId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Blob>(
      {url: `/api/v1/applicants/${id}/documents/${documentId}`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }
  



export const getGetApplicantsIdDocumentsDocumentIdQueryKey = (id?: string,
    documentId?: string,) => {
    return [
    `/api/v1/applicants/${id}/documents/${documentId}`
    ] as const;
    }

    
export const getGetApplicantsIdDocumentsDocumentIdQueryOptions = <TData = Awaited<ReturnType<typeof getApplicantsIdDocumentsDocumentId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(id: string,
    documentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicantsIdDocumentsDocumentId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApplicantsIdDocumentsDocumentIdQueryKey(id,documentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApplicantsIdDocumentsDocumentId>>> = ({ signal }) => getApplicantsIdDocumentsDocumentId(id,documentId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id && documentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApplicantsIdDocumentsDocumentId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApplicantsIdDocumentsDocumentIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApplicantsIdDocumentsDocumentId>>>
export type GetApplicantsIdDocumentsDocumentIdQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetApplicantsIdDocumentsDocumentId<TData = Awaited<ReturnType<typeof getApplicantsIdDocumentsDocumentId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 id: string,
    documentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicantsIdDocumentsDocumentId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApplicantsIdDocumentsDocumentId>>,
          TError,
          Awaited<ReturnType<typeof getApplicantsIdDocumentsDocumentId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApplicantsIdDocumentsDocumentId<TData = Awaited<ReturnType<typeof getApplicantsIdDocumentsDocumentId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 id: string,
    documentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicantsIdDocumentsDocumentId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApplicantsIdDocumentsDocumentId>>,
          TError,
          Awaited<ReturnType<typeof getApplicantsIdDocumentsDocumentId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApplicantsIdDocumentsDocumentId<TData = Awaited<ReturnType<typeof getApplicantsIdDocumentsDocumentId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 id: string,
    documentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicantsIdDocumentsDocumentId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Download an applicant document
 */

export function useGetApplicantsIdDocumentsDocumentId<TData = Awaited<ReturnType<typeof getApplicantsIdDocumentsDocumentId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 id: string,
    documentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApplicantsIdDocumentsDocumentId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApplicantsIdDocumentsDocumentIdQueryOptions(id,documentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Remove the document and its file; recomputes the applicant summary.
 * @summary Delete an applicant document
 */
export const deleteApplicantsIdDocumentsDocumentId = (
    id: string,
    documentId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<Applicant>(
      {url: `/api/v1/applicants/${id}/documents/${documentId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteApplicantsIdDocumentsDocumentIdMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApplicantsIdDocumentsDocumentId>>, TError,{id: string;documentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApplicantsIdDocumentsDocumentId>>, TError,{id: string;documentId: string}, TContext> => {

const mutationKey = ['deleteApplicantsIdDocumentsDocumentId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApplicantsIdDocumentsDocumentId>>, {id: string;documentId: string}> = (props) => {
          const {id,documentId} = props ?? {};

          return  deleteApplicantsIdDocumentsDocumentId(id,documentId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApplicantsIdDocumentsDocumentIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApplicantsIdDocumentsDocumentId>>>
    
    export type DeleteApplicantsIdDocumentsDocumentIdMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Delete an applicant document
 */
export const useDeleteApplicantsIdDocumentsDocumentId = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApplicantsIdDocumentsDocumentId>>, TError,{id: string;documentId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteApplicantsIdDocumentsDocumentId>>,
        TError,
        {id: string;documentId: string},
        TContext
      > => {

      const mutationOptions = getDeleteApplicantsIdDocumentsDocumentIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Move the document to another applicant; recomputes both summaries.
 * @summary Reassign a document to a different applicant
 */
export const postApplicantsIdDocumentsDocumentIdReassign = (
    id: string,
    documentId: string,
    postApplicantsIdDocumentsDocumentIdReassignBody: PostApplicantsIdDocumentsDocumentIdReassignBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<Applicant>(
      {url: `/api/v1/applicants/${id}/documents/${documentId}/reassign`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postApplicantsIdDocumentsDocumentIdReassignBody, signal
    },
      options);
    }
  


export const getPostApplicantsIdDocumentsDocumentIdReassignMutationOptions = <TError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApplicantsIdDocumentsDocumentIdReassign>>, TError,{id: string;documentId: string;data: PostApplicantsIdDocumentsDocumentIdReassignBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postApplicantsIdDocumentsDocumentIdReassign>>, TError,{id: string;documentId: string;data: PostApplicantsIdDocumentsDocumentIdReassignBody}, TContext> => {

const mutationKey = ['postApplicantsIdDocumentsDocumentIdReassign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApplicantsIdDocumentsDocumentIdReassign>>, {id: string;documentId: string;data: PostApplicantsIdDocumentsDocumentIdReassignBody}> = (props) => {
          const {id,documentId,data} = props ?? {};

          return  postApplicantsIdDocumentsDocumentIdReassign(id,documentId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApplicantsIdDocumentsDocumentIdReassignMutationResult = NonNullable<Awaited<ReturnType<typeof postApplicantsIdDocumentsDocumentIdReassign>>>
    export type PostApplicantsIdDocumentsDocumentIdReassignMutationBody = PostApplicantsIdDocumentsDocumentIdReassignBody
    export type PostApplicantsIdDocumentsDocumentIdReassignMutationError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Reassign a document to a different applicant
 */
export const usePostApplicantsIdDocumentsDocumentIdReassign = <TError = ValidationErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApplicantsIdDocumentsDocumentIdReassign>>, TError,{id: string;documentId: string;data: PostApplicantsIdDocumentsDocumentIdReassignBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApplicantsIdDocumentsDocumentIdReassign>>,
        TError,
        {id: string;documentId: string;data: PostApplicantsIdDocumentsDocumentIdReassignBody},
        TContext
      > => {

      const mutationOptions = getPostApplicantsIdDocumentsDocumentIdReassignMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Admin-only configuration for the recruiter-email applicant harvester.
 * @summary Get applicant-harvest settings
 */
export const getHarvestSettings = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<HarvestSettings>(
      {url: `/api/v1/harvest/settings`, method: 'GET', signal
    },
      options);
    }
  



export const getGetHarvestSettingsQueryKey = () => {
    return [
    `/api/v1/harvest/settings`
    ] as const;
    }

    
export const getGetHarvestSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getHarvestSettings>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHarvestSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetHarvestSettingsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getHarvestSettings>>> = ({ signal }) => getHarvestSettings(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getHarvestSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetHarvestSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getHarvestSettings>>>
export type GetHarvestSettingsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetHarvestSettings<TData = Awaited<ReturnType<typeof getHarvestSettings>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHarvestSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHarvestSettings>>,
          TError,
          Awaited<ReturnType<typeof getHarvestSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHarvestSettings<TData = Awaited<ReturnType<typeof getHarvestSettings>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHarvestSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getHarvestSettings>>,
          TError,
          Awaited<ReturnType<typeof getHarvestSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetHarvestSettings<TData = Awaited<ReturnType<typeof getHarvestSettings>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHarvestSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get applicant-harvest settings
 */

export function useGetHarvestSettings<TData = Awaited<ReturnType<typeof getHarvestSettings>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getHarvestSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetHarvestSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Apply a JSON-PATCH (RFC 6902) to the harvest settings (e.g. set the OIDC audience / client id).
 * @summary Update applicant-harvest settings
 */
export const patchHarvestSettings = (
    jsonPatchOperation: JsonPatchOperation[],
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<HarvestSettings>(
      {url: `/api/v1/harvest/settings`, method: 'PATCH',
      headers: {'Content-Type': 'application/json-patch+json', },
      data: jsonPatchOperation
    },
      options);
    }
  


export const getPatchHarvestSettingsMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchHarvestSettings>>, TError,{data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchHarvestSettings>>, TError,{data: JsonPatchOperation[]}, TContext> => {

const mutationKey = ['patchHarvestSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchHarvestSettings>>, {data: JsonPatchOperation[]}> = (props) => {
          const {data} = props ?? {};

          return  patchHarvestSettings(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchHarvestSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof patchHarvestSettings>>>
    export type PatchHarvestSettingsMutationBody = JsonPatchOperation[]
    export type PatchHarvestSettingsMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Update applicant-harvest settings
 */
export const usePatchHarvestSettings = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchHarvestSettings>>, TError,{data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchHarvestSettings>>,
        TError,
        {data: JsonPatchOperation[]},
        TContext
      > => {

      const mutationOptions = getPatchHarvestSettingsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Admin-only configuration for the public website contact forms.
Replaces the api-config.json the website repo's brief assumed, so a
Turnstile key rotation or recipient change needs no deploy.
Secrets are never returned — see WebFormSettings.

 * @summary Get public website form settings
 */
export const getWebFormsSettings = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<WebFormSettings>(
      {url: `/api/v1/web-forms/settings`, method: 'GET', signal
    },
      options);
    }
  



export const getGetWebFormsSettingsQueryKey = () => {
    return [
    `/api/v1/web-forms/settings`
    ] as const;
    }

    
export const getGetWebFormsSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getWebFormsSettings>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebFormsSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWebFormsSettingsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWebFormsSettings>>> = ({ signal }) => getWebFormsSettings(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWebFormsSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWebFormsSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getWebFormsSettings>>>
export type GetWebFormsSettingsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetWebFormsSettings<TData = Awaited<ReturnType<typeof getWebFormsSettings>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebFormsSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWebFormsSettings>>,
          TError,
          Awaited<ReturnType<typeof getWebFormsSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWebFormsSettings<TData = Awaited<ReturnType<typeof getWebFormsSettings>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebFormsSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWebFormsSettings>>,
          TError,
          Awaited<ReturnType<typeof getWebFormsSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWebFormsSettings<TData = Awaited<ReturnType<typeof getWebFormsSettings>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebFormsSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get public website form settings
 */

export function useGetWebFormsSettings<TData = Awaited<ReturnType<typeof getWebFormsSettings>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebFormsSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWebFormsSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Apply a JSON-PATCH (RFC 6902) to the web form settings. Secret fields
(turnstile_site_key, turnstile_secret_key, smtp_password) are
write-only: patching one sets it, omitting it leaves the stored value
untouched, and an explicit empty string clears it.

 * @summary Update public website form settings
 */
export const patchWebFormsSettings = (
    jsonPatchOperation: JsonPatchOperation[],
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<WebFormSettings>(
      {url: `/api/v1/web-forms/settings`, method: 'PATCH',
      headers: {'Content-Type': 'application/json-patch+json', },
      data: jsonPatchOperation
    },
      options);
    }
  


export const getPatchWebFormsSettingsMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchWebFormsSettings>>, TError,{data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchWebFormsSettings>>, TError,{data: JsonPatchOperation[]}, TContext> => {

const mutationKey = ['patchWebFormsSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchWebFormsSettings>>, {data: JsonPatchOperation[]}> = (props) => {
          const {data} = props ?? {};

          return  patchWebFormsSettings(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchWebFormsSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof patchWebFormsSettings>>>
    export type PatchWebFormsSettingsMutationBody = JsonPatchOperation[]
    export type PatchWebFormsSettingsMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Update public website form settings
 */
export const usePatchWebFormsSettings = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchWebFormsSettings>>, TError,{data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchWebFormsSettings>>,
        TError,
        {data: JsonPatchOperation[]},
        TContext
      > => {

      const mutationOptions = getPatchWebFormsSettingsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * The dashboard's single outbound mail relay. Every feature that sends
transactional email goes through it, so there is one place to
configure credentials and one place to test.

It has no From address of its own: who mail is from belongs to
whichever feature is sending it, and arrives with each message.

Distinct from the SendGrid integration, which is marketing email — a
different provider, sending reputation, and audience.

The password is never returned; `password_set` reports only whether
one is stored.

 * @summary Get the outbound SMTP relay settings
 */
export const getSettingsSmtp = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SMTPSettings>(
      {url: `/api/v1/settings/smtp`, method: 'GET', signal
    },
      options);
    }
  



export const getGetSettingsSmtpQueryKey = () => {
    return [
    `/api/v1/settings/smtp`
    ] as const;
    }

    
export const getGetSettingsSmtpQueryOptions = <TData = Awaited<ReturnType<typeof getSettingsSmtp>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsSmtp>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSettingsSmtpQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsSmtp>>> = ({ signal }) => getSettingsSmtp(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSettingsSmtp>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsSmtpQueryResult = NonNullable<Awaited<ReturnType<typeof getSettingsSmtp>>>
export type GetSettingsSmtpQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetSettingsSmtp<TData = Awaited<ReturnType<typeof getSettingsSmtp>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsSmtp>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsSmtp>>,
          TError,
          Awaited<ReturnType<typeof getSettingsSmtp>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsSmtp<TData = Awaited<ReturnType<typeof getSettingsSmtp>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsSmtp>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsSmtp>>,
          TError,
          Awaited<ReturnType<typeof getSettingsSmtp>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsSmtp<TData = Awaited<ReturnType<typeof getSettingsSmtp>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsSmtp>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get the outbound SMTP relay settings
 */

export function useGetSettingsSmtp<TData = Awaited<ReturnType<typeof getSettingsSmtp>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsSmtp>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSettingsSmtpQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Apply a JSON-PATCH (RFC 6902). `password` is write-only: patching it
sets it, omitting it leaves the stored value untouched, and an
explicit empty string clears it.

 * @summary Update the outbound SMTP relay settings
 */
export const patchSettingsSmtp = (
    jsonPatchOperation: JsonPatchOperation[],
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<SMTPSettings>(
      {url: `/api/v1/settings/smtp`, method: 'PATCH',
      headers: {'Content-Type': 'application/json-patch+json', },
      data: jsonPatchOperation
    },
      options);
    }
  


export const getPatchSettingsSmtpMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchSettingsSmtp>>, TError,{data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchSettingsSmtp>>, TError,{data: JsonPatchOperation[]}, TContext> => {

const mutationKey = ['patchSettingsSmtp'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchSettingsSmtp>>, {data: JsonPatchOperation[]}> = (props) => {
          const {data} = props ?? {};

          return  patchSettingsSmtp(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchSettingsSmtpMutationResult = NonNullable<Awaited<ReturnType<typeof patchSettingsSmtp>>>
    export type PatchSettingsSmtpMutationBody = JsonPatchOperation[]
    export type PatchSettingsSmtpMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Update the outbound SMTP relay settings
 */
export const usePatchSettingsSmtp = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchSettingsSmtp>>, TError,{data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchSettingsSmtp>>,
        TError,
        {data: JsonPatchOperation[]},
        TContext
      > => {

      const mutationOptions = getPatchSettingsSmtpMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Separate from GET /settings/smtp so the plaintext crosses the wire
only when explicitly asked for, rather than on every settings load.
Every reveal is logged.

 * @summary Reveal the stored SMTP password
 */
export const getSettingsSmtpSecret = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<WebFormSecretValue>(
      {url: `/api/v1/settings/smtp/secret`, method: 'GET', signal
    },
      options);
    }
  



export const getGetSettingsSmtpSecretQueryKey = () => {
    return [
    `/api/v1/settings/smtp/secret`
    ] as const;
    }

    
export const getGetSettingsSmtpSecretQueryOptions = <TData = Awaited<ReturnType<typeof getSettingsSmtpSecret>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsSmtpSecret>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSettingsSmtpSecretQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSettingsSmtpSecret>>> = ({ signal }) => getSettingsSmtpSecret(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSettingsSmtpSecret>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSettingsSmtpSecretQueryResult = NonNullable<Awaited<ReturnType<typeof getSettingsSmtpSecret>>>
export type GetSettingsSmtpSecretQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetSettingsSmtpSecret<TData = Awaited<ReturnType<typeof getSettingsSmtpSecret>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsSmtpSecret>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsSmtpSecret>>,
          TError,
          Awaited<ReturnType<typeof getSettingsSmtpSecret>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsSmtpSecret<TData = Awaited<ReturnType<typeof getSettingsSmtpSecret>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsSmtpSecret>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSettingsSmtpSecret>>,
          TError,
          Awaited<ReturnType<typeof getSettingsSmtpSecret>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSettingsSmtpSecret<TData = Awaited<ReturnType<typeof getSettingsSmtpSecret>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsSmtpSecret>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Reveal the stored SMTP password
 */

export function useGetSettingsSmtpSecret<TData = Awaited<ReturnType<typeof getSettingsSmtpSecret>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSettingsSmtpSecret>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSettingsSmtpSecretQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Dials the configured relay and SENDS a real test message from `from`
to `to`. Running this puts an email in that inbox.

It takes a sender because the relay has none: From belongs to
whichever feature is sending.

It sends rather than stopping at the envelope because only a completed
DATA proves delivery — a relay can accept MAIL FROM and RCPT TO and
still refuse the message at the end of DATA.

Tests what is currently SAVED, not what is typed in the form.

 * @summary Test the outbound SMTP relay
 */
export const postSettingsSmtpTestConnection = (
    postSettingsSmtpTestConnectionBody: PostSettingsSmtpTestConnectionBody,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<WebFormTestResult>(
      {url: `/api/v1/settings/smtp/test-connection`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postSettingsSmtpTestConnectionBody, signal
    },
      options);
    }
  


export const getPostSettingsSmtpTestConnectionMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSettingsSmtpTestConnection>>, TError,{data: PostSettingsSmtpTestConnectionBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postSettingsSmtpTestConnection>>, TError,{data: PostSettingsSmtpTestConnectionBody}, TContext> => {

const mutationKey = ['postSettingsSmtpTestConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postSettingsSmtpTestConnection>>, {data: PostSettingsSmtpTestConnectionBody}> = (props) => {
          const {data} = props ?? {};

          return  postSettingsSmtpTestConnection(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostSettingsSmtpTestConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof postSettingsSmtpTestConnection>>>
    export type PostSettingsSmtpTestConnectionMutationBody = PostSettingsSmtpTestConnectionBody
    export type PostSettingsSmtpTestConnectionMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Test the outbound SMTP relay
 */
export const usePostSettingsSmtpTestConnection = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postSettingsSmtpTestConnection>>, TError,{data: PostSettingsSmtpTestConnectionBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postSettingsSmtpTestConnection>>,
        TError,
        {data: PostSettingsSmtpTestConnectionBody},
        TContext
      > => {

      const mutationOptions = getPostSettingsSmtpTestConnectionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Posts a real message to the configured channel. Running this puts a
message in that channel — which is the point: a webhook URL is only
proven by something arriving.

Tests what is currently SAVED, not what is typed in the form.

 * @summary Test the Slack webhook
 */
export const postWebFormsSettingsSlackTestConnection = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<WebFormTestResult>(
      {url: `/api/v1/web-forms/settings/slack/test-connection`, method: 'POST', signal
    },
      options);
    }
  


export const getPostWebFormsSettingsSlackTestConnectionMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWebFormsSettingsSlackTestConnection>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postWebFormsSettingsSlackTestConnection>>, TError,void, TContext> => {

const mutationKey = ['postWebFormsSettingsSlackTestConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postWebFormsSettingsSlackTestConnection>>, void> = () => {
          

          return  postWebFormsSettingsSlackTestConnection(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostWebFormsSettingsSlackTestConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof postWebFormsSettingsSlackTestConnection>>>
    
    export type PostWebFormsSettingsSlackTestConnectionMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Test the Slack webhook
 */
export const usePostWebFormsSettingsSlackTestConnection = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWebFormsSettingsSlackTestConnection>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postWebFormsSettingsSlackTestConnection>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostWebFormsSettingsSlackTestConnectionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Probes Cloudflare siteverify with a deliberately invalid token and
reads the error code back. A valid secret plus a junk token yields
`invalid-input-response`; a bad secret yields `invalid-input-secret`
regardless of the token. That difference is what makes the secret key
checkable without a real visitor.

LIMIT: this cannot prove the site key and secret key are a matching
PAIR. Only a token minted by the widget demonstrates that, and minting
one needs a real browser solving a real challenge. A mismatched pair
stays invisible until traffic arrives — at which point every
submission is quarantined rather than lost, and the quarantine count
is shown on the Form Submissions page.

Tests what is currently SAVED, not what is typed in the form.

 * @summary Test the Turnstile configuration
 */
export const postWebFormsSettingsTurnstileTestConnection = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<WebFormTestResult>(
      {url: `/api/v1/web-forms/settings/turnstile/test-connection`, method: 'POST', signal
    },
      options);
    }
  


export const getPostWebFormsSettingsTurnstileTestConnectionMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWebFormsSettingsTurnstileTestConnection>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postWebFormsSettingsTurnstileTestConnection>>, TError,void, TContext> => {

const mutationKey = ['postWebFormsSettingsTurnstileTestConnection'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postWebFormsSettingsTurnstileTestConnection>>, void> = () => {
          

          return  postWebFormsSettingsTurnstileTestConnection(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostWebFormsSettingsTurnstileTestConnectionMutationResult = NonNullable<Awaited<ReturnType<typeof postWebFormsSettingsTurnstileTestConnection>>>
    
    export type PostWebFormsSettingsTurnstileTestConnectionMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Test the Turnstile configuration
 */
export const usePostWebFormsSettingsTurnstileTestConnection = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWebFormsSettingsTurnstileTestConnection>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postWebFormsSettingsTurnstileTestConnection>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostWebFormsSettingsTurnstileTestConnectionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Returns the plaintext of a single stored secret so an admin can
compare it against the Cloudflare dashboard. A site-key/secret-key
mismatch cannot be diagnosed without seeing which key is stored.

Deliberately a separate endpoint rather than a field on GET
/web-forms/settings: this way the plaintext crosses the wire only when
someone explicitly asks for it, instead of on every settings page load.
Every reveal is logged.

 * @summary Reveal one stored web-form secret
 */
export const getWebFormsSettingsSecretsSecretName = (
    secretName: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<WebFormSecretValue>(
      {url: `/api/v1/web-forms/settings/secrets/${secretName}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetWebFormsSettingsSecretsSecretNameQueryKey = (secretName?: string,) => {
    return [
    `/api/v1/web-forms/settings/secrets/${secretName}`
    ] as const;
    }

    
export const getGetWebFormsSettingsSecretsSecretNameQueryOptions = <TData = Awaited<ReturnType<typeof getWebFormsSettingsSecretsSecretName>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(secretName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebFormsSettingsSecretsSecretName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWebFormsSettingsSecretsSecretNameQueryKey(secretName);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWebFormsSettingsSecretsSecretName>>> = ({ signal }) => getWebFormsSettingsSecretsSecretName(secretName, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(secretName), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWebFormsSettingsSecretsSecretName>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWebFormsSettingsSecretsSecretNameQueryResult = NonNullable<Awaited<ReturnType<typeof getWebFormsSettingsSecretsSecretName>>>
export type GetWebFormsSettingsSecretsSecretNameQueryError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetWebFormsSettingsSecretsSecretName<TData = Awaited<ReturnType<typeof getWebFormsSettingsSecretsSecretName>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 secretName: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebFormsSettingsSecretsSecretName>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWebFormsSettingsSecretsSecretName>>,
          TError,
          Awaited<ReturnType<typeof getWebFormsSettingsSecretsSecretName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWebFormsSettingsSecretsSecretName<TData = Awaited<ReturnType<typeof getWebFormsSettingsSecretsSecretName>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 secretName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebFormsSettingsSecretsSecretName>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWebFormsSettingsSecretsSecretName>>,
          TError,
          Awaited<ReturnType<typeof getWebFormsSettingsSecretsSecretName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWebFormsSettingsSecretsSecretName<TData = Awaited<ReturnType<typeof getWebFormsSettingsSecretsSecretName>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 secretName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebFormsSettingsSecretsSecretName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Reveal one stored web-form secret
 */

export function useGetWebFormsSettingsSecretsSecretName<TData = Awaited<ReturnType<typeof getWebFormsSettingsSecretsSecretName>>, TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 secretName: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebFormsSettingsSecretsSecretName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWebFormsSettingsSecretsSecretNameQueryOptions(secretName,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * The formId -> human label map this service owns. The browser
deliberately never sends a label: client text in a mail Subject is a
header-injection vector. An unrecognised formId is still accepted and
stored, falling back to the id itself as its label.

 * @summary List web form definitions
 */
export const getWebFormsDefinitions = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<WebFormDefinition[]>(
      {url: `/api/v1/web-forms/definitions`, method: 'GET', signal
    },
      options);
    }
  



export const getGetWebFormsDefinitionsQueryKey = () => {
    return [
    `/api/v1/web-forms/definitions`
    ] as const;
    }

    
export const getGetWebFormsDefinitionsQueryOptions = <TData = Awaited<ReturnType<typeof getWebFormsDefinitions>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebFormsDefinitions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWebFormsDefinitionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWebFormsDefinitions>>> = ({ signal }) => getWebFormsDefinitions(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWebFormsDefinitions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWebFormsDefinitionsQueryResult = NonNullable<Awaited<ReturnType<typeof getWebFormsDefinitions>>>
export type GetWebFormsDefinitionsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetWebFormsDefinitions<TData = Awaited<ReturnType<typeof getWebFormsDefinitions>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebFormsDefinitions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWebFormsDefinitions>>,
          TError,
          Awaited<ReturnType<typeof getWebFormsDefinitions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWebFormsDefinitions<TData = Awaited<ReturnType<typeof getWebFormsDefinitions>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebFormsDefinitions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWebFormsDefinitions>>,
          TError,
          Awaited<ReturnType<typeof getWebFormsDefinitions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWebFormsDefinitions<TData = Awaited<ReturnType<typeof getWebFormsDefinitions>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebFormsDefinitions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List web form definitions
 */

export function useGetWebFormsDefinitions<TData = Awaited<ReturnType<typeof getWebFormsDefinitions>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebFormsDefinitions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWebFormsDefinitionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Create a web form definition
 */
export const postWebFormsDefinitions = (
    webFormDefinition: WebFormDefinition,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<WebFormDefinition>(
      {url: `/api/v1/web-forms/definitions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: webFormDefinition, signal
    },
      options);
    }
  


export const getPostWebFormsDefinitionsMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWebFormsDefinitions>>, TError,{data: WebFormDefinition}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postWebFormsDefinitions>>, TError,{data: WebFormDefinition}, TContext> => {

const mutationKey = ['postWebFormsDefinitions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postWebFormsDefinitions>>, {data: WebFormDefinition}> = (props) => {
          const {data} = props ?? {};

          return  postWebFormsDefinitions(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostWebFormsDefinitionsMutationResult = NonNullable<Awaited<ReturnType<typeof postWebFormsDefinitions>>>
    export type PostWebFormsDefinitionsMutationBody = WebFormDefinition
    export type PostWebFormsDefinitionsMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Create a web form definition
 */
export const usePostWebFormsDefinitions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWebFormsDefinitions>>, TError,{data: WebFormDefinition}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postWebFormsDefinitions>>,
        TError,
        {data: WebFormDefinition},
        TContext
      > => {

      const mutationOptions = getPostWebFormsDefinitionsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Update a web form definition
 */
export const putWebFormsDefinitionsDefinitionId = (
    definitionId: string,
    webFormDefinition: WebFormDefinition,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<WebFormDefinition>(
      {url: `/api/v1/web-forms/definitions/${definitionId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: webFormDefinition
    },
      options);
    }
  


export const getPutWebFormsDefinitionsDefinitionIdMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putWebFormsDefinitionsDefinitionId>>, TError,{definitionId: string;data: WebFormDefinition}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putWebFormsDefinitionsDefinitionId>>, TError,{definitionId: string;data: WebFormDefinition}, TContext> => {

const mutationKey = ['putWebFormsDefinitionsDefinitionId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putWebFormsDefinitionsDefinitionId>>, {definitionId: string;data: WebFormDefinition}> = (props) => {
          const {definitionId,data} = props ?? {};

          return  putWebFormsDefinitionsDefinitionId(definitionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutWebFormsDefinitionsDefinitionIdMutationResult = NonNullable<Awaited<ReturnType<typeof putWebFormsDefinitionsDefinitionId>>>
    export type PutWebFormsDefinitionsDefinitionIdMutationBody = WebFormDefinition
    export type PutWebFormsDefinitionsDefinitionIdMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Update a web form definition
 */
export const usePutWebFormsDefinitionsDefinitionId = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putWebFormsDefinitionsDefinitionId>>, TError,{definitionId: string;data: WebFormDefinition}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putWebFormsDefinitionsDefinitionId>>,
        TError,
        {definitionId: string;data: WebFormDefinition},
        TContext
      > => {

      const mutationOptions = getPutWebFormsDefinitionsDefinitionIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Removes the label mapping only. Existing submissions keep the label
snapshotted at submission time, so deleting a definition never
rewrites history.

 * @summary Delete a web form definition
 */
export const deleteWebFormsDefinitionsDefinitionId = (
    definitionId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/web-forms/definitions/${definitionId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteWebFormsDefinitionsDefinitionIdMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWebFormsDefinitionsDefinitionId>>, TError,{definitionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteWebFormsDefinitionsDefinitionId>>, TError,{definitionId: string}, TContext> => {

const mutationKey = ['deleteWebFormsDefinitionsDefinitionId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWebFormsDefinitionsDefinitionId>>, {definitionId: string}> = (props) => {
          const {definitionId} = props ?? {};

          return  deleteWebFormsDefinitionsDefinitionId(definitionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteWebFormsDefinitionsDefinitionIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWebFormsDefinitionsDefinitionId>>>
    
    export type DeleteWebFormsDefinitionsDefinitionIdMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Delete a web form definition
 */
export const useDeleteWebFormsDefinitionsDefinitionId = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWebFormsDefinitionsDefinitionId>>, TError,{definitionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteWebFormsDefinitionsDefinitionId>>,
        TError,
        {definitionId: string},
        TContext
      > => {

      const mutationOptions = getDeleteWebFormsDefinitionsDefinitionIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Cursor-paginated list of submissions received from the public site.
Quarantined rows (honeypot spam, failed verification, and rows where
verification could not be performed at all) are excluded unless
`status` asks for them: a Turnstile key mismatch quarantines real
enquiries, and those are the ones worth recovering.

 * @summary List public website form submissions
 */
export const getWebFormsSubmissions = (
    params?: GetWebFormsSubmissionsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetWebFormsSubmissions200>(
      {url: `/api/v1/web-forms/submissions`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetWebFormsSubmissionsQueryKey = (params?: GetWebFormsSubmissionsParams,) => {
    return [
    `/api/v1/web-forms/submissions`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetWebFormsSubmissionsQueryOptions = <TData = Awaited<ReturnType<typeof getWebFormsSubmissions>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(params?: GetWebFormsSubmissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebFormsSubmissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWebFormsSubmissionsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWebFormsSubmissions>>> = ({ signal }) => getWebFormsSubmissions(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWebFormsSubmissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWebFormsSubmissionsQueryResult = NonNullable<Awaited<ReturnType<typeof getWebFormsSubmissions>>>
export type GetWebFormsSubmissionsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetWebFormsSubmissions<TData = Awaited<ReturnType<typeof getWebFormsSubmissions>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params: undefined |  GetWebFormsSubmissionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebFormsSubmissions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWebFormsSubmissions>>,
          TError,
          Awaited<ReturnType<typeof getWebFormsSubmissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWebFormsSubmissions<TData = Awaited<ReturnType<typeof getWebFormsSubmissions>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetWebFormsSubmissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebFormsSubmissions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWebFormsSubmissions>>,
          TError,
          Awaited<ReturnType<typeof getWebFormsSubmissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWebFormsSubmissions<TData = Awaited<ReturnType<typeof getWebFormsSubmissions>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetWebFormsSubmissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebFormsSubmissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List public website form submissions
 */

export function useGetWebFormsSubmissions<TData = Awaited<ReturnType<typeof getWebFormsSubmissions>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
 params?: GetWebFormsSubmissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebFormsSubmissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWebFormsSubmissionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Get one web form submission
 */
export const getWebFormsSubmissionsSubmissionId = (
    submissionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<WebFormSubmission>(
      {url: `/api/v1/web-forms/submissions/${submissionId}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetWebFormsSubmissionsSubmissionIdQueryKey = (submissionId?: string,) => {
    return [
    `/api/v1/web-forms/submissions/${submissionId}`
    ] as const;
    }

    
export const getGetWebFormsSubmissionsSubmissionIdQueryOptions = <TData = Awaited<ReturnType<typeof getWebFormsSubmissionsSubmissionId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(submissionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebFormsSubmissionsSubmissionId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWebFormsSubmissionsSubmissionIdQueryKey(submissionId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWebFormsSubmissionsSubmissionId>>> = ({ signal }) => getWebFormsSubmissionsSubmissionId(submissionId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(submissionId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWebFormsSubmissionsSubmissionId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWebFormsSubmissionsSubmissionIdQueryResult = NonNullable<Awaited<ReturnType<typeof getWebFormsSubmissionsSubmissionId>>>
export type GetWebFormsSubmissionsSubmissionIdQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void


export function useGetWebFormsSubmissionsSubmissionId<TData = Awaited<ReturnType<typeof getWebFormsSubmissionsSubmissionId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 submissionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebFormsSubmissionsSubmissionId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWebFormsSubmissionsSubmissionId>>,
          TError,
          Awaited<ReturnType<typeof getWebFormsSubmissionsSubmissionId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWebFormsSubmissionsSubmissionId<TData = Awaited<ReturnType<typeof getWebFormsSubmissionsSubmissionId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 submissionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebFormsSubmissionsSubmissionId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWebFormsSubmissionsSubmissionId>>,
          TError,
          Awaited<ReturnType<typeof getWebFormsSubmissionsSubmissionId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWebFormsSubmissionsSubmissionId<TData = Awaited<ReturnType<typeof getWebFormsSubmissionsSubmissionId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 submissionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebFormsSubmissionsSubmissionId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get one web form submission
 */

export function useGetWebFormsSubmissionsSubmissionId<TData = Awaited<ReturnType<typeof getWebFormsSubmissionsSubmissionId>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void>(
 submissionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebFormsSubmissionsSubmissionId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWebFormsSubmissionsSubmissionIdQueryOptions(submissionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Reclassifies a submission. `accepted` means "not spam"; `spam` means
the reverse.

Marking something NOT spam also delivers it if it never was — a
submission held back by a Turnstile failure has no notification email,
so reclassifying it without sending would leave the lead sitting in
the dashboard where nobody is looking.

Marking something spam does NOT unsend a notification that already
went out; it cannot. It stops the row cluttering the default view and
makes it eligible for the spam retention purge.

The underlying reason a row was flagged is preserved in
`reject_reason` regardless, so the history survives reclassification.

 * @summary Mark a submission as spam or not spam
 */
export const patchWebFormsSubmissionsSubmissionId = (
    submissionId: string,
    patchWebFormsSubmissionsSubmissionIdBody: PatchWebFormsSubmissionsSubmissionIdBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<WebFormSubmission>(
      {url: `/api/v1/web-forms/submissions/${submissionId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchWebFormsSubmissionsSubmissionIdBody
    },
      options);
    }
  


export const getPatchWebFormsSubmissionsSubmissionIdMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchWebFormsSubmissionsSubmissionId>>, TError,{submissionId: string;data: PatchWebFormsSubmissionsSubmissionIdBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchWebFormsSubmissionsSubmissionId>>, TError,{submissionId: string;data: PatchWebFormsSubmissionsSubmissionIdBody}, TContext> => {

const mutationKey = ['patchWebFormsSubmissionsSubmissionId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchWebFormsSubmissionsSubmissionId>>, {submissionId: string;data: PatchWebFormsSubmissionsSubmissionIdBody}> = (props) => {
          const {submissionId,data} = props ?? {};

          return  patchWebFormsSubmissionsSubmissionId(submissionId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchWebFormsSubmissionsSubmissionIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchWebFormsSubmissionsSubmissionId>>>
    export type PatchWebFormsSubmissionsSubmissionIdMutationBody = PatchWebFormsSubmissionsSubmissionIdBody
    export type PatchWebFormsSubmissionsSubmissionIdMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Mark a submission as spam or not spam
 */
export const usePatchWebFormsSubmissionsSubmissionId = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchWebFormsSubmissionsSubmissionId>>, TError,{submissionId: string;data: PatchWebFormsSubmissionsSubmissionIdBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchWebFormsSubmissionsSubmissionId>>,
        TError,
        {submissionId: string;data: PatchWebFormsSubmissionsSubmissionIdBody},
        TContext
      > => {

      const mutationOptions = getPatchWebFormsSubmissionsSubmissionIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Re-queues delivery. Used to recover a lead after an SMTP outage, or
after releasing a submission that was quarantined by a Turnstile
misconfiguration.

 * @summary Re-send the notification email for a submission
 */
export const postWebFormsSubmissionsSubmissionIdResend = (
    submissionId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<WebFormSubmission>(
      {url: `/api/v1/web-forms/submissions/${submissionId}/resend`, method: 'POST', signal
    },
      options);
    }
  


export const getPostWebFormsSubmissionsSubmissionIdResendMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWebFormsSubmissionsSubmissionIdResend>>, TError,{submissionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postWebFormsSubmissionsSubmissionIdResend>>, TError,{submissionId: string}, TContext> => {

const mutationKey = ['postWebFormsSubmissionsSubmissionIdResend'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postWebFormsSubmissionsSubmissionIdResend>>, {submissionId: string}> = (props) => {
          const {submissionId} = props ?? {};

          return  postWebFormsSubmissionsSubmissionIdResend(submissionId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostWebFormsSubmissionsSubmissionIdResendMutationResult = NonNullable<Awaited<ReturnType<typeof postWebFormsSubmissionsSubmissionIdResend>>>
    
    export type PostWebFormsSubmissionsSubmissionIdResendMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Re-send the notification email for a submission
 */
export const usePostWebFormsSubmissionsSubmissionIdResend = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWebFormsSubmissionsSubmissionIdResend>>, TError,{submissionId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postWebFormsSubmissionsSubmissionIdResend>>,
        TError,
        {submissionId: string},
        TContext
      > => {

      const mutationOptions = getPostWebFormsSubmissionsSubmissionIdResendMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Get certificate monitoring settings
 */
export const getMonitoringSettings = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MonitorSettings>(
      {url: `/api/v1/monitoring/settings`, method: 'GET', signal
    },
      options);
    }
  



export const getGetMonitoringSettingsQueryKey = () => {
    return [
    `/api/v1/monitoring/settings`
    ] as const;
    }

    
export const getGetMonitoringSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getMonitoringSettings>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMonitoringSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMonitoringSettingsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMonitoringSettings>>> = ({ signal }) => getMonitoringSettings(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMonitoringSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMonitoringSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getMonitoringSettings>>>
export type GetMonitoringSettingsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetMonitoringSettings<TData = Awaited<ReturnType<typeof getMonitoringSettings>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMonitoringSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMonitoringSettings>>,
          TError,
          Awaited<ReturnType<typeof getMonitoringSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMonitoringSettings<TData = Awaited<ReturnType<typeof getMonitoringSettings>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMonitoringSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMonitoringSettings>>,
          TError,
          Awaited<ReturnType<typeof getMonitoringSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMonitoringSettings<TData = Awaited<ReturnType<typeof getMonitoringSettings>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMonitoringSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get certificate monitoring settings
 */

export function useGetMonitoringSettings<TData = Awaited<ReturnType<typeof getMonitoringSettings>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMonitoringSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMonitoringSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * Apply a JSON-PATCH (RFC 6902) to the monitoring settings.

 * @summary Update certificate monitoring settings
 */
export const patchMonitoringSettings = (
    jsonPatchOperation: JsonPatchOperation[],
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<MonitorSettings>(
      {url: `/api/v1/monitoring/settings`, method: 'PATCH',
      headers: {'Content-Type': 'application/json-patch+json', },
      data: jsonPatchOperation
    },
      options);
    }
  


export const getPatchMonitoringSettingsMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchMonitoringSettings>>, TError,{data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchMonitoringSettings>>, TError,{data: JsonPatchOperation[]}, TContext> => {

const mutationKey = ['patchMonitoringSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchMonitoringSettings>>, {data: JsonPatchOperation[]}> = (props) => {
          const {data} = props ?? {};

          return  patchMonitoringSettings(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchMonitoringSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof patchMonitoringSettings>>>
    export type PatchMonitoringSettingsMutationBody = JsonPatchOperation[]
    export type PatchMonitoringSettingsMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Update certificate monitoring settings
 */
export const usePatchMonitoringSettings = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchMonitoringSettings>>, TError,{data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchMonitoringSettings>>,
        TError,
        {data: JsonPatchOperation[]},
        TContext
      > => {

      const mutationOptions = getPatchMonitoringSettingsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary List monitored hosts
 */
export const getMonitoringHosts = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MonitoredHost[]>(
      {url: `/api/v1/monitoring/hosts`, method: 'GET', signal
    },
      options);
    }
  



export const getGetMonitoringHostsQueryKey = () => {
    return [
    `/api/v1/monitoring/hosts`
    ] as const;
    }

    
export const getGetMonitoringHostsQueryOptions = <TData = Awaited<ReturnType<typeof getMonitoringHosts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMonitoringHosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMonitoringHostsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMonitoringHosts>>> = ({ signal }) => getMonitoringHosts(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMonitoringHosts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetMonitoringHostsQueryResult = NonNullable<Awaited<ReturnType<typeof getMonitoringHosts>>>
export type GetMonitoringHostsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetMonitoringHosts<TData = Awaited<ReturnType<typeof getMonitoringHosts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMonitoringHosts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMonitoringHosts>>,
          TError,
          Awaited<ReturnType<typeof getMonitoringHosts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMonitoringHosts<TData = Awaited<ReturnType<typeof getMonitoringHosts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMonitoringHosts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMonitoringHosts>>,
          TError,
          Awaited<ReturnType<typeof getMonitoringHosts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetMonitoringHosts<TData = Awaited<ReturnType<typeof getMonitoringHosts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMonitoringHosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List monitored hosts
 */

export function useGetMonitoringHosts<TData = Awaited<ReturnType<typeof getMonitoringHosts>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMonitoringHosts>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetMonitoringHostsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Add a monitored host
 */
export const postMonitoringHosts = (
    monitoredHost: NonReadonly<MonitoredHost>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MonitoredHost>(
      {url: `/api/v1/monitoring/hosts`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: monitoredHost, signal
    },
      options);
    }
  


export const getPostMonitoringHostsMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMonitoringHosts>>, TError,{data: NonReadonly<MonitoredHost>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postMonitoringHosts>>, TError,{data: NonReadonly<MonitoredHost>}, TContext> => {

const mutationKey = ['postMonitoringHosts'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMonitoringHosts>>, {data: NonReadonly<MonitoredHost>}> = (props) => {
          const {data} = props ?? {};

          return  postMonitoringHosts(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMonitoringHostsMutationResult = NonNullable<Awaited<ReturnType<typeof postMonitoringHosts>>>
    export type PostMonitoringHostsMutationBody = NonReadonly<MonitoredHost>
    export type PostMonitoringHostsMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Add a monitored host
 */
export const usePostMonitoringHosts = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMonitoringHosts>>, TError,{data: NonReadonly<MonitoredHost>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMonitoringHosts>>,
        TError,
        {data: NonReadonly<MonitoredHost>},
        TContext
      > => {

      const mutationOptions = getPostMonitoringHostsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Update a monitored host
 */
export const putMonitoringHostsHostId = (
    hostId: string,
    monitoredHost: NonReadonly<MonitoredHost>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<MonitoredHost>(
      {url: `/api/v1/monitoring/hosts/${hostId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: monitoredHost
    },
      options);
    }
  


export const getPutMonitoringHostsHostIdMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMonitoringHostsHostId>>, TError,{hostId: string;data: NonReadonly<MonitoredHost>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putMonitoringHostsHostId>>, TError,{hostId: string;data: NonReadonly<MonitoredHost>}, TContext> => {

const mutationKey = ['putMonitoringHostsHostId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putMonitoringHostsHostId>>, {hostId: string;data: NonReadonly<MonitoredHost>}> = (props) => {
          const {hostId,data} = props ?? {};

          return  putMonitoringHostsHostId(hostId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutMonitoringHostsHostIdMutationResult = NonNullable<Awaited<ReturnType<typeof putMonitoringHostsHostId>>>
    export type PutMonitoringHostsHostIdMutationBody = NonReadonly<MonitoredHost>
    export type PutMonitoringHostsHostIdMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Update a monitored host
 */
export const usePutMonitoringHostsHostId = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putMonitoringHostsHostId>>, TError,{hostId: string;data: NonReadonly<MonitoredHost>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putMonitoringHostsHostId>>,
        TError,
        {hostId: string;data: NonReadonly<MonitoredHost>},
        TContext
      > => {

      const mutationOptions = getPutMonitoringHostsHostIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Remove a monitored host
 */
export const deleteMonitoringHostsHostId = (
    hostId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/monitoring/hosts/${hostId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteMonitoringHostsHostIdMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMonitoringHostsHostId>>, TError,{hostId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteMonitoringHostsHostId>>, TError,{hostId: string}, TContext> => {

const mutationKey = ['deleteMonitoringHostsHostId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteMonitoringHostsHostId>>, {hostId: string}> = (props) => {
          const {hostId} = props ?? {};

          return  deleteMonitoringHostsHostId(hostId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteMonitoringHostsHostIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteMonitoringHostsHostId>>>
    
    export type DeleteMonitoringHostsHostIdMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Remove a monitored host
 */
export const useDeleteMonitoringHostsHostId = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteMonitoringHostsHostId>>, TError,{hostId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteMonitoringHostsHostId>>,
        TError,
        {hostId: string},
        TContext
      > => {

      const mutationOptions = getDeleteMonitoringHostsHostIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Runs exactly the check the scheduled job runs — the same code path, so
what you see here is what the timer will do. Results are recorded
against the hosts and alerts are sent if a host has got worse, or
recovered.

Escalation still applies, so running this repeatedly does not repeat
alerts: a host only alerts when its band worsens.

The dead-man's switch is deliberately untouched. It measures whether the
timer is still alive, and a manual run that pinged it would hide a dead
timer for as long as someone kept clicking.

 * @summary Run the certificate checks now
 */
export const postMonitoringCheck = (
    monitorCheckRequest?: MonitorCheckRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostMonitoringCheck200>(
      {url: `/api/v1/monitoring/check`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: monitorCheckRequest, signal
    },
      options);
    }
  


export const getPostMonitoringCheckMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMonitoringCheck>>, TError,{data: MonitorCheckRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postMonitoringCheck>>, TError,{data: MonitorCheckRequest}, TContext> => {

const mutationKey = ['postMonitoringCheck'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMonitoringCheck>>, {data: MonitorCheckRequest}> = (props) => {
          const {data} = props ?? {};

          return  postMonitoringCheck(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMonitoringCheckMutationResult = NonNullable<Awaited<ReturnType<typeof postMonitoringCheck>>>
    export type PostMonitoringCheckMutationBody = MonitorCheckRequest
    export type PostMonitoringCheckMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Run the certificate checks now
 */
export const usePostMonitoringCheck = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMonitoringCheck>>, TError,{data: MonitorCheckRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMonitoringCheck>>,
        TError,
        {data: MonitorCheckRequest},
        TContext
      > => {

      const mutationOptions = getPostMonitoringCheckMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Delivers a synthetic alert to the dashboard, Slack and email so the
paths can be proven before anything depends on them. An alert path
that has never delivered a message is not a monitor, and the first
real failure is a bad time to discover it.

 * @summary Send a test alert through every configured channel
 */
export const postMonitoringTestAlert = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MonitorTestStage[]>(
      {url: `/api/v1/monitoring/test-alert`, method: 'POST', signal
    },
      options);
    }
  


export const getPostMonitoringTestAlertMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMonitoringTestAlert>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postMonitoringTestAlert>>, TError,void, TContext> => {

const mutationKey = ['postMonitoringTestAlert'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postMonitoringTestAlert>>, void> = () => {
          

          return  postMonitoringTestAlert(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostMonitoringTestAlertMutationResult = NonNullable<Awaited<ReturnType<typeof postMonitoringTestAlert>>>
    
    export type PostMonitoringTestAlertMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Send a test alert through every configured channel
 */
export const usePostMonitoringTestAlert = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postMonitoringTestAlert>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postMonitoringTestAlert>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostMonitoringTestAlertMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Get website monitoring settings
 */
export const getWebmonSettings = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<WebMonSettings>(
      {url: `/api/v1/webmon/settings`, method: 'GET', signal
    },
      options);
    }
  



export const getGetWebmonSettingsQueryKey = () => {
    return [
    `/api/v1/webmon/settings`
    ] as const;
    }

    
export const getGetWebmonSettingsQueryOptions = <TData = Awaited<ReturnType<typeof getWebmonSettings>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebmonSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWebmonSettingsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWebmonSettings>>> = ({ signal }) => getWebmonSettings(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWebmonSettings>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWebmonSettingsQueryResult = NonNullable<Awaited<ReturnType<typeof getWebmonSettings>>>
export type GetWebmonSettingsQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetWebmonSettings<TData = Awaited<ReturnType<typeof getWebmonSettings>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebmonSettings>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWebmonSettings>>,
          TError,
          Awaited<ReturnType<typeof getWebmonSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWebmonSettings<TData = Awaited<ReturnType<typeof getWebmonSettings>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebmonSettings>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWebmonSettings>>,
          TError,
          Awaited<ReturnType<typeof getWebmonSettings>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWebmonSettings<TData = Awaited<ReturnType<typeof getWebmonSettings>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebmonSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get website monitoring settings
 */

export function useGetWebmonSettings<TData = Awaited<ReturnType<typeof getWebmonSettings>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebmonSettings>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWebmonSettingsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Update website monitoring settings
 */
export const patchWebmonSettings = (
    jsonPatchOperation: JsonPatchOperation[],
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<WebMonSettings>(
      {url: `/api/v1/webmon/settings`, method: 'PATCH',
      headers: {'Content-Type': 'application/json-patch+json', },
      data: jsonPatchOperation
    },
      options);
    }
  


export const getPatchWebmonSettingsMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchWebmonSettings>>, TError,{data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchWebmonSettings>>, TError,{data: JsonPatchOperation[]}, TContext> => {

const mutationKey = ['patchWebmonSettings'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchWebmonSettings>>, {data: JsonPatchOperation[]}> = (props) => {
          const {data} = props ?? {};

          return  patchWebmonSettings(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchWebmonSettingsMutationResult = NonNullable<Awaited<ReturnType<typeof patchWebmonSettings>>>
    export type PatchWebmonSettingsMutationBody = JsonPatchOperation[]
    export type PatchWebmonSettingsMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Update website monitoring settings
 */
export const usePatchWebmonSettings = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchWebmonSettings>>, TError,{data: JsonPatchOperation[]}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchWebmonSettings>>,
        TError,
        {data: JsonPatchOperation[]},
        TContext
      > => {

      const mutationOptions = getPatchWebmonSettingsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary List monitored sites with their check rules
 */
export const getWebmonSites = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MonitoredSite[]>(
      {url: `/api/v1/webmon/sites`, method: 'GET', signal
    },
      options);
    }
  



export const getGetWebmonSitesQueryKey = () => {
    return [
    `/api/v1/webmon/sites`
    ] as const;
    }

    
export const getGetWebmonSitesQueryOptions = <TData = Awaited<ReturnType<typeof getWebmonSites>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebmonSites>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWebmonSitesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWebmonSites>>> = ({ signal }) => getWebmonSites(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWebmonSites>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetWebmonSitesQueryResult = NonNullable<Awaited<ReturnType<typeof getWebmonSites>>>
export type GetWebmonSitesQueryError = UnauthorizedErrorResponse | ForbiddenErrorResponse


export function useGetWebmonSites<TData = Awaited<ReturnType<typeof getWebmonSites>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebmonSites>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWebmonSites>>,
          TError,
          Awaited<ReturnType<typeof getWebmonSites>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWebmonSites<TData = Awaited<ReturnType<typeof getWebmonSites>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebmonSites>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWebmonSites>>,
          TError,
          Awaited<ReturnType<typeof getWebmonSites>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetWebmonSites<TData = Awaited<ReturnType<typeof getWebmonSites>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebmonSites>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List monitored sites with their check rules
 */

export function useGetWebmonSites<TData = Awaited<ReturnType<typeof getWebmonSites>>, TError = UnauthorizedErrorResponse | ForbiddenErrorResponse>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWebmonSites>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetWebmonSitesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Add a monitored site
 */
export const postWebmonSites = (
    monitoredSite: NonReadonly<MonitoredSite>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MonitoredSite>(
      {url: `/api/v1/webmon/sites`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: monitoredSite, signal
    },
      options);
    }
  


export const getPostWebmonSitesMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWebmonSites>>, TError,{data: NonReadonly<MonitoredSite>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postWebmonSites>>, TError,{data: NonReadonly<MonitoredSite>}, TContext> => {

const mutationKey = ['postWebmonSites'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postWebmonSites>>, {data: NonReadonly<MonitoredSite>}> = (props) => {
          const {data} = props ?? {};

          return  postWebmonSites(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostWebmonSitesMutationResult = NonNullable<Awaited<ReturnType<typeof postWebmonSites>>>
    export type PostWebmonSitesMutationBody = NonReadonly<MonitoredSite>
    export type PostWebmonSitesMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Add a monitored site
 */
export const usePostWebmonSites = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWebmonSites>>, TError,{data: NonReadonly<MonitoredSite>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postWebmonSites>>,
        TError,
        {data: NonReadonly<MonitoredSite>},
        TContext
      > => {

      const mutationOptions = getPostWebmonSitesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Update a monitored site
 */
export const putWebmonSitesSiteId = (
    siteId: string,
    monitoredSite: NonReadonly<MonitoredSite>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<MonitoredSite>(
      {url: `/api/v1/webmon/sites/${siteId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: monitoredSite
    },
      options);
    }
  


export const getPutWebmonSitesSiteIdMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putWebmonSitesSiteId>>, TError,{siteId: string;data: NonReadonly<MonitoredSite>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putWebmonSitesSiteId>>, TError,{siteId: string;data: NonReadonly<MonitoredSite>}, TContext> => {

const mutationKey = ['putWebmonSitesSiteId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putWebmonSitesSiteId>>, {siteId: string;data: NonReadonly<MonitoredSite>}> = (props) => {
          const {siteId,data} = props ?? {};

          return  putWebmonSitesSiteId(siteId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutWebmonSitesSiteIdMutationResult = NonNullable<Awaited<ReturnType<typeof putWebmonSitesSiteId>>>
    export type PutWebmonSitesSiteIdMutationBody = NonReadonly<MonitoredSite>
    export type PutWebmonSitesSiteIdMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Update a monitored site
 */
export const usePutWebmonSitesSiteId = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putWebmonSitesSiteId>>, TError,{siteId: string;data: NonReadonly<MonitoredSite>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putWebmonSitesSiteId>>,
        TError,
        {siteId: string;data: NonReadonly<MonitoredSite>},
        TContext
      > => {

      const mutationOptions = getPutWebmonSitesSiteIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Remove a monitored site
 */
export const deleteWebmonSitesSiteId = (
    siteId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/webmon/sites/${siteId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteWebmonSitesSiteIdMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWebmonSitesSiteId>>, TError,{siteId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteWebmonSitesSiteId>>, TError,{siteId: string}, TContext> => {

const mutationKey = ['deleteWebmonSitesSiteId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWebmonSitesSiteId>>, {siteId: string}> = (props) => {
          const {siteId} = props ?? {};

          return  deleteWebmonSitesSiteId(siteId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteWebmonSitesSiteIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWebmonSitesSiteId>>>
    
    export type DeleteWebmonSitesSiteIdMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Remove a monitored site
 */
export const useDeleteWebmonSitesSiteId = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWebmonSitesSiteId>>, TError,{siteId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteWebmonSitesSiteId>>,
        TError,
        {siteId: string},
        TContext
      > => {

      const mutationOptions = getDeleteWebmonSitesSiteIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Add a check rule to a site
 */
export const postWebmonSitesSiteIdChecks = (
    siteId: string,
    siteCheck: NonReadonly<SiteCheck>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SiteCheck>(
      {url: `/api/v1/webmon/sites/${siteId}/checks`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: siteCheck, signal
    },
      options);
    }
  


export const getPostWebmonSitesSiteIdChecksMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWebmonSitesSiteIdChecks>>, TError,{siteId: string;data: NonReadonly<SiteCheck>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postWebmonSitesSiteIdChecks>>, TError,{siteId: string;data: NonReadonly<SiteCheck>}, TContext> => {

const mutationKey = ['postWebmonSitesSiteIdChecks'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postWebmonSitesSiteIdChecks>>, {siteId: string;data: NonReadonly<SiteCheck>}> = (props) => {
          const {siteId,data} = props ?? {};

          return  postWebmonSitesSiteIdChecks(siteId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostWebmonSitesSiteIdChecksMutationResult = NonNullable<Awaited<ReturnType<typeof postWebmonSitesSiteIdChecks>>>
    export type PostWebmonSitesSiteIdChecksMutationBody = NonReadonly<SiteCheck>
    export type PostWebmonSitesSiteIdChecksMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Add a check rule to a site
 */
export const usePostWebmonSitesSiteIdChecks = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWebmonSitesSiteIdChecks>>, TError,{siteId: string;data: NonReadonly<SiteCheck>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postWebmonSitesSiteIdChecks>>,
        TError,
        {siteId: string;data: NonReadonly<SiteCheck>},
        TContext
      > => {

      const mutationOptions = getPostWebmonSitesSiteIdChecksMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * One request, one transaction. Reordering by PUTting each rule's new
position cannot be made atomic from a browser, and a request that fails
halfway leaves duplicate positions.

 * @summary Reorder a site's check rules
 */
export const putWebmonSitesSiteIdChecksOrder = (
    siteId: string,
    putWebmonSitesSiteIdChecksOrderBody: PutWebmonSitesSiteIdChecksOrderBody,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<SiteCheck[]>(
      {url: `/api/v1/webmon/sites/${siteId}/checks/order`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: putWebmonSitesSiteIdChecksOrderBody
    },
      options);
    }
  


export const getPutWebmonSitesSiteIdChecksOrderMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putWebmonSitesSiteIdChecksOrder>>, TError,{siteId: string;data: PutWebmonSitesSiteIdChecksOrderBody}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putWebmonSitesSiteIdChecksOrder>>, TError,{siteId: string;data: PutWebmonSitesSiteIdChecksOrderBody}, TContext> => {

const mutationKey = ['putWebmonSitesSiteIdChecksOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putWebmonSitesSiteIdChecksOrder>>, {siteId: string;data: PutWebmonSitesSiteIdChecksOrderBody}> = (props) => {
          const {siteId,data} = props ?? {};

          return  putWebmonSitesSiteIdChecksOrder(siteId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutWebmonSitesSiteIdChecksOrderMutationResult = NonNullable<Awaited<ReturnType<typeof putWebmonSitesSiteIdChecksOrder>>>
    export type PutWebmonSitesSiteIdChecksOrderMutationBody = PutWebmonSitesSiteIdChecksOrderBody
    export type PutWebmonSitesSiteIdChecksOrderMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Reorder a site's check rules
 */
export const usePutWebmonSitesSiteIdChecksOrder = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putWebmonSitesSiteIdChecksOrder>>, TError,{siteId: string;data: PutWebmonSitesSiteIdChecksOrderBody}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putWebmonSitesSiteIdChecksOrder>>,
        TError,
        {siteId: string;data: PutWebmonSitesSiteIdChecksOrderBody},
        TContext
      > => {

      const mutationOptions = getPutWebmonSitesSiteIdChecksOrderMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Update a check rule
 */
export const putWebmonSitesSiteIdChecksCheckId = (
    siteId: string,
    checkId: string,
    siteCheck: NonReadonly<SiteCheck>,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<SiteCheck>(
      {url: `/api/v1/webmon/sites/${siteId}/checks/${checkId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: siteCheck
    },
      options);
    }
  


export const getPutWebmonSitesSiteIdChecksCheckIdMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putWebmonSitesSiteIdChecksCheckId>>, TError,{siteId: string;checkId: string;data: NonReadonly<SiteCheck>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putWebmonSitesSiteIdChecksCheckId>>, TError,{siteId: string;checkId: string;data: NonReadonly<SiteCheck>}, TContext> => {

const mutationKey = ['putWebmonSitesSiteIdChecksCheckId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putWebmonSitesSiteIdChecksCheckId>>, {siteId: string;checkId: string;data: NonReadonly<SiteCheck>}> = (props) => {
          const {siteId,checkId,data} = props ?? {};

          return  putWebmonSitesSiteIdChecksCheckId(siteId,checkId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutWebmonSitesSiteIdChecksCheckIdMutationResult = NonNullable<Awaited<ReturnType<typeof putWebmonSitesSiteIdChecksCheckId>>>
    export type PutWebmonSitesSiteIdChecksCheckIdMutationBody = NonReadonly<SiteCheck>
    export type PutWebmonSitesSiteIdChecksCheckIdMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Update a check rule
 */
export const usePutWebmonSitesSiteIdChecksCheckId = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putWebmonSitesSiteIdChecksCheckId>>, TError,{siteId: string;checkId: string;data: NonReadonly<SiteCheck>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putWebmonSitesSiteIdChecksCheckId>>,
        TError,
        {siteId: string;checkId: string;data: NonReadonly<SiteCheck>},
        TContext
      > => {

      const mutationOptions = getPutWebmonSitesSiteIdChecksCheckIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Remove a check rule
 */
export const deleteWebmonSitesSiteIdChecksCheckId = (
    siteId: string,
    checkId: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/v1/webmon/sites/${siteId}/checks/${checkId}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteWebmonSitesSiteIdChecksCheckIdMutationOptions = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWebmonSitesSiteIdChecksCheckId>>, TError,{siteId: string;checkId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteWebmonSitesSiteIdChecksCheckId>>, TError,{siteId: string;checkId: string}, TContext> => {

const mutationKey = ['deleteWebmonSitesSiteIdChecksCheckId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteWebmonSitesSiteIdChecksCheckId>>, {siteId: string;checkId: string}> = (props) => {
          const {siteId,checkId} = props ?? {};

          return  deleteWebmonSitesSiteIdChecksCheckId(siteId,checkId,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteWebmonSitesSiteIdChecksCheckIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteWebmonSitesSiteIdChecksCheckId>>>
    
    export type DeleteWebmonSitesSiteIdChecksCheckIdMutationError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void

    /**
 * @summary Remove a check rule
 */
export const useDeleteWebmonSitesSiteIdChecksCheckId = <TError = UnauthorizedErrorResponse | ForbiddenErrorResponse | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteWebmonSitesSiteIdChecksCheckId>>, TError,{siteId: string;checkId: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteWebmonSitesSiteIdChecksCheckId>>,
        TError,
        {siteId: string;checkId: string},
        TContext
      > => {

      const mutationOptions = getDeleteWebmonSitesSiteIdChecksCheckIdMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Runs the supplied check once and returns the observed status, headers
and a body prefix alongside each assertion's verdict. Persists nothing,
alerts nothing, and touches no site's state.

Takes the check in the body rather than by id so a rule can be tried
while it is still being written. Authoring a redirect or a header
assertion without first seeing what the site actually sends is
guesswork, and requiring a save before every attempt makes that loop
unusable.

How far the probe may reach still comes from stored settings, never
from this request, so a crafted body cannot widen it. Naming a site
applies that site's override.

 * @summary Evaluate a check without saving it
 */
export const postWebmonTryCheck = (
    siteCheckTryRequest: SiteCheckTryRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SiteCheckTryResult>(
      {url: `/api/v1/webmon/try-check`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: siteCheckTryRequest, signal
    },
      options);
    }
  


export const getPostWebmonTryCheckMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWebmonTryCheck>>, TError,{data: SiteCheckTryRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postWebmonTryCheck>>, TError,{data: SiteCheckTryRequest}, TContext> => {

const mutationKey = ['postWebmonTryCheck'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postWebmonTryCheck>>, {data: SiteCheckTryRequest}> = (props) => {
          const {data} = props ?? {};

          return  postWebmonTryCheck(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostWebmonTryCheckMutationResult = NonNullable<Awaited<ReturnType<typeof postWebmonTryCheck>>>
    export type PostWebmonTryCheckMutationBody = SiteCheckTryRequest
    export type PostWebmonTryCheckMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Evaluate a check without saving it
 */
export const usePostWebmonTryCheck = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWebmonTryCheck>>, TError,{data: SiteCheckTryRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postWebmonTryCheck>>,
        TError,
        {data: SiteCheckTryRequest},
        TContext
      > => {

      const mutationOptions = getPostWebmonTryCheckMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Runs exactly what the scheduler runs, through the same code path, so
what you see here is what the schedule will do. Results are recorded
and alerts are sent if a site has changed state.

The dead-man's switch is deliberately untouched: it measures whether
the scheduler is alive, and a manual run that pinged it would hide a
stopped scheduler for as long as someone kept clicking.

 * @summary Run the site checks now
 */
export const postWebmonCheck = (
    webMonCheckRequest?: WebMonCheckRequest,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<PostWebmonCheck200>(
      {url: `/api/v1/webmon/check`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: webMonCheckRequest, signal
    },
      options);
    }
  


export const getPostWebmonCheckMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWebmonCheck>>, TError,{data: WebMonCheckRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postWebmonCheck>>, TError,{data: WebMonCheckRequest}, TContext> => {

const mutationKey = ['postWebmonCheck'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postWebmonCheck>>, {data: WebMonCheckRequest}> = (props) => {
          const {data} = props ?? {};

          return  postWebmonCheck(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostWebmonCheckMutationResult = NonNullable<Awaited<ReturnType<typeof postWebmonCheck>>>
    export type PostWebmonCheckMutationBody = WebMonCheckRequest
    export type PostWebmonCheckMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Run the site checks now
 */
export const usePostWebmonCheck = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWebmonCheck>>, TError,{data: WebMonCheckRequest}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postWebmonCheck>>,
        TError,
        {data: WebMonCheckRequest},
        TContext
      > => {

      const mutationOptions = getPostWebmonCheckMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * Delivers a synthetic alert to the dashboard, Slack and email so the
paths can be proven before anything depends on them. An alert path that
has never delivered a message is not a monitor.

 * @summary Send a test alert through every configured channel
 */
export const postWebmonTestAlert = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<MonitorTestStage[]>(
      {url: `/api/v1/webmon/test-alert`, method: 'POST', signal
    },
      options);
    }
  


export const getPostWebmonTestAlertMutationOptions = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWebmonTestAlert>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postWebmonTestAlert>>, TError,void, TContext> => {

const mutationKey = ['postWebmonTestAlert'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postWebmonTestAlert>>, void> = () => {
          

          return  postWebmonTestAlert(requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostWebmonTestAlertMutationResult = NonNullable<Awaited<ReturnType<typeof postWebmonTestAlert>>>
    
    export type PostWebmonTestAlertMutationError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse

    /**
 * @summary Send a test alert through every configured channel
 */
export const usePostWebmonTestAlert = <TError = RequestErrorResponse | UnauthorizedErrorResponse | ForbiddenErrorResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postWebmonTestAlert>>, TError,void, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postWebmonTestAlert>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getPostWebmonTestAlertMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
